var cities = {
  AAA : {
    country: "PF",
    name: {
      en : "Anaa"
    }
  },
  AAB : {
    country: "AU",
    name: {
      en : "Arrabury"
    }
  },
  AAE : {
    country: "DZ",
    name: {
      en : "Annaba"
    }
  },
  AAF : {
    country: "US",
    name: {
      en : "Apalachicola"
    }
  },
  AAG : {
    country: "BR",
    name: {
      en : "Arapoti"
    }
  },
  AAH : {
    country: "DE",
    popularity: 4,
    name: {
      en : "Aachen"
    }
  },
  AAK : {
    country: "KI",
    name: {
      en : "Aranuka"
    }
  },
  AAL : {
    country: "DK",
    name: {
      en : "Aalborg"
    }
  },
  AAM : {
    country: "ZA",
    name: {
      en : "Mala Mala"
    }
  },
  AAN : {
    country: "AE",
    name: {
      en : "Al Ain"
    }
  },
  AAO : {
    country: "VE",
    name: {
      en : "Anaco"
    }
  },
  AAQ : {
    country: "RU",
    popularity: 4,
    name: {
      en : "Anapa"
    }
  },
  AAR : {
    country: "DK",
    popularity: 8,
    name: {
      en : "Aarhus"
    }
  },
  AAT : {
    country: "CN",
    name: {
      en : "Altay"
    }
  },
  AAX : {
    country: "BR",
    name: {
      en : "Araxa"
    }
  },
  AAY : {
    country: "YE",
    name: {
      en : "Al Ghaydah"
    }
  },
  ABA : {
    country: "RU",
    name: {
      en : "Abakan"
    }
  },
  ABC : {
    country: "ES",
    name: {
      en : "Albacete"
    }
  },
  ABD : {
    country: "IR",
    name: {
      en : "Abadan"
    }
  },
  ABE : {
    country: "US",
    name: {
      en : "Allentown"
    }
  },
  ABF : {
    country: "KI",
    name: {
      en : "Abaiang"
    }
  },
  ABH : {
    country: "AU",
    name: {
      en : "Alpha"
    }
  },
  ABI : {
    country: "US",
    name: {
      en : "Abilene"
    }
  },
  ABJ : {
    country: "CI",
    popularity: 6,
    name: {
      en : "Abidjan"
    }
  },
  ABK : {
    country: "ET",
    name: {
      en : "Kabri Dar"
    }
  },
  ABL : {
    country: "US",
    name: {
      en : "Ambler"
    }
  },
  ABM : {
    country: "AU",
    name: {
      en : "Bamaga"
    }
  },
  ABQ : {
    country: "US",
    name: {
      en : "Albuquerque"
    }
  },
  ABR : {
    country: "US",
    name: {
      en : "Aberdeen"
    }
  },
  ABS : {
    country: "EG",
    name: {
      en : "Abu Simbel"
    }
  },
  ABT : {
    country: "SA",
    name: {
      en : "Al Baha"
    }
  },
  ABU : {
    country: "ID",
    name: {
      en : "Atambua"
    }
  },
  ABV : {
    country: "NG",
    name: {
      en : "Abuja"
    }
  },
  ABX : {
    country: "AU",
    name: {
      en : "Albury"
    }
  },
  ABY : {
    country: "US",
    name: {
      en : "Albany"
    }
  },
  ABZ : {
    country: "GB",
    popularity: 32,
    name: {
      en : "Aberdeen"
    }
  },
  ACA : {
    country: "MX",
    name: {
      en : "Acapulco"
    }
  },
  ACC : {
    country: "GH",
    name: {
      en : "Accra"
    }
  },
  ACD : {
    country: "CO",
    name: {
      en : "Acandi"
    }
  },
  ACE : {
    country: "ES",
    popularity: 584,
    name: {
      en : "Lanzarote"
    }
  },
  ACH : {
    country: "CH",
    name: {
      en : "Altenrhein"
    }
  },
  ACI : {
    country: "GB",
    name: {
      en : "Alderney"
    }
  },
  ACK : {
    country: "US",
    name: {
      en : "Nantucket"
    }
  },
  ACO : {
    country: "CH",
    name: {
      en : "Ascona"
    }
  },
  ACP : {
    country: "IR",
    name: {
      en : "Sahand"
    }
  },
  ACR : {
    country: "CO",
    name: {
      en : "Araracuara"
    }
  },
  ACS : {
    country: "RU",
    name: {
      en : "Achinsk"
    }
  },
  ACT : {
    country: "US",
    name: {
      en : "Waco"
    }
  },
  ACU : {
    country: "PA",
    name: {
      en : "Achutupo"
    }
  },
  ACV : {
    country: "US",
    name: {
      en : "Eureka"
    }
  },
  ACX : {
    country: "CN",
    name: {
      en : "Xingyi"
    }
  },
  ACZ : {
    country: "IR",
    name: {
      en : "Zabol"
    }
  },
  ADA : {
    country: "TR",
    name: {
      en : "Adana"
    }
  },
  ADB : {
    country: "TR",
    name: {
      en : "Izmir"
    }
  },
  ADD : {
    country: "ET",
    name: {
      en : "Addis Ababa"
    }
  },
  ADE : {
    country: "YE",
    name: {
      en : "Aden"
    }
  },
  ADF : {
    country: "TR",
    name: {
      en : "Adiyaman"
    }
  },
  ADG : {
    country: "US",
    name: {
      en : "Adrian"
    }
  },
  ADH : {
    country: "RU",
    name: {
      en : "Aldan"
    }
  },
  ADK : {
    country: "US",
    popularity: 10,
    name: {
      en : "Adak Island"
    }
  },
  ADL : {
    country: "AU",
    popularity: 24,
    name: {
      en : "Adelaide"
    }
  },
  ADM : {
    country: "US",
    name: {
      en : "Ardmore"
    }
  },
  ADQ : {
    country: "US",
    name: {
      en : "Kodiak"
    }
  },
  ADT : {
    country: "US",
    name: {
      en : "Ada OK"
    }
  },
  ADU : {
    country: "IR",
    name: {
      en : "Ardabil"
    }
  },
  ADV : {
    country: "GB",
    name: {
      en : "Andover"
    }
  },
  ADW : {
    country: "US",
    name: {
      en : "Camp Springs"
    }
  },
  ADX : {
    country: "GB",
    name: {
      en : "St Andrews"
    }
  },
  ADZ : {
    country: "CO",
    name: {
      en : "San Andres"
    }
  },
  AEA : {
    country: "KI",
    name: {
      en : "Abemama"
    }
  },
  AEB : {
    country: "CN",
    name: {
      en : "Baise"
    }
  },
  AEG : {
    country: "ID",
    name: {
      en : "Aek Godang"
    }
  },
  AEH : {
    country: "TD",
    name: {
      en : "Abecher"
    }
  },
  AEI : {
    country: "ES",
    name: {
      en : "Algeciras"
    }
  },
  AEL : {
    country: "US",
    name: {
      en : "Albert Lea"
    }
  },
  AEO : {
    country: "MR",
    name: {
      en : "Aioun Atrouss"
    }
  },
  AER : {
    country: "RU",
    popularity: 196,
    name: {
      en : "Sochi"
    }
  },
  AES : {
    country: "NO",
    name: {
      en : "Alesund"
    }
  },
  AET : {
    country: "US",
    name: {
      en : "Allakaket"
    }
  },
  AEX : {
    country: "US",
    name: {
      en : "Alexandria"
    }
  },
  AEY : {
    country: "IS",
    popularity: 2,
    name: {
      en : "Akureyri"
    }
  },
  AFA : {
    country: "AR",
    name: {
      en : "San Rafael"
    }
  },
  AFK : {
    country: "LK",
    name: {
      en : "Ampara"
    }
  },
  AFL : {
    country: "BR",
    name: {
      en : "Alta Floresta"
    }
  },
  AFS : {
    country: "UZ",
    name: {
      en : "Zarafsan"
    }
  },
  AFT : {
    country: "SB",
    name: {
      en : "Afutara Aerodrome"
    }
  },
  AFZ : {
    country: "IR",
    name: {
      en : "Sabzevar"
    }
  },
  AGA : {
    country: "MA",
    name: {
      en : "Agadir"
    }
  },
  AGB : {
    country: "DE",
    name: {
      en : "Augsburg"
    }
  },
  AGE : {
    country: "DE",
    name: {
      en : "Wangerooge"
    }
  },
  AGF : {
    country: "FR",
    name: {
      en : "Agen"
    }
  },
  AGH : {
    country: "SE",
    name: {
      en : "Angelholm"
    }
  },
  AGJ : {
    country: "JP",
    name: {
      en : "Aguni"
    }
  },
  AGL : {
    country: "PG",
    name: {
      en : "Wanigela"
    }
  },
  AGM : {
    country: "GL",
    name: {
      en : "Tasiilaq"
    }
  },
  AGN : {
    country: "US",
    name: {
      en : "Angoon"
    }
  },
  AGO : {
    country: "US",
    name: {
      en : "Magnolia"
    }
  },
  AGP : {
    country: "ES",
    name: {
      en : "Malaga"
    }
  },
  AGR : {
    country: "IN",
    name: {
      en : "Agra"
    }
  },
  AGS : {
    country: "US",
    name: {
      en : "Augusta"
    }
  },
  AGT : {
    country: "PY",
    name: {
      en : "Ciudad Del Este"
    }
  },
  AGU : {
    country: "MX",
    name: {
      en : "Aguascalientes"
    }
  },
  AGV : {
    country: "VE",
    name: {
      en : "Acarigua"
    }
  },
  AGX : {
    country: "IN",
    name: {
      en : "Agatti Island"
    }
  },
  AGZ : {
    country: "ZA",
    name: {
      en : "Aggeneys"
    }
  },
  AHB : {
    country: "SA",
    name: {
      en : "Abha"
    }
  },
  AHE : {
    country: "PF",
    name: {
      en : "Ahe"
    }
  },
  AHI : {
    country: "ID",
    name: {
      en : "Amahai"
    }
  },
  AHN : {
    country: "US",
    name: {
      en : "Athens"
    }
  },
  AHO : {
    country: "IT",
    name: {
      en : "Alghero"
    }
  },
  AHS : {
    country: "HN",
    name: {
      en : "Ahuas"
    }
  },
  AHT : {
    country: "US",
    name: {
      en : "Amchitka"
    }
  },
  AHU : {
    country: "MA",
    name: {
      en : "Al Hoceima"
    }
  },
  AIA : {
    country: "US",
    name: {
      en : "Alliance"
    }
  },
  AID : {
    country: "US",
    name: {
      en : "Anderson"
    }
  },
  AIE : {
    country: "PG",
    name: {
      en : "Aiome"
    }
  },
  AIF : {
    country: "BR",
    name: {
      en : "Assis"
    }
  },
  AIK : {
    country: "US",
    name: {
      en : "Aiken"
    }
  },
  AIN : {
    country: "US",
    name: {
      en : "Wainwright"
    }
  },
  AIS : {
    country: "KI",
    name: {
      en : "Arorae Island"
    }
  },
  AIT : {
    country: "CK",
    name: {
      en : "Aitutaki"
    }
  },
  AIU : {
    country: "CK",
    name: {
      en : "Atiu Island"
    }
  },
  AIY : {
    country: "US",
    name: {
      en : "Atlantic City"
    }
  },
  AIZ : {
    country: "US",
    name: {
      en : "Lake Of The Ozarks"
    }
  },
  AJA : {
    country: "FR",
    name: {
      en : "Ajaccio"
    }
  },
  AJF : {
    country: "SA",
    name: {
      en : "Al Jouf"
    }
  },
  AJI : {
    country: "TR",
    name: {
      en : "Agri"
    }
  },
  AJL : {
    country: "IN",
    name: {
      en : "Aizawl"
    }
  },
  AJN : {
    country: "KM",
    name: {
      en : "Anjouan"
    }
  },
  AJR : {
    country: "SE",
    name: {
      en : "Arvidsjaur"
    }
  },
  AJU : {
    country: "BR",
    name: {
      en : "Aracaju"
    }
  },
  AKA : {
    country: "CN",
    name: {
      en : "Ankang"
    }
  },
  AKB : {
    country: "US",
    name: {
      en : "Atka"
    }
  },
  AKF : {
    country: "LY",
    name: {
      en : "Kufrah"
    }
  },
  AKG : {
    country: "PG",
    name: {
      en : "Anguganak"
    }
  },
  AKI : {
    country: "US",
    name: {
      en : "Akiak"
    }
  },
  AKJ : {
    country: "JP",
    name: {
      en : "Asahikawa"
    }
  },
  AKK : {
    country: "US",
    name: {
      en : "Akhiok"
    }
  },
  AKL : {
    country: "NZ",
    popularity: 8,
    name: {
      en : "Auckland"
    }
  },
  AKN : {
    country: "US",
    name: {
      en : "King Salmon"
    }
  },
  AKP : {
    country: "US",
    name: {
      en : "Anaktuvuk Pass"
    }
  },
  AKR : {
    country: "NG",
    name: {
      en : "Akure"
    }
  },
  AKS : {
    country: "SB",
    name: {
      en : "Akui"
    }
  },
  AKU : {
    country: "CN",
    name: {
      en : "Aksu"
    }
  },
  AKV : {
    country: "CA",
    name: {
      en : "Akulivik"
    }
  },
  AKX : {
    country: "KZ",
    name: {
      en : "Aqtobe"
    }
  },
  AKY : {
    country: "MM",
    name: {
      en : "Akyab"
    }
  },
  ALA : {
    country: "KZ",
    popularity: 88,
    name: {
      en : "Almaty"
    }
  },
  ALB : {
    country: "US",
    name: {
      en : "Albany"
    }
  },
  ALC : {
    country: "ES",
    popularity: 16,
    name: {
      en : "Alicante"
    }
  },
  ALE : {
    country: "US",
    name: {
      en : "Alpine"
    }
  },
  ALF : {
    country: "NO",
    name: {
      en : "Alta"
    }
  },
  ALG : {
    country: "DZ",
    popularity: 116,
    name: {
      en : "Algiers"
    }
  },
  ALH : {
    country: "AU",
    name: {
      en : "Albany"
    }
  },
  ALJ : {
    country: "ZA",
    name: {
      en : "Alexander Bay"
    }
  },
  ALL : {
    country: "IT",
    name: {
      en : "Albenga"
    }
  },
  ALM : {
    country: "US",
    name: {
      en : "Alamogordo"
    }
  },
  ALN : {
    country: "US",
    name: {
      en : "Alton"
    }
  },
  ALO : {
    country: "US",
    name: {
      en : "Waterloo"
    }
  },
  ALP : {
    country: "SY",
    name: {
      en : "Aleppo"
    }
  },
  ALR : {
    country: "NZ",
    name: {
      en : "Alexandra"
    }
  },
  ALS : {
    country: "US",
    name: {
      en : "Alamosa"
    }
  },
  ALU : {
    country: "SO",
    name: {
      en : "Alula"
    }
  },
  ALV : {
    country: "AD",
    name: {
      en : "Andorra La Vella"
    }
  },
  ALW : {
    country: "US",
    name: {
      en : "Walla Walla"
    }
  },
  ALX : {
    country: "US",
    name: {
      en : "Alexander City"
    }
  },
  ALY : {
    country: "EG",
    name: {
      en : "Alexandria"
    }
  },
  ALZ : {
    country: "US",
    name: {
      en : "Alitak"
    }
  },
  AMA : {
    country: "US",
    name: {
      en : "Amarillo"
    }
  },
  AMD : {
    country: "IN",
    name: {
      en : "Ahmedabad"
    }
  },
  AMH : {
    country: "ET",
    name: {
      en : "Arba Mintch"
    }
  },
  AMI : {
    country: "ID",
    name: {
      en : "Mataram"
    }
  },
  AML : {
    country: "PA",
    name: {
      en : "Puerto Armuelles"
    }
  },
  AMM : {
    country: "JO",
    popularity: 4,
    name: {
      en : "Amman"
    }
  },
  AMP : {
    country: "MG",
    name: {
      en : "Ampanihy"
    }
  },
  AMQ : {
    country: "ID",
    name: {
      en : "Ambon"
    }
  },
  AMS : {
    country: "NL",
    popularity: 1029,
    name: {
      en : "Amsterdam"
    }
  },
  AMU : {
    country: "PG",
    name: {
      en : "Amanab"
    }
  },
  AMV : {
    country: "RU",
    name: {
      en : "Amderma"
    }
  },
  AMW : {
    country: "US",
    name: {
      en : "Ames"
    }
  },
  AMY : {
    country: "MG",
    name: {
      en : "Ambatomainty"
    }
  },
  ANA : {
    country: "US",
    name: {
      en : "Anaheim"
    }
  },
  ANB : {
    country: "US",
    name: {
      en : "Anniston"
    }
  },
  ANC : {
    country: "US",
    popularity: 16,
    name: {
      en : "Anchorage"
    }
  },
  AND : {
    country: "US",
    name: {
      en : "Anderson"
    }
  },
  ANE : {
    country: "FR",
    name: {
      en : "Angers"
    }
  },
  ANF : {
    country: "CL",
    name: {
      en : "Antofagasta"
    }
  },
  ANG : {
    country: "FR",
    name: {
      en : "Angouleme"
    }
  },
  ANI : {
    country: "US",
    name: {
      en : "Aniak"
    }
  },
  ANJ : {
    country: "CG",
    name: {
      en : "Zanaga"
    }
  },
  ANK : {
    country: "TR",
    popularity: 18,
    name: {
      en : "Ankara"
    }
  },
  ANM : {
    country: "MG",
    name: {
      en : "Antalaha"
    }
  },
  ANP : {
    country: "US",
    name: {
      en : "Annapolis"
    }
  },
  ANR : {
    country: "BE",
    name: {
      en : "Antwerp"
    }
  },
  ANS : {
    country: "PE",
    name: {
      en : "Andahuaylas"
    }
  },
  ANT : {
    country: "AT",
    name: {
      en : "St Anton"
    }
  },
  ANU : {
    country: "AG",
    name: {
      en : "Antigua"
    }
  },
  ANV : {
    country: "US",
    name: {
      en : "Anvik"
    }
  },
  ANW : {
    country: "US",
    name: {
      en : "Ainsworth"
    }
  },
  ANX : {
    country: "NO",
    name: {
      en : "Andenes"
    }
  },
  AOC : {
    country: "DE",
    name: {
      en : "Altenburg"
    }
  },
  AOE : {
    country: "TR",
    name: {
      en : "Eskişehir"
    }
  },
  AOG : {
    country: "CN",
    name: {
      en : "Anshan"
    }
  },
  AOH : {
    country: "US",
    name: {
      en : "Lima"
    }
  },
  AOI : {
    country: "IT",
    name: {
      en : "Ancona"
    }
  },
  AOJ : {
    country: "JP",
    name: {
      en : "Aomori"
    }
  },
  AOK : {
    country: "GR",
    name: {
      en : "Karpathos"
    }
  },
  AOL : {
    country: "AR",
    name: {
      en : "Paso de los Libres"
    }
  },
  AOO : {
    country: "US",
    name: {
      en : "Altoona"
    }
  },
  AOR : {
    country: "MY",
    name: {
      en : "Alor Setar"
    }
  },
  AOS : {
    country: "US",
    name: {
      en : "Amook Bay"
    }
  },
  AOT : {
    country: "IT",
    popularity: 2,
    name: {
      en : "Aosta"
    }
  },
  APC : {
    country: "US",
    name: {
      en : "Napa"
    }
  },
  APF : {
    country: "US",
    name: {
      en : "Naples"
    }
  },
  APK : {
    country: "PF",
    name: {
      en : "Apataki"
    }
  },
  APL : {
    country: "MZ",
    name: {
      en : "Nampula"
    }
  },
  APN : {
    country: "US",
    name: {
      en : "Alpena"
    }
  },
  APO : {
    country: "CO",
    name: {
      en : "Apartado"
    }
  },
  APS : {
    country: "BR",
    name: {
      en : "Anapolis"
    }
  },
  APW : {
    country: "WS",
    popularity: 4,
    name: {
      en : "Apia"
    }
  },
  APZ : {
    country: "AR",
    name: {
      en : "Zapala"
    }
  },
  AQA : {
    country: "BR",
    name: {
      en : "Araraquara"
    }
  },
  AQG : {
    country: "CN",
    name: {
      en : "Anqing"
    }
  },
  AQI : {
    country: "SA",
    name: {
      en : "Qaisumah"
    }
  },
  AQJ : {
    country: "JO",
    popularity: 2,
    name: {
      en : "Aqaba"
    }
  },
  AQP : {
    country: "PE",
    name: {
      en : "Arequipa"
    }
  },
  ARB : {
    country: "US",
    name: {
      en : "Ann Arbor"
    }
  },
  ARC : {
    country: "US",
    name: {
      en : "Arctic Village"
    }
  },
  ARD : {
    country: "ID",
    name: {
      en : "Alor Island"
    }
  },
  ARE : {
    country: "US",
    name: {
      en : "Arecibo"
    }
  },
  ARH : {
    country: "RU",
    popularity: 28,
    name: {
      en : "Arkhangelsk"
    }
  },
  ARI : {
    country: "CL",
    name: {
      en : "Arica"
    }
  },
  ARK : {
    country: "TZ",
    name: {
      en : "Arusha"
    }
  },
  ARL : {
    country: "BF",
    name: {
      en : "Arly"
    }
  },
  ARM : {
    country: "AU",
    popularity: 4,
    name: {
      en : "Armidale"
    }
  },
  ARP : {
    country: "PG",
    name: {
      en : "Aragip"
    }
  },
  ARR : {
    country: "AR",
    name: {
      en : "Alto Rio Senguerr"
    }
  },
  ART : {
    country: "US",
    name: {
      en : "Watertown"
    }
  },
  ARU : {
    country: "BR",
    name: {
      en : "Aracatuba"
    }
  },
  ARV : {
    country: "US",
    name: {
      en : "Minocqua"
    }
  },
  ARW : {
    country: "RO",
    name: {
      en : "Arad"
    }
  },
  ARX : {
    country: "US",
    name: {
      en : "Asbury Park"
    }
  },
  ARY : {
    country: "AU",
    name: {
      en : "Ararat"
    }
  },
  ARZ : {
    country: "AO",
    name: {
      en : "N Zeto"
    }
  },
  ASA : {
    country: "ER",
    name: {
      en : "Assab"
    }
  },
  ASB : {
    country: "TM",
    popularity: 4,
    name: {
      en : "Ashgabat"
    }
  },
  ASD : {
    country: "BS",
    name: {
      en : "Andros Town"
    }
  },
  ASE : {
    country: "US",
    popularity: 6,
    name: {
      en : "Aspen"
    }
  },
  ASF : {
    country: "RU",
    popularity: 10,
    name: {
      en : "Astrakhan"
    }
  },
  ASH : {
    country: "US",
    name: {
      en : "Nashua"
    }
  },
  ASI : {
    country: "SH",
    name: {
      en : "Georgetown"
    }
  },
  ASJ : {
    country: "JP",
    name: {
      en : "Amami O Shima"
    }
  },
  ASK : {
    country: "CI",
    name: {
      en : "Yamoussouro"
    }
  },
  ASL : {
    country: "US",
    name: {
      en : "Marshall"
    }
  },
  ASM : {
    country: "ER",
    name: {
      en : "Asmara"
    }
  },
  ASO : {
    country: "ET",
    name: {
      en : "Asosa"
    }
  },
  ASP : {
    country: "AU",
    popularity: 6,
    name: {
      en : "Alice Springs"
    }
  },
  ASR : {
    country: "TR",
    popularity: 2,
    name: {
      en : "Kayseri"
    }
  },
  AST : {
    country: "US",
    name: {
      en : "Astoria"
    }
  },
  ASU : {
    country: "PY",
    popularity: 6,
    name: {
      en : "Asuncion"
    }
  },
  ASV : {
    country: "KE",
    name: {
      en : "Amboseli"
    }
  },
  ASW : {
    country: "EG",
    name: {
      en : "Aswan"
    }
  },
  ASX : {
    country: "US",
    name: {
      en : "Ashland"
    }
  },
  ATA : {
    country: "PE",
    name: {
      en : "Anta"
    }
  },
  ATB : {
    country: "SD",
    name: {
      en : "Atbara"
    }
  },
  ATC : {
    country: "BS",
    name: {
      en : "Arthurs Town"
    }
  },
  ATD : {
    country: "SB",
    name: {
      en : "Atoifi"
    }
  },
  ATH : {
    country: "GR",
    popularity: 150,
    name: {
      en : "Athens"
    }
  },
  ATI : {
    country: "UY",
    name: {
      en : "Artigas"
    }
  },
  ATK : {
    country: "US",
    name: {
      en : "Atqasuk"
    }
  },
  ATL : {
    country: "US",
    popularity: 44,
    name: {
      en : "Atlanta"
    }
  },
  ATM : {
    country: "BR",
    name: {
      en : "Altamira"
    }
  },
  ATN : {
    country: "PG",
    name: {
      en : "Namatanai"
    }
  },
  ATO : {
    country: "US",
    name: {
      en : "Athens"
    }
  },
  ATP : {
    country: "PG",
    name: {
      en : "Aitape"
    }
  },
  ATQ : {
    country: "IN",
    name: {
      en : "Amritsar"
    }
  },
  ATR : {
    country: "MR",
    name: {
      en : "Atar"
    }
  },
  ATS : {
    country: "US",
    name: {
      en : "Artesia"
    }
  },
  ATT : {
    country: "US",
    name: {
      en : "Atmautluak"
    }
  },
  ATW : {
    country: "US",
    name: {
      en : "Appleton"
    }
  },
  ATX : {
    country: "KZ",
    name: {
      en : "Atbasar"
    }
  },
  ATY : {
    country: "US",
    name: {
      en : "Watertown"
    }
  },
  ATZ : {
    country: "EG",
    name: {
      en : "Assiut"
    }
  },
  AUA : {
    country: "AW",
    popularity: 4,
    name: {
      en : "Aruba"
    }
  },
  AUC : {
    country: "CO",
    name: {
      en : "Arauca"
    }
  },
  AUF : {
    country: "FR",
    name: {
      en : "Auxerre"
    }
  },
  AUG : {
    country: "US",
    name: {
      en : "Augusta"
    }
  },
  AUH : {
    country: "AE",
    popularity: 24,
    name: {
      en : "Abu Dhabi"
    }
  },
  AUI : {
    country: "PG",
    name: {
      en : "Aua Island"
    }
  },
  AUJ : {
    country: "PG",
    name: {
      en : "Ambunti"
    }
  },
  AUK : {
    country: "US",
    name: {
      en : "Alakanuk"
    }
  },
  AUO : {
    country: "US",
    name: {
      en : "Auburn"
    }
  },
  AUP : {
    country: "PG",
    name: {
      en : "Agaun"
    }
  },
  AUQ : {
    country: "PF",
    name: {
      en : "Atuona"
    }
  },
  AUR : {
    country: "FR",
    name: {
      en : "Aurillac"
    }
  },
  AUS : {
    country: "US",
    name: {
      en : "Austin"
    }
  },
  AUU : {
    country: "AU",
    name: {
      en : "Aurukun Mission"
    }
  },
  AUW : {
    country: "US",
    name: {
      en : "Wausau"
    }
  },
  AUX : {
    country: "BR",
    popularity: 2,
    name: {
      en : "Araguaina"
    }
  },
  AUY : {
    country: "VU",
    name: {
      en : "Aneityum"
    }
  },
  AUZ : {
    country: "US",
    name: {
      en : "Aurora"
    }
  },
  AVA : {
    country: "CN",
    name: {
      en : "Anshun"
    }
  },
  AVI : {
    country: "CU",
    name: {
      en : "Ciego de Avila"
    }
  },
  AVL : {
    country: "US",
    name: {
      en : "Asheville"
    }
  },
  AVN : {
    country: "FR",
    name: {
      en : "Avignon"
    }
  },
  AVP : {
    country: "US",
    name: {
      en : "Scranton"
    }
  },
  AVU : {
    country: "SB",
    name: {
      en : "Avu Avu"
    }
  },
  AVX : {
    country: "US",
    name: {
      en : "Catalina Island"
    }
  },
  AWA : {
    country: "ET",
    name: {
      en : "Awasa"
    }
  },
  AWB : {
    country: "PG",
    name: {
      en : "Awaba"
    }
  },
  AWD : {
    country: "VU",
    name: {
      en : "Aniwa"
    }
  },
  AWK : {
    country: "UM",
    name: {
      en : "Wake Island"
    }
  },
  AWN : {
    country: "AU",
    name: {
      en : "Alton Downs"
    }
  },
  AWZ : {
    country: "IR",
    name: {
      en : "Ahwaz"
    }
  },
  AXA : {
    country: "AI",
    name: {
      en : "Anguilla"
    }
  },
  AXD : {
    country: "GR",
    name: {
      en : "Alexandroupolis"
    }
  },
  AXE : {
    country: "BR",
    name: {
      en : "Xanxere"
    }
  },
  AXK : {
    country: "YE",
    name: {
      en : "Ataq"
    }
  },
  AXL : {
    country: "AU",
    name: {
      en : "Alexandria"
    }
  },
  AXM : {
    country: "CO",
    name: {
      en : "Armenia"
    }
  },
  AXN : {
    country: "US",
    name: {
      en : "Alexandria"
    }
  },
  AXP : {
    country: "BS",
    name: {
      en : "Spring Point"
    }
  },
  AXR : {
    country: "PF",
    name: {
      en : "Arutua"
    }
  },
  AXT : {
    country: "JP",
    name: {
      en : "Akita"
    }
  },
  AXU : {
    country: "ET",
    name: {
      en : "Axum"
    }
  },
  AXV : {
    country: "US",
    name: {
      en : "Wapakoneta"
    }
  },
  AYJ : {
    country: "IN",
    name: {
      en : "Ayodhya"
    }
  },
  AYK : {
    country: "KZ",
    name: {
      en : "AYK"
    }
  },
  AYP : {
    country: "PE",
    name: {
      en : "Ayacucho"
    }
  },
  AYQ : {
    country: "AU",
    name: {
      en : "Ayers Rock"
    }
  },
  AYR : {
    country: "AU",
    name: {
      en : "Ayr"
    }
  },
  AYS : {
    country: "US",
    name: {
      en : "Waycross"
    }
  },
  AYT : {
    country: "TR",
    popularity: 150,
    name: {
      en : "Antalya"
    }
  },
  AZB : {
    country: "PG",
    name: {
      en : "Amazon Bay"
    }
  },
  AZD : {
    country: "IR",
    name: {
      en : "Yazd"
    }
  },
  AZG : {
    country: "MX",
    name: {
      en : "Apatzingan"
    }
  },
  AZN : {
    country: "UZ",
    name: {
      en : "Andizhan"
    }
  },
  AZO : {
    country: "US",
    name: {
      en : "Kalamazoo"
    }
  },
  AZR : {
    country: "DZ",
    name: {
      en : "Adrar"
    }
  },
  AZS : {
    country: "DO",
    name: {
      en : "Samana"
    }
  },
  BAA : {
    country: "PG",
    name: {
      en : "Bialla"
    }
  },
  BAG : {
    country: "PH",
    name: {
      en : "Baguio"
    }
  },
  BAH : {
    country: "BH",
    popularity: 4,
    name: {
      en : "Muharraq"
    }
  },
  BAJ : {
    country: "PG",
    name: {
      en : "Bali"
    }
  },
  BAK : {
    country: "AZ",
    popularity: 2,
    name: {
      en : "Baku"
    }
  },
  BAL : {
    country: "TR",
    name: {
      en : "Batman"
    }
  },
  BAP : {
    country: "PG",
    name: {
      en : "Baibara"
    }
  },
  BAQ : {
    country: "CO",
    name: {
      en : "Barranquilla"
    }
  },
  BAS : {
    country: "SB",
    name: {
      en : "Balalae"
    }
  },
  BAT : {
    country: "BR",
    name: {
      en : "Barretos"
    }
  },
  BAU : {
    country: "BR",
    name: {
      en : "Bauru"
    }
  },
  BAV : {
    country: "CN",
    name: {
      en : "Baotou"
    }
  },
  BAX : {
    country: "RU",
    popularity: 1,
    name: {
      en : "Barnaul"
    }
  },
  BAY : {
    country: "RO",
    name: {
      en : "Baia Mare"
    }
  },
  BAZ : {
    country: "BR",
    name: {
      en : "Barcelos"
    }
  },
  BBA : {
    country: "CL",
    name: {
      en : "Balmaceda"
    }
  },
  BBC : {
    country: "US",
    name: {
      en : "Bay City"
    }
  },
  BBF : {
    country: "US",
    name: {
      en : "Burlington"
    }
  },
  BBG : {
    country: "KI",
    name: {
      en : "Butaritari"
    }
  },
  BBH : {
    country: "DE",
    name: {
      en : "Barth"
    }
  },
  BBI : {
    country: "IN",
    name: {
      en : "Bhubaneswar"
    }
  },
  BBJ : {
    country: "DE",
    name: {
      en : "Bitburg"
    }
  },
  BBK : {
    country: "BW",
    name: {
      en : "Kasane"
    }
  },
  BBN : {
    country: "MY",
    name: {
      en : "Bario"
    }
  },
  BBO : {
    country: "SO",
    name: {
      en : "Berbera"
    }
  },
  BBQ : {
    country: "KN",
    name: {
      en : "Barbuda"
    }
  },
  BBR : {
    country: "GP",
    name: {
      en : "Basse Terre"
    }
  },
  BBS : {
    country: "GB",
    name: {
      en : "BBS"
    }
  },
  BBW : {
    country: "US",
    name: {
      en : "Broken Bow"
    }
  },
  BBX : {
    country: "US",
    name: {
      en : "Blue Bell"
    }
  },
  BCA : {
    country: "CU",
    name: {
      en : "Baracoa"
    }
  },
  BCB : {
    country: "US",
    name: {
      en : "Blacksburg"
    }
  },
  BCD : {
    country: "PH",
    name: {
      en : "Bacolod"
    }
  },
  BCE : {
    country: "US",
    name: {
      en : "Bryce"
    }
  },
  BCH : {
    country: "TL",
    name: {
      en : "Baucau"
    }
  },
  BCI : {
    country: "AU",
    name: {
      en : "Barcaldine"
    }
  },
  BCM : {
    country: "RO",
    name: {
      en : "Bacau"
    }
  },
  BCN : {
    country: "ES",
    popularity: 476,
    name: {
      en : "Barcelona"
    }
  },
  BCT : {
    country: "US",
    name: {
      en : "Boca Raton"
    }
  },
  BCV : {
    country: "  ",
    name: {
      en : "BCV"
    }
  },
  BCX : {
    country: "RU",
    name: {
      en : "Beloreck"
    }
  },
  BDA : {
    country: "BM",
    name: {
      en : "Bermuda"
    }
  },
  BDB : {
    country: "AU",
    name: {
      en : "Bundaberg"
    }
  },
  BDD : {
    country: "AU",
    name: {
      en : "Badu Island"
    }
  },
  BDG : {
    country: "US",
    name: {
      en : "Blanding"
    }
  },
  BDH : {
    country: "IR",
    name: {
      en : "Bandar Lengeh"
    }
  },
  BDJ : {
    country: "ID",
    name: {
      en : "Banjarmasin"
    }
  },
  BDK : {
    country: "CI",
    name: {
      en : "Bondoukou"
    }
  },
  BDO : {
    country: "ID",
    name: {
      en : "Bandung"
    }
  },
  BDP : {
    country: "NP",
    name: {
      en : "Bhadrapur"
    }
  },
  BDQ : {
    country: "IN",
    name: {
      en : "Vadodara"
    }
  },
  BDR : {
    country: "US",
    name: {
      en : "Bridgeport"
    }
  },
  BDS : {
    country: "IT",
    name: {
      en : "Brindisi"
    }
  },
  BDT : {
    country: "CD",
    name: {
      en : "Bado Lite"
    }
  },
  BDU : {
    country: "NO",
    name: {
      en : "Bardufoss"
    }
  },
  BEA : {
    country: "PG",
    name: {
      en : "Bereina"
    }
  },
  BEB : {
    country: "GB",
    name: {
      en : "Benbecula"
    }
  },
  BED : {
    country: "US",
    name: {
      en : "Bedford"
    }
  },
  BEG : {
    country: "RS",
    popularity: 410,
    name: {
      en : "Belgrade"
    }
  },
  BEH : {
    country: "US",
    name: {
      en : "Benton Harbor"
    }
  },
  BEI : {
    country: "ET",
    name: {
      en : "Beica"
    }
  },
  BEJ : {
    country: "ID",
    name: {
      en : "Berau"
    }
  },
  BEK : {
    country: "IN",
    name: {
      en : "Rae Bareli"
    }
  },
  BEL : {
    country: "BR",
    name: {
      en : "Belem"
    }
  },
  BEM : {
    country: "MA",
    name: {
      en : "Beni Mellal"
    }
  },
  BEN : {
    country: "LY",
    name: {
      en : "Benghazi"
    }
  },
  BEQ : {
    country: "GB",
    name: {
      en : "Bury St Edmunds"
    }
  },
  BER : {
    country: "DE",
    popularity: 502,
    name: {
      en : "Berlin"
    }
  },
  BES : {
    country: "FR",
    name: {
      en : "Brest"
    }
  },
  BET : {
    country: "US",
    name: {
      en : "Bethel"
    }
  },
  BEU : {
    country: "AU",
    name: {
      en : "Bedourie"
    }
  },
  BEV : {
    country: "IL",
    name: {
      en : "Beersheba"
    }
  },
  BEW : {
    country: "MZ",
    name: {
      en : "Beira"
    }
  },
  BEY : {
    country: "LB",
    popularity: 40,
    name: {
      en : "Beirut"
    }
  },
  BEZ : {
    country: "KI",
    name: {
      en : "Beru"
    }
  },
  BFD : {
    country: "US",
    name: {
      en : "Bradford"
    }
  },
  BFE : {
    country: "DE",
    name: {
      en : "Bielefeld"
    }
  },
  BFF : {
    country: "US",
    name: {
      en : "Scottsbluff"
    }
  },
  BFG : {
    country: "US",
    name: {
      en : "Bullfrog Basin"
    }
  },
  BFJ : {
    country: "FJ",
    name: {
      en : "Ba"
    }
  },
  BFL : {
    country: "US",
    name: {
      en : "Bakersfield"
    }
  },
  BFN : {
    country: "ZA",
    name: {
      en : "Bloemfontein"
    }
  },
  BFO : {
    country: "ZW",
    name: {
      en : "Buffalo Range"
    }
  },
  BFP : {
    country: "US",
    name: {
      en : "Beaver Falls"
    }
  },
  BFQ : {
    country: "PA",
    name: {
      en : "Bahia Pinas"
    }
  },
  BFR : {
    country: "US",
    name: {
      en : "Bedford"
    }
  },
  BFS : {
    country: "GB",
    popularity: 32,
    name: {
      en : "Belfast"
    }
  },
  BFT : {
    country: "US",
    name: {
      en : "Beaufort"
    }
  },
  BFV : {
    country: "TH",
    name: {
      en : "Buri Ram"
    }
  },
  BFX : {
    country: "CM",
    name: {
      en : "Bafoussam"
    }
  },
  BGA : {
    country: "CO",
    name: {
      en : "Bucaramanga"
    }
  },
  BGC : {
    country: "PT",
    name: {
      en : "Braganca"
    }
  },
  BGF : {
    country: "CF",
    name: {
      en : "Bangui"
    }
  },
  BGG : {
    country: "TR",
    name: {
      en : "Bingol"
    }
  },
  BGI : {
    country: "BB",
    popularity: 10,
    name: {
      en : "Bridgetown"
    }
  },
  BGJ : {
    country: "IS",
    name: {
      en : "Borgarfjordur"
    }
  },
  BGK : {
    country: "BZ",
    name: {
      en : "Big Creek"
    }
  },
  BGM : {
    country: "US",
    name: {
      en : "Binghamton"
    }
  },
  BGN : {
    country: "RU",
    name: {
      en : "Belaya Gora"
    }
  },
  BGO : {
    country: "NO",
    name: {
      en : "Bergen"
    }
  },
  BGR : {
    country: "US",
    name: {
      en : "Bangor"
    }
  },
  BGV : {
    country: "BR",
    name: {
      en : "Bento Goncalves"
    }
  },
  BGW : {
    country: "IQ",
    name: {
      en : "Baghdad"
    }
  },
  BGX : {
    country: "BR",
    name: {
      en : "Bage"
    }
  },
  BGY : {
    country: "IT",
    name: {
      en : "Bergamo"
    }
  },
  BGZ : {
    country: "PT",
    name: {
      en : "Braga"
    }
  },
  BHB : {
    country: "US",
    name: {
      en : "Bar Harbor"
    }
  },
  BHE : {
    country: "NZ",
    name: {
      en : "Blenheim"
    }
  },
  BHG : {
    country: "HN",
    name: {
      en : "Brus Laguna"
    }
  },
  BHH : {
    country: "SA",
    name: {
      en : "Bisha"
    }
  },
  BHI : {
    country: "AR",
    name: {
      en : "Bahia Blanca"
    }
  },
  BHJ : {
    country: "IN",
    name: {
      en : "Bhuj"
    }
  },
  BHK : {
    country: "UZ",
    name: {
      en : "Bukhara"
    }
  },
  BHL : {
    country: "MX",
    name: {
      en : "Bahia De Los Angeles"
    }
  },
  BHM : {
    country: "US",
    name: {
      en : "Birmingham"
    }
  },
  BHN : {
    country: "YE",
    name: {
      en : "Beihan"
    }
  },
  BHO : {
    country: "IN",
    name: {
      en : "Bhopal"
    }
  },
  BHQ : {
    country: "AU",
    name: {
      en : "Broken Hill"
    }
  },
  BHR : {
    country: "NP",
    name: {
      en : "Bharatpur"
    }
  },
  BHS : {
    country: "AU",
    name: {
      en : "Bathurst"
    }
  },
  BHU : {
    country: "IN",
    name: {
      en : "Bhavnagar"
    }
  },
  BHV : {
    country: "PK",
    name: {
      en : "Bahawalpur"
    }
  },
  BHX : {
    country: "GB",
    popularity: 14,
    name: {
      en : "Birmingham"
    }
  },
  BHY : {
    country: "CN",
    name: {
      en : "Beihai"
    }
  },
  BHZ : {
    country: "BR",
    name: {
      en : "Belo Horizonte"
    }
  },
  BIA : {
    country: "FR",
    name: {
      en : "Bastia"
    }
  },
  BIC : {
    country: "US",
    name: {
      en : "Big Creek"
    }
  },
  BID : {
    country: "US",
    name: {
      en : "Block Island"
    }
  },
  BIH : {
    country: "US",
    name: {
      en : "Bishop"
    }
  },
  BII : {
    country: "MH",
    name: {
      en : "Bikini Atoll"
    }
  },
  BIK : {
    country: "ID",
    name: {
      en : "Biak"
    }
  },
  BIL : {
    country: "US",
    name: {
      en : "Billings"
    }
  },
  BIM : {
    country: "BS",
    name: {
      en : "Bimini"
    }
  },
  BIO : {
    country: "ES",
    popularity: 4,
    name: {
      en : "Bilbao"
    }
  },
  BIQ : {
    country: "FR",
    name: {
      en : "Biarritz"
    }
  },
  BIR : {
    country: "NP",
    name: {
      en : "Biratnagar"
    }
  },
  BIS : {
    country: "US",
    name: {
      en : "Bismarck"
    }
  },
  BIU : {
    country: "IS",
    name: {
      en : "Bildudalur"
    }
  },
  BIX : {
    country: "US",
    name: {
      en : "Biloxi"
    }
  },
  BIY : {
    country: "ZA",
    name: {
      en : "Bhisho"
    }
  },
  BJA : {
    country: "DZ",
    name: {
      en : "Bejaia"
    }
  },
  BJB : {
    country: "IR",
    name: {
      en : "Bojnord"
    }
  },
  BJC : {
    country: "US",
    name: {
      en : "Broomfield"
    }
  },
  BJD : {
    country: "IS",
    name: {
      en : "Bakkafjordur"
    }
  },
  BJF : {
    country: "NO",
    name: {
      en : "Batsfjord"
    }
  },
  BJI : {
    country: "US",
    name: {
      en : "Bemidji"
    }
  },
  BJL : {
    country: "GM",
    name: {
      en : "Banjul"
    }
  },
  BJM : {
    country: "BI",
    name: {
      en : "Bujumbura"
    }
  },
  BJP : {
    country: "BR",
    name: {
      en : "Braganca Paulista"
    }
  },
  BJR : {
    country: "ET",
    name: {
      en : "Bahar Dar"
    }
  },
  BJS : {
    country: "CN",
    popularity: 34,
    name: {
      en : "Beijing"
    }
  },
  BJT : {
    country: "LK",
    name: {
      en : "Bentota River"
    }
  },
  BJU : {
    country: "NP",
    name: {
      en : "Bajura"
    }
  },
  BJV : {
    country: "TR",
    popularity: 8,
    name: {
      en : "Bodrum"
    }
  },
  BJW : {
    country: "ID",
    name: {
      en : "Bajawa"
    }
  },
  BJX : {
    country: "MX",
    name: {
      en : "Leon"
    }
  },
  BJZ : {
    country: "ES",
    name: {
      en : "Badajoz"
    }
  },
  BKA : {
    country: "RU",
    name: {
      en : "Baykit"
    }
  },
  BKB : {
    country: "IN",
    name: {
      en : "Bikaner"
    }
  },
  BKC : {
    country: "US",
    name: {
      en : "Buckland"
    }
  },
  BKG : {
    country: "US",
    name: {
      en : "Branson"
    }
  },
  BKI : {
    country: "MY",
    name: {
      en : "Kota Kinabalu"
    }
  },
  BKK : {
    country: "TH",
    popularity: 222,
    name: {
      en : "Bangkok"
    }
  },
  BKM : {
    country: "MY",
    name: {
      en : "Bakalalan"
    }
  },
  BKO : {
    country: "ML",
    name: {
      en : "Bamako"
    }
  },
  BKQ : {
    country: "AU",
    name: {
      en : "Blackall"
    }
  },
  BKS : {
    country: "ID",
    name: {
      en : "Bengkulu"
    }
  },
  BKU : {
    country: "MG",
    name: {
      en : "Betioky"
    }
  },
  BKW : {
    country: "US",
    name: {
      en : "Beckley"
    }
  },
  BKX : {
    country: "US",
    name: {
      en : "Brookings"
    }
  },
  BKY : {
    country: "CD",
    name: {
      en : "Bukavu"
    }
  },
  BKZ : {
    country: "TZ",
    name: {
      en : "Bukoba"
    }
  },
  BLA : {
    country: "VE",
    name: {
      en : "Barcelona"
    }
  },
  BLE : {
    country: "SE",
    name: {
      en : "Borlange"
    }
  },
  BLF : {
    country: "US",
    name: {
      en : "Bluefield"
    }
  },
  BLG : {
    country: "MY",
    name: {
      en : "Belaga"
    }
  },
  BLH : {
    country: "US",
    name: {
      en : "Blythe"
    }
  },
  BLI : {
    country: "US",
    name: {
      en : "Bellingham"
    }
  },
  BLJ : {
    country: "DZ",
    name: {
      en : "Batna"
    }
  },
  BLK : {
    country: "GB",
    name: {
      en : "Blackpool"
    }
  },
  BLL : {
    country: "DK",
    name: {
      en : "Billund"
    }
  },
  BLO : {
    country: "IS",
    name: {
      en : "Blonduos"
    }
  },
  BLQ : {
    country: "IT",
    popularity: 40,
    name: {
      en : "Bologna"
    }
  },
  BLR : {
    country: "IN",
    popularity: 4,
    name: {
      en : "Bangalore"
    }
  },
  BLT : {
    country: "AU",
    name: {
      en : "Blackwater"
    }
  },
  BLV : {
    country: "US",
    name: {
      en : "Belleville"
    }
  },
  BLX : {
    country: "IT",
    name: {
      en : "Belluno"
    }
  },
  BLZ : {
    country: "MW",
    name: {
      en : "Blantyre"
    }
  },
  BMB : {
    country: "CD",
    name: {
      en : "Bumba"
    }
  },
  BMC : {
    country: "US",
    name: {
      en : "Brigham City"
    }
  },
  BMD : {
    country: "MG",
    name: {
      en : "Belo"
    }
  },
  BME : {
    country: "AU",
    name: {
      en : "Broome"
    }
  },
  BMG : {
    country: "US",
    name: {
      en : "Bloomington"
    }
  },
  BMH : {
    country: "PG",
    name: {
      en : "Bomai"
    }
  },
  BMI : {
    country: "US",
    name: {
      en : "Bloomington"
    }
  },
  BMK : {
    country: "DE",
    name: {
      en : "Borkum"
    }
  },
  BMM : {
    country: "GA",
    name: {
      en : "Bitam"
    }
  },
  BMO : {
    country: "MM",
    name: {
      en : "Bhamo"
    }
  },
  BMP : {
    country: "AU",
    name: {
      en : "Brampton Island"
    }
  },
  BMU : {
    country: "ID",
    name: {
      en : "Bima"
    }
  },
  BMV : {
    country: "VN",
    name: {
      en : "Banmethuot"
    }
  },
  BMW : {
    country: "DZ",
    name: {
      en : "Bordj Badji Mokhtar"
    }
  },
  BMY : {
    country: "NC",
    name: {
      en : "Belep Island"
    }
  },
  BNA : {
    country: "US",
    name: {
      en : "Nashville"
    }
  },
  BNB : {
    country: "CD",
    name: {
      en : "Boende"
    }
  },
  BNC : {
    country: "CD",
    name: {
      en : "Beni"
    }
  },
  BND : {
    country: "IR",
    name: {
      en : "Bandar Abbas"
    }
  },
  BNE : {
    country: "AU",
    popularity: 12,
    name: {
      en : "Brisbane"
    }
  },
  BNI : {
    country: "NG",
    name: {
      en : "Benin City"
    }
  },
  BNJ : {
    country: "DE",
    name: {
      en : "Bonn"
    }
  },
  BNK : {
    country: "AU",
    name: {
      en : "Ballina"
    }
  },
  BNM : {
    country: "PG",
    name: {
      en : "Bodinumu"
    }
  },
  BNN : {
    country: "NO",
    name: {
      en : "Bronnoysund"
    }
  },
  BNO : {
    country: "US",
    name: {
      en : "Burns"
    }
  },
  BNP : {
    country: "PK",
    name: {
      en : "Bannu"
    }
  },
  BNS : {
    country: "VE",
    name: {
      en : "Barinas"
    }
  },
  BNT : {
    country: "PG",
    name: {
      en : "Bundi"
    }
  },
  BNU : {
    country: "BR",
    name: {
      en : "Blumenau"
    }
  },
  BNX : {
    country: "BA",
    name: {
      en : "Banja Luka"
    }
  },
  BNY : {
    country: "SB",
    name: {
      en : "Bellona"
    }
  },
  BOA : {
    country: "CD",
    name: {
      en : "Boma"
    }
  },
  BOB : {
    country: "PF",
    popularity: 4,
    name: {
      en : "Bora Bora"
    }
  },
  BOC : {
    country: "PA",
    name: {
      en : "Bocas Del Toro"
    }
  },
  BOD : {
    country: "FR",
    popularity: 10,
    name: {
      en : "Bordeaux"
    }
  },
  BOE : {
    country: "CG",
    name: {
      en : "Boundji"
    }
  },
  BOG : {
    country: "CO",
    popularity: 4,
    name: {
      en : "Bogota"
    }
  },
  BOH : {
    country: "GB",
    name: {
      en : "Bournemouth"
    }
  },
  BOI : {
    country: "US",
    name: {
      en : "Boise"
    }
  },
  BOJ : {
    country: "BG",
    popularity: 8,
    name: {
      en : "Bourgas"
    }
  },
  BOM : {
    country: "IN",
    popularity: 102,
    name: {
      en : "Mumbai"
    }
  },
  BON : {
    country: "BQ",
    name: {
      en : "Bonaire"
    }
  },
  BOO : {
    country: "NO",
    name: {
      en : "Bodo"
    }
  },
  BOR : {
    country: "FR",
    name: {
      en : "Belfort"
    }
  },
  BOS : {
    country: "US",
    popularity: 48,
    name: {
      en : "Boston"
    }
  },
  BOU : {
    country: "FR",
    name: {
      en : "Bourges"
    }
  },
  BOV : {
    country: "PG",
    name: {
      en : "Boang"
    }
  },
  BOW : {
    country: "US",
    name: {
      en : "Bartow"
    }
  },
  BOX : {
    country: "AU",
    name: {
      en : "Borroloola"
    }
  },
  BOY : {
    country: "BF",
    name: {
      en : "Bobo Dioulasso"
    }
  },
  BPB : {
    country: "PG",
    name: {
      en : "Boridi"
    }
  },
  BPC : {
    country: "CM",
    name: {
      en : "Bamenda"
    }
  },
  BPE : {
    country: "CN",
    name: {
      en : "Qinhuangdao Beidaihe"
    }
  },
  BPF : {
    country: "SB",
    name: {
      en : "Batuna"
    }
  },
  BPG : {
    country: "BR",
    name: {
      en : "Barra Do Garcas"
    }
  },
  BPL : {
    country: "CN",
    name: {
      en : "BPL"
    }
  },
  BPN : {
    country: "ID",
    popularity: 112,
    name: {
      en : "Balikpapan"
    }
  },
  BPS : {
    country: "BR",
    name: {
      en : "Porto Seguro"
    }
  },
  BPT : {
    country: "US",
    name: {
      en : "Beaumont"
    }
  },
  BPX : {
    country: "CN",
    name: {
      en : "Bangda"
    }
  },
  BPY : {
    country: "MG",
    name: {
      en : "Besalampy"
    }
  },
  BQB : {
    country: "AU",
    name: {
      en : "Busselton"
    }
  },
  BQG : {
    country: "RU",
    name: {
      en : "Bogorodskoe"
    }
  },
  BQJ : {
    country: "RU",
    popularity: 1,
    name: {
      en : "Batagay"
    }
  },
  BQK : {
    country: "US",
    name: {
      en : "Brunswick"
    }
  },
  BQL : {
    country: "AU",
    name: {
      en : "Boulia"
    }
  },
  BQN : {
    country: "PR",
    name: {
      en : "Aguadilla"
    }
  },
  BQO : {
    country: "CI",
    name: {
      en : "Bouna"
    }
  },
  BQS : {
    country: "RU",
    name: {
      en : "Blagoveshchensk"
    }
  },
  BQT : {
    country: "BY",
    name: {
      en : "Brest"
    }
  },
  BQU : {
    country: "VC",
    name: {
      en : "Port Elizabeth"
    }
  },
  BRA : {
    country: "BR",
    name: {
      en : "Barreiras"
    }
  },
  BRC : {
    country: "AR",
    name: {
      en : "San Carlos Bariloche"
    }
  },
  BRD : {
    country: "US",
    name: {
      en : "Brainerd"
    }
  },
  BRE : {
    country: "DE",
    name: {
      en : "Bremen"
    }
  },
  BRF : {
    country: "GB",
    name: {
      en : "Bradford"
    }
  },
  BRI : {
    country: "IT",
    popularity: 16,
    name: {
      en : "Bari"
    }
  },
  BRK : {
    country: "AU",
    name: {
      en : "Bourke"
    }
  },
  BRL : {
    country: "US",
    name: {
      en : "Burlington"
    }
  },
  BRM : {
    country: "VE",
    name: {
      en : "Barquisimeto"
    }
  },
  BRN : {
    country: "CH",
    popularity: 6,
    name: {
      en : "Berne"
    }
  },
  BRO : {
    country: "US",
    name: {
      en : "Brownsville"
    }
  },
  BRP : {
    country: "PG",
    name: {
      en : "Biaru"
    }
  },
  BRQ : {
    country: "CZ",
    name: {
      en : "Brno"
    }
  },
  BRR : {
    country: "GB",
    name: {
      en : "Barra"
    }
  },
  BRS : {
    country: "GB",
    name: {
      en : "Bristol"
    }
  },
  BRT : {
    country: "AU",
    name: {
      en : "Bathurst Isl"
    }
  },
  BRU : {
    country: "BE",
    popularity: 282,
    name: {
      en : "Brussels"
    }
  },
  BRV : {
    country: "DE",
    name: {
      en : "Bremerhaven"
    }
  },
  BRW : {
    country: "US",
    name: {
      en : "Barrow"
    }
  },
  BRX : {
    country: "DO",
    name: {
      en : "Barahona"
    }
  },
  BSA : {
    country: "SO",
    name: {
      en : "Bossaso"
    }
  },
  BSB : {
    country: "BR",
    popularity: 2,
    name: {
      en : "Brasilia"
    }
  },
  BSC : {
    country: "CO",
    name: {
      en : "Bahia Solano"
    }
  },
  BSD : {
    country: "CN",
    name: {
      en : "Baoshan"
    }
  },
  BSG : {
    country: "GQ",
    name: {
      en : "Bata"
    }
  },
  BSH : {
    country: "GB",
    name: {
      en : "Brighton"
    }
  },
  BSI : {
    country: "US",
    name: {
      en : "Blairsville"
    }
  },
  BSJ : {
    country: "AU",
    name: {
      en : "Bairnsdale"
    }
  },
  BSK : {
    country: "DZ",
    name: {
      en : "Biskra"
    }
  },
  BSL : {
    country: "CH",
    popularity: 2,
    name: {
      en : "Basel"
    }
  },
  BSO : {
    country: "PH",
    name: {
      en : "Basco"
    }
  },
  BSP : {
    country: "PG",
    name: {
      en : "Bensbach"
    }
  },
  BSQ : {
    country: "US",
    name: {
      en : "Bisbee"
    }
  },
  BSR : {
    country: "IQ",
    name: {
      en : "Basra"
    }
  },
  BSS : {
    country: "BR",
    name: {
      en : "Balsas"
    }
  },
  BST : {
    country: "AF",
    name: {
      en : "Bost"
    }
  },
  BSU : {
    country: "CD",
    name: {
      en : "Basankusu"
    }
  },
  BSX : {
    country: "MM",
    name: {
      en : "Bassein"
    }
  },
  BSZ : {
    country: "KG",
    popularity: 10,
    name: {
      en : "Bishkek"
    }
  },
  BTA : {
    country: "CM",
    name: {
      en : "Bertoua"
    }
  },
  BTH : {
    country: "ID",
    name: {
      en : "Batam"
    }
  },
  BTI : {
    country: "US",
    name: {
      en : "Barter Island"
    }
  },
  BTJ : {
    country: "ID",
    name: {
      en : "Banda Aceh"
    }
  },
  BTK : {
    country: "RU",
    popularity: 8,
    name: {
      en : "Bratsk"
    }
  },
  BTL : {
    country: "US",
    name: {
      en : "Battle Creek"
    }
  },
  BTM : {
    country: "US",
    name: {
      en : "Butte"
    }
  },
  BTP : {
    country: "US",
    name: {
      en : "Butler"
    }
  },
  BTR : {
    country: "US",
    name: {
      en : "Baton Rouge"
    }
  },
  BTS : {
    country: "SK",
    popularity: 22,
    name: {
      en : "Bratislava"
    }
  },
  BTT : {
    country: "US",
    name: {
      en : "Bettles"
    }
  },
  BTU : {
    country: "MY",
    name: {
      en : "Bintulu"
    }
  },
  BTV : {
    country: "US",
    name: {
      en : "Burlington"
    }
  },
  BTZ : {
    country: "TR",
    name: {
      en : "Bursa"
    }
  },
  BUA : {
    country: "PG",
    name: {
      en : "Buka Island"
    }
  },
  BUC : {
    country: "AU",
    name: {
      en : "Burketown"
    }
  },
  BUD : {
    country: "HU",
    popularity: 270,
    name: {
      en : "Budapest"
    }
  },
  BUE : {
    country: "AR",
    popularity: 2,
    name: {
      en : "Buenos Aires"
    }
  },
  BUF : {
    country: "US",
    name: {
      en : "Buffalo"
    }
  },
  BUG : {
    country: "AO",
    name: {
      en : "Benguela"
    }
  },
  BUH : {
    country: "RO",
    popularity: 174,
    name: {
      en : "Bucharest"
    }
  },
  BUI : {
    country: "ID",
    name: {
      en : "Bokondini"
    }
  },
  BUK : {
    country: "YE",
    name: {
      en : "Albuq"
    }
  },
  BUL : {
    country: "PG",
    name: {
      en : "Bulolo"
    }
  },
  BUN : {
    country: "CO",
    name: {
      en : "Buenaventura"
    }
  },
  BUO : {
    country: "SO",
    name: {
      en : "Burao"
    }
  },
  BUQ : {
    country: "ZW",
    name: {
      en : "Bulawayo"
    }
  },
  BUR : {
    country: "US",
    name: {
      en : "Burbank"
    }
  },
  BUS : {
    country: "GE",
    popularity: 4,
    name: {
      en : "Batumi"
    }
  },
  BUW : {
    country: "ID",
    name: {
      en : "Baubau"
    }
  },
  BUX : {
    country: "CD",
    name: {
      en : "Bunia"
    }
  },
  BUY : {
    country: "AU",
    name: {
      en : "Bunbury"
    }
  },
  BUZ : {
    country: "IR",
    name: {
      en : "Bushehr"
    }
  },
  BVB : {
    country: "BR",
    name: {
      en : "Boa Vista"
    }
  },
  BVC : {
    country: "CV",
    name: {
      en : "Boa Vista"
    }
  },
  BVE : {
    country: "FR",
    name: {
      en : "Brive La Gaill"
    }
  },
  BVG : {
    country: "NO",
    name: {
      en : "Berlevag"
    }
  },
  BVH : {
    country: "BR",
    name: {
      en : "Vilhena"
    }
  },
  BVI : {
    country: "AU",
    name: {
      en : "Birdsville"
    }
  },
  BVJ : {
    country: "RU",
    popularity: 781,
    name: {
      en : "Bovanenkovo"
    }
  },
  BVO : {
    country: "US",
    name: {
      en : "Bartlesville"
    }
  },
  BVR : {
    country: "CV",
    name: {
      en : "Brava"
    }
  },
  BVV : {
    country: "RU",
    name: {
      en : "BVV"
    }
  },
  BVX : {
    country: "US",
    name: {
      en : "Batesville"
    }
  },
  BWA : {
    country: "NP",
    name: {
      en : "Bhairawa"
    }
  },
  BWC : {
    country: "US",
    name: {
      en : "Brawley"
    }
  },
  BWD : {
    country: "US",
    name: {
      en : "Brownwood"
    }
  },
  BWE : {
    country: "DE",
    name: {
      en : "Braunschweig"
    }
  },
  BWF : {
    country: "GB",
    name: {
      en : "Barrow In Furness"
    }
  },
  BWG : {
    country: "US",
    name: {
      en : "Bowling Green"
    }
  },
  BWI : {
    country: "US",
    popularity: 32,
    name: {
      en : "Baltimore"
    }
  },
  BWK : {
    country: "HR",
    name: {
      en : "Bol"
    }
  },
  BWN : {
    country: "BN",
    name: {
      en : "Bandar Seri Bagawan"
    }
  },
  BWO : {
    country: "RU",
    name: {
      en : "Balakovo"
    }
  },
  BWQ : {
    country: "AU",
    name: {
      en : "Brewarrina"
    }
  },
  BWT : {
    country: "AU",
    name: {
      en : "Burnie"
    }
  },
  BWU : {
    country: "AU",
    name: {
      en : "Bankstown"
    }
  },
  BWW : {
    country: "CU",
    name: {
      en : "BWW"
    }
  },
  BWX : {
    country: "ID",
    name: {
      en : "Banyuwangi Regency"
    }
  },
  BXB : {
    country: "ID",
    name: {
      en : "Babo"
    }
  },
  BXD : {
    country: "ID",
    name: {
      en : "Bade"
    }
  },
  BXE : {
    country: "SN",
    name: {
      en : "Bakel"
    }
  },
  BXG : {
    country: "AU",
    name: {
      en : "Bendigo"
    }
  },
  BXH : {
    country: "KZ",
    name: {
      en : "Balhash"
    }
  },
  BXI : {
    country: "CI",
    name: {
      en : "Boundiali"
    }
  },
  BXJ : {
    country: "KZ",
    name: {
      en : "Burundai"
    }
  },
  BXR : {
    country: "IR",
    name: {
      en : "Bam"
    }
  },
  BXS : {
    country: "US",
    name: {
      en : "Borrego Springs"
    }
  },
  BXU : {
    country: "PH",
    name: {
      en : "Butuan"
    }
  },
  BXV : {
    country: "IS",
    name: {
      en : "Breiddalsvik"
    }
  },
  BXY : {
    country: "KZ",
    popularity: 189,
    name: {
      en : "Baikonur"
    }
  },
  BYA : {
    country: "US",
    name: {
      en : "Boundary"
    }
  },
  BYB : {
    country: "OM",
    name: {
      en : "Dibaa"
    }
  },
  BYC : {
    country: "BO",
    name: {
      en : "Yacuiba"
    }
  },
  BYF : {
    country: "FR",
    name: {
      en : "Albert"
    }
  },
  BYI : {
    country: "US",
    name: {
      en : "Burley"
    }
  },
  BYK : {
    country: "CI",
    name: {
      en : "Bouake"
    }
  },
  BYM : {
    country: "CU",
    name: {
      en : "Bayamo"
    }
  },
  BYN : {
    country: "MN",
    name: {
      en : "Bayankhongor"
    }
  },
  BYO : {
    country: "BR",
    name: {
      en : "Bonito"
    }
  },
  BYR : {
    country: "DK",
    name: {
      en : "Laeso Island"
    }
  },
  BYU : {
    country: "DE",
    name: {
      en : "Bayreuth"
    }
  },
  BYW : {
    country: "US",
    name: {
      en : "Blakely Island"
    }
  },
  BZC : {
    country: "BR",
    name: {
      en : "Buzios"
    }
  },
  BZD : {
    country: "AU",
    name: {
      en : "Balranald"
    }
  },
  BZE : {
    country: "BZ",
    name: {
      en : "Belize City"
    }
  },
  BZG : {
    country: "PL",
    name: {
      en : "Bydgoszcz"
    }
  },
  BZH : {
    country: "ZW",
    name: {
      en : "Bumi Hills"
    }
  },
  BZI : {
    country: "TR",
    name: {
      en : "Balikesir"
    }
  },
  BZK : {
    country: "RU",
    name: {
      en : "Briansk"
    }
  },
  BZL : {
    country: "BD",
    name: {
      en : "Barisal"
    }
  },
  BZM : {
    country: "NL",
    name: {
      en : "Bergen Op Zoom"
    }
  },
  BZN : {
    country: "US",
    name: {
      en : "Bozeman"
    }
  },
  BZO : {
    country: "IT",
    name: {
      en : "Bolzano"
    }
  },
  BZR : {
    country: "FR",
    name: {
      en : "Beziers"
    }
  },
  BZT : {
    country: "US",
    name: {
      en : "Brazoria"
    }
  },
  BZV : {
    country: "CG",
    name: {
      en : "Brazzaville"
    }
  },
  BZY : {
    country: "RU",
    name: {
      en : "Beltsy"
    }
  },
  BZZ : {
    country: "GB",
    name: {
      en : "Brize Norton"
    }
  },
  CAB : {
    country: "AO",
    name: {
      en : "Cabinda"
    }
  },
  CAC : {
    country: "BR",
    name: {
      en : "Cascavel"
    }
  },
  CAD : {
    country: "US",
    name: {
      en : "Cadillac"
    }
  },
  CAE : {
    country: "US",
    name: {
      en : "Columbia"
    }
  },
  CAG : {
    country: "IT",
    popularity: 20,
    name: {
      en : "Cagliari"
    }
  },
  CAH : {
    country: "VN",
    name: {
      en : "Ca Mau"
    }
  },
  CAI : {
    country: "EG",
    popularity: 162,
    name: {
      en : "Cairo"
    }
  },
  CAJ : {
    country: "VE",
    name: {
      en : "Canaima"
    }
  },
  CAK : {
    country: "US",
    name: {
      en : "Akron"
    }
  },
  CAL : {
    country: "GB",
    name: {
      en : "Campbelltown"
    }
  },
  CAM : {
    country: "BO",
    name: {
      en : "Camiri"
    }
  },
  CAN : {
    country: "CN",
    name: {
      en : "Guangzhou"
    }
  },
  CAP : {
    country: "HT",
    name: {
      en : "Cap Haitien"
    }
  },
  CAQ : {
    country: "CO",
    name: {
      en : "Caucasia"
    }
  },
  CAR : {
    country: "US",
    name: {
      en : "Caribou"
    }
  },
  CAS : {
    country: "MA",
    popularity: 44,
    name: {
      en : "Casablanca"
    }
  },
  CAU : {
    country: "BR",
    name: {
      en : "Caruaru"
    }
  },
  CAW : {
    country: "BR",
    name: {
      en : "Campos"
    }
  },
  CAX : {
    country: "GB",
    name: {
      en : "Carlisle"
    }
  },
  CAY : {
    country: "GF",
    name: {
      en : "Cayenne"
    }
  },
  CAZ : {
    country: "AU",
    name: {
      en : "Cobar"
    }
  },
  CBB : {
    country: "BO",
    name: {
      en : "Cochabamba"
    }
  },
  CBE : {
    country: "US",
    name: {
      en : "Cumberland"
    }
  },
  CBF : {
    country: "US",
    name: {
      en : "Council Bluffs"
    }
  },
  CBG : {
    country: "GB",
    name: {
      en : "Cambridge"
    }
  },
  CBH : {
    country: "DZ",
    name: {
      en : "Bechar"
    }
  },
  CBI : {
    country: "AU",
    name: {
      en : "Cape Barren Island TAS"
    }
  },
  CBK : {
    country: "US",
    name: {
      en : "Colby"
    }
  },
  CBL : {
    country: "VE",
    name: {
      en : "Ciudad Bolivar"
    }
  },
  CBN : {
    country: "ID",
    name: {
      en : "Cirebon"
    }
  },
  CBO : {
    country: "PH",
    name: {
      en : "Cotabato"
    }
  },
  CBP : {
    country: "PT",
    name: {
      en : "Coimbra"
    }
  },
  CBQ : {
    country: "NG",
    name: {
      en : "Calabar"
    }
  },
  CBR : {
    country: "AU",
    popularity: 166,
    name: {
      en : "Canberra"
    }
  },
  CBS : {
    country: "VE",
    name: {
      en : "Cabimas"
    }
  },
  CBT : {
    country: "AO",
    name: {
      en : "Catumbela"
    }
  },
  CBU : {
    country: "DE",
    name: {
      en : "Cottbus"
    }
  },
  CBW : {
    country: "BR",
    name: {
      en : "Campo Mourao"
    }
  },
  CBX : {
    country: "AU",
    name: {
      en : "Condobolin"
    }
  },
  CCC : {
    country: "CU",
    name: {
      en : "Cayo Coco"
    }
  },
  CCD : {
    country: "US",
    name: {
      en : "Century City"
    }
  },
  CCE : {
    country: "GP",
    name: {
      en : "Saint Martin"
    }
  },
  CCF : {
    country: "FR",
    name: {
      en : "Carcassonne"
    }
  },
  CCJ : {
    country: "IN",
    name: {
      en : "Kozhikode"
    }
  },
  CCK : {
    country: "CC",
    name: {
      en : "Cocos Islands"
    }
  },
  CCL : {
    country: "AU",
    name: {
      en : "Chinchilla"
    }
  },
  CCM : {
    country: "BR",
    name: {
      en : "Criciuma"
    }
  },
  CCN : {
    country: "AF",
    name: {
      en : "Chakcharan"
    }
  },
  CCP : {
    country: "CL",
    name: {
      en : "Concepcion"
    }
  },
  CCR : {
    country: "US",
    name: {
      en : "Concord"
    }
  },
  CCS : {
    country: "VE",
    popularity: 10,
    name: {
      en : "Caracas"
    }
  },
  CCT : {
    country: "AR",
    name: {
      en : "Colonia Catriel"
    }
  },
  CCU : {
    country: "IN",
    name: {
      en : "Kolkata"
    }
  },
  CCV : {
    country: "VU",
    name: {
      en : "Craig Cove"
    }
  },
  CCW : {
    country: "AU",
    name: {
      en : "Cowell"
    }
  },
  CCX : {
    country: "BR",
    name: {
      en : "Caceres"
    }
  },
  CCZ : {
    country: "BS",
    name: {
      en : "Chub Cay"
    }
  },
  CDA : {
    country: "AU",
    name: {
      en : "Cooinda"
    }
  },
  CDB : {
    country: "US",
    name: {
      en : "Cold Bay"
    }
  },
  CDC : {
    country: "US",
    name: {
      en : "Cedar City"
    }
  },
  CDD : {
    country: "HN",
    name: {
      en : "Cauquira"
    }
  },
  CDH : {
    country: "US",
    name: {
      en : "Camden"
    }
  },
  CDI : {
    country: "BR",
    name: {
      en : "Cachoeiro De Itapemirim"
    }
  },
  CDJ : {
    country: "BR",
    name: {
      en : "Conceicao Do Araguaia"
    }
  },
  CDP : {
    country: "IN",
    name: {
      en : "Cuddapah"
    }
  },
  CDQ : {
    country: "AU",
    name: {
      en : "Croydon"
    }
  },
  CDR : {
    country: "US",
    name: {
      en : "Chadron"
    }
  },
  CDT : {
    country: "ES",
    name: {
      en : "Castellón de la Plana"
    }
  },
  CDV : {
    country: "US",
    name: {
      en : "Cordova"
    }
  },
  CDW : {
    country: "US",
    name: {
      en : "Caldwell"
    }
  },
  CDZ : {
    country: "ES",
    name: {
      en : "Cadiz"
    }
  },
  CEB : {
    country: "PH",
    name: {
      en : "Cebu"
    }
  },
  CEC : {
    country: "US",
    name: {
      en : "Crescent City"
    }
  },
  CED : {
    country: "AU",
    name: {
      en : "Ceduna"
    }
  },
  CEE : {
    country: "RU",
    name: {
      en : "Cherepovets"
    }
  },
  CEG : {
    country: "GB",
    name: {
      en : "Chester"
    }
  },
  CEH : {
    country: "MW",
    name: {
      en : "Chelinda"
    }
  },
  CEI : {
    country: "TH",
    name: {
      en : "Chiang Rai"
    }
  },
  CEJ : {
    country: "UA",
    name: {
      en : "Chernigov"
    }
  },
  CEK : {
    country: "RU",
    popularity: 52,
    name: {
      en : "Chelyabinsk"
    }
  },
  CEM : {
    country: "US",
    name: {
      en : "Central"
    }
  },
  CEN : {
    country: "MX",
    name: {
      en : "Ciudad Obregon"
    }
  },
  CEO : {
    country: "AO",
    name: {
      en : "Waco Kungo"
    }
  },
  CEQ : {
    country: "FR",
    name: {
      en : "Cannes"
    }
  },
  CER : {
    country: "FR",
    name: {
      en : "Cherbourg"
    }
  },
  CES : {
    country: "AU",
    name: {
      en : "Cessnock"
    }
  },
  CET : {
    country: "FR",
    name: {
      en : "Cholet"
    }
  },
  CEU : {
    country: "US",
    name: {
      en : "Clemson"
    }
  },
  CEY : {
    country: "US",
    name: {
      en : "Murray"
    }
  },
  CEZ : {
    country: "US",
    name: {
      en : "Cortez"
    }
  },
  CFA : {
    country: "US",
    name: {
      en : "Coffee Point"
    }
  },
  CFB : {
    country: "BR",
    name: {
      en : "Cabo Frio"
    }
  },
  CFC : {
    country: "BR",
    name: {
      en : "Cacador"
    }
  },
  CFE : {
    country: "FR",
    name: {
      en : "Clermont-Ferrand"
    }
  },
  CFG : {
    country: "CU",
    popularity: 4,
    name: {
      en : "Cienfuegos"
    }
  },
  CFH : {
    country: "AU",
    name: {
      en : "Clifton Hills"
    }
  },
  CFK : {
    country: "DZ",
    name: {
      en : "Chlef"
    }
  },
  CFN : {
    country: "IE",
    name: {
      en : "Donegal"
    }
  },
  CFQ : {
    country: "CA",
    name: {
      en : "Creston"
    }
  },
  CFR : {
    country: "FR",
    name: {
      en : "Caen"
    }
  },
  CFS : {
    country: "AU",
    name: {
      en : "Coffs Harbour"
    }
  },
  CFU : {
    country: "GR",
    popularity: 4,
    name: {
      en : "Kerkyra"
    }
  },
  CGA : {
    country: "US",
    name: {
      en : "Craig"
    }
  },
  CGB : {
    country: "BR",
    name: {
      en : "Cuiaba"
    }
  },
  CGC : {
    country: "PG",
    name: {
      en : "Cape Gloucester"
    }
  },
  CGD : {
    country: "CN",
    name: {
      en : "Changde"
    }
  },
  CGE : {
    country: "US",
    name: {
      en : "Cambridge"
    }
  },
  CGI : {
    country: "US",
    name: {
      en : "Cape Girardeau"
    }
  },
  CGJ : {
    country: "ZM",
    name: {
      en : "Chingola"
    }
  },
  CGM : {
    country: "PH",
    name: {
      en : "Mambajao"
    }
  },
  CGN : {
    country: "DE",
    popularity: 42,
    name: {
      en : "Cologne"
    }
  },
  CGO : {
    country: "CN",
    name: {
      en : "Zhengzhou"
    }
  },
  CGP : {
    country: "BD",
    popularity: 2,
    name: {
      en : "Chittagong"
    }
  },
  CGQ : {
    country: "CN",
    name: {
      en : "Changchun"
    }
  },
  CGR : {
    country: "BR",
    name: {
      en : "Campogrande"
    }
  },
  CGS : {
    country: "US",
    name: {
      en : "College Park"
    }
  },
  CGU : {
    country: "VE",
    name: {
      en : "Ciudad Guayana"
    }
  },
  CGY : {
    country: "PH",
    name: {
      en : "Cagayan"
    }
  },
  CHA : {
    country: "US",
    name: {
      en : "Chattanooga"
    }
  },
  CHC : {
    country: "NZ",
    popularity: 2,
    name: {
      en : "Christchurch"
    }
  },
  CHG : {
    country: "CN",
    name: {
      en : "Chaoyang"
    }
  },
  CHI : {
    country: "US",
    popularity: 69,
    name: {
      en : "Chicago"
    }
  },
  CHM : {
    country: "PE",
    name: {
      en : "Chimbote"
    }
  },
  CHO : {
    country: "US",
    name: {
      en : "Charlottesville"
    }
  },
  CHQ : {
    country: "GR",
    popularity: 4,
    name: {
      en : "Chania"
    }
  },
  CHR : {
    country: "FR",
    name: {
      en : "Chateauroux"
    }
  },
  CHS : {
    country: "US",
    name: {
      en : "Charleston"
    }
  },
  CHT : {
    country: "NZ",
    name: {
      en : "Chatham Island"
    }
  },
  CHU : {
    country: "US",
    name: {
      en : "Chuathbaluk"
    }
  },
  CHV : {
    country: "PT",
    name: {
      en : "Chaves"
    }
  },
  CHX : {
    country: "PA",
    name: {
      en : "Changuinola"
    }
  },
  CHY : {
    country: "SB",
    name: {
      en : "Choiseul Bay"
    }
  },
  CIC : {
    country: "US",
    name: {
      en : "Chico"
    }
  },
  CID : {
    country: "US",
    name: {
      en : "Cedar Rapids"
    }
  },
  CIF : {
    country: "CN",
    name: {
      en : "Chifeng"
    }
  },
  CIG : {
    country: "US",
    name: {
      en : "Craig"
    }
  },
  CIH : {
    country: "CN",
    name: {
      en : "Changzhi"
    }
  },
  CIJ : {
    country: "BO",
    name: {
      en : "Cobija"
    }
  },
  CIK : {
    country: "US",
    name: {
      en : "Chalkyitsik"
    }
  },
  CIL : {
    country: "US",
    name: {
      en : "Council"
    }
  },
  CIO : {
    country: "PY",
    name: {
      en : "Concepcion"
    }
  },
  CIP : {
    country: "ZM",
    name: {
      en : "Chipata"
    }
  },
  CIS : {
    country: "KI",
    name: {
      en : "Canton Island"
    }
  },
  CIT : {
    country: "KZ",
    name: {
      en : "Shimkent"
    }
  },
  CIW : {
    country: "VC",
    name: {
      en : "Canouan Island"
    }
  },
  CIX : {
    country: "PE",
    popularity: 10,
    name: {
      en : "Chiclayo"
    }
  },
  CIY : {
    country: "IT",
    name: {
      en : "Comiso"
    }
  },
  CIZ : {
    country: "BR",
    name: {
      en : "Coari"
    }
  },
  CJA : {
    country: "PE",
    name: {
      en : "Cajamarca"
    }
  },
  CJB : {
    country: "IN",
    name: {
      en : "Coimbatore"
    }
  },
  CJC : {
    country: "CL",
    name: {
      en : "Calama"
    }
  },
  CJI : {
    country: "ES",
    name: {
      en : "Ciudad Real"
    }
  },
  CJJ : {
    country: "KR",
    name: {
      en : "Cheongju"
    }
  },
  CJL : {
    country: "PK",
    name: {
      en : "Chitral"
    }
  },
  CJM : {
    country: "TH",
    name: {
      en : "Chumphon"
    }
  },
  CJN : {
    country: "US",
    name: {
      en : "El Cajon"
    }
  },
  CJS : {
    country: "MX",
    name: {
      en : "Ciudad Juarez"
    }
  },
  CJU : {
    country: "KR",
    name: {
      en : "Jeju City"
    }
  },
  CKB : {
    country: "US",
    name: {
      en : "Clarksburg"
    }
  },
  CKC : {
    country: "UA",
    name: {
      en : "Cherkassy"
    }
  },
  CKD : {
    country: "US",
    name: {
      en : "Crooked Creek"
    }
  },
  CKG : {
    country: "CN",
    name: {
      en : "Chongqing"
    }
  },
  CKH : {
    country: "RU",
    name: {
      en : "Chokurdah"
    }
  },
  CKM : {
    country: "US",
    name: {
      en : "Clarksdale"
    }
  },
  CKS : {
    country: "BR",
    name: {
      en : "Carajas"
    }
  },
  CKV : {
    country: "US",
    name: {
      en : "Clarksville"
    }
  },
  CKX : {
    country: "US",
    name: {
      en : "Chicken"
    }
  },
  CKY : {
    country: "GN",
    name: {
      en : "Conakry"
    }
  },
  CKZ : {
    country: "TR",
    name: {
      en : "Canakkale"
    }
  },
  CLA : {
    country: "BD",
    name: {
      en : "Comilla"
    }
  },
  CLC : {
    country: "US",
    name: {
      en : "Clear Lake City"
    }
  },
  CLD : {
    country: "US",
    name: {
      en : "Carlsbad"
    }
  },
  CLE : {
    country: "US",
    popularity: 32,
    name: {
      en : "Cleveland"
    }
  },
  CLJ : {
    country: "RO",
    popularity: 462,
    name: {
      en : "Cluj"
    }
  },
  CLL : {
    country: "US",
    name: {
      en : "College Station"
    }
  },
  CLM : {
    country: "US",
    name: {
      en : "Port Angeles"
    }
  },
  CLO : {
    country: "CO",
    name: {
      en : "Cali"
    }
  },
  CLP : {
    country: "US",
    name: {
      en : "Clarks Point"
    }
  },
  CLQ : {
    country: "MX",
    name: {
      en : "Colima"
    }
  },
  CLT : {
    country: "US",
    popularity: 32,
    name: {
      en : "Charlotte"
    }
  },
  CLU : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  CLV : {
    country: "BR",
    name: {
      en : "Caldas Novas"
    }
  },
  CLW : {
    country: "US",
    name: {
      en : "Clearwater"
    }
  },
  CLY : {
    country: "FR",
    name: {
      en : "Calvi"
    }
  },
  CLZ : {
    country: "VE",
    name: {
      en : "Calabozo"
    }
  },
  CMA : {
    country: "AU",
    name: {
      en : "Cunnamulla"
    }
  },
  CMB : {
    country: "LK",
    popularity: 34,
    name: {
      en : "Colombo"
    }
  },
  CMD : {
    country: "AU",
    name: {
      en : "Cootamundra"
    }
  },
  CME : {
    country: "MX",
    name: {
      en : "Ciudad Del Carmen"
    }
  },
  CMF : {
    country: "FR",
    name: {
      en : "Chambery"
    }
  },
  CMG : {
    country: "BR",
    name: {
      en : "Corumba"
    }
  },
  CMH : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  CMI : {
    country: "US",
    popularity: 2,
    name: {
      en : "Champaign"
    }
  },
  CMN : {
    country: "MA",
    popularity: 44,
    name: {
      en : "Casablanca"
    }
  },
  CMP : {
    country: "BR",
    name: {
      en : "Campo Alegre"
    }
  },
  CMQ : {
    country: "AU",
    name: {
      en : "Clermont"
    }
  },
  CMR : {
    country: "FR",
    name: {
      en : "Colmar"
    }
  },
  CMU : {
    country: "PG",
    name: {
      en : "Kundiawa"
    }
  },
  CMV : {
    country: "NZ",
    name: {
      en : "Coromandel"
    }
  },
  CMW : {
    country: "CU",
    name: {
      en : "Camaguey"
    }
  },
  CMX : {
    country: "US",
    name: {
      en : "Houghton"
    }
  },
  CMY : {
    country: "US",
    name: {
      en : "Sparta"
    }
  },
  CNB : {
    country: "AU",
    name: {
      en : "Coonamble"
    }
  },
  CNC : {
    country: "AU",
    name: {
      en : "Coconut Island"
    }
  },
  CND : {
    country: "RO",
    name: {
      en : "Constanta"
    }
  },
  CNG : {
    country: "FR",
    name: {
      en : "Cognac"
    }
  },
  CNJ : {
    country: "AU",
    name: {
      en : "Cloncurry"
    }
  },
  CNM : {
    country: "US",
    popularity: 2,
    name: {
      en : "Carlsbad"
    }
  },
  CNN : {
    country: "IN",
    name: {
      en : "Kannur International Airport"
    }
  },
  CNP : {
    country: "GL",
    name: {
      en : "Neerlerit Inaat"
    }
  },
  CNQ : {
    country: "AR",
    name: {
      en : "Corrientes"
    }
  },
  CNS : {
    country: "AU",
    name: {
      en : "Cairns"
    }
  },
  CNX : {
    country: "TH",
    name: {
      en : "Chiang Mai"
    }
  },
  CNY : {
    country: "US",
    name: {
      en : "Moab"
    }
  },
  COC : {
    country: "AR",
    name: {
      en : "Concordia"
    }
  },
  COD : {
    country: "US",
    name: {
      en : "Cody"
    }
  },
  COE : {
    country: "US",
    name: {
      en : "Coeur d'Alene"
    }
  },
  COF : {
    country: "US",
    name: {
      en : "Cocoa"
    }
  },
  COG : {
    country: "CO",
    name: {
      en : "Condoto"
    }
  },
  COH : {
    country: "IN",
    name: {
      en : "Cooch Behar"
    }
  },
  COI : {
    country: "US",
    name: {
      en : "Cocoa Metro Area"
    }
  },
  COJ : {
    country: "AU",
    name: {
      en : "Coonabarabrn"
    }
  },
  COK : {
    country: "IN",
    name: {
      en : "Kochi"
    }
  },
  COL : {
    country: "GB",
    name: {
      en : "Coll Island"
    }
  },
  CON : {
    country: "US",
    name: {
      en : "Concord"
    }
  },
  COO : {
    country: "BJ",
    name: {
      en : "Cotonou"
    }
  },
  COQ : {
    country: "MN",
    name: {
      en : "Choibalsan"
    }
  },
  COR : {
    country: "AR",
    name: {
      en : "Cordoba"
    }
  },
  COS : {
    country: "US",
    name: {
      en : "Colorado Springs"
    }
  },
  COU : {
    country: "US",
    name: {
      en : "Columbia"
    }
  },
  COV : {
    country: "PT",
    name: {
      en : "Covilha"
    }
  },
  COW : {
    country: "CL",
    name: {
      en : "Coquimbo"
    }
  },
  CPA : {
    country: "LR",
    name: {
      en : "Cape Palmas"
    }
  },
  CPB : {
    country: "CO",
    name: {
      en : "Capurgana"
    }
  },
  CPC : {
    country: "AR",
    name: {
      en : "San Martin de los Andes"
    }
  },
  CPD : {
    country: "AU",
    name: {
      en : "Coober Pedy"
    }
  },
  CPE : {
    country: "MX",
    name: {
      en : "Campeche"
    }
  },
  CPH : {
    country: "DK",
    popularity: 228,
    name: {
      en : "Copenhagen"
    }
  },
  CPN : {
    country: "PG",
    name: {
      en : "Cape Rodney"
    }
  },
  CPO : {
    country: "CL",
    popularity: 6,
    name: {
      en : "Copiapo"
    }
  },
  CPQ : {
    country: "BR",
    name: {
      en : "Campinas"
    }
  },
  CPR : {
    country: "US",
    name: {
      en : "Casper"
    }
  },
  CPT : {
    country: "ZA",
    popularity: 4,
    name: {
      en : "Cape Town"
    }
  },
  CPV : {
    country: "BR",
    name: {
      en : "Campina Grande"
    }
  },
  CPX : {
    country: "US",
    name: {
      en : "Culebra"
    }
  },
  CQD : {
    country: "IR",
    name: {
      en : "Shahre Kord"
    }
  },
  CQF : {
    country: "FR",
    name: {
      en : "Calais"
    }
  },
  CQM : {
    country: "ES",
    name: {
      en : "Ciudad Real"
    }
  },
  CRA : {
    country: "RO",
    name: {
      en : "Craiova"
    }
  },
  CRC : {
    country: "CO",
    name: {
      en : "Cartago"
    }
  },
  CRD : {
    country: "AR",
    name: {
      en : "Comodoro Rivadavia"
    }
  },
  CRI : {
    country: "BS",
    name: {
      en : "Crooked Island"
    }
  },
  CRK : {
    country: "PH",
    name: {
      en : "Luzon Island"
    }
  },
  CRM : {
    country: "PH",
    name: {
      en : "Catarman"
    }
  },
  CRP : {
    country: "US",
    name: {
      en : "Corpus Christi"
    }
  },
  CRU : {
    country: "GD",
    name: {
      en : "Carriacou"
    }
  },
  CRV : {
    country: "IT",
    name: {
      en : "Crotone"
    }
  },
  CRW : {
    country: "US",
    name: {
      en : "Charleston"
    }
  },
  CRX : {
    country: "US",
    name: {
      en : "Corinth"
    }
  },
  CRZ : {
    country: "TM",
    name: {
      en : "Turkmenabad"
    }
  },
  CSA : {
    country: "GB",
    name: {
      en : "Colonsay Island"
    }
  },
  CSB : {
    country: "RO",
    name: {
      en : "Caransebes"
    }
  },
  CSE : {
    country: "US",
    name: {
      en : "Crested Butte"
    }
  },
  CSF : {
    country: "FR",
    name: {
      en : "Creil"
    }
  },
  CSG : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  CSH : {
    country: "RU",
    name: {
      en : "Solovetsky"
    }
  },
  CSI : {
    country: "AU",
    name: {
      en : "Casino"
    }
  },
  CSK : {
    country: "SN",
    name: {
      en : "Cap Skirring"
    }
  },
  CSL : {
    country: "US",
    name: {
      en : "San Luis Obispo"
    }
  },
  CSM : {
    country: "US",
    name: {
      en : "Clinton"
    }
  },
  CSN : {
    country: "US",
    name: {
      en : "Carson City"
    }
  },
  CSS : {
    country: "BR",
    name: {
      en : "Cassilandia"
    }
  },
  CST : {
    country: "FJ",
    name: {
      en : "Castaway"
    }
  },
  CSU : {
    country: "BR",
    name: {
      en : "Santa Cruz Do Sul"
    }
  },
  CSV : {
    country: "US",
    name: {
      en : "Crossville"
    }
  },
  CSX : {
    country: "CN",
    name: {
      en : "Changsha"
    }
  },
  CSY : {
    country: "RU",
    name: {
      en : "Cheboksary"
    }
  },
  CTA : {
    country: "IT",
    popularity: 4,
    name: {
      en : "Catania"
    }
  },
  CTC : {
    country: "AR",
    name: {
      en : "Catamarca"
    }
  },
  CTD : {
    country: "PA",
    name: {
      en : "Chitre"
    }
  },
  CTG : {
    country: "CO",
    name: {
      en : "Cartagena"
    }
  },
  CTL : {
    country: "AU",
    name: {
      en : "Charleville"
    }
  },
  CTM : {
    country: "MX",
    name: {
      en : "Chetumal"
    }
  },
  CTN : {
    country: "AU",
    name: {
      en : "Cooktown"
    }
  },
  CTU : {
    country: "CN",
    name: {
      en : "Chengdu"
    }
  },
  CTW : {
    country: "US",
    name: {
      en : "Cottonwood"
    }
  },
  CUA : {
    country: "MX",
    name: {
      en : "Ciudad Constitucion"
    }
  },
  CUC : {
    country: "CO",
    name: {
      en : "Cucuta"
    }
  },
  CUD : {
    country: "AU",
    name: {
      en : "Caloundra"
    }
  },
  CUE : {
    country: "EC",
    popularity: 4,
    name: {
      en : "Cuenca"
    }
  },
  CUF : {
    country: "IT",
    name: {
      en : "Cuneo"
    }
  },
  CUG : {
    country: "AU",
    name: {
      en : "Cudal"
    }
  },
  CUK : {
    country: "BZ",
    name: {
      en : "Caye Caulker"
    }
  },
  CUL : {
    country: "MX",
    name: {
      en : "Culiacan"
    }
  },
  CUM : {
    country: "VE",
    name: {
      en : "Cumana"
    }
  },
  CUN : {
    country: "MX",
    popularity: 64,
    name: {
      en : "Cancun"
    }
  },
  CUP : {
    country: "VE",
    name: {
      en : "Carupano"
    }
  },
  CUQ : {
    country: "AU",
    name: {
      en : "Coen"
    }
  },
  CUR : {
    country: "CW",
    name: {
      en : "Curacao"
    }
  },
  CUS : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  CUT : {
    country: "AR",
    name: {
      en : "Cutral Co"
    }
  },
  CUU : {
    country: "MX",
    name: {
      en : "Chihuahua"
    }
  },
  CUZ : {
    country: "PE",
    name: {
      en : "Cuzco"
    }
  },
  CVF : {
    country: "FR",
    name: {
      en : "Courchevel"
    }
  },
  CVG : {
    country: "US",
    popularity: 32,
    name: {
      en : "Cincinnati"
    }
  },
  CVJ : {
    country: "MX",
    name: {
      en : "Cuernavaca"
    }
  },
  CVL : {
    country: "PG",
    name: {
      en : "Cape Vogel"
    }
  },
  CVM : {
    country: "MX",
    name: {
      en : "Ciudad Victoria"
    }
  },
  CVN : {
    country: "US",
    name: {
      en : "Clovis"
    }
  },
  CVO : {
    country: "US",
    name: {
      en : "Corvallis"
    }
  },
  CVQ : {
    country: "AU",
    name: {
      en : "Carnarvon"
    }
  },
  CVT : {
    country: "GB",
    name: {
      en : "Coventry"
    }
  },
  CVU : {
    country: "PT",
    name: {
      en : "Corvo Island"
    }
  },
  CWB : {
    country: "BR",
    name: {
      en : "Curitiba"
    }
  },
  CWC : {
    country: "UA",
    name: {
      en : "Chernovtsy"
    }
  },
  CWG : {
    country: "US",
    name: {
      en : "Callaway Gardens"
    }
  },
  CWI : {
    country: "US",
    name: {
      en : "Clinton"
    }
  },
  CWL : {
    country: "GB",
    name: {
      en : "Cardiff"
    }
  },
  CWR : {
    country: "AU",
    name: {
      en : "Cowarie"
    }
  },
  CWT : {
    country: "AU",
    name: {
      en : "Cowra"
    }
  },
  CWW : {
    country: "AU",
    name: {
      en : "Corowa"
    }
  },
  CXB : {
    country: "BD",
    name: {
      en : "Coxs Bazaar"
    }
  },
  CXI : {
    country: "KI",
    name: {
      en : "Christmas Island"
    }
  },
  CXJ : {
    country: "BR",
    name: {
      en : "Caxias Do Sul"
    }
  },
  CXL : {
    country: "US",
    name: {
      en : "Calexico"
    }
  },
  CXO : {
    country: "US",
    name: {
      en : "Conroe"
    }
  },
  CXP : {
    country: "ID",
    name: {
      en : "Cilacap"
    }
  },
  CXR : {
    country: "VN",
    name: {
      en : "Cam Ranh"
    }
  },
  CXT : {
    country: "AU",
    name: {
      en : "Charters Towers"
    }
  },
  CXY : {
    country: "BS",
    name: {
      en : "Cat Cay"
    }
  },
  CYB : {
    country: "KY",
    name: {
      en : "Cayman Brac"
    }
  },
  CYC : {
    country: "BZ",
    name: {
      en : "Caye Chapel"
    }
  },
  CYF : {
    country: "US",
    name: {
      en : "Chefornak"
    }
  },
  CYI : {
    country: "TW",
    name: {
      en : "Chiayi"
    }
  },
  CYO : {
    country: "CU",
    name: {
      en : "Cayo Largo del Sur"
    }
  },
  CYP : {
    country: "PH",
    name: {
      en : "Calbayog"
    }
  },
  CYR : {
    country: "UY",
    name: {
      en : "Colonia"
    }
  },
  CYS : {
    country: "US",
    popularity: 16,
    name: {
      en : "Cheyenne"
    }
  },
  CYX : {
    country: "RU",
    name: {
      en : "Cherskiy"
    }
  },
  CYZ : {
    country: "PH",
    name: {
      en : "Cauayan"
    }
  },
  CZA : {
    country: "MX",
    name: {
      en : "Chichen Itza"
    }
  },
  CZE : {
    country: "VE",
    name: {
      en : "Coro"
    }
  },
  CZF : {
    country: "US",
    name: {
      en : "Cape Romanzof"
    }
  },
  CZH : {
    country: "BZ",
    name: {
      en : "Corozal"
    }
  },
  CZL : {
    country: "DZ",
    name: {
      en : "Constantine"
    }
  },
  CZM : {
    country: "MX",
    name: {
      en : "Cozumel"
    }
  },
  CZN : {
    country: "US",
    name: {
      en : "Chisana"
    }
  },
  CZR : {
    country: "RU",
    name: {
      en : "Chara"
    }
  },
  CZS : {
    country: "BR",
    name: {
      en : "Cruzeiro Do Sul"
    }
  },
  CZU : {
    country: "CO",
    name: {
      en : "Corozal"
    }
  },
  CZW : {
    country: "PL",
    name: {
      en : "Czestochowa"
    }
  },
  CZX : {
    country: "CN",
    name: {
      en : "Changzhou"
    }
  },
  DAB : {
    country: "US",
    name: {
      en : "Daytona Beach"
    }
  },
  DAC : {
    country: "BD",
    popularity: 6,
    name: {
      en : "Dhaka"
    }
  },
  DAD : {
    country: "VN",
    popularity: 2,
    name: {
      en : "Da Nang"
    }
  },
  DAG : {
    country: "US",
    name: {
      en : "Daggett"
    }
  },
  DAK : {
    country: "EG",
    name: {
      en : "Dakhla Oasis"
    }
  },
  DAM : {
    country: "SY",
    popularity: 4,
    name: {
      en : "Damascus"
    }
  },
  DAN : {
    country: "US",
    name: {
      en : "Danville"
    }
  },
  DAR : {
    country: "TZ",
    name: {
      en : "Dar Es Salaam"
    }
  },
  DAT : {
    country: "CN",
    name: {
      en : "Datong"
    }
  },
  DAU : {
    country: "PG",
    name: {
      en : "Daru"
    }
  },
  DAV : {
    country: "PA",
    popularity: 2,
    name: {
      en : "David"
    }
  },
  DAX : {
    country: "CN",
    name: {
      en : "Daxian"
    }
  },
  DAY : {
    country: "US",
    name: {
      en : "Dayton"
    }
  },
  DBA : {
    country: "PK",
    name: {
      en : "Dalbandin"
    }
  },
  DBB : {
    country: "EG",
    name: {
      en : "El Dabaa"
    }
  },
  DBM : {
    country: "ET",
    name: {
      en : "Debremarcos"
    }
  },
  DBN : {
    country: "US",
    name: {
      en : "Dublin"
    }
  },
  DBO : {
    country: "AU",
    name: {
      en : "Dubbo"
    }
  },
  DBQ : {
    country: "US",
    name: {
      en : "Dubuque"
    }
  },
  DBS : {
    country: "SE",
    name: {
      en : "DBS"
    }
  },
  DBV : {
    country: "HR",
    popularity: 8,
    name: {
      en : "Dubrovnik"
    }
  },
  DBY : {
    country: "AU",
    name: {
      en : "Dalby"
    }
  },
  DCF : {
    country: "DM",
    popularity: 1,
    name: {
      en : "Roseau"
    }
  },
  DCG : {
    name: {
      en : "DCG"
    }
  },
  DCM : {
    country: "FR",
    name: {
      en : "Castres"
    }
  },
  DCN : {
    country: "AU",
    name: {
      en : "Derby"
    }
  },
  DCU : {
    country: "US",
    name: {
      en : "Decatur"
    }
  },
  DCY : {
    country: "CN",
    name: {
      en : "Daocheng County"
    }
  },
  DDC : {
    country: "US",
    name: {
      en : "Dodge City"
    }
  },
  DDG : {
    country: "CN",
    name: {
      en : "Dandong"
    }
  },
  DDI : {
    country: "AU",
    name: {
      en : "Daydream Island"
    }
  },
  DDM : {
    country: "PG",
    name: {
      en : "Dodoima"
    }
  },
  DDN : {
    country: "AU",
    name: {
      en : "Delta Downs"
    }
  },
  DDP : {
    country: "US",
    name: {
      en : "Dorado"
    }
  },
  DEA : {
    country: "PK",
    name: {
      en : "Dera Ghazi Khan"
    }
  },
  DEB : {
    country: "HU",
    name: {
      en : "Debrecen"
    }
  },
  DEC : {
    country: "US",
    name: {
      en : "Decatur"
    }
  },
  DED : {
    country: "IN",
    name: {
      en : "Dehra Dun"
    }
  },
  DEE : {
    country: "RU",
    name: {
      en : "DEE"
    }
  },
  DEF : {
    country: "IR",
    name: {
      en : "Dezful"
    }
  },
  DEH : {
    country: "US",
    name: {
      en : "Decorah"
    }
  },
  DEL : {
    country: "IN",
    popularity: 120,
    name: {
      en : "Delhi"
    }
  },
  DEM : {
    country: "ET",
    name: {
      en : "Dembidollo"
    }
  },
  DEN : {
    country: "US",
    popularity: 14,
    name: {
      en : "Denver"
    }
  },
  DER : {
    country: "PG",
    name: {
      en : "Derim"
    }
  },
  DEZ : {
    country: "SY",
    name: {
      en : "Deirezzor"
    }
  },
  DFI : {
    country: "US",
    name: {
      en : "Defiance"
    }
  },
  DFW : {
    country: "US",
    popularity: 10,
    name: {
      en : "Dallas"
    }
  },
  DGA : {
    country: "BZ",
    name: {
      en : "Dangriga"
    }
  },
  DGD : {
    country: "AU",
    name: {
      en : "Dalgaranga"
    }
  },
  DGE : {
    country: "AU",
    name: {
      en : "Mudgee"
    }
  },
  DGK : {
    country: "MZ",
    name: {
      en : "Dugong"
    }
  },
  DGM : {
    country: "CN",
    name: {
      en : "Dongguan"
    }
  },
  DGO : {
    country: "MX",
    name: {
      en : "Durango"
    }
  },
  DGP : {
    country: "LV",
    name: {
      en : "Daugavpils"
    }
  },
  DGT : {
    country: "PH",
    name: {
      en : "Dumaguete"
    }
  },
  DHA : {
    country: "SA",
    name: {
      en : "Dhahran"
    }
  },
  DHB : {
    country: "US",
    name: {
      en : "DHB"
    }
  },
  DHD : {
    country: "AU",
    name: {
      en : "Durham Downs"
    }
  },
  DHI : {
    country: "NP",
    name: {
      en : "Dhangarhi"
    }
  },
  DHM : {
    country: "IN",
    name: {
      en : "Dharamsala"
    }
  },
  DHN : {
    country: "US",
    popularity: 4,
    name: {
      en : "Dothan"
    }
  },
  DHR : {
    country: "NL",
    name: {
      en : "Den Helder"
    }
  },
  DIB : {
    country: "IN",
    name: {
      en : "Dibrugarh"
    }
  },
  DIE : {
    country: "MG",
    name: {
      en : "Diegosuarez"
    }
  },
  DIG : {
    country: "CN",
    name: {
      en : "Diqing"
    }
  },
  DIJ : {
    country: "FR",
    name: {
      en : "Dijon"
    }
  },
  DIK : {
    country: "US",
    name: {
      en : "Dickinson"
    }
  },
  DIL : {
    country: "TL",
    name: {
      en : "Dili"
    }
  },
  DIN : {
    country: "VN",
    name: {
      en : "Dien Bien Phu"
    }
  },
  DIO : {
    country: "US",
    name: {
      en : "Diomede Island"
    }
  },
  DIQ : {
    country: "BR",
    name: {
      en : "Divinopolis"
    }
  },
  DIR : {
    country: "ET",
    name: {
      en : "Dire Dawa"
    }
  },
  DIS : {
    country: "CG",
    name: {
      en : "Loubomo"
    }
  },
  DIU : {
    country: "IN",
    name: {
      en : "Diu In"
    }
  },
  DIW : {
    country: "LK",
    name: {
      en : "Dikwella"
    }
  },
  DIY : {
    country: "TR",
    name: {
      en : "Diyarbakir"
    }
  },
  DJB : {
    country: "ID",
    name: {
      en : "Jambi"
    }
  },
  DJE : {
    country: "TN",
    name: {
      en : "Djerba"
    }
  },
  DJG : {
    country: "DZ",
    name: {
      en : "Djanet"
    }
  },
  DJJ : {
    country: "ID",
    name: {
      en : "Jayapura"
    }
  },
  DJO : {
    country: "CI",
    name: {
      en : "Daloa"
    }
  },
  DKA : {
    country: "NG",
    name: {
      en : "DKA"
    }
  },
  DKI : {
    country: "AU",
    name: {
      en : "Dunk Island"
    }
  },
  DKK : {
    country: "US",
    name: {
      en : "Dunkirk"
    }
  },
  DKR : {
    country: "SN",
    name: {
      en : "Dakar"
    }
  },
  DKS : {
    country: "RU",
    name: {
      en : "Dikson"
    }
  },
  DLA : {
    country: "CM",
    name: {
      en : "Douala"
    }
  },
  DLC : {
    country: "CN",
    name: {
      en : "Dalian"
    }
  },
  DLD : {
    country: "NO",
    name: {
      en : "Geilo"
    }
  },
  DLE : {
    country: "FR",
    name: {
      en : "Dole"
    }
  },
  DLG : {
    country: "US",
    name: {
      en : "Dillingham"
    }
  },
  DLH : {
    country: "US",
    name: {
      en : "Duluth"
    }
  },
  DLI : {
    country: "VN",
    name: {
      en : "Dalat"
    }
  },
  DLL : {
    country: "US",
    name: {
      en : "Dillon"
    }
  },
  DLM : {
    country: "TR",
    popularity: 10,
    name: {
      en : "Dalaman"
    }
  },
  DLP : {
    country: "FR",
    name: {
      en : "Disneyland Paris"
    }
  },
  DLS : {
    country: "US",
    name: {
      en : "The Dalles"
    }
  },
  DLU : {
    country: "CN",
    name: {
      en : "Dali City"
    }
  },
  DLY : {
    country: "VU",
    name: {
      en : "Dillons Bay"
    }
  },
  DLZ : {
    country: "MN",
    name: {
      en : "Dalanzadgad"
    }
  },
  DMB : {
    country: "KZ",
    name: {
      en : "Taraz"
    }
  },
  DMD : {
    country: "AU",
    name: {
      en : "Doomadgee"
    }
  },
  DMM : {
    country: "SA",
    popularity: 4,
    name: {
      en : "Dammam"
    }
  },
  DMO : {
    country: "US",
    name: {
      en : "Sedalia"
    }
  },
  DMS : {
    country: "SA",
    name: {
      en : "DMS"
    }
  },
  DMU : {
    country: "IN",
    name: {
      en : "Dimapur"
    }
  },
  DNB : {
    country: "AU",
    name: {
      en : "Dunbar"
    }
  },
  DND : {
    country: "GB",
    name: {
      en : "Dundee"
    }
  },
  DNH : {
    country: "CN",
    name: {
      en : "Dunhuang"
    }
  },
  DNK : {
    country: "UA",
    popularity: 4,
    name: {
      en : "Dnepropetrovsk"
    }
  },
  DNM : {
    country: "AU",
    name: {
      en : "Denham"
    }
  },
  DNN : {
    country: "US",
    name: {
      en : "Dalton"
    }
  },
  DNQ : {
    country: "AU",
    name: {
      en : "Deniliquin"
    }
  },
  DNR : {
    country: "FR",
    name: {
      en : "Dinard"
    }
  },
  DNV : {
    country: "US",
    name: {
      en : "Danville"
    }
  },
  DNZ : {
    country: "TR",
    popularity: 2,
    name: {
      en : "Denizli"
    }
  },
  DOA : {
    country: "MG",
    name: {
      en : "Doany"
    }
  },
  DOC : {
    country: "GB",
    name: {
      en : "Dornoch"
    }
  },
  DOD : {
    country: "TZ",
    name: {
      en : "Dodoma"
    }
  },
  DOG : {
    country: "SD",
    name: {
      en : "Dongola"
    }
  },
  DOH : {
    country: "QA",
    popularity: 4,
    name: {
      en : "Doha"
    }
  },
  DOL : {
    country: "FR",
    name: {
      en : "Deauville"
    }
  },
  DOM : {
    country: "DM",
    popularity: 5,
    name: {
      en : "Dominica"
    }
  },
  DOO : {
    country: "PG",
    name: {
      en : "Dorobisoro"
    }
  },
  DOP : {
    country: "NP",
    name: {
      en : "Dolpa"
    }
  },
  DOR : {
    country: "BF",
    name: {
      en : "Dori"
    }
  },
  DOU : {
    country: "BR",
    name: {
      en : "Dourados"
    }
  },
  DOV : {
    country: "US",
    name: {
      en : "Dover"
    }
  },
  DOX : {
    country: "AU",
    name: {
      en : "Dongara"
    }
  },
  DOY : {
    country: "CN",
    name: {
      en : "Dongying"
    }
  },
  DPE : {
    country: "FR",
    name: {
      en : "Dieppe"
    }
  },
  DPL : {
    country: "PH",
    name: {
      en : "Dipolog"
    }
  },
  DPO : {
    country: "AU",
    name: {
      en : "Devonport"
    }
  },
  DPS : {
    country: "ID",
    popularity: 116,
    name: {
      en : "Denpasar Bali"
    }
  },
  DPT : {
    country: "RU",
    name: {
      en : "Deputatsky"
    }
  },
  DQA : {
    country: "CN",
    name: {
      en : "Daqing"
    }
  },
  DQM : {
    country: "OM",
    name: {
      en : "Duqm"
    }
  },
  DRB : {
    country: "AU",
    name: {
      en : "Derby"
    }
  },
  DRD : {
    country: "AU",
    name: {
      en : "Dorunda"
    }
  },
  DRG : {
    country: "US",
    name: {
      en : "Deering"
    }
  },
  DRK : {
    country: "CR",
    name: {
      en : "Drake Bay"
    }
  },
  DRO : {
    country: "US",
    name: {
      en : "Durango"
    }
  },
  DRR : {
    country: "AU",
    name: {
      en : "Durrie"
    }
  },
  DRS : {
    country: "DE",
    name: {
      en : "Dresden"
    }
  },
  DRT : {
    country: "US",
    name: {
      en : "Del Rio"
    }
  },
  DRW : {
    country: "AU",
    name: {
      en : "Darwin"
    }
  },
  DSA : {
    country: "GB",
    name: {
      en : "Doncaster"
    }
  },
  DSC : {
    country: "CM",
    name: {
      en : "Dschang"
    }
  },
  DSD : {
    country: "GP",
    name: {
      en : "La Desirade"
    }
  },
  DSE : {
    country: "ET",
    name: {
      en : "Dessie"
    }
  },
  DSI : {
    country: "US",
    name: {
      en : "Destin"
    }
  },
  DSK : {
    country: "PK",
    name: {
      en : "Dera Ismail Khan"
    }
  },
  DSM : {
    country: "US",
    name: {
      en : "Des Moines"
    }
  },
  DSN : {
    country: "CN",
    name: {
      en : "Ordos"
    }
  },
  DSS : {
    country: "SN",
    name: {
      en : "Ndiass"
    }
  },
  DTA : {
    country: "US",
    name: {
      en : "Delta"
    }
  },
  DTI : {
    country: "BR",
    name: {
      en : "Diamantina"
    }
  },
  DTL : {
    country: "US",
    name: {
      en : "Detroit Lakes"
    }
  },
  DTM : {
    country: "DE",
    popularity: 4,
    name: {
      en : "Dortmund"
    }
  },
  DTT : {
    country: "US",
    popularity: 16,
    name: {
      en : "Detroit"
    }
  },
  DUB : {
    country: "IE",
    popularity: 198,
    name: {
      en : "Dublin"
    }
  },
  DUC : {
    country: "US",
    name: {
      en : "Duncan"
    }
  },
  DUD : {
    country: "NZ",
    name: {
      en : "Dunedin"
    }
  },
  DUE : {
    country: "AO",
    name: {
      en : "Dundo"
    }
  },
  DUG : {
    country: "US",
    name: {
      en : "Douglas"
    }
  },
  DUI : {
    country: "DE",
    name: {
      en : "Duisburg"
    }
  },
  DUJ : {
    country: "US",
    name: {
      en : "Dubois"
    }
  },
  DUM : {
    country: "ID",
    name: {
      en : "Dumai"
    }
  },
  DUQ : {
    country: "CA",
    name: {
      en : "Duncan"
    }
  },
  DUR : {
    country: "ZA",
    name: {
      en : "Durban"
    }
  },
  DUS : {
    country: "DE",
    popularity: 354,
    name: {
      en : "Dusseldorf"
    }
  },
  DUT : {
    country: "US",
    name: {
      en : "Dutch Harbor"
    }
  },
  DVL : {
    country: "US",
    name: {
      en : "Devils Lake"
    }
  },
  DVN : {
    country: "US",
    name: {
      en : "Davenport"
    }
  },
  DVO : {
    country: "PH",
    name: {
      en : "Davao"
    }
  },
  DWB : {
    country: "MG",
    name: {
      en : "Soalala"
    }
  },
  DWD : {
    country: "SA",
    name: {
      en : "DWD"
    }
  },
  DXB : {
    country: "AE",
    popularity: 116,
    aliases: "|Дубай",
    name: {
      en : "Dubai"
    }
  },
  DXR : {
    country: "US",
    name: {
      en : "Danbury"
    }
  },
  DYA : {
    country: "AU",
    name: {
      en : "Dysart"
    }
  },
  DYG : {
    country: "CN",
    name: {
      en : "Dayong"
    }
  },
  DYL : {
    country: "US",
    name: {
      en : "Doylestown"
    }
  },
  DYR : {
    country: "RU",
    popularity: 2,
    name: {
      en : "Anadyr"
    }
  },
  DYU : {
    country: "TJ",
    name: {
      en : "Dushanbe"
    }
  },
  DZA : {
    country: "YT",
    name: {
      en : "Dzaoudzi"
    }
  },
  DZN : {
    country: "KZ",
    name: {
      en : "Zhezkazgan"
    }
  },
  EAA : {
    country: "US",
    name: {
      en : "Eagle"
    }
  },
  EAE : {
    country: "VU",
    name: {
      en : "Emae"
    }
  },
  EAL : {
    country: "MH",
    name: {
      en : "Kwajalein Atoll"
    }
  },
  EAM : {
    country: "SA",
    name: {
      en : "Nejran"
    }
  },
  EAP : {
    country: "CH",
    name: {
      en : "Mulhouse Basel"
    }
  },
  EAR : {
    country: "US",
    name: {
      en : "Kearney"
    }
  },
  EAS : {
    country: "ES",
    name: {
      en : "San Sebastian"
    }
  },
  EAT : {
    country: "US",
    name: {
      en : "Wenatchee"
    }
  },
  EAU : {
    country: "US",
    name: {
      en : "Eau Claire"
    }
  },
  EBA : {
    country: "IT",
    name: {
      en : "Elba Island"
    }
  },
  EBB : {
    country: "UG",
    popularity: 8,
    name: {
      en : "Entebbe"
    }
  },
  EBD : {
    country: "SD",
    name: {
      en : "El Obeid"
    }
  },
  EBG : {
    country: "CO",
    name: {
      en : "El Bagre"
    }
  },
  EBH : {
    country: "DZ",
    name: {
      en : "Hoevenen"
    }
  },
  EBJ : {
    country: "DK",
    name: {
      en : "Esbjerg"
    }
  },
  EBL : {
    country: "IQ",
    name: {
      en : "Erbil"
    }
  },
  EBO : {
    country: "MH",
    name: {
      en : "Ebon"
    }
  },
  EBU : {
    country: "FR",
    name: {
      en : "St Etienne"
    }
  },
  ECG : {
    country: "US",
    name: {
      en : "Elizabeth City"
    }
  },
  ECH : {
    country: "AU",
    name: {
      en : "Echuca"
    }
  },
  ECN : {
    country: "CY",
    popularity: 4,
    name: {
      en : "Ercan"
    }
  },
  EDA : {
    country: "US",
    name: {
      en : "Edna Bay"
    }
  },
  EDE : {
    country: "US",
    name: {
      en : "Edenton"
    }
  },
  EDG : {
    country: "US",
    name: {
      en : "Edgewood"
    }
  },
  EDI : {
    country: "GB",
    popularity: 62,
    name: {
      en : "Edinburgh"
    }
  },
  EDL : {
    country: "KE",
    name: {
      en : "Eldoret"
    }
  },
  EDM : {
    country: "FR",
    name: {
      en : "La Roche"
    }
  },
  EDO : {
    country: "TR",
    name: {
      en : "Edremit"
    }
  },
  EDR : {
    country: "AU",
    name: {
      en : "Edward River"
    }
  },
  EDW : {
    country: "US",
    name: {
      en : "Edwards"
    }
  },
  EED : {
    country: "US",
    name: {
      en : "Needles"
    }
  },
  EEK : {
    country: "US",
    name: {
      en : "Eek"
    }
  },
  EEM : {
    country: "ES",
    name: {
      en : "EEM"
    }
  },
  EEN : {
    country: "US",
    name: {
      en : "Keene"
    }
  },
  EEP : {
    country: "ES",
    name: {
      en : "EEP"
    }
  },
  EER : {
    country: "ES",
    name: {
      en : "EER"
    }
  },
  EFG : {
    country: "PG",
    name: {
      en : "Efogi"
    }
  },
  EFL : {
    country: "GR",
    name: {
      en : "Kefalonia"
    }
  },
  EGC : {
    country: "FR",
    name: {
      en : "Bergerac"
    }
  },
  EGE : {
    country: "US",
    name: {
      en : "Eagle"
    }
  },
  EGM : {
    country: "SB",
    name: {
      en : "Sege"
    }
  },
  EGN : {
    country: "SD",
    name: {
      en : "Geneina"
    }
  },
  EGO : {
    country: "RU",
    name: {
      en : "Belgorod"
    }
  },
  EGP : {
    country: "US",
    name: {
      en : "Eagle Pass"
    }
  },
  EGS : {
    country: "IS",
    popularity: 6,
    name: {
      en : "Egilsstadir"
    }
  },
  EGV : {
    country: "US",
    name: {
      en : "Eagle River"
    }
  },
  EGX : {
    country: "US",
    name: {
      en : "Egegik"
    }
  },
  EHL : {
    country: "AR",
    name: {
      en : "El Bolson"
    }
  },
  EHM : {
    country: "US",
    name: {
      en : "Cape Newenham"
    }
  },
  EHT : {
    country: "US",
    name: {
      en : "East Hartford"
    }
  },
  EIB : {
    country: "DE",
    name: {
      en : "Eisenach"
    }
  },
  EIE : {
    country: "RU",
    name: {
      en : "Eniseysk"
    }
  },
  EIK : {
    country: "RU",
    name: {
      en : "Yeysk"
    }
  },
  EIN : {
    country: "NL",
    name: {
      en : "Eindhoven"
    }
  },
  EIS : {
    country: "VG",
    name: {
      en : "Beef Island"
    }
  },
  EJA : {
    country: "CO",
    name: {
      en : "Barrancabermeja"
    }
  },
  EJH : {
    country: "SA",
    name: {
      en : "Wedjh"
    }
  },
  EKB : {
    country: "KZ",
    name: {
      en : "EKB"
    }
  },
  EKI : {
    country: "US",
    name: {
      en : "Elkhart"
    }
  },
  EKN : {
    country: "US",
    name: {
      en : "Elkins"
    }
  },
  EKO : {
    country: "US",
    name: {
      en : "Elko"
    }
  },
  EKS : {
    country: "RU",
    name: {
      en : "Shakhtyorsk"
    }
  },
  EKT : {
    country: "SE",
    name: {
      en : "Eskilstuna"
    }
  },
  EKX : {
    country: "US",
    name: {
      en : "Elizabethtown"
    }
  },
  ELC : {
    country: "AU",
    name: {
      en : "Elcho"
    }
  },
  ELD : {
    country: "US",
    name: {
      en : "El Dorado"
    }
  },
  ELF : {
    country: "SD",
    name: {
      en : "El Fasher"
    }
  },
  ELG : {
    country: "DZ",
    name: {
      en : "El Golea"
    }
  },
  ELH : {
    country: "BS",
    name: {
      en : "North Eleuthera"
    }
  },
  ELI : {
    country: "US",
    name: {
      en : "Elim"
    }
  },
  ELK : {
    country: "US",
    name: {
      en : "Elk City"
    }
  },
  ELM : {
    country: "US",
    name: {
      en : "Elmira"
    }
  },
  ELP : {
    country: "US",
    name: {
      en : "El Paso"
    }
  },
  ELQ : {
    country: "SA",
    name: {
      en : "Gassim"
    }
  },
  ELS : {
    country: "ZA",
    name: {
      en : "East London"
    }
  },
  ELT : {
    country: "EG",
    name: {
      en : "El Tor"
    }
  },
  ELU : {
    country: "DZ",
    name: {
      en : "El Oued"
    }
  },
  ELV : {
    country: "US",
    name: {
      en : "Elfin Cove"
    }
  },
  ELY : {
    country: "US",
    name: {
      en : "Ely NV"
    }
  },
  EMA : {
    country: "GB",
    popularity: 1,
    name: {
      en : "East Midlands"
    }
  },
  EMD : {
    country: "AU",
    name: {
      en : "Emerald"
    }
  },
  EME : {
    country: "DE",
    name: {
      en : "Emden"
    }
  },
  EMI : {
    country: "PG",
    name: {
      en : "Emirau"
    }
  },
  EMK : {
    country: "US",
    name: {
      en : "Emmonak"
    }
  },
  EMN : {
    country: "MR",
    name: {
      en : "Nema"
    }
  },
  EMO : {
    country: "PG",
    name: {
      en : "Emo PG"
    }
  },
  EMP : {
    country: "US",
    name: {
      en : "Emporia"
    }
  },
  EMS : {
    country: "PG",
    name: {
      en : "Embessa"
    }
  },
  EMT : {
    country: "US",
    name: {
      en : "El Monte"
    }
  },
  EMX : {
    country: "AR",
    name: {
      en : "El Maiten"
    }
  },
  ENA : {
    country: "US",
    name: {
      en : "Kenai"
    }
  },
  ENC : {
    country: "FR",
    name: {
      en : "Nancy"
    }
  },
  ENE : {
    country: "ID",
    name: {
      en : "Ende"
    }
  },
  ENF : {
    country: "FI",
    name: {
      en : "Enontekio"
    }
  },
  ENH : {
    country: "CN",
    name: {
      en : "Enshi"
    }
  },
  ENI : {
    country: "PH",
    name: {
      en : "El Nido"
    }
  },
  ENK : {
    country: "IE",
    name: {
      en : "Enniskillen"
    }
  },
  ENL : {
    country: "US",
    name: {
      en : "Centralia"
    }
  },
  ENN : {
    country: "US",
    name: {
      en : "Nenana"
    }
  },
  ENO : {
    country: "PY",
    name: {
      en : "Encarnacion"
    }
  },
  ENS : {
    country: "NL",
    name: {
      en : "Enschede"
    }
  },
  ENU : {
    country: "NG",
    name: {
      en : "Enugu"
    }
  },
  ENV : {
    country: "US",
    name: {
      en : "Wendover"
    }
  },
  ENW : {
    country: "US",
    name: {
      en : "Kenosha"
    }
  },
  ENY : {
    country: "CN",
    name: {
      en : "Yanan"
    }
  },
  EOI : {
    country: "GB",
    name: {
      en : "Eday"
    }
  },
  EOK : {
    country: "US",
    name: {
      en : "Keokuk"
    }
  },
  EPL : {
    country: "FR",
    name: {
      en : "Epinal"
    }
  },
  EPR : {
    country: "AU",
    name: {
      en : "Esperance"
    }
  },
  EPS : {
    country: "DO",
    name: {
      en : "Samana"
    }
  },
  EPU : {
    country: "EE",
    name: {
      en : "Parnu"
    }
  },
  EQS : {
    country: "AR",
    name: {
      en : "Esquel"
    }
  },
  ERC : {
    country: "TR",
    name: {
      en : "Erzincan"
    }
  },
  ERF : {
    country: "DE",
    name: {
      en : "Erfurt"
    }
  },
  ERH : {
    country: "MA",
    name: {
      en : "Errachidia"
    }
  },
  ERI : {
    country: "US",
    name: {
      en : "Erie"
    }
  },
  ERL : {
    country: "CN",
    name: {
      en : "Erldunda"
    }
  },
  ERM : {
    country: "BR",
    name: {
      en : "Erechim"
    }
  },
  ERN : {
    country: "BR",
    name: {
      en : "Eirunepe"
    }
  },
  ERU : {
    country: "PG",
    name: {
      en : "Erume"
    }
  },
  ERV : {
    country: "US",
    name: {
      en : "Kerrville"
    }
  },
  ERZ : {
    country: "TR",
    name: {
      en : "Erzurum"
    }
  },
  ESA : {
    country: "PG",
    name: {
      en : "Esa Ala"
    }
  },
  ESC : {
    country: "US",
    name: {
      en : "Escanaba"
    }
  },
  ESD : {
    country: "US",
    name: {
      en : "East Sound"
    }
  },
  ESE : {
    country: "MX",
    name: {
      en : "Ensenada"
    }
  },
  ESK : {
    country: "TR",
    name: {
      en : "Eskisehir"
    }
  },
  ESL : {
    country: "RU",
    name: {
      en : "Elista"
    }
  },
  ESM : {
    country: "EC",
    name: {
      en : "Esmeraldas"
    }
  },
  ESN : {
    country: "US",
    name: {
      en : "Easton"
    }
  },
  ESP : {
    country: "US",
    name: {
      en : "East Stroudsburg"
    }
  },
  ESR : {
    country: "CL",
    name: {
      en : "El Salvador"
    }
  },
  ESS : {
    country: "DE",
    popularity: 2,
    name: {
      en : "Essen"
    }
  },
  ESU : {
    country: "MA",
    name: {
      en : "Essaouira"
    }
  },
  ETB : {
    country: "US",
    name: {
      en : "West Bend"
    }
  },
  ETD : {
    country: "AU",
    name: {
      en : "Etadunna"
    }
  },
  ETE : {
    country: "ET",
    name: {
      en : "Metemma"
    }
  },
  ETH : {
    country: "IL",
    popularity: 36,
    name: {
      en : "Elat"
    }
  },
  ETM : {
    country: "IL",
    popularity: 36,
    name: {
      en : "Elat"
    }
  },
  ETR : {
    country: "EC",
    name: {
      en : "Etrepagny"
    }
  },
  ETS : {
    country: "US",
    name: {
      en : "Enterprise"
    }
  },
  ETZ : {
    country: "FR",
    popularity: 2,
    name: {
      en : "Metz Nancy"
    }
  },
  EUA : {
    country: "TO",
    name: {
      en : "Eua To"
    }
  },
  EUF : {
    country: "US",
    name: {
      en : "Eufaula"
    }
  },
  EUG : {
    country: "US",
    name: {
      en : "Eugene"
    }
  },
  EUM : {
    country: "DE",
    name: {
      en : "Neumuenster"
    }
  },
  EUN : {
    country: "MA",
    name: {
      en : "El Aaiun"
    }
  },
  EUX : {
    country: "BQ",
    name: {
      en : "St Eustatius"
    }
  },
  EVE : {
    country: "NO",
    name: {
      en : "Harstad Narvik"
    }
  },
  EVG : {
    country: "SE",
    name: {
      en : "Sveg"
    }
  },
  EVM : {
    country: "US",
    name: {
      en : "Eveleth"
    }
  },
  EVN : {
    country: "AM",
    popularity: 6,
    name: {
      en : "Yerevan"
    }
  },
  EVV : {
    country: "US",
    name: {
      en : "Evansville"
    }
  },
  EVW : {
    country: "US",
    name: {
      en : "Evanston"
    }
  },
  EVX : {
    country: "FR",
    name: {
      en : "Evreux"
    }
  },
  EWB : {
    country: "US",
    name: {
      en : "New Bedford"
    }
  },
  EWD : {
    country: "US",
    name: {
      en : "Wildman Lake"
    }
  },
  EWI : {
    country: "ID",
    name: {
      en : "Enarotali"
    }
  },
  EWK : {
    country: "US",
    name: {
      en : "Newton"
    }
  },
  EWN : {
    country: "US",
    name: {
      en : "New Bern"
    }
  },
  EWR : {
    country: "US",
    popularity: 34,
    name: {
      en : "Newark"
    }
  },
  EWY : {
    country: "GB",
    name: {
      en : "Newbury"
    }
  },
  EXI : {
    country: "US",
    name: {
      en : "Excursion Inlet"
    }
  },
  EXM : {
    country: "AU",
    name: {
      en : "Exmouth Gulf"
    }
  },
  EXT : {
    country: "GB",
    name: {
      en : "Exeter"
    }
  },
  EYA : {
    country: "RU",
    name: {
      en : "Zeya"
    }
  },
  EYK : {
    country: "RU",
    name: {
      en : "Beloyarsky"
    }
  },
  EYP : {
    country: "CO",
    name: {
      en : "El Yopal"
    }
  },
  EYW : {
    country: "US",
    name: {
      en : "Key West"
    }
  },
  EZS : {
    country: "TR",
    name: {
      en : "Elazig"
    }
  },
  EZV : {
    country: "RU",
    name: {
      en : "Beryozovo"
    }
  },
  FAB : {
    country: "GB",
    name: {
      en : "Farnborough Hampshire"
    }
  },
  FAC : {
    country: "PF",
    name: {
      en : "Faaite"
    }
  },
  FAE : {
    country: "FO",
    name: {
      en : "Faeroe Islands"
    }
  },
  FAH : {
    country: "AF",
    name: {
      en : "Farah"
    }
  },
  FAI : {
    country: "US",
    name: {
      en : "Fairbanks"
    }
  },
  FAJ : {
    country: "US",
    name: {
      en : "Fajardo"
    }
  },
  FAO : {
    country: "PT",
    popularity: 138,
    name: {
      en : "Faro"
    }
  },
  FAR : {
    country: "US",
    name: {
      en : "Fargo"
    }
  },
  FAT : {
    country: "US",
    name: {
      en : "Fresno"
    }
  },
  FAV : {
    country: "PF",
    name: {
      en : "Fakarava"
    }
  },
  FAY : {
    country: "US",
    name: {
      en : "Fayetteville"
    }
  },
  FBA : {
    country: "BR",
    name: {
      en : "Fonte Boa"
    }
  },
  FBD : {
    country: "AF",
    name: {
      en : "Faizabad"
    }
  },
  FBM : {
    country: "CD",
    name: {
      en : "Lubumbashi"
    }
  },
  FBS : {
    country: "US",
    name: {
      en : "Friday Harbor"
    }
  },
  FCA : {
    country: "US",
    name: {
      en : "Kalispell"
    }
  },
  FCB : {
    country: "ZA",
    name: {
      en : "Ficksburg"
    }
  },
  FCN : {
    country: "DE",
    name: {
      en : "Cuxhaven"
    }
  },
  FCY : {
    country: "US",
    name: {
      en : "Forrest City"
    }
  },
  FDE : {
    country: "NO",
    name: {
      en : "Forde"
    }
  },
  FDF : {
    country: "MQ",
    name: {
      en : "Ft De France"
    }
  },
  FDH : {
    country: "DE",
    name: {
      en : "Friedrichshafen"
    }
  },
  FDK : {
    country: "US",
    name: {
      en : "Frederick"
    }
  },
  FDU : {
    country: "CD",
    name: {
      en : "Bandundu"
    }
  },
  FDY : {
    country: "US",
    name: {
      en : "Findlay"
    }
  },
  FEC : {
    country: "BR",
    name: {
      en : "Feira de Santana"
    }
  },
  FEG : {
    country: "UZ",
    name: {
      en : "Fergana"
    }
  },
  FEL : {
    country: "DE",
    name: {
      en : "Furstenfeldbruck"
    }
  },
  FEN : {
    country: "BR",
    name: {
      en : "Fernando De Noronha"
    }
  },
  FES : {
    country: "ES",
    name: {
      en : "San Fernando"
    }
  },
  FEZ : {
    country: "MA",
    name: {
      en : "Fez Ma"
    }
  },
  FFM : {
    country: "US",
    name: {
      en : "Fergus Falls"
    }
  },
  FFT : {
    country: "US",
    name: {
      en : "Frankfort"
    }
  },
  FGL : {
    country: "NZ",
    name: {
      en : "Fox Glacier"
    }
  },
  FGR : {
    country: "ES",
    name: {
      en : "Fuengirola"
    }
  },
  FGU : {
    country: "PF",
    name: {
      en : "Fangatau"
    }
  },
  FHU : {
    country: "US",
    name: {
      en : "Fort Huachuca"
    }
  },
  FHZ : {
    country: "PF",
    name: {
      en : "Fakahina"
    }
  },
  FIE : {
    country: "GB",
    name: {
      en : "Fair Isle"
    }
  },
  FIH : {
    country: "CD",
    name: {
      en : "Kinshasa"
    }
  },
  FIN : {
    country: "PG",
    name: {
      en : "Finschhafen"
    }
  },
  FIZ : {
    country: "AU",
    name: {
      en : "Fitzroy Crossing"
    }
  },
  FJR : {
    country: "AE",
    name: {
      en : "Al Fujairah"
    }
  },
  FKB : {
    country: "DE",
    popularity: 2,
    name: {
      en : "Karlsruhe Baden Baden"
    }
  },
  FKI : {
    country: "CD",
    name: {
      en : "Kisangani"
    }
  },
  FKL : {
    country: "US",
    popularity: 2,
    name: {
      en : "Franklin"
    }
  },
  FKQ : {
    country: "ID",
    name: {
      en : "Fak Fak"
    }
  },
  FKS : {
    country: "JP",
    name: {
      en : "Fukushima"
    }
  },
  FLA : {
    country: "CO",
    name: {
      en : "Florencia"
    }
  },
  FLB : {
    country: "BR",
    name: {
      en : "Floriano"
    }
  },
  FLC : {
    country: "AU",
    name: {
      en : "Falls Creek"
    }
  },
  FLF : {
    country: "DE",
    name: {
      en : "Flensburg"
    }
  },
  FLG : {
    country: "US",
    name: {
      en : "Flagstaff"
    }
  },
  FLI : {
    country: "IS",
    name: {
      en : "Flateyri"
    }
  },
  FLL : {
    country: "US",
    name: {
      en : "Ft Lauderdale"
    }
  },
  FLN : {
    country: "BR",
    popularity: 4,
    name: {
      en : "Florianopolis"
    }
  },
  FLO : {
    country: "US",
    name: {
      en : "Florence"
    }
  },
  FLP : {
    country: "US",
    name: {
      en : "Flippin"
    }
  },
  FLR : {
    country: "IT",
    name: {
      en : "Florence"
    }
  },
  FLS : {
    country: "AU",
    name: {
      en : "Flinder Island"
    }
  },
  FLT : {
    country: "US",
    name: {
      en : "Flat"
    }
  },
  FLW : {
    country: "PT",
    popularity: 2,
    name: {
      en : "Santa Cruz Flores"
    }
  },
  FMA : {
    country: "AR",
    name: {
      en : "Formosa"
    }
  },
  FMH : {
    country: "US",
    name: {
      en : "Falmouth"
    }
  },
  FMI : {
    country: "CD",
    name: {
      en : "Kalemie"
    }
  },
  FMM : {
    country: "DE",
    name: {
      en : "Memmingen"
    }
  },
  FMN : {
    country: "US",
    popularity: 2,
    name: {
      en : "Farmington"
    }
  },
  FMO : {
    country: "DE",
    name: {
      en : "Muenster"
    }
  },
  FMS : {
    country: "US",
    name: {
      en : "Fort Madison"
    }
  },
  FMY : {
    country: "US",
    name: {
      en : "Fort Myers"
    }
  },
  FNA : {
    country: "SL",
    name: {
      en : "Freetown"
    }
  },
  FNB : {
    country: "DE",
    name: {
      en : "Neubrandenburg"
    }
  },
  FNC : {
    country: "PT",
    popularity: 12,
    name: {
      en : "Funchal"
    }
  },
  FNE : {
    country: "PG",
    name: {
      en : "Fane"
    }
  },
  FNI : {
    country: "FR",
    name: {
      en : "Nimes"
    }
  },
  FNJ : {
    country: "KP",
    name: {
      en : "Pyongyang"
    }
  },
  FNL : {
    country: "US",
    name: {
      en : "Ft Collins"
    }
  },
  FNR : {
    country: "US",
    name: {
      en : "Funter Bay"
    }
  },
  FNT : {
    country: "US",
    name: {
      en : "Flint"
    }
  },
  FOA : {
    country: "GB",
    name: {
      en : "Foula"
    }
  },
  FOB : {
    country: "US",
    name: {
      en : "Fort Bragg"
    }
  },
  FOC : {
    country: "CN",
    name: {
      en : "Fuzhou"
    }
  },
  FOD : {
    country: "US",
    name: {
      en : "Fort Dodge"
    }
  },
  FOG : {
    country: "IT",
    name: {
      en : "Foggia"
    }
  },
  FOK : {
    country: "US",
    name: {
      en : "Westhampton"
    }
  },
  FON : {
    country: "CR",
    name: {
      en : "Fortuna"
    }
  },
  FOO : {
    country: "ID",
    name: {
      en : "Numfoor"
    }
  },
  FOR : {
    country: "BR",
    name: {
      en : "Fortaleza"
    }
  },
  FOT : {
    country: "AU",
    name: {
      en : "Forster"
    }
  },
  FOU : {
    country: "GA",
    name: {
      en : "Fougamou"
    }
  },
  FPO : {
    country: "BS",
    name: {
      en : "Freeport"
    }
  },
  FPR : {
    country: "US",
    name: {
      en : "Fort Pierce"
    }
  },
  FRA : {
    country: "DE",
    popularity: 376,
    name: {
      en : "Frankfurt am Main"
    }
  },
  FRB : {
    country: "AU",
    name: {
      en : "Forbes"
    }
  },
  FRC : {
    country: "BR",
    name: {
      en : "Franca"
    }
  },
  FRD : {
    country: "US",
    name: {
      en : "Friday Harbor"
    }
  },
  FRE : {
    country: "SB",
    name: {
      en : "Fera Island"
    }
  },
  FRG : {
    country: "US",
    name: {
      en : "Farmingdale"
    }
  },
  FRJ : {
    country: "FR",
    name: {
      en : "Frejus"
    }
  },
  FRK : {
    country: "SC",
    name: {
      en : "Fregate Island"
    }
  },
  FRL : {
    country: "IT",
    name: {
      en : "Forli"
    }
  },
  FRM : {
    country: "US",
    name: {
      en : "Fairmont"
    }
  },
  FRO : {
    country: "NO",
    name: {
      en : "Floro"
    }
  },
  FRR : {
    country: "US",
    name: {
      en : "Front Royal"
    }
  },
  FRS : {
    country: "GT",
    name: {
      en : "Flores"
    }
  },
  FRU : {
    country: "KG",
    popularity: 20,
    name: {
      en : "Bishkek"
    }
  },
  FRW : {
    country: "BW",
    name: {
      en : "Francistown"
    }
  },
  FRZ : {
    country: "DE",
    name: {
      en : "Fritzlar"
    }
  },
  FSC : {
    country: "FR",
    name: {
      en : "Figari"
    }
  },
  FSD : {
    country: "US",
    name: {
      en : "Sioux Falls"
    }
  },
  FSM : {
    country: "US",
    name: {
      en : "Ft Smith"
    }
  },
  FSP : {
    country: "PM",
    name: {
      en : "St Pierre"
    }
  },
  FST : {
    country: "US",
    name: {
      en : "Fort Stockton"
    }
  },
  FSZ : {
    country: "JP",
    name: {
      en : "Shizuoka"
    }
  },
  FTA : {
    country: "VU",
    name: {
      en : "Futuna Island"
    }
  },
  FTE : {
    country: "AR",
    name: {
      en : "El Calafate"
    }
  },
  FTU : {
    country: "MG",
    name: {
      en : "Fort Dauphin"
    }
  },
  FTW : {
    country: "US",
    name: {
      en : "Ft Worth"
    }
  },
  FTX : {
    country: "CG",
    name: {
      en : "Owando"
    }
  },
  FUB : {
    country: "PG",
    name: {
      en : "Fulleborn"
    }
  },
  FUE : {
    country: "ES",
    name: {
      en : "Puerto Del Rosario"
    }
  },
  FUG : {
    country: "CN",
    name: {
      en : "Fuyang"
    }
  },
  FUJ : {
    country: "JP",
    name: {
      en : "Fukue"
    }
  },
  FUK : {
    country: "JP",
    name: {
      en : "Fukuoka"
    }
  },
  FUL : {
    country: "US",
    name: {
      en : "Fullerton"
    }
  },
  FUN : {
    country: "TV",
    name: {
      en : "Funafuti"
    }
  },
  FUO : {
    country: "CN",
    name: {
      en : "Fuoshan"
    }
  },
  FUT : {
    country: "WF",
    name: {
      en : "Futuna"
    }
  },
  FWA : {
    country: "US",
    name: {
      en : "Ft Wayne"
    }
  },
  FWM : {
    country: "GB",
    name: {
      en : "Fort William"
    }
  },
  FYG : {
    country: "CN",
    name: {
      en : "FYG"
    }
  },
  FYJ : {
    country: "CN",
    name: {
      en : "Fuyuan"
    }
  },
  FYN : {
    country: "CN",
    name: {
      en : "Fuyun"
    }
  },
  FYU : {
    country: "US",
    name: {
      en : "Ft Yukon"
    }
  },
  FYV : {
    country: "US",
    name: {
      en : "Fayetteville"
    }
  },
  FZL : {
    country: "AZ",
    name: {
      en : "Fuzuli"
    }
  },
  FZO : {
    country: "GB",
    name: {
      en : "Filton"
    }
  },
  GAD : {
    country: "US",
    name: {
      en : "Gadsden"
    }
  },
  GAE : {
    country: "TN",
    name: {
      en : "Gabes"
    }
  },
  GAF : {
    country: "TN",
    name: {
      en : "Gafsa"
    }
  },
  GAI : {
    country: "US",
    name: {
      en : "Gaithersburg"
    }
  },
  GAJ : {
    country: "JP",
    name: {
      en : "Yamagata"
    }
  },
  GAL : {
    country: "US",
    name: {
      en : "Galena"
    }
  },
  GAM : {
    country: "US",
    name: {
      en : "Gambell"
    }
  },
  GAN : {
    country: "MV",
    name: {
      en : "Gan Island"
    }
  },
  GAO : {
    country: "CU",
    name: {
      en : "Guantanamo"
    }
  },
  GAR : {
    country: "PG",
    name: {
      en : "Garaina"
    }
  },
  GAS : {
    country: "KE",
    name: {
      en : "Garissa"
    }
  },
  GAT : {
    country: "FR",
    name: {
      en : "Gap France"
    }
  },
  GAU : {
    country: "IN",
    name: {
      en : "Guwahati"
    }
  },
  GAX : {
    country: "GA",
    name: {
      en : "Gamba"
    }
  },
  GAY : {
    country: "IN",
    name: {
      en : "Gaya"
    }
  },
  GBB : {
    country: "AZ",
    popularity: 130000,
    name: {
      en : "Gabala"
    }
  },
  GBD : {
    country: "US",
    name: {
      en : "Great Bend"
    }
  },
  GBE : {
    country: "BW",
    name: {
      en : "Gaborone"
    }
  },
  GBG : {
    country: "US",
    name: {
      en : "Galesburg"
    }
  },
  GBJ : {
    country: "GP",
    name: {
      en : "Marie Galante"
    }
  },
  GBK : {
    country: "SL",
    name: {
      en : "Gbangbatok"
    }
  },
  GBN : {
    country: "IT",
    name: {
      en : "San Giovanni Rotondo"
    }
  },
  GBQ : {
    country: "BH",
    name: {
      en : "Muharraq Town"
    }
  },
  GBR : {
    country: "US",
    name: {
      en : "Great Barrington"
    }
  },
  GBT : {
    country: "IR",
    name: {
      en : "Gorgon"
    }
  },
  GBZ : {
    country: "NZ",
    name: {
      en : "Great Barrier Island"
    }
  },
  GCC : {
    country: "US",
    name: {
      en : "Gillette"
    }
  },
  GCI : {
    country: "GB",
    name: {
      en : "Guernsey"
    }
  },
  GCK : {
    country: "US",
    name: {
      en : "Garden City"
    }
  },
  GCM : {
    country: "KY",
    name: {
      en : "Grand Cayman Island"
    }
  },
  GCN : {
    country: "US",
    name: {
      en : "Grand Canyon"
    }
  },
  GCV : {
    country: "BR",
    name: {
      en : "Gravatai"
    }
  },
  GCW : {
    country: "US",
    name: {
      en : "Grand Canyon West Airport"
    }
  },
  GCY : {
    country: "US",
    name: {
      en : "Greeneville"
    }
  },
  GDE : {
    country: "ET",
    name: {
      en : "Gode"
    }
  },
  GDL : {
    country: "MX",
    name: {
      en : "Guadalajara"
    }
  },
  GDN : {
    country: "PL",
    name: {
      en : "Gdansk"
    }
  },
  GDQ : {
    country: "ET",
    name: {
      en : "Gondar"
    }
  },
  GDT : {
    country: "TC",
    name: {
      en : "Grand Turk"
    }
  },
  GDV : {
    country: "US",
    name: {
      en : "Glendive"
    }
  },
  GDX : {
    country: "RU",
    name: {
      en : "Magadan"
    }
  },
  GDZ : {
    country: "RU",
    name: {
      en : "Gelendzik"
    }
  },
  GED : {
    country: "US",
    name: {
      en : "Georgetown"
    }
  },
  GEE : {
    country: "AU",
    name: {
      en : "George Town"
    }
  },
  GEG : {
    country: "US",
    name: {
      en : "Spokane"
    }
  },
  GEL : {
    country: "BR",
    name: {
      en : "Santo Angelo"
    }
  },
  GEN : {
    country: "ES",
    name: {
      en : "Puente Genil"
    }
  },
  GEO : {
    country: "GY",
    name: {
      en : "Georgetown"
    }
  },
  GER : {
    country: "CU",
    name: {
      en : "Nueva Gerona"
    }
  },
  GES : {
    country: "PH",
    name: {
      en : "General Santos"
    }
  },
  GET : {
    country: "AU",
    name: {
      en : "Geraldton"
    }
  },
  GEV : {
    country: "SE",
    name: {
      en : "Gallivare"
    }
  },
  GEW : {
    country: "PG",
    name: {
      en : "Gewoia"
    }
  },
  GEX : {
    country: "AU",
    name: {
      en : "Geelong"
    }
  },
  GFD : {
    country: "US",
    name: {
      en : "Greenfield"
    }
  },
  GFF : {
    country: "AU",
    name: {
      en : "Griffith"
    }
  },
  GFK : {
    country: "US",
    name: {
      en : "Grand Forks"
    }
  },
  GFL : {
    country: "US",
    name: {
      en : "Glens Falls"
    }
  },
  GFN : {
    country: "AU",
    name: {
      en : "Grafton"
    }
  },
  GFR : {
    country: "FR",
    name: {
      en : "Granville"
    }
  },
  GFY : {
    country: "NA",
    name: {
      en : "Grootfontein"
    }
  },
  GGE : {
    country: "US",
    name: {
      en : "Georgetown"
    }
  },
  GGG : {
    country: "US",
    name: {
      en : "Longview"
    }
  },
  GGM : {
    country: "KE",
    name: {
      en : "Kakamega"
    }
  },
  GGR : {
    country: "SO",
    name: {
      en : "Garoe"
    }
  },
  GGS : {
    country: "AR",
    name: {
      en : "Gobernador Gregores"
    }
  },
  GGT : {
    country: "BS",
    name: {
      en : "George Town"
    }
  },
  GGW : {
    country: "US",
    name: {
      en : "Glasgow"
    }
  },
  GHA : {
    country: "DZ",
    name: {
      en : "Ghardaia"
    }
  },
  GHB : {
    country: "BS",
    name: {
      en : "Governor S Harbour"
    }
  },
  GHT : {
    country: "LY",
    name: {
      en : "Ghat"
    }
  },
  GIB : {
    country: "GI",
    name: {
      en : "Gibraltar"
    }
  },
  GIC : {
    country: "AU",
    name: {
      en : "Boigu Island"
    }
  },
  GIF : {
    country: "US",
    name: {
      en : "Winter Haven"
    }
  },
  GIL : {
    country: "PK",
    name: {
      en : "Gilgit"
    }
  },
  GIS : {
    country: "NZ",
    name: {
      en : "Gisborne"
    }
  },
  GIZ : {
    country: "SA",
    name: {
      en : "Gizan"
    }
  },
  GJA : {
    country: "HN",
    name: {
      en : "Guanaja"
    }
  },
  GJL : {
    country: "DZ",
    name: {
      en : "Jijel"
    }
  },
  GJR : {
    country: "IS",
    name: {
      en : "Gjogur"
    }
  },
  GJT : {
    country: "US",
    name: {
      en : "Grand Junction"
    }
  },
  GKA : {
    country: "PG",
    name: {
      en : "Goroka"
    }
  },
  GKL : {
    country: "AU",
    name: {
      en : "Great Keppel Is"
    }
  },
  GKT : {
    country: "US",
    name: {
      en : "Gatlinburg"
    }
  },
  GLA : {
    country: "GB",
    popularity: 44,
    name: {
      en : "Glasgow"
    }
  },
  GLC : {
    country: "ET",
    name: {
      en : "Geladi"
    }
  },
  GLD : {
    country: "US",
    name: {
      en : "Goodland"
    }
  },
  GLE : {
    country: "US",
    name: {
      en : "Gainesville"
    }
  },
  GLF : {
    country: "CR",
    name: {
      en : "Golfito"
    }
  },
  GLG : {
    country: "AU",
    name: {
      en : "Glengyle"
    }
  },
  GLH : {
    country: "US",
    name: {
      en : "Greenville"
    }
  },
  GLI : {
    country: "AU",
    name: {
      en : "Glen Innes"
    }
  },
  GLK : {
    country: "SO",
    name: {
      en : "Galcaio"
    }
  },
  GLL : {
    country: "NO",
    name: {
      en : "Gol City"
    }
  },
  GLN : {
    country: "MA",
    name: {
      en : "Goulimime"
    }
  },
  GLO : {
    country: "GB",
    name: {
      en : "Gloucester"
    }
  },
  GLQ : {
    country: "US",
    name: {
      en : "Glennallen"
    }
  },
  GLR : {
    country: "US",
    name: {
      en : "Gaylord"
    }
  },
  GLS : {
    country: "US",
    name: {
      en : "Galveston"
    }
  },
  GLT : {
    country: "AU",
    name: {
      en : "Gladstone"
    }
  },
  GLV : {
    country: "US",
    name: {
      en : "Golovin"
    }
  },
  GLW : {
    country: "US",
    name: {
      en : "Glasgow"
    }
  },
  GLX : {
    country: "ID",
    name: {
      en : "Galela"
    }
  },
  GLZ : {
    country: "NL",
    name: {
      en : "Breda"
    }
  },
  GMA : {
    country: "CD",
    name: {
      en : "Gemena"
    }
  },
  GMB : {
    country: "ET",
    name: {
      en : "Gambela"
    }
  },
  GME : {
    country: "BY",
    name: {
      en : "Gomel"
    }
  },
  GMI : {
    country: "PG",
    name: {
      en : "Gasmata"
    }
  },
  GMN : {
    country: "NZ",
    name: {
      en : "Greymouth"
    }
  },
  GMO : {
    country: "NG",
    name: {
      en : "GMO"
    }
  },
  GMR : {
    country: "PF",
    name: {
      en : "Gambier Island"
    }
  },
  GMZ : {
    country: "ES",
    name: {
      en : "San Sebastian De La Gomera"
    }
  },
  GNA : {
    country: "BY",
    name: {
      en : "Grodna"
    }
  },
  GNB : {
    country: "FR",
    popularity: 16,
    name: {
      en : "Grenoble"
    }
  },
  GND : {
    country: "GD",
    name: {
      en : "Grenada"
    }
  },
  GNE : {
    country: "BE",
    name: {
      en : "Ghent"
    }
  },
  GNM : {
    country: "BR",
    name: {
      en : "Guanambi"
    }
  },
  GNR : {
    country: "AR",
    name: {
      en : "General Roca"
    }
  },
  GNS : {
    country: "ID",
    name: {
      en : "Gunungsitoli"
    }
  },
  GNU : {
    country: "US",
    name: {
      en : "Goodnews Bay"
    }
  },
  GNV : {
    country: "US",
    name: {
      en : "Gainesville"
    }
  },
  GNY : {
    country: "TR",
    name: {
      en : "Sanliurfa"
    }
  },
  GOA : {
    country: "IT",
    name: {
      en : "Genoa"
    }
  },
  GOB : {
    country: "ET",
    name: {
      en : "Goba"
    }
  },
  GOC : {
    country: "PG",
    name: {
      en : "Gora"
    }
  },
  GOE : {
    country: "PG",
    name: {
      en : "Gonalia"
    }
  },
  GOH : {
    country: "GL",
    name: {
      en : "Nuuk"
    }
  },
  GOI : {
    country: "IN",
    popularity: 68,
    name: {
      en : "Goa"
    }
  },
  GOJ : {
    country: "RU",
    popularity: 42,
    name: {
      en : "Nizhniy Novgorod"
    }
  },
  GOM : {
    country: "CD",
    name: {
      en : "Goma"
    }
  },
  GON : {
    country: "US",
    popularity: 4,
    name: {
      en : "New London"
    }
  },
  GOO : {
    country: "AU",
    name: {
      en : "Goondiwindi"
    }
  },
  GOP : {
    country: "IN",
    name: {
      en : "Gorakhpur"
    }
  },
  GOQ : {
    country: "CN",
    name: {
      en : "Golmud"
    }
  },
  GOR : {
    country: "ET",
    name: {
      en : "Gore"
    }
  },
  GOS : {
    country: "AU",
    name: {
      en : "Gosford"
    }
  },
  GOT : {
    country: "SE",
    name: {
      en : "Gothenburg"
    }
  },
  GOU : {
    country: "CM",
    name: {
      en : "Garoua"
    }
  },
  GOV : {
    country: "AU",
    name: {
      en : "Gove"
    }
  },
  GOY : {
    country: "RU",
    name: {
      en : "Tura"
    }
  },
  GOZ : {
    country: "BG",
    name: {
      en : "Gorna Orjahovica"
    }
  },
  GPA : {
    country: "GR",
    name: {
      en : "Patras"
    }
  },
  GPB : {
    country: "BR",
    name: {
      en : "Guarapuava"
    }
  },
  GPI : {
    country: "CO",
    name: {
      en : "Guapi"
    }
  },
  GPN : {
    country: "AU",
    name: {
      en : "Garden Point"
    }
  },
  GPO : {
    country: "AR",
    name: {
      en : "General Pico"
    }
  },
  GPS : {
    country: "EC",
    name: {
      en : "Galapagos Is"
    }
  },
  GPT : {
    country: "US",
    name: {
      en : "Gulfport"
    }
  },
  GPZ : {
    country: "US",
    name: {
      en : "Grand Rapids"
    }
  },
  GQQ : {
    country: "US",
    name: {
      en : "Galion"
    }
  },
  GRB : {
    country: "US",
    name: {
      en : "Green Bay"
    }
  },
  GRD : {
    country: "US",
    name: {
      en : "Greenwood"
    }
  },
  GRI : {
    country: "US",
    name: {
      en : "Grand Island"
    }
  },
  GRJ : {
    country: "ZA",
    name: {
      en : "George"
    }
  },
  GRM : {
    country: "US",
    name: {
      en : "Grand Marais"
    }
  },
  GRO : {
    country: "ES",
    name: {
      en : "Gerona"
    }
  },
  GRP : {
    country: "BR",
    name: {
      en : "Gurupi"
    }
  },
  GRQ : {
    country: "NL",
    name: {
      en : "Groningen"
    }
  },
  GRR : {
    country: "US",
    name: {
      en : "Grand Rapids"
    }
  },
  GRS : {
    country: "IT",
    name: {
      en : "Grosseto"
    }
  },
  GRV : {
    country: "RU",
    name: {
      en : "Groznyj"
    }
  },
  GRW : {
    country: "PT",
    name: {
      en : "Graciosa Island"
    }
  },
  GRX : {
    country: "ES",
    name: {
      en : "Granada"
    }
  },
  GRY : {
    country: "IS",
    name: {
      en : "Grimsey"
    }
  },
  GRZ : {
    country: "AT",
    name: {
      en : "Graz"
    }
  },
  GSA : {
    country: "MY",
    name: {
      en : "Sabah"
    }
  },
  GSB : {
    country: "US",
    name: {
      en : "Goldsboro"
    }
  },
  GSH : {
    country: "US",
    name: {
      en : "Goshen"
    }
  },
  GSM : {
    country: "IR",
    name: {
      en : "Gheshm"
    }
  },
  GSO : {
    country: "US",
    name: {
      en : "Greensboro"
    }
  },
  GSP : {
    country: "US",
    name: {
      en : "Greenville"
    }
  },
  GSQ : {
    country: "EG",
    name: {
      en : "Shark Elowainat"
    }
  },
  GST : {
    country: "US",
    name: {
      en : "Glacier Bay"
    }
  },
  GSY : {
    country: "GB",
    name: {
      en : "Grimsby"
    }
  },
  GTA : {
    country: "SB",
    name: {
      en : "Gatokae"
    }
  },
  GTB : {
    country: "MY",
    name: {
      en : "Genting"
    }
  },
  GTE : {
    country: "AU",
    name: {
      en : "Grte Eylandt"
    }
  },
  GTF : {
    country: "US",
    name: {
      en : "Great Falls"
    }
  },
  GTI : {
    country: "DE",
    name: {
      en : "Guettin"
    }
  },
  GTN : {
    country: "NZ",
    name: {
      en : "Mt Cook"
    }
  },
  GTO : {
    country: "ID",
    name: {
      en : "Gorontalo"
    }
  },
  GTR : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  GTS : {
    country: "AU",
    name: {
      en : "Granites"
    }
  },
  GTT : {
    country: "AU",
    name: {
      en : "Georgetown"
    }
  },
  GTY : {
    country: "US",
    name: {
      en : "Gettysburg"
    }
  },
  GTZ : {
    country: "TZ",
    name: {
      en : "Grumeti"
    }
  },
  GUA : {
    country: "GT",
    name: {
      en : "Guatemala City"
    }
  },
  GUC : {
    country: "US",
    name: {
      en : "Gunnison"
    }
  },
  GUF : {
    country: "US",
    name: {
      en : "Gulf Shores"
    }
  },
  GUG : {
    country: "PG",
    name: {
      en : "Guari"
    }
  },
  GUH : {
    country: "AU",
    name: {
      en : "Gunnedah"
    }
  },
  GUI : {
    country: "VE",
    name: {
      en : "Guiria"
    }
  },
  GUJ : {
    country: "BR",
    name: {
      en : "Guaratingueta"
    }
  },
  GUL : {
    country: "AU",
    name: {
      en : "Goulburn"
    }
  },
  GUM : {
    country: "GU",
    name: {
      en : "Guam"
    }
  },
  GUP : {
    country: "US",
    name: {
      en : "Gallup"
    }
  },
  GUQ : {
    country: "VE",
    name: {
      en : "Guanare"
    }
  },
  GUR : {
    country: "PG",
    name: {
      en : "Alotau"
    }
  },
  GUT : {
    country: "DE",
    name: {
      en : "Gutersloh"
    }
  },
  GUU : {
    country: "IS",
    name: {
      en : "Grundarfjordur"
    }
  },
  GUW : {
    country: "KZ",
    name: {
      en : "Atyrau"
    }
  },
  GUY : {
    country: "US",
    name: {
      en : "Guymon"
    }
  },
  GUZ : {
    country: "BR",
    name: {
      en : "Guarapari"
    }
  },
  GVA : {
    country: "CH",
    popularity: 744,
    name: {
      en : "Geneva"
    }
  },
  GVI : {
    country: "PG",
    name: {
      en : "Green River"
    }
  },
  GVL : {
    country: "US",
    name: {
      en : "Gainesville"
    }
  },
  GVN : {
    country: "RU",
    name: {
      en : "Sovetskaya Gavan"
    }
  },
  GVR : {
    country: "BR",
    name: {
      en : "Governador Valadares"
    }
  },
  GVT : {
    country: "US",
    name: {
      en : "Greenville"
    }
  },
  GVX : {
    country: "SE",
    name: {
      en : "Gavle"
    }
  },
  GWD : {
    country: "PK",
    name: {
      en : "Gwadar"
    }
  },
  GWE : {
    country: "ZW",
    name: {
      en : "Gweru"
    }
  },
  GWL : {
    country: "IN",
    name: {
      en : "Gwalior"
    }
  },
  GWO : {
    country: "US",
    name: {
      en : "Greenwood"
    }
  },
  GWS : {
    country: "US",
    name: {
      en : "Glenwood Springs"
    }
  },
  GWT : {
    country: "DE",
    name: {
      en : "Westerland"
    }
  },
  GWY : {
    country: "IE",
    name: {
      en : "Galway"
    }
  },
  GXF : {
    country: "YE",
    name: {
      en : "Seiyun"
    }
  },
  GXQ : {
    country: "CL",
    name: {
      en : "Coyhaique"
    }
  },
  GXY : {
    country: "US",
    name: {
      en : "Greeley"
    }
  },
  GYA : {
    country: "BO",
    name: {
      en : "Guayaramerin"
    }
  },
  GYE : {
    country: "EC",
    name: {
      en : "Guayaquil"
    }
  },
  GYI : {
    country: "RW",
    name: {
      en : "Gisenyi"
    }
  },
  GYL : {
    country: "AU",
    name: {
      en : "Argyle"
    }
  },
  GYM : {
    country: "MX",
    name: {
      en : "Guaymas"
    }
  },
  GYN : {
    country: "BR",
    name: {
      en : "Goiania"
    }
  },
  GYP : {
    country: "AU",
    name: {
      en : "Gympie"
    }
  },
  GYR : {
    country: "US",
    name: {
      en : "Goodyear"
    }
  },
  GYS : {
    country: "CN",
    name: {
      en : "Guang Yuan"
    }
  },
  GYU : {
    country: "CN",
    name: {
      en : "Guyuan"
    }
  },
  GYY : {
    country: "US",
    name: {
      en : "Gary"
    }
  },
  GZA : {
    country: "PS",
    name: {
      en : "Gaza"
    }
  },
  GZM : {
    country: "MT",
    popularity: 2,
    name: {
      en : "Gozo"
    }
  },
  GZO : {
    country: "SB",
    name: {
      en : "Gizo"
    }
  },
  GZP : {
    country: "TR",
    popularity: 12000,
    name: {
      en : "Alanya"
    }
  },
  GZT : {
    country: "TR",
    name: {
      en : "Gaziantep"
    }
  },
  HAA : {
    country: "NO",
    name: {
      en : "Hasvik"
    }
  },
  HAC : {
    country: "JP",
    name: {
      en : "Hachijo Jima"
    }
  },
  HAD : {
    country: "SE",
    name: {
      en : "Halmstad"
    }
  },
  HAE : {
    country: "US",
    name: {
      en : "Havasupai"
    }
  },
  HAG : {
    country: "NL",
    name: {
      en : "The Hague"
    }
  },
  HAJ : {
    country: "DE",
    popularity: 8,
    name: {
      en : "Hannover"
    }
  },
  HAK : {
    country: "CN",
    name: {
      en : "Haikou"
    }
  },
  HAM : {
    country: "DE",
    popularity: 54,
    name: {
      en : "Hamburg"
    }
  },
  HAN : {
    country: "VN",
    popularity: 22,
    name: {
      en : "Hanoi"
    }
  },
  HAP : {
    country: "AU",
    name: {
      en : "Long Island"
    }
  },
  HAQ : {
    country: "MV",
    name: {
      en : "Hanimaadhoo"
    }
  },
  HAR : {
    country: "US",
    name: {
      en : "Harrisburg"
    }
  },
  HAS : {
    country: "SA",
    name: {
      en : "Hail"
    }
  },
  HAU : {
    country: "NO",
    name: {
      en : "Haugesund"
    }
  },
  HAV : {
    country: "CU",
    popularity: 218,
    name: {
      en : "Havana"
    }
  },
  HAW : {
    country: "GB",
    name: {
      en : "Haverfordwest"
    }
  },
  HBA : {
    country: "AU",
    name: {
      en : "Hobart"
    }
  },
  HBE : {
    country: "EG",
    name: {
      en : "Borg El Arab"
    }
  },
  HBG : {
    country: "US",
    name: {
      en : "Hattiesburg"
    }
  },
  HBI : {
    country: "BS",
    name: {
      en : "Harbour Island"
    }
  },
  HBT : {
    country: "SA",
    name: {
      en : "Hafr Albatin"
    }
  },
  HBX : {
    country: "IN",
    name: {
      en : "Hubli"
    }
  },
  HBZ : {
    country: "DE",
    name: {
      en : "Heber"
    }
  },
  HCN : {
    country: "TW",
    name: {
      en : "Hengchun"
    }
  },
  HCQ : {
    country: "AU",
    name: {
      en : "Halls Creek"
    }
  },
  HCR : {
    country: "US",
    name: {
      en : "Holy Cross"
    }
  },
  HDB : {
    country: "DE",
    name: {
      en : "Heidelberg"
    }
  },
  HDD : {
    country: "PK",
    name: {
      en : "Hyderabad"
    }
  },
  HDF : {
    country: "DE",
    name: {
      en : "Heringsdorf"
    }
  },
  HDG : {
    country: "CN",
    name: {
      en : "HDG"
    }
  },
  HDM : {
    country: "IR",
    name: {
      en : "Hamadan"
    }
  },
  HDN : {
    country: "US",
    name: {
      en : "Hayden"
    }
  },
  HDS : {
    country: "ZA",
    name: {
      en : "Hoedspruit"
    }
  },
  HDY : {
    country: "TH",
    name: {
      en : "Hat Yai"
    }
  },
  HEA : {
    country: "AF",
    name: {
      en : "Herat"
    }
  },
  HEH : {
    country: "MM",
    name: {
      en : "Heho"
    }
  },
  HEI : {
    country: "DE",
    name: {
      en : "Heide Buesum"
    }
  },
  HEK : {
    country: "CN",
    name: {
      en : "Heihe"
    }
  },
  HEL : {
    country: "FI",
    popularity: 368,
    name: {
      en : "Helsinki"
    }
  },
  HER : {
    country: "GR",
    popularity: 14,
    name: {
      en : "Heraklion"
    }
  },
  HET : {
    country: "CN",
    name: {
      en : "Hohhot"
    }
  },
  HEV : {
    country: "ES",
    name: {
      en : "Huelva"
    }
  },
  HEZ : {
    country: "US",
    name: {
      en : "Natchez"
    }
  },
  HFA : {
    country: "IL",
    popularity: 12,
    name: {
      en : "Haifa"
    }
  },
  HFD : {
    country: "US",
    name: {
      en : "Hartford"
    }
  },
  HFE : {
    country: "CN",
    name: {
      en : "Hefei"
    }
  },
  HFN : {
    country: "IS",
    name: {
      en : "Hornafjordur"
    }
  },
  HFS : {
    country: "SE",
    name: {
      en : "Hagfors"
    }
  },
  HFT : {
    country: "NO",
    name: {
      en : "Hammerfest"
    }
  },
  HGA : {
    country: "SO",
    name: {
      en : "Hargeisa"
    }
  },
  HGD : {
    country: "AU",
    name: {
      en : "Hughenden"
    }
  },
  HGH : {
    country: "CN",
    name: {
      en : "Hangzhou"
    }
  },
  HGL : {
    country: "DE",
    name: {
      en : "Helgoland"
    }
  },
  HGN : {
    country: "TH",
    name: {
      en : "Mae Hongson"
    }
  },
  HGO : {
    country: "CI",
    name: {
      en : "Korhogo"
    }
  },
  HGR : {
    country: "US",
    name: {
      en : "Hagerstown"
    }
  },
  HGU : {
    country: "PG",
    name: {
      en : "Mt Hagen"
    }
  },
  HHA : {
    country: "CN",
    name: {
      en : "Huanghua"
    }
  },
  HHE : {
    country: "JP",
    name: {
      en : "Hachinohe"
    }
  },
  HHH : {
    country: "US",
    name: {
      en : "Hilton Head"
    }
  },
  HHQ : {
    country: "TH",
    name: {
      en : "Hua Hin"
    }
  },
  HHR : {
    country: "US",
    name: {
      en : "Hawthorne"
    }
  },
  HHZ : {
    country: "PF",
    name: {
      en : "Hikueru"
    }
  },
  HIA : {
    country: "CN",
    name: {
      en : "Huaian"
    }
  },
  HIB : {
    country: "US",
    name: {
      en : "Hibbing"
    }
  },
  HID : {
    country: "AU",
    name: {
      en : "Horn Island"
    }
  },
  HII : {
    country: "US",
    name: {
      en : "Lake Havasu Cty"
    }
  },
  HIJ : {
    country: "JP",
    name: {
      en : "Hiroshima"
    }
  },
  HIL : {
    country: "ET",
    name: {
      en : "Shillavo"
    }
  },
  HIN : {
    country: "KR",
    name: {
      en : "Chinju"
    }
  },
  HIO : {
    country: "US",
    name: {
      en : "Hillsboro"
    }
  },
  HIR : {
    country: "SB",
    name: {
      en : "Honiara"
    }
  },
  HIS : {
    country: "AU",
    name: {
      en : "Hayman Island"
    }
  },
  HIX : {
    country: "PF",
    name: {
      en : "Hiva Oa"
    }
  },
  HJJ : {
    country: "CN",
    name: {
      en : "Zhijiang"
    }
  },
  HJR : {
    country: "IN",
    name: {
      en : "Khajuraho"
    }
  },
  HKA : {
    country: "US",
    name: {
      en : "Blytheville"
    }
  },
  HKB : {
    country: "US",
    name: {
      en : "Healy Lake"
    }
  },
  HKD : {
    country: "JP",
    name: {
      en : "Hakodate"
    }
  },
  HKG : {
    country: "HK",
    popularity: 96,
    name: {
      en : "Hong Kong"
    }
  },
  HKK : {
    country: "NZ",
    name: {
      en : "Hokitika"
    }
  },
  HKN : {
    country: "PG",
    name: {
      en : "Hoskins"
    }
  },
  HKT : {
    country: "TH",
    popularity: 18,
    name: {
      en : "Phuket"
    }
  },
  HKY : {
    country: "US",
    name: {
      en : "Hickory"
    }
  },
  HLA : {
    country: "ZA",
    name: {
      en : "Lanseria"
    }
  },
  HLB : {
    country: "US",
    name: {
      en : "Batesville"
    }
  },
  HLD : {
    country: "CN",
    name: {
      en : "Hailar"
    }
  },
  HLE : {
    country: "GB",
    name: {
      en : "Saint Helena"
    }
  },
  HLF : {
    country: "SE",
    name: {
      en : "Hultsfred"
    }
  },
  HLG : {
    country: "US",
    name: {
      en : "Wheeling"
    }
  },
  HLH : {
    country: "CN",
    name: {
      en : "Ulanhot"
    }
  },
  HLJ : {
    country: "LT",
    name: {
      en : "Barysiai"
    }
  },
  HLM : {
    country: "US",
    name: {
      en : "Holland"
    }
  },
  HLN : {
    country: "US",
    name: {
      en : "Helena"
    }
  },
  HLQ : {
    country: "GR",
    name: {
      en : "Agrinion"
    }
  },
  HLS : {
    country: "AU",
    name: {
      en : "St Helens"
    }
  },
  HLT : {
    country: "AU",
    name: {
      en : "Hamilton"
    }
  },
  HLW : {
    country: "ZA",
    name: {
      en : "Hluhluwe"
    }
  },
  HLY : {
    country: "GB",
    name: {
      en : "Holyhead"
    }
  },
  HLZ : {
    country: "NZ",
    name: {
      en : "Hamilton"
    }
  },
  HMA : {
    country: "RU",
    name: {
      en : "Khanty Mansiysk"
    }
  },
  HMB : {
    country: "EG",
    name: {
      en : "HMB"
    }
  },
  HME : {
    country: "DZ",
    name: {
      en : "Hassi Messaoud"
    }
  },
  HMI : {
    country: "CN",
    name: {
      en : "Hami"
    }
  },
  HMJ : {
    country: "UA",
    name: {
      en : "Khmelnitskiy"
    }
  },
  HMO : {
    country: "MX",
    popularity: 6,
    name: {
      en : "Hermosillo"
    }
  },
  HMR : {
    country: "NO",
    name: {
      en : "Hamar"
    }
  },
  HMT : {
    country: "US",
    name: {
      en : "Hemet"
    }
  },
  HMV : {
    country: "SE",
    name: {
      en : "Hemavan"
    }
  },
  HNA : {
    country: "JP",
    name: {
      en : "Morioka"
    }
  },
  HNB : {
    country: "US",
    name: {
      en : "Huntingburg"
    }
  },
  HNC : {
    country: "US",
    name: {
      en : "Hatteras"
    }
  },
  HNH : {
    country: "US",
    name: {
      en : "Hoonah"
    }
  },
  HNK : {
    country: "AU",
    name: {
      en : "Hinchinbrooke Is"
    }
  },
  HNL : {
    country: "US",
    popularity: 42,
    name: {
      en : "Honolulu"
    }
  },
  HNM : {
    country: "US",
    name: {
      en : "Hana"
    }
  },
  HNS : {
    country: "US",
    name: {
      en : "Haines"
    }
  },
  HNY : {
    country: "CN",
    name: {
      en : "Hengyang"
    }
  },
  HOB : {
    country: "US",
    name: {
      en : "Hobbs"
    }
  },
  HOD : {
    country: "YE",
    name: {
      en : "Hodeidah"
    }
  },
  HOE : {
    country: "LA",
    name: {
      en : "Houeisay"
    }
  },
  HOF : {
    country: "SA",
    name: {
      en : "Hofuf"
    }
  },
  HOG : {
    country: "CU",
    popularity: 4,
    name: {
      en : "Holguin"
    }
  },
  HOI : {
    country: "PF",
    name: {
      en : "Hao Island"
    }
  },
  HOM : {
    country: "US",
    name: {
      en : "Homer"
    }
  },
  HON : {
    country: "US",
    name: {
      en : "Huron"
    }
  },
  HOP : {
    country: "US",
    name: {
      en : "Hopkinsville"
    }
  },
  HOQ : {
    country: "DE",
    name: {
      en : "Hof De"
    }
  },
  HOR : {
    country: "PT",
    name: {
      en : "Horta"
    }
  },
  HOT : {
    country: "US",
    name: {
      en : "Hot Springs"
    }
  },
  HOU : {
    country: "US",
    popularity: 123,
    name: {
      en : "Houston"
    }
  },
  HOV : {
    country: "NO",
    name: {
      en : "Orsta Volda"
    }
  },
  HPA : {
    country: "TO",
    name: {
      en : "Ha Apai"
    }
  },
  HPB : {
    country: "US",
    name: {
      en : "Hooper Bay"
    }
  },
  HPH : {
    country: "VN",
    name: {
      en : "Haiphong"
    }
  },
  HPN : {
    country: "US",
    name: {
      en : "White Plains"
    }
  },
  HPP : {
    country: "KH",
    name: {
      en : "Poipet"
    }
  },
  HPV : {
    country: "US",
    name: {
      en : "Princeville"
    }
  },
  HQM : {
    country: "US",
    name: {
      en : "Hoquaim"
    }
  },
  HRB : {
    country: "CN",
    name: {
      en : "Harbin"
    }
  },
  HRD : {
    country: "NO",
    name: {
      en : "Harstad"
    }
  },
  HRE : {
    country: "ZW",
    name: {
      en : "Harare"
    }
  },
  HRG : {
    country: "EG",
    popularity: 52,
    name: {
      en : "Hurghada"
    }
  },
  HRI : {
    country: "LK",
    name: {
      en : "Hambantota"
    }
  },
  HRK : {
    country: "UA",
    popularity: 10,
    name: {
      en : "Kharkov"
    }
  },
  HRL : {
    country: "US",
    name: {
      en : "Harlingen"
    }
  },
  HRO : {
    country: "US",
    name: {
      en : "Harrison"
    }
  },
  HRS : {
    country: "ZA",
    name: {
      en : "Harrismith"
    }
  },
  HRT : {
    country: "GB",
    name: {
      en : "Harrogate"
    }
  },
  HRZ : {
    country: "BR",
    name: {
      en : "Horizontina"
    }
  },
  HSA : {
    country: "KZ",
    name: {
      en : "Turkistan"
    }
  },
  HSG : {
    country: "JP",
    name: {
      en : "Saga"
    }
  },
  HSI : {
    country: "US",
    name: {
      en : "Hastings"
    }
  },
  HSK : {
    country: "ES",
    name: {
      en : "Huesca"
    }
  },
  HSL : {
    country: "US",
    name: {
      en : "Huslia"
    }
  },
  HSM : {
    country: "AU",
    name: {
      en : "Horsham"
    }
  },
  HSN : {
    country: "CN",
    name: {
      en : "Zhoushan"
    }
  },
  HSP : {
    country: "US",
    name: {
      en : "Hot Springs"
    }
  },
  HST : {
    country: "US",
    name: {
      en : "Homestead"
    }
  },
  HSV : {
    country: "US",
    name: {
      en : "Huntsville"
    }
  },
  HSZ : {
    country: "TW",
    name: {
      en : "Hsinchun"
    }
  },
  HTA : {
    country: "RU",
    popularity: 6,
    name: {
      en : "Chita"
    }
  },
  HTF : {
    country: "GB",
    name: {
      en : "Hatfield"
    }
  },
  HTG : {
    country: "RU",
    name: {
      en : "Hatanga"
    }
  },
  HTH : {
    country: "US",
    name: {
      en : "Hawthorne"
    }
  },
  HTI : {
    country: "AU",
    name: {
      en : "Hamilton Island"
    }
  },
  HTN : {
    country: "CN",
    name: {
      en : "Hotan"
    }
  },
  HTO : {
    country: "US",
    name: {
      en : "East Hampton"
    }
  },
  HTR : {
    country: "JP",
    name: {
      en : "Hateruma"
    }
  },
  HTS : {
    country: "US",
    name: {
      en : "Huntington"
    }
  },
  HTV : {
    country: "US",
    name: {
      en : "Huntsville"
    }
  },
  HTY : {
    country: "TR",
    name: {
      en : "Antakya"
    }
  },
  HUC : {
    country: "US",
    name: {
      en : "Humacao"
    }
  },
  HUE : {
    country: "ET",
    name: {
      en : "Humera"
    }
  },
  HUF : {
    country: "US",
    name: {
      en : "Terre Haute"
    }
  },
  HUH : {
    country: "PF",
    name: {
      en : "Huahine"
    }
  },
  HUI : {
    country: "VN",
    name: {
      en : "Hu PG"
    }
  },
  HUM : {
    country: "US",
    name: {
      en : "Houma"
    }
  },
  HUN : {
    country: "TW",
    popularity: 2,
    name: {
      en : "Hualien"
    }
  },
  HUQ : {
    country: "LY",
    name: {
      en : "Houn"
    }
  },
  HUS : {
    country: "US",
    name: {
      en : "Hughes"
    }
  },
  HUT : {
    country: "US",
    name: {
      en : "Hutchinson"
    }
  },
  HUU : {
    country: "PE",
    name: {
      en : "Huanuco"
    }
  },
  HUV : {
    country: "SE",
    name: {
      en : "Hudiksvall"
    }
  },
  HUW : {
    country: "BR",
    name: {
      en : "Kirmington"
    }
  },
  HUX : {
    country: "MX",
    name: {
      en : "Santa Cruz Huatulco"
    }
  },
  HUY : {
    country: "GB",
    popularity: 4,
    name: {
      en : "Humberside"
    }
  },
  HUZ : {
    country: "CN",
    name: {
      en : "Huizhou"
    }
  },
  HVA : {
    country: "MG",
    name: {
      en : "Analalava"
    }
  },
  HVB : {
    country: "AU",
    name: {
      en : "Hervey Bay"
    }
  },
  HVD : {
    country: "MN",
    name: {
      en : "Khovd"
    }
  },
  HVE : {
    country: "US",
    name: {
      en : "Hanksville"
    }
  },
  HVG : {
    country: "NO",
    name: {
      en : "Honningsvag"
    }
  },
  HVK : {
    country: "IS",
    name: {
      en : "Holmavik"
    }
  },
  HVN : {
    country: "US",
    name: {
      en : "New Haven"
    }
  },
  HVR : {
    country: "US",
    name: {
      en : "Havre"
    }
  },
  HVS : {
    country: "US",
    name: {
      en : "Hartsville"
    }
  },
  HWA : {
    country: "PG",
    name: {
      en : "Hawabango"
    }
  },
  HWD : {
    country: "US",
    name: {
      en : "Hayward"
    }
  },
  HWI : {
    country: "US",
    name: {
      en : "Hawk Inlet"
    }
  },
  HWN : {
    country: "ZW",
    name: {
      en : "Hwange"
    }
  },
  HXX : {
    country: "AU",
    name: {
      en : "Hay AU"
    }
  },
  HYA : {
    country: "US",
    name: {
      en : "Hyannis"
    }
  },
  HYC : {
    country: "GB",
    name: {
      en : "High Wycombe"
    }
  },
  HYD : {
    country: "IN",
    name: {
      en : "Hyderabad"
    }
  },
  HYF : {
    country: "PG",
    name: {
      en : "Hayfields"
    }
  },
  HYG : {
    country: "US",
    name: {
      en : "Hydaburg"
    }
  },
  HYL : {
    country: "US",
    name: {
      en : "Hollis"
    }
  },
  HYN : {
    country: "CN",
    name: {
      en : "Huangyan"
    }
  },
  HYR : {
    country: "US",
    name: {
      en : "Hayward"
    }
  },
  HYS : {
    country: "US",
    name: {
      en : "Hays"
    }
  },
  HZG : {
    country: "CN",
    name: {
      en : "Hanzhong"
    }
  },
  HZH : {
    country: "CN",
    name: {
      en : "Liping City"
    }
  },
  HZK : {
    country: "IS",
    name: {
      en : "Husavik"
    }
  },
  HZL : {
    country: "US",
    name: {
      en : "Hazelton"
    }
  },
  IAA : {
    country: "RU",
    name: {
      en : "Igarka"
    }
  },
  IAG : {
    country: "US",
    name: {
      en : "Niagara Falls"
    }
  },
  IAM : {
    country: "DZ",
    name: {
      en : "In Amenas"
    }
  },
  IAN : {
    country: "US",
    name: {
      en : "Kiana"
    }
  },
  IAO : {
    country: "PH",
    name: {
      en : "Del Carmin"
    }
  },
  IAR : {
    country: "RU",
    name: {
      en : "Yaroslavl"
    }
  },
  IAS : {
    country: "RO",
    name: {
      en : "Iasi"
    }
  },
  IBA : {
    country: "NG",
    name: {
      en : "Ibadan"
    }
  },
  IBE : {
    country: "CO",
    name: {
      en : "Ibague"
    }
  },
  IBR : {
    country: "JP",
    name: {
      en : "Omitami Iba"
    }
  },
  IBZ : {
    country: "ES",
    popularity: 16,
    name: {
      en : "Ibiza"
    }
  },
  ICI : {
    country: "FJ",
    name: {
      en : "Cicia"
    }
  },
  ICK : {
    country: "SR",
    name: {
      en : "Nieuw Nickerie"
    }
  },
  ICT : {
    country: "US",
    name: {
      en : "Wichita"
    }
  },
  IDA : {
    country: "US",
    name: {
      en : "Idaho Falls"
    }
  },
  IDI : {
    country: "US",
    name: {
      en : "Indiana"
    }
  },
  IDN : {
    country: "PG",
    name: {
      en : "Indagen"
    }
  },
  IDR : {
    country: "IN",
    name: {
      en : "Indore"
    }
  },
  IEG : {
    country: "PL",
    name: {
      en : "Zielona"
    }
  },
  IEV : {
    country: "UA",
    popularity: 1194,
    name: {
      en : "Kiev"
    }
  },
  IFJ : {
    country: "IS",
    name: {
      en : "Isafjordur"
    }
  },
  IFN : {
    country: "IR",
    name: {
      en : "Isfahan"
    }
  },
  IFO : {
    country: "UA",
    name: {
      en : "Ivano-Frankivsk"
    }
  },
  IFP : {
    country: "US",
    name: {
      en : "Bullhead City"
    }
  },
  IGA : {
    country: "BS",
    name: {
      en : "Inagua"
    }
  },
  IGD : {
    country: "TR",
    name: {
      en : "Igdir"
    }
  },
  IGG : {
    country: "US",
    name: {
      en : "Igiugig"
    }
  },
  IGH : {
    country: "AU",
    name: {
      en : "Ingham"
    }
  },
  IGM : {
    country: "US",
    name: {
      en : "Kingman"
    }
  },
  IGO : {
    country: "CO",
    name: {
      en : "Chigoro"
    }
  },
  IGR : {
    country: "AR",
    name: {
      en : "Iguazu"
    }
  },
  IGS : {
    country: "DE",
    name: {
      en : "Ingolstadt"
    }
  },
  IGT : {
    country: "RU",
    name: {
      en : "Magas"
    }
  },
  IGU : {
    country: "BR",
    name: {
      en : "Iguassu Falls"
    }
  },
  IHN : {
    country: "YE",
    name: {
      en : "Qishn"
    }
  },
  IHO : {
    country: "MG",
    name: {
      en : "Ihosy"
    }
  },
  IHR : {
    country: "IR",
    name: {
      en : "Iran Shahr"
    }
  },
  IHU : {
    country: "PG",
    name: {
      en : "Ihu"
    }
  },
  IIA : {
    country: "IE",
    name: {
      en : "Inishmaan"
    }
  },
  IIL : {
    country: "IR",
    name: {
      en : "Ilaam"
    }
  },
  IIS : {
    country: "PG",
    name: {
      en : "Nissan"
    }
  },
  IJK : {
    country: "RU",
    name: {
      en : "Izhevsk"
    }
  },
  IJX : {
    country: "US",
    name: {
      en : "Jacksonville"
    }
  },
  IKI : {
    country: "JP",
    name: {
      en : "Iki Jp"
    }
  },
  IKK : {
    country: "US",
    name: {
      en : "Kankakee"
    }
  },
  IKO : {
    country: "US",
    name: {
      en : "Nikolski"
    }
  },
  IKP : {
    country: "AU",
    name: {
      en : "Inkerman"
    }
  },
  IKS : {
    country: "RU",
    name: {
      en : "Tiksi"
    }
  },
  IKT : {
    country: "RU",
    popularity: 18,
    name: {
      en : "Irkutsk"
    }
  },
  IKU : {
    country: "KG",
    popularity: 3,
    name: {
      en : "Tamchy"
    }
  },
  ILD : {
    country: "ES",
    name: {
      en : "Lleida"
    }
  },
  ILE : {
    country: "US",
    name: {
      en : "Killeen"
    }
  },
  ILF : {
    country: "CA",
    name: {
      en : "Ilford"
    }
  },
  ILG : {
    country: "US",
    name: {
      en : "Wilmington"
    }
  },
  ILI : {
    country: "US",
    name: {
      en : "Iliamna"
    }
  },
  ILM : {
    country: "US",
    name: {
      en : "Wilmington"
    }
  },
  ILO : {
    country: "PH",
    name: {
      en : "Iloilo"
    }
  },
  ILP : {
    country: "NC",
    name: {
      en : "Ile des Pins"
    }
  },
  ILR : {
    country: "NG",
    name: {
      en : "Ilorin"
    }
  },
  ILY : {
    country: "GB",
    name: {
      en : "Islay"
    }
  },
  ILZ : {
    country: "SK",
    name: {
      en : "Zilina"
    }
  },
  IMA : {
    country: "PG",
    name: {
      en : "Iamalele"
    }
  },
  IMD : {
    country: "PG",
    name: {
      en : "Imonda"
    }
  },
  IMF : {
    country: "IN",
    name: {
      en : "Imphal"
    }
  },
  IMK : {
    country: "NP",
    name: {
      en : "Simikot"
    }
  },
  IMP : {
    country: "BR",
    name: {
      en : "Imperatriz"
    }
  },
  IMT : {
    country: "US",
    name: {
      en : "Iron Mountain"
    }
  },
  INA : {
    country: "RU",
    name: {
      en : "Inta"
    }
  },
  INC : {
    country: "CN",
    name: {
      en : "Yinchuan"
    }
  },
  IND : {
    country: "US",
    popularity: 2,
    name: {
      en : "Indianapolis"
    }
  },
  INF : {
    country: "DZ",
    name: {
      en : "Guezzam"
    }
  },
  ING : {
    country: "AR",
    name: {
      en : "Lago Argentino"
    }
  },
  INH : {
    country: "MZ",
    name: {
      en : "Inhambane"
    }
  },
  INI : {
    country: "RS",
    name: {
      en : "Nis RS"
    }
  },
  INL : {
    country: "US",
    name: {
      en : "International Falls"
    }
  },
  INM : {
    country: "AU",
    name: {
      en : "Innamincka"
    }
  },
  INN : {
    country: "AT",
    popularity: 10,
    name: {
      en : "Innsbruck"
    }
  },
  INO : {
    country: "CD",
    name: {
      en : "Inongo"
    }
  },
  INQ : {
    country: "IE",
    name: {
      en : "Inisheer"
    }
  },
  INT : {
    country: "US",
    name: {
      en : "Winston-Salem"
    }
  },
  INU : {
    country: "NR",
    name: {
      en : "Nauru Island"
    }
  },
  INV : {
    country: "GB",
    name: {
      en : "Inverness"
    }
  },
  INW : {
    country: "US",
    name: {
      en : "Winslow"
    }
  },
  INZ : {
    country: "DZ",
    name: {
      en : "In Salah"
    }
  },
  IOA : {
    country: "GR",
    name: {
      en : "Ioannina"
    }
  },
  IOK : {
    country: "PG",
    name: {
      en : "Iokea"
    }
  },
  IOM : {
    country: "GB",
    name: {
      en : "Isle Of Man"
    }
  },
  ION : {
    country: "CG",
    name: {
      en : "Impfondo"
    }
  },
  IOP : {
    country: "PG",
    name: {
      en : "Ioma"
    }
  },
  IOR : {
    country: "IE",
    name: {
      en : "Inishmore"
    }
  },
  IOS : {
    country: "BR",
    name: {
      en : "Ilheus"
    }
  },
  IOW : {
    country: "US",
    name: {
      en : "Iowa City"
    }
  },
  IPA : {
    country: "VU",
    name: {
      en : "Ipota"
    }
  },
  IPC : {
    country: "CL",
    popularity: 12,
    name: {
      en : "Easter Island"
    }
  },
  IPH : {
    country: "MY",
    popularity: 4,
    name: {
      en : "Ipoh"
    }
  },
  IPI : {
    country: "CO",
    name: {
      en : "Ipiales"
    }
  },
  IPL : {
    country: "US",
    name: {
      en : "El Centro"
    }
  },
  IPN : {
    country: "BR",
    name: {
      en : "Ipatinga"
    }
  },
  IPT : {
    country: "US",
    name: {
      en : "Williamsport"
    }
  },
  IPW : {
    country: "GB",
    name: {
      en : "Ipswich"
    }
  },
  IQA : {
    country: "IQ",
    name: {
      en : "Iqaluit"
    }
  },
  IQM : {
    country: "CN",
    name: {
      en : "Qiemo"
    }
  },
  IQN : {
    country: "CN",
    name: {
      en : "Qingyang"
    }
  },
  IQQ : {
    country: "CL",
    name: {
      en : "Iquique"
    }
  },
  IQT : {
    country: "PE",
    name: {
      en : "Iquitos"
    }
  },
  IRA : {
    country: "SB",
    name: {
      en : "Kirakira"
    }
  },
  IRC : {
    country: "US",
    name: {
      en : "Circle"
    }
  },
  IRG : {
    country: "AU",
    name: {
      en : "Lockhart"
    }
  },
  IRI : {
    country: "TZ",
    name: {
      en : "Iringa"
    }
  },
  IRJ : {
    country: "AR",
    name: {
      en : "La Rioja"
    }
  },
  IRK : {
    country: "US",
    name: {
      en : "Kirksville"
    }
  },
  IRM : {
    country: "RU",
    name: {
      en : "Igrim"
    }
  },
  IRP : {
    country: "CD",
    name: {
      en : "Isiro"
    }
  },
  IRS : {
    country: "US",
    name: {
      en : "Sturgis"
    }
  },
  IRZ : {
    country: "BR",
    name: {
      en : "Santa Isabel Rio Negro"
    }
  },
  ISA : {
    country: "AU",
    name: {
      en : "Mount Isa"
    }
  },
  ISB : {
    country: "PK",
    popularity: 4,
    name: {
      en : "Islamabad"
    }
  },
  ISC : {
    country: "GB",
    name: {
      en : "Scilly, Isles Of"
    }
  },
  ISE : {
    country: "TR",
    name: {
      en : "Isparta"
    }
  },
  ISG : {
    country: "JP",
    name: {
      en : "Ishigaki"
    }
  },
  ISH : {
    country: "IT",
    name: {
      en : "Ischia"
    }
  },
  ISJ : {
    country: "MX",
    name: {
      en : "Isla Mujeres"
    }
  },
  ISK : {
    country: "IN",
    name: {
      en : "Nasik"
    }
  },
  ISM : {
    country: "US",
    name: {
      en : "Kissimmee"
    }
  },
  ISN : {
    country: "US",
    name: {
      en : "Williston"
    }
  },
  ISO : {
    country: "US",
    name: {
      en : "Kinston"
    }
  },
  ISP : {
    country: "US",
    name: {
      en : "Islip"
    }
  },
  ISQ : {
    country: "US",
    name: {
      en : "Manistique"
    }
  },
  ISS : {
    country: "US",
    name: {
      en : "Wiscasset"
    }
  },
  IST : {
    country: "TR",
    popularity: 494,
    name: {
      en : "Istanbul"
    }
  },
  ISU : {
    country: "IQ",
    name: {
      en : "Sulaimaniyah"
    }
  },
  ISW : {
    country: "US",
    name: {
      en : "Wisconsin Rapids"
    }
  },
  ITB : {
    country: "BR",
    name: {
      en : "Itaituba"
    }
  },
  ITH : {
    country: "US",
    name: {
      en : "Ithaca"
    }
  },
  ITJ : {
    country: "BR",
    name: {
      en : "Itajai"
    }
  },
  ITK : {
    country: "PG",
    name: {
      en : "Itokama"
    }
  },
  ITN : {
    country: "BR",
    name: {
      en : "Itabuna"
    }
  },
  ITO : {
    country: "US",
    popularity: 4,
    name: {
      en : "Hilo"
    }
  },
  ITP : {
    country: "BR",
    name: {
      en : "Itaperuna"
    }
  },
  ITR : {
    country: "BR",
    name: {
      en : "Itumbiara"
    }
  },
  ITU : {
    country: "RU",
    name: {
      en : "Kurilsk"
    }
  },
  IUE : {
    country: "NU",
    name: {
      en : "Niue"
    }
  },
  IVA : {
    country: "MG",
    name: {
      en : "Ambanja"
    }
  },
  IVC : {
    country: "NZ",
    name: {
      en : "Invercargill"
    }
  },
  IVL : {
    country: "FI",
    name: {
      en : "Ivalo"
    }
  },
  IVR : {
    country: "AU",
    name: {
      en : "Inverell"
    }
  },
  IWA : {
    country: "RU",
    name: {
      en : "Ivanovo"
    }
  },
  IWD : {
    country: "US",
    name: {
      en : "Ironwood"
    }
  },
  IWJ : {
    country: "JP",
    name: {
      en : "Iwami"
    }
  },
  IWK : {
    country: "JP",
    name: {
      en : "Iwakuni"
    }
  },
  IXA : {
    country: "IN",
    name: {
      en : "Agartala"
    }
  },
  IXB : {
    country: "IN",
    popularity: 2,
    name: {
      en : "Bagdogra"
    }
  },
  IXC : {
    country: "IN",
    name: {
      en : "Chandigarh"
    }
  },
  IXD : {
    country: "IN",
    name: {
      en : "Allahabad"
    }
  },
  IXE : {
    country: "IN",
    name: {
      en : "Mangalore"
    }
  },
  IXG : {
    country: "IN",
    name: {
      en : "Belgaum"
    }
  },
  IXI : {
    country: "IN",
    name: {
      en : "Lilabari"
    }
  },
  IXJ : {
    country: "IN",
    name: {
      en : "Jammu"
    }
  },
  IXK : {
    country: "IN",
    name: {
      en : "Keshod"
    }
  },
  IXL : {
    country: "IN",
    popularity: 12,
    name: {
      en : "Leh IN"
    }
  },
  IXM : {
    country: "IN",
    popularity: 2,
    name: {
      en : "Madurai"
    }
  },
  IXP : {
    country: "IN",
    name: {
      en : "Pathankot"
    }
  },
  IXR : {
    country: "IN",
    name: {
      en : "Ranchi"
    }
  },
  IXS : {
    country: "IN",
    name: {
      en : "Silchar"
    }
  },
  IXU : {
    country: "IN",
    name: {
      en : "Aurangabad"
    }
  },
  IXW : {
    country: "IN",
    name: {
      en : "Jamshedpur"
    }
  },
  IXY : {
    country: "IN",
    name: {
      en : "Kandla"
    }
  },
  IXZ : {
    country: "IN",
    name: {
      en : "Port Blair"
    }
  },
  IYK : {
    country: "US",
    name: {
      en : "Inyokern"
    }
  },
  IZM : {
    country: "TR",
    popularity: 4,
    name: {
      en : "Izmir"
    }
  },
  IZO : {
    country: "JP",
    name: {
      en : "Izumo"
    }
  },
  IZT : {
    country: "MX",
    name: {
      en : "Ixtepec"
    }
  },
  JAB : {
    country: "AU",
    name: {
      en : "Jabiru"
    }
  },
  JAC : {
    country: "US",
    name: {
      en : "Jackson"
    }
  },
  JAD : {
    country: "AU",
    name: {
      en : "Jandakot"
    }
  },
  JAE : {
    country: "PE",
    name: {
      en : "Jaén"
    }
  },
  JAG : {
    country: "PK",
    name: {
      en : "Jacobabad"
    }
  },
  JAH : {
    country: "FR",
    name: {
      en : "Aubagne"
    }
  },
  JAI : {
    country: "IN",
    popularity: 2,
    name: {
      en : "Jaipur"
    }
  },
  JAL : {
    country: "MX",
    name: {
      en : "Jalapa"
    }
  },
  JAN : {
    country: "US",
    name: {
      en : "Jackson"
    }
  },
  JAP : {
    country: "CR",
    name: {
      en : "Punta Renes"
    }
  },
  JAQ : {
    country: "PG",
    name: {
      en : "Jacquinot"
    }
  },
  JAU : {
    country: "PE",
    name: {
      en : "Jauja"
    }
  },
  JAV : {
    country: "GL",
    name: {
      en : "Ilulissat"
    }
  },
  JAX : {
    country: "US",
    name: {
      en : "Jacksonville"
    }
  },
  JBB : {
    country: "ID",
    name: {
      en : "Jember Regency"
    }
  },
  JBK : {
    country: "US",
    name: {
      en : "Berkeley"
    }
  },
  JBQ : {
    country: "DO",
    name: {
      en : "Higuero"
    }
  },
  JBR : {
    country: "US",
    name: {
      en : "Jonesboro"
    }
  },
  JBS : {
    country: "US",
    name: {
      en : "Pleasanton"
    }
  },
  JCB : {
    country: "BR",
    name: {
      en : "Joacaba"
    }
  },
  JCH : {
    country: "GL",
    name: {
      en : "Qasigiannguit"
    }
  },
  JCK : {
    country: "AU",
    name: {
      en : "Julia Creek"
    }
  },
  JCN : {
    country: "KR",
    name: {
      en : "Incheon"
    }
  },
  JCU : {
    country: "ES",
    name: {
      en : "Ceuta"
    }
  },
  JDF : {
    country: "BR",
    name: {
      en : "Juiz De Fora"
    }
  },
  JDH : {
    country: "IN",
    name: {
      en : "Jodhpur"
    }
  },
  JDO : {
    country: "BR",
    name: {
      en : "Juazeiro Do Norte"
    }
  },
  JDR : {
    country: "BR",
    name: {
      en : "JDR"
    }
  },
  JDZ : {
    country: "CN",
    name: {
      en : "Jingdezhen"
    }
  },
  JED : {
    country: "SA",
    popularity: 4,
    name: {
      en : "Jeddah"
    }
  },
  JEF : {
    country: "US",
    name: {
      en : "Jefferson City"
    }
  },
  JEG : {
    country: "GL",
    name: {
      en : "Aasiaat"
    }
  },
  JEJ : {
    country: "MH",
    name: {
      en : "Jeh"
    }
  },
  JER : {
    country: "GB",
    name: {
      en : "Jersey"
    }
  },
  JEV : {
    country: "FR",
    name: {
      en : "Evry"
    }
  },
  JFM : {
    country: "AU",
    name: {
      en : "Fremantle"
    }
  },
  JFR : {
    country: "GL",
    name: {
      en : "Paamiut"
    }
  },
  JGA : {
    country: "IN",
    name: {
      en : "Jamnagar"
    }
  },
  JGD : {
    country: "CN",
    name: {
      en : "Jiagedaqi District"
    }
  },
  JGN : {
    country: "CN",
    name: {
      en : "Jiayuguan"
    }
  },
  JGO : {
    country: "GL",
    name: {
      en : "Qeqertarsuaq"
    }
  },
  JGR : {
    country: "GL",
    name: {
      en : "Groennedal"
    }
  },
  JGS : {
    country: "CN",
    name: {
      en : "Ji an"
    }
  },
  JHB : {
    country: "MY",
    name: {
      en : "Johor Bahru"
    }
  },
  JHC : {
    country: "US",
    name: {
      en : "Garden City"
    }
  },
  JHE : {
    country: "SE",
    name: {
      en : "Helsingborg"
    }
  },
  JHG : {
    country: "CN",
    name: {
      en : "Jinghong"
    }
  },
  JHM : {
    country: "US",
    name: {
      en : "Kapalua"
    }
  },
  JHQ : {
    country: "AU",
    name: {
      en : "Shute Hrb"
    }
  },
  JHS : {
    country: "GL",
    name: {
      en : "Sisimiut"
    }
  },
  JHW : {
    country: "US",
    name: {
      en : "Jamestown"
    }
  },
  JIB : {
    country: "DJ",
    name: {
      en : "Djibouti"
    }
  },
  JIC : {
    country: "CN",
    name: {
      en : "Jinchang"
    }
  },
  JIJ : {
    country: "ET",
    name: {
      en : "Jijiga"
    }
  },
  JIK : {
    country: "GR",
    name: {
      en : "Ikaria Island"
    }
  },
  JIL : {
    country: "CN",
    name: {
      en : "Jilin"
    }
  },
  JIM : {
    country: "ET",
    name: {
      en : "Jimma"
    }
  },
  JIQ : {
    country: "CN",
    name: {
      en : "Zhoubai Town"
    }
  },
  JIU : {
    country: "CN",
    name: {
      en : "Jiujiang"
    }
  },
  JIW : {
    country: "PK",
    name: {
      en : "Jiwani"
    }
  },
  JJD : {
    country: "BR",
    name: {
      en : "Jijoca de Jericoacoara"
    }
  },
  JJI : {
    country: "PE",
    name: {
      en : "Juanjui"
    }
  },
  JJM : {
    country: "KE",
    name: {
      en : "Meru-Kinna"
    }
  },
  JJN : {
    country: "CN",
    name: {
      en : "Jinjiang"
    }
  },
  JJU : {
    country: "GL",
    name: {
      en : "Qaqortoq"
    }
  },
  JKG : {
    country: "SE",
    name: {
      en : "Jonkoping"
    }
  },
  JKH : {
    country: "GR",
    popularity: 6,
    name: {
      en : "Chios"
    }
  },
  JKL : {
    country: "GR",
    name: {
      en : "Kalymnos Island"
    }
  },
  JKR : {
    country: "NP",
    name: {
      en : "Janakpur"
    }
  },
  JKT : {
    country: "ID",
    popularity: 45,
    name: {
      en : "Jakarta"
    }
  },
  JKV : {
    country: "US",
    name: {
      en : "Jacksonville"
    }
  },
  JLD : {
    country: "SE",
    name: {
      en : "Landskrona"
    }
  },
  JLN : {
    country: "US",
    name: {
      en : "Joplin"
    }
  },
  JLO : {
    country: "IT",
    name: {
      en : "Jesolo"
    }
  },
  JLP : {
    country: "FR",
    name: {
      en : "Juan Les Pins"
    }
  },
  JLR : {
    country: "IN",
    name: {
      en : "Jabalpur"
    }
  },
  JMC : {
    country: "US",
    name: {
      en : "Sausalito"
    }
  },
  JMJ : {
    country: "CN",
    name: {
      en : "Lancang Lahu Autonomous County"
    }
  },
  JMK : {
    country: "GR",
    popularity: 4,
    name: {
      en : "Mykonos"
    }
  },
  JMO : {
    country: "NP",
    name: {
      en : "Jomsom"
    }
  },
  JMS : {
    country: "US",
    name: {
      en : "Jamestown"
    }
  },
  JMU : {
    country: "CN",
    name: {
      en : "Jiamusi"
    }
  },
  JNB : {
    country: "ZA",
    name: {
      en : "Johannesburg"
    }
  },
  JNG : {
    country: "CN",
    name: {
      en : "Jining"
    }
  },
  JNN : {
    country: "GL",
    name: {
      en : "Nanortalik"
    }
  },
  JNS : {
    country: "GL",
    name: {
      en : "Narsaq"
    }
  },
  JNU : {
    country: "US",
    name: {
      en : "Juneau"
    }
  },
  JNX : {
    country: "GR",
    name: {
      en : "Naxos"
    }
  },
  JNZ : {
    country: "CN",
    name: {
      en : "Jinzhou"
    }
  },
  JOE : {
    country: "FI",
    name: {
      en : "Joensuu"
    }
  },
  JOG : {
    country: "ID",
    name: {
      en : "Yogjakarta"
    }
  },
  JOI : {
    country: "BR",
    name: {
      en : "Joinville"
    }
  },
  JOK : {
    country: "RU",
    name: {
      en : "Joshkar-Ola"
    }
  },
  JOL : {
    country: "PH",
    name: {
      en : "Jolo"
    }
  },
  JON : {
    country: "UM",
    name: {
      en : "Johnston Island"
    }
  },
  JOS : {
    country: "NG",
    name: {
      en : "Jos NG"
    }
  },
  JOT : {
    country: "US",
    name: {
      en : "Joliet"
    }
  },
  JPA : {
    country: "BR",
    name: {
      en : "Joao Pessoa"
    }
  },
  JPD : {
    country: "US",
    name: {
      en : "Pasadena"
    }
  },
  JPR : {
    country: "BR",
    name: {
      en : "Ji Parana"
    }
  },
  JQA : {
    country: "GL",
    name: {
      en : "Qaarsut"
    }
  },
  JQE : {
    country: "PA",
    name: {
      en : "Jaque"
    }
  },
  JQO : {
    country: "RU",
    name: {
      en : "JQO"
    }
  },
  JRH : {
    country: "IN",
    name: {
      en : "Jorhat"
    }
  },
  JRO : {
    country: "TZ",
    name: {
      en : "Kilimanjaro"
    }
  },
  JRS : {
    country: "IL",
    name: {
      en : "Jerusalem"
    }
  },
  JSH : {
    country: "GR",
    name: {
      en : "Sitia"
    }
  },
  JSI : {
    country: "GR",
    name: {
      en : "Skiathos"
    }
  },
  JSJ : {
    country: "CN",
    name: {
      en : "Jiansanjiang"
    }
  },
  JSM : {
    country: "AR",
    name: {
      en : "Jose De San Martin"
    }
  },
  JSO : {
    country: "SE",
    name: {
      en : "Sodertalje"
    }
  },
  JSR : {
    country: "BD",
    name: {
      en : "Jessore"
    }
  },
  JSS : {
    country: "GR",
    name: {
      en : "Spetsai Island"
    }
  },
  JST : {
    country: "US",
    name: {
      en : "Johnstown"
    }
  },
  JSU : {
    country: "GL",
    name: {
      en : "Maniitsoq"
    }
  },
  JSY : {
    country: "GR",
    name: {
      en : "Syros Island"
    }
  },
  JTC : {
    country: "BR",
    name: {
      en : "Bauru"
    }
  },
  JTR : {
    country: "GR",
    name: {
      en : "Thira"
    }
  },
  JTY : {
    country: "GR",
    popularity: 2,
    name: {
      en : "Astypalaia Island"
    }
  },
  JUB : {
    country: "SD",
    name: {
      en : "Juba"
    }
  },
  JUH : {
    country: "CN",
    name: {
      en : "Chizhou"
    }
  },
  JUI : {
    country: "DE",
    name: {
      en : "Juist"
    }
  },
  JUJ : {
    country: "AR",
    name: {
      en : "Jujuy"
    }
  },
  JUL : {
    country: "PE",
    name: {
      en : "Juliaca"
    }
  },
  JUM : {
    country: "NP",
    name: {
      en : "Jumla"
    }
  },
  JUO : {
    country: "CO",
    name: {
      en : "Jurado"
    }
  },
  JUV : {
    country: "GL",
    name: {
      en : "Upernavik"
    }
  },
  JUZ : {
    country: "CN",
    name: {
      en : "Juzhou"
    }
  },
  JVA : {
    country: "MG",
    name: {
      en : "Ankavandra"
    }
  },
  JVL : {
    country: "US",
    name: {
      en : "Beloit"
    }
  },
  JWN : {
    country: "IR",
    name: {
      en : "Zanjan"
    }
  },
  JXA : {
    country: "CN",
    name: {
      en : "JXA"
    }
  },
  JXN : {
    country: "US",
    name: {
      en : "Jackson"
    }
  },
  JYV : {
    country: "FI",
    name: {
      en : "Jyvaskyla"
    }
  },
  JZH : {
    country: "CN",
    name: {
      en : "Songpan"
    }
  },
  KAA : {
    country: "ZM",
    name: {
      en : "Kazama"
    }
  },
  KAB : {
    country: "ZW",
    popularity: 6,
    name: {
      en : "Kariba Dam"
    }
  },
  KAC : {
    country: "SY",
    name: {
      en : "Kameshli"
    }
  },
  KAD : {
    country: "NG",
    name: {
      en : "Kaduna"
    }
  },
  KAE : {
    country: "US",
    name: {
      en : "Kake"
    }
  },
  KAJ : {
    country: "FI",
    name: {
      en : "Kajaani"
    }
  },
  KAL : {
    country: "US",
    name: {
      en : "Kaltag"
    }
  },
  KAN : {
    country: "NG",
    name: {
      en : "Kano"
    }
  },
  KAO : {
    country: "FI",
    name: {
      en : "Kuusamo"
    }
  },
  KAT : {
    country: "NZ",
    name: {
      en : "Kaitaia"
    }
  },
  KAW : {
    country: "MM",
    name: {
      en : "Kawthaung"
    }
  },
  KAX : {
    country: "AU",
    name: {
      en : "Kalbarri"
    }
  },
  KAZ : {
    country: "ID",
    name: {
      en : "Au ID"
    }
  },
  KBC : {
    country: "US",
    name: {
      en : "Birch Creek"
    }
  },
  KBJ : {
    country: "AU",
    name: {
      en : "Kings Canyon"
    }
  },
  KBL : {
    country: "AF",
    name: {
      en : "Kabul"
    }
  },
  KBM : {
    country: "PG",
    name: {
      en : "Kabwum"
    }
  },
  KBR : {
    country: "MY",
    popularity: 4,
    name: {
      en : "Kota Bharu"
    }
  },
  KBU : {
    country: "ID",
    name: {
      en : "Kotabaru"
    }
  },
  KBV : {
    country: "TH",
    name: {
      en : "Krabi"
    }
  },
  KBY : {
    country: "AU",
    name: {
      en : "Streaky Bay"
    }
  },
  KBZ : {
    country: "NZ",
    name: {
      en : "Kaikoura"
    }
  },
  KCA : {
    country: "CN",
    name: {
      en : "Kuqa"
    }
  },
  KCC : {
    country: "US",
    name: {
      en : "Coffman Cove"
    }
  },
  KCD : {
    country: "ID",
    name: {
      en : "Kamur"
    }
  },
  KCE : {
    country: "AU",
    name: {
      en : "Collinsville"
    }
  },
  KCF : {
    country: "PK",
    name: {
      en : "Kadanwari"
    }
  },
  KCG : {
    country: "US",
    name: {
      en : "Chignik"
    }
  },
  KCH : {
    country: "MY",
    name: {
      en : "Kuching"
    }
  },
  KCK : {
    country: "RU",
    name: {
      en : "Kirensk"
    }
  },
  KCL : {
    country: "US",
    name: {
      en : "Chignik Lagoon"
    }
  },
  KCM : {
    country: "TR",
    name: {
      en : "Kahramanmaras"
    }
  },
  KCO : {
    country: "TR",
    name: {
      en : "Izmit"
    }
  },
  KCT : {
    country: "LK",
    name: {
      en : "Koggala"
    }
  },
  KCZ : {
    country: "JP",
    name: {
      en : "Kochi"
    }
  },
  KDG : {
    country: "BG",
    name: {
      en : "Kardjali"
    }
  },
  KDH : {
    country: "AF",
    name: {
      en : "Kandahar"
    }
  },
  KDI : {
    country: "ID",
    name: {
      en : "Kendari"
    }
  },
  KDL : {
    country: "EE",
    name: {
      en : "Kardla"
    }
  },
  KDM : {
    country: "MV",
    name: {
      en : "Kaadedhdhoo"
    }
  },
  KDN : {
    country: "GA",
    name: {
      en : "N Dende"
    }
  },
  KDO : {
    country: "MV",
    name: {
      en : "Kadhdhoo"
    }
  },
  KDR : {
    country: "PG",
    name: {
      en : "Kandrian"
    }
  },
  KDU : {
    country: "PK",
    name: {
      en : "Skardu"
    }
  },
  KDV : {
    country: "FJ",
    name: {
      en : "Kandavu"
    }
  },
  KDZ : {
    country: "LK",
    name: {
      en : "Katugastota"
    }
  },
  KEB : {
    country: "US",
    name: {
      en : "Nanwalek"
    }
  },
  KED : {
    country: "MR",
    name: {
      en : "Kaedi"
    }
  },
  KEE : {
    country: "CG",
    name: {
      en : "Kelle"
    }
  },
  KEH : {
    country: "US",
    name: {
      en : "Kenmore"
    }
  },
  KEI : {
    country: "ID",
    name: {
      en : "Kepi"
    }
  },
  KEJ : {
    country: "RU",
    popularity: 18,
    name: {
      en : "Kemerovo"
    }
  },
  KEK : {
    country: "US",
    name: {
      en : "Ekwok"
    }
  },
  KEL : {
    country: "DE",
    name: {
      en : "Kiel"
    }
  },
  KEM : {
    country: "FI",
    name: {
      en : "Kemi"
    }
  },
  KEN : {
    country: "SL",
    name: {
      en : "Kenema"
    }
  },
  KEO : {
    country: "CI",
    name: {
      en : "Odienne"
    }
  },
  KEP : {
    country: "NP",
    name: {
      en : "Nepalganj"
    }
  },
  KEQ : {
    country: "ID",
    name: {
      en : "Kebar"
    }
  },
  KER : {
    country: "IR",
    name: {
      en : "Kerman"
    }
  },
  KET : {
    country: "MM",
    name: {
      en : "Kengtung"
    }
  },
  KEW : {
    country: "CA",
    name: {
      en : "Keewaywin"
    }
  },
  KEX : {
    country: "PG",
    name: {
      en : "Kanabea"
    }
  },
  KEY : {
    country: "KE",
    name: {
      en : "Kericho"
    }
  },
  KFA : {
    country: "MR",
    name: {
      en : "Kiffa"
    }
  },
  KFP : {
    country: "US",
    name: {
      en : "False Pass"
    }
  },
  KFS : {
    country: "TR",
    name: {
      en : "Kastamonu"
    }
  },
  KGA : {
    country: "CD",
    name: {
      en : "Kananga"
    }
  },
  KGB : {
    country: "PG",
    name: {
      en : "Konge"
    }
  },
  KGC : {
    country: "AU",
    name: {
      en : "Kingscote"
    }
  },
  KGD : {
    country: "RU",
    popularity: 86,
    name: {
      en : "Kaliningrad"
    }
  },
  KGE : {
    country: "SB",
    name: {
      en : "Kagau"
    }
  },
  KGF : {
    country: "KZ",
    popularity: 8,
    name: {
      en : "Karaganda"
    }
  },
  KGG : {
    country: "SN",
    name: {
      en : "Kedougou"
    }
  },
  KGH : {
    country: "PG",
    name: {
      en : "Yongai"
    }
  },
  KGI : {
    country: "AU",
    name: {
      en : "Kalgoorlie"
    }
  },
  KGJ : {
    country: "MW",
    name: {
      en : "Karonga"
    }
  },
  KGK : {
    country: "US",
    name: {
      en : "Koliganek"
    }
  },
  KGL : {
    country: "RW",
    name: {
      en : "Kigali"
    }
  },
  KGO : {
    country: "UA",
    name: {
      en : "Kirovograd"
    }
  },
  KGP : {
    country: "RU",
    name: {
      en : "Kogalym"
    }
  },
  KGS : {
    country: "GR",
    name: {
      en : "Kos Gr"
    }
  },
  KGT : {
    country: "CN",
    name: {
      en : "KGT"
    }
  },
  KGW : {
    country: "PG",
    name: {
      en : "Kagi"
    }
  },
  KGX : {
    country: "US",
    name: {
      en : "Grayling"
    }
  },
  KGY : {
    country: "AU",
    name: {
      en : "Kingaroy"
    }
  },
  KHC : {
    country: "AK",
    name: {
      en : "Kerch"
    }
  },
  KHD : {
    country: "IR",
    name: {
      en : "Khorramabad"
    }
  },
  KHG : {
    country: "CN",
    name: {
      en : "Kashi"
    }
  },
  KHH : {
    country: "TW",
    name: {
      en : "Kaohsiung"
    }
  },
  KHI : {
    country: "PK",
    popularity: 4,
    name: {
      en : "Karachi"
    }
  },
  KHM : {
    country: "MM",
    name: {
      en : "Khamtis"
    }
  },
  KHN : {
    country: "CN",
    name: {
      en : "Nanchang"
    }
  },
  KHR : {
    country: "MN",
    name: {
      en : "Kharkhorin"
    }
  },
  KHS : {
    country: "OM",
    name: {
      en : "Khasab"
    }
  },
  KHU : {
    country: "UA",
    name: {
      en : "Kremenchug"
    }
  },
  KHV : {
    country: "RU",
    popularity: 6,
    name: {
      en : "Khabarovsk"
    }
  },
  KHY : {
    country: "IR",
    name: {
      en : "Khoy"
    }
  },
  KHZ : {
    country: "PF",
    name: {
      en : "Kauehi"
    }
  },
  KIB : {
    country: "US",
    name: {
      en : "Ivanof Bay"
    }
  },
  KIC : {
    country: "US",
    name: {
      en : "King City"
    }
  },
  KID : {
    country: "SE",
    name: {
      en : "Kristianstad"
    }
  },
  KIE : {
    country: "PG",
    name: {
      en : "Kieta"
    }
  },
  KIF : {
    country: "CA",
    name: {
      en : "Kingfisher Lake"
    }
  },
  KIH : {
    country: "IR",
    name: {
      en : "Kish Island"
    }
  },
  KIJ : {
    country: "JP",
    name: {
      en : "Niigata"
    }
  },
  KIK : {
    country: "IQ",
    name: {
      en : "Kirkuk"
    }
  },
  KIM : {
    country: "ZA",
    name: {
      en : "Kimberley"
    }
  },
  KIN : {
    country: "JM",
    popularity: 18,
    name: {
      en : "Kingston"
    }
  },
  KIQ : {
    country: "PG",
    name: {
      en : "Kira"
    }
  },
  KIR : {
    country: "IE",
    name: {
      en : "Kerry County"
    }
  },
  KIS : {
    country: "KE",
    name: {
      en : "Kisumu"
    }
  },
  KIT : {
    country: "GR",
    name: {
      en : "Kithira"
    }
  },
  KIV : {
    country: "MD",
    popularity: 440,
    name: {
      en : "Chisinau"
    }
  },
  KIW : {
    country: "ZM",
    name: {
      en : "Kitwe"
    }
  },
  KIY : {
    country: "TZ",
    name: {
      en : "Kilwa"
    }
  },
  KJA : {
    country: "RU",
    popularity: 10,
    name: {
      en : "Krasnoyarsk"
    }
  },
  KJI : {
    country: "CN",
    name: {
      en : "Burqin"
    }
  },
  KJK : {
    country: "BE",
    name: {
      en : "Kortrijk"
    }
  },
  KKA : {
    country: "US",
    name: {
      en : "Koyuk"
    }
  },
  KKB : {
    country: "US",
    name: {
      en : "Kitoi Bay"
    }
  },
  KKC : {
    country: "TH",
    name: {
      en : "Khon Kaen"
    }
  },
  KKD : {
    country: "PG",
    name: {
      en : "Kokoda"
    }
  },
  KKE : {
    country: "NZ",
    name: {
      en : "Kerikeri"
    }
  },
  KKH : {
    country: "US",
    name: {
      en : "Kongiganak"
    }
  },
  KKI : {
    country: "US",
    name: {
      en : "Akiachak"
    }
  },
  KKJ : {
    country: "JP",
    name: {
      en : "Kitakyushu"
    }
  },
  KKN : {
    country: "NO",
    name: {
      en : "Kirkenes"
    }
  },
  KKQ : {
    country: "RU",
    name: {
      en : "Krasnoselkup"
    }
  },
  KKR : {
    country: "PF",
    name: {
      en : "Kaukura"
    }
  },
  KKT : {
    country: "US",
    name: {
      en : "Kentland"
    }
  },
  KKU : {
    country: "US",
    name: {
      en : "Ekuk"
    }
  },
  KKX : {
    country: "JP",
    name: {
      en : "Kikaiga Shima"
    }
  },
  KKY : {
    country: "IE",
    name: {
      en : "Kilkenny"
    }
  },
  KLA : {
    country: "UG",
    name: {
      en : "Kampala"
    }
  },
  KLD : {
    country: "RU",
    name: {
      en : "Tver"
    }
  },
  KLF : {
    country: "RU",
    name: {
      en : "Kaluga"
    }
  },
  KLG : {
    country: "US",
    name: {
      en : "Kalskag"
    }
  },
  KLH : {
    country: "IN",
    name: {
      en : "Kolhapur"
    }
  },
  KLJ : {
    country: "LT",
    name: {
      en : "Klaipeda"
    }
  },
  KLL : {
    country: "US",
    name: {
      en : "Levelock"
    }
  },
  KLN : {
    country: "US",
    name: {
      en : "Larsen Bay"
    }
  },
  KLO : {
    country: "PH",
    popularity: 2,
    name: {
      en : "Kalibo"
    }
  },
  KLR : {
    country: "SE",
    name: {
      en : "Kalmar"
    }
  },
  KLS : {
    country: "US",
    name: {
      en : "Kelso"
    }
  },
  KLT : {
    country: "DE",
    name: {
      en : "Kaiserslautern"
    }
  },
  KLU : {
    country: "AT",
    name: {
      en : "Klagenfurt"
    }
  },
  KLV : {
    country: "CZ",
    popularity: 54,
    name: {
      en : "Karlovy Vary"
    }
  },
  KLW : {
    country: "US",
    name: {
      en : "Klawock"
    }
  },
  KLX : {
    country: "GR",
    name: {
      en : "Kalamata"
    }
  },
  KMA : {
    country: "PG",
    name: {
      en : "Kerema"
    }
  },
  KMC : {
    country: "SA",
    name: {
      en : "King Khalid Military City"
    }
  },
  KME : {
    country: "RW",
    name: {
      en : "Kamembe"
    }
  },
  KMF : {
    country: "PG",
    name: {
      en : "Kamina"
    }
  },
  KMG : {
    country: "CN",
    name: {
      en : "Kunming"
    }
  },
  KMI : {
    country: "JP",
    name: {
      en : "Miyazaki"
    }
  },
  KMJ : {
    country: "JP",
    name: {
      en : "Kumamoto"
    }
  },
  KMM : {
    country: "ID",
    name: {
      en : "Kimam"
    }
  },
  KMN : {
    country: "CD",
    name: {
      en : "Kamina"
    }
  },
  KMO : {
    country: "US",
    name: {
      en : "Manokotak"
    }
  },
  KMP : {
    country: "ZA",
    name: {
      en : "Keetmanshoop"
    }
  },
  KMQ : {
    country: "JP",
    name: {
      en : "Komatsu"
    }
  },
  KMR : {
    country: "PG",
    name: {
      en : "Karimui"
    }
  },
  KMS : {
    country: "GH",
    name: {
      en : "Kumasi"
    }
  },
  KMT : {
    country: "KH",
    name: {
      en : "Kampot"
    }
  },
  KMU : {
    country: "SO",
    name: {
      en : "Kismayu"
    }
  },
  KMV : {
    country: "MM",
    name: {
      en : "Kalemyo"
    }
  },
  KMW : {
    country: "RU",
    name: {
      en : "Kostroma"
    }
  },
  KMX : {
    country: "SA",
    name: {
      en : "Khamis Mushait"
    }
  },
  KMY : {
    country: "US",
    name: {
      en : "Moser Bay"
    }
  },
  KNA : {
    country: "CL",
    name: {
      en : "Vina Del Mar"
    }
  },
  KND : {
    country: "CD",
    name: {
      en : "Kindu"
    }
  },
  KNF : {
    country: "GB",
    name: {
      en : "Kings Lynn"
    }
  },
  KNG : {
    country: "ID",
    name: {
      en : "Kaimana"
    }
  },
  KNH : {
    country: "TW",
    name: {
      en : "Kinmen"
    }
  },
  KNK : {
    country: "US",
    name: {
      en : "Kakhonak"
    }
  },
  KNO : {
    country: "ID",
    name: {
      en : "Medan"
    }
  },
  KNQ : {
    country: "NC",
    name: {
      en : "Kone"
    }
  },
  KNS : {
    country: "AU",
    name: {
      en : "King Island"
    }
  },
  KNT : {
    country: "US",
    name: {
      en : "Kennett"
    }
  },
  KNU : {
    country: "IN",
    name: {
      en : "Kanpur"
    }
  },
  KNW : {
    country: "US",
    name: {
      en : "New Stuyahok"
    }
  },
  KNX : {
    country: "AU",
    name: {
      en : "Kununurra"
    }
  },
  KNY : {
    country: "RU",
    name: {
      en : "Kodinsk"
    }
  },
  KOA : {
    country: "US",
    name: {
      en : "Kona"
    }
  },
  KOB : {
    country: "CM",
    name: {
      en : "Koutaba"
    }
  },
  KOC : {
    country: "NC",
    name: {
      en : "Koumac"
    }
  },
  KOE : {
    country: "ID",
    name: {
      en : "Kupang"
    }
  },
  KOH : {
    country: "AU",
    name: {
      en : "Koolatah"
    }
  },
  KOI : {
    country: "GB",
    name: {
      en : "Kirkwall"
    }
  },
  KOJ : {
    country: "JP",
    name: {
      en : "Kagoshima"
    }
  },
  KOK : {
    country: "FI",
    name: {
      en : "Kokkola"
    }
  },
  KOO : {
    country: "CD",
    name: {
      en : "Kongolo"
    }
  },
  KOP : {
    country: "TH",
    name: {
      en : "Nakhon Phanom"
    }
  },
  KOR : {
    country: "PG",
    name: {
      en : "Kokoro"
    }
  },
  KOS : {
    country: "KH",
    name: {
      en : "Sihanoukville"
    }
  },
  KOT : {
    country: "US",
    name: {
      en : "Kotlik"
    }
  },
  KOU : {
    country: "GA",
    name: {
      en : "Koulamoutou"
    }
  },
  KOV : {
    country: "KZ",
    name: {
      en : "Kokshetau"
    }
  },
  KOW : {
    country: "CN",
    name: {
      en : "Ganzhou"
    }
  },
  KOY : {
    country: "US",
    name: {
      en : "Olga Bay"
    }
  },
  KOZ : {
    country: "US",
    name: {
      en : "Ouzinkie"
    }
  },
  KPA : {
    country: "PG",
    name: {
      en : "Kopiago"
    }
  },
  KPB : {
    country: "US",
    name: {
      en : "Point Baker"
    }
  },
  KPC : {
    country: "US",
    name: {
      en : "Port Clarence"
    }
  },
  KPD : {
    country: "US",
    name: {
      en : "King of Prussia"
    }
  },
  KPI : {
    country: "MY",
    name: {
      en : "Kapit"
    }
  },
  KPK : {
    country: "US",
    name: {
      en : "Parks"
    }
  },
  KPN : {
    country: "US",
    name: {
      en : "Kipnuk"
    }
  },
  KPO : {
    country: "KR",
    name: {
      en : "Pohang"
    }
  },
  KPR : {
    country: "US",
    name: {
      en : "Port Williams"
    }
  },
  KPS : {
    country: "AU",
    name: {
      en : "Kempsey"
    }
  },
  KPV : {
    country: "US",
    name: {
      en : "Perryville"
    }
  },
  KPW : {
    country: "RU",
    name: {
      en : "Keperveyem"
    }
  },
  KPY : {
    country: "US",
    name: {
      en : "Port Bailey"
    }
  },
  KQA : {
    country: "US",
    name: {
      en : "Akutan"
    }
  },
  KQT : {
    country: "TJ",
    name: {
      en : "Qurghonteppa"
    }
  },
  KRA : {
    country: "AU",
    name: {
      en : "Kerang"
    }
  },
  KRB : {
    country: "AU",
    name: {
      en : "Karumba"
    }
  },
  KRC : {
    country: "ID",
    name: {
      en : "Kerinci"
    }
  },
  KRE : {
    country: "BI",
    name: {
      en : "Kirundo"
    }
  },
  KRF : {
    country: "SE",
    name: {
      en : "Kramfors"
    }
  },
  KRG : {
    country: "GY",
    name: {
      en : "Karasabai"
    }
  },
  KRI : {
    country: "PG",
    name: {
      en : "Kikori"
    }
  },
  KRJ : {
    country: "PG",
    name: {
      en : "Karawari"
    }
  },
  KRK : {
    country: "PL",
    popularity: 4,
    name: {
      en : "Krakow"
    }
  },
  KRL : {
    country: "CN",
    name: {
      en : "Korla"
    }
  },
  KRN : {
    country: "SE",
    name: {
      en : "Kiruna"
    }
  },
  KRO : {
    country: "RU",
    name: {
      en : "Kurgan"
    }
  },
  KRP : {
    country: "DK",
    name: {
      en : "Karup"
    }
  },
  KRQ : {
    country: "UA",
    name: {
      en : "Kramatorsk"
    }
  },
  KRR : {
    country: "RU",
    popularity: 52,
    name: {
      en : "Krasnodar"
    }
  },
  KRS : {
    country: "NO",
    name: {
      en : "Kristiansand"
    }
  },
  KRT : {
    country: "SD",
    name: {
      en : "Khartoum"
    }
  },
  KRU : {
    country: "PG",
    name: {
      en : "Kerau"
    }
  },
  KRW : {
    country: "TM",
    name: {
      en : "Turkmanbashi"
    }
  },
  KRX : {
    country: "PG",
    name: {
      en : "Karkar"
    }
  },
  KRY : {
    country: "CN",
    name: {
      en : "Karamay"
    }
  },
  KSA : {
    country: "FM",
    name: {
      en : "Kosrae"
    }
  },
  KSC : {
    country: "SK",
    name: {
      en : "Kosice"
    }
  },
  KSD : {
    country: "SE",
    name: {
      en : "Karlstad"
    }
  },
  KSE : {
    country: "UG",
    name: {
      en : "Kasese"
    }
  },
  KSF : {
    country: "DE",
    name: {
      en : "Kassel"
    }
  },
  KSG : {
    country: "PG",
    name: {
      en : "Kisengan"
    }
  },
  KSH : {
    country: "IR",
    name: {
      en : "Kermanshah"
    }
  },
  KSJ : {
    country: "GR",
    name: {
      en : "Kasos Island"
    }
  },
  KSK : {
    country: "SE",
    name: {
      en : "Karlskoga"
    }
  },
  KSL : {
    country: "SD",
    name: {
      en : "Kassala"
    }
  },
  KSM : {
    country: "US",
    name: {
      en : "St Marys"
    }
  },
  KSN : {
    country: "KZ",
    name: {
      en : "Kostanay"
    }
  },
  KSO : {
    country: "GR",
    name: {
      en : "Kastoria"
    }
  },
  KSQ : {
    country: "UZ",
    name: {
      en : "Karshi"
    }
  },
  KSR : {
    country: "US",
    name: {
      en : "Sandy River"
    }
  },
  KSU : {
    country: "NO",
    name: {
      en : "Kristiansund"
    }
  },
  KSW : {
    country: "IL",
    popularity: 2,
    name: {
      en : "Kiryat Shmona"
    }
  },
  KSY : {
    country: "TR",
    name: {
      en : "Kars"
    }
  },
  KSZ : {
    country: "RU",
    name: {
      en : "Kotlas"
    }
  },
  KTA : {
    country: "AU",
    name: {
      en : "Karratha"
    }
  },
  KTB : {
    country: "US",
    name: {
      en : "Thorne Bay"
    }
  },
  KTD : {
    country: "JP",
    name: {
      en : "Kitadaito"
    }
  },
  KTE : {
    country: "MY",
    name: {
      en : "Kerteh"
    }
  },
  KTG : {
    country: "ID",
    name: {
      en : "Ketapang"
    }
  },
  KTL : {
    country: "KE",
    name: {
      en : "Kitale"
    }
  },
  KTM : {
    country: "NP",
    popularity: 8,
    name: {
      en : "Kathmandu"
    }
  },
  KTN : {
    country: "US",
    name: {
      en : "Ketchikan"
    }
  },
  KTR : {
    country: "AU",
    name: {
      en : "Katherine"
    }
  },
  KTS : {
    country: "US",
    name: {
      en : "Brevig Mission"
    }
  },
  KTT : {
    country: "FI",
    popularity: 12,
    name: {
      en : "Kittila"
    }
  },
  KTW : {
    country: "PL",
    name: {
      en : "Katowice"
    }
  },
  KUA : {
    country: "MY",
    name: {
      en : "Kuantan"
    }
  },
  KUB : {
    country: "BN",
    name: {
      en : "Kuala Belait"
    }
  },
  KUC : {
    country: "KI",
    name: {
      en : "Kuria"
    }
  },
  KUD : {
    country: "MY",
    name: {
      en : "Kudat"
    }
  },
  KUF : {
    country: "RU",
    popularity: 152,
    name: {
      en : "Samara"
    }
  },
  KUG : {
    country: "AU",
    name: {
      en : "Kubin Island"
    }
  },
  KUH : {
    country: "JP",
    name: {
      en : "Kushiro"
    }
  },
  KUK : {
    country: "US",
    name: {
      en : "Kasigluk"
    }
  },
  KUL : {
    country: "MY",
    popularity: 34,
    name: {
      en : "Kuala Lumpur"
    }
  },
  KUM : {
    country: "JP",
    name: {
      en : "Yakushima"
    }
  },
  KUN : {
    country: "LT",
    popularity: 4,
    name: {
      en : "Kaunas"
    }
  },
  KUO : {
    country: "FI",
    name: {
      en : "Kuopio"
    }
  },
  KUP : {
    country: "PG",
    name: {
      en : "Kupiano"
    }
  },
  KUS : {
    country: "GL",
    name: {
      en : "Kulusuk"
    }
  },
  KUT : {
    country: "GE",
    name: {
      en : "Kutaisi"
    }
  },
  KUU : {
    country: "IN",
    name: {
      en : "Kulu"
    }
  },
  KUV : {
    country: "KR",
    name: {
      en : "Kunsan"
    }
  },
  KVA : {
    country: "GR",
    name: {
      en : "Kavalla"
    }
  },
  KVB : {
    country: "SE",
    name: {
      en : "Skovde"
    }
  },
  KVC : {
    country: "US",
    name: {
      en : "King Cove"
    }
  },
  KVD : {
    country: "AZ",
    name: {
      en : "GANJA"
    }
  },
  KVG : {
    country: "PG",
    name: {
      en : "Kavieng"
    }
  },
  KVK : {
    country: "RU",
    name: {
      en : "Kirovsk"
    }
  },
  KVL : {
    country: "US",
    name: {
      en : "Kivalina"
    }
  },
  KVO : {
    country: "RS",
    popularity: 909,
    name: {
      en : "Kraljevo"
    }
  },
  KVR : {
    country: "RU",
    name: {
      en : "KAVALEROVO "
    }
  },
  KVX : {
    country: "RU",
    name: {
      en : "Kirov"
    }
  },
  KWA : {
    country: "MH",
    name: {
      en : "Kwajalein"
    }
  },
  KWE : {
    country: "CN",
    name: {
      en : "Guiyang"
    }
  },
  KWF : {
    country: "US",
    name: {
      en : "Waterfall"
    }
  },
  KWG : {
    country: "UA",
    name: {
      en : "Krivoy Rog"
    }
  },
  KWI : {
    country: "KW",
    popularity: 4,
    name: {
      en : "Kuwait"
    }
  },
  KWJ : {
    country: "KR",
    name: {
      en : "Gwangju"
    }
  },
  KWK : {
    country: "US",
    name: {
      en : "Kwigillingok"
    }
  },
  KWL : {
    country: "CN",
    name: {
      en : "Guilin"
    }
  },
  KWM : {
    country: "AU",
    name: {
      en : "Kowanyama"
    }
  },
  KWN : {
    country: "US",
    name: {
      en : "Quinhagak"
    }
  },
  KWP : {
    country: "US",
    name: {
      en : "West Point"
    }
  },
  KWT : {
    country: "US",
    name: {
      en : "Kwethluk"
    }
  },
  KWZ : {
    country: "CD",
    name: {
      en : "Kolwezi"
    }
  },
  KXA : {
    country: "US",
    name: {
      en : "Kasaan"
    }
  },
  KXE : {
    country: "ZA",
    name: {
      en : "Klerksdorp"
    }
  },
  KXF : {
    country: "FJ",
    name: {
      en : "Koro"
    }
  },
  KXK : {
    country: "RU",
    popularity: 10,
    name: {
      en : "Komsomolsk Na Amure"
    }
  },
  KXU : {
    country: "PF",
    name: {
      en : "Katiu"
    }
  },
  KYA : {
    country: "TR",
    name: {
      en : "Konya"
    }
  },
  KYK : {
    country: "US",
    name: {
      en : "Karluk"
    }
  },
  KYL : {
    country: "US",
    name: {
      en : "Key Largo"
    }
  },
  KYN : {
    country: "GB",
    name: {
      en : "Milton Keynes"
    }
  },
  KYP : {
    country: "MM",
    name: {
      en : "Kyaukpyu"
    }
  },
  KYS : {
    country: "ML",
    name: {
      en : "Kayes"
    }
  },
  KYU : {
    country: "US",
    name: {
      en : "Koyukuk"
    }
  },
  KYX : {
    country: "PG",
    name: {
      en : "Yalumet"
    }
  },
  KYZ : {
    country: "RU",
    name: {
      en : "Kyzyl"
    }
  },
  KZB : {
    country: "US",
    name: {
      en : "Zachar Bay"
    }
  },
  KZD : {
    country: "KH",
    name: {
      en : "Krakor"
    }
  },
  KZF : {
    country: "PG",
    name: {
      en : "Kaintiba"
    }
  },
  KZI : {
    country: "GR",
    name: {
      en : "Kozani"
    }
  },
  KZN : {
    country: "RU",
    popularity: 44,
    name: {
      en : "Kazan"
    }
  },
  KZO : {
    country: "KZ",
    name: {
      en : "Kyzylorda"
    }
  },
  KZR : {
    country: "TR",
    name: {
      en : "Kutahya"
    }
  },
  KZS : {
    country: "GR",
    name: {
      en : "Kastelorizo"
    }
  },
  LAA : {
    country: "US",
    name: {
      en : "Lamar"
    }
  },
  LAB : {
    country: "PG",
    name: {
      en : "Lablab"
    }
  },
  LAD : {
    country: "AO",
    name: {
      en : "Luanda"
    }
  },
  LAE : {
    country: "PG",
    name: {
      en : "Lae Pg"
    }
  },
  LAF : {
    country: "US",
    name: {
      en : "Lafayette"
    }
  },
  LAH : {
    country: "ID",
    name: {
      en : "Labuha"
    }
  },
  LAI : {
    country: "FR",
    name: {
      en : "Lannion"
    }
  },
  LAJ : {
    country: "BR",
    name: {
      en : "Lages"
    }
  },
  LAK : {
    country: "CA",
    name: {
      en : "Aklavik"
    }
  },
  LAL : {
    country: "US",
    name: {
      en : "Lakeland"
    }
  },
  LAM : {
    country: "US",
    name: {
      en : "Los Alamos"
    }
  },
  LAN : {
    country: "US",
    name: {
      en : "Lansing"
    }
  },
  LAO : {
    country: "PH",
    name: {
      en : "Laoag"
    }
  },
  LAP : {
    country: "MX",
    name: {
      en : "La Paz"
    }
  },
  LAQ : {
    country: "LY",
    name: {
      en : "Beida"
    }
  },
  LAR : {
    country: "US",
    name: {
      en : "Laramie"
    }
  },
  LAS : {
    country: "US",
    popularity: 44,
    name: {
      en : "Las Vegas"
    }
  },
  LAU : {
    country: "KE",
    name: {
      en : "Lamu"
    }
  },
  LAW : {
    country: "US",
    name: {
      en : "Lawton"
    }
  },
  LAX : {
    country: "US",
    popularity: 282,
    name: {
      en : "Los Angeles"
    }
  },
  LAY : {
    country: "ZA",
    name: {
      en : "Ladysmith"
    }
  },
  LAZ : {
    country: "BR",
    name: {
      en : "Bom Jesus Da Lapa"
    }
  },
  LBA : {
    country: "GB",
    name: {
      en : "Leeds"
    }
  },
  LBB : {
    country: "US",
    name: {
      en : "Lubbock"
    }
  },
  LBC : {
    country: "DE",
    name: {
      en : "Luebeck"
    }
  },
  LBD : {
    country: "TJ",
    name: {
      en : "Khujand"
    }
  },
  LBE : {
    country: "US",
    name: {
      en : "Latrobe"
    }
  },
  LBF : {
    country: "US",
    name: {
      en : "North Platte"
    }
  },
  LBI : {
    country: "FR",
    name: {
      en : "Albi"
    }
  },
  LBJ : {
    country: "ID",
    name: {
      en : "Labuan Bajo"
    }
  },
  LBL : {
    country: "US",
    name: {
      en : "Liberal"
    }
  },
  LBP : {
    country: "MY",
    name: {
      en : "Long Banga"
    }
  },
  LBQ : {
    country: "GA",
    name: {
      en : "Lambarene"
    }
  },
  LBR : {
    country: "BR",
    name: {
      en : "Labrea"
    }
  },
  LBS : {
    country: "FJ",
    name: {
      en : "Labasa"
    }
  },
  LBT : {
    country: "US",
    name: {
      en : "Lumberton"
    }
  },
  LBU : {
    country: "MY",
    name: {
      en : "Labuan"
    }
  },
  LBV : {
    country: "GA",
    name: {
      en : "Libreville"
    }
  },
  LBW : {
    country: "ID",
    name: {
      en : "Long Bawan"
    }
  },
  LBY : {
    country: "FR",
    name: {
      en : "La Baule"
    }
  },
  LCA : {
    country: "CY",
    popularity: 286,
    name: {
      en : "Larnaca"
    }
  },
  LCC : {
    country: "IT",
    name: {
      en : "Lecce"
    }
  },
  LCE : {
    country: "HN",
    name: {
      en : "La Ceiba"
    }
  },
  LCF : {
    country: "GT",
    name: {
      en : "Rio Dulce"
    }
  },
  LCG : {
    country: "ES",
    name: {
      en : "La Coruna"
    }
  },
  LCH : {
    country: "US",
    name: {
      en : "Lake Charles"
    }
  },
  LCI : {
    country: "US",
    name: {
      en : "Laconia"
    }
  },
  LCJ : {
    country: "PL",
    name: {
      en : "Lodz"
    }
  },
  LCR : {
    country: "CO",
    name: {
      en : "La Chorrera"
    }
  },
  LCV : {
    country: "IT",
    name: {
      en : "Lucca"
    }
  },
  LCX : {
    country: "CN",
    name: {
      en : "Longyan"
    }
  },
  LDB : {
    country: "BR",
    name: {
      en : "Londrina"
    }
  },
  LDE : {
    country: "FR",
    name: {
      en : "Lourdes"
    }
  },
  LDG : {
    country: "RU",
    name: {
      en : "Leshukonskoye"
    }
  },
  LDH : {
    country: "AU",
    name: {
      en : "Lord Howe Island"
    }
  },
  LDI : {
    country: "TZ",
    name: {
      en : "Lindi"
    }
  },
  LDJ : {
    country: "US",
    name: {
      en : "Linden"
    }
  },
  LDK : {
    country: "SE",
    name: {
      en : "Lidkoping"
    }
  },
  LDM : {
    country: "US",
    name: {
      en : "Ludington"
    }
  },
  LDN : {
    country: "NP",
    name: {
      en : "Lamidanda"
    }
  },
  LDS : {
    country: "CN",
    name: {
      en : "LDS"
    }
  },
  LDU : {
    country: "MY",
    name: {
      en : "Lahad Datu"
    }
  },
  LDX : {
    country: "GF",
    name: {
      en : "Saint Laurent du Maroni"
    }
  },
  LDY : {
    country: "GB",
    popularity: 178,
    name: {
      en : "Londonderry"
    }
  },
  LEA : {
    country: "AU",
    name: {
      en : "Learmonth"
    }
  },
  LEB : {
    country: "US",
    name: {
      en : "Lebanon"
    }
  },
  LEC : {
    country: "BR",
    name: {
      en : "Lencois"
    }
  },
  LED : {
    country: "RU",
    popularity: 818,
    aliases: "|Петербург|Питер|Sank-Piterburg|Saint Petersburg",
    name: {
      en : "St Petersburg"
    }
  },
  LEE : {
    country: "US",
    name: {
      en : "Leesburg"
    }
  },
  LEF : {
    country: "LS",
    name: {
      en : "Lebakeng"
    }
  },
  LEH : {
    country: "FR",
    popularity: 4,
    name: {
      en : "Le Havre"
    }
  },
  LEI : {
    country: "ES",
    popularity: 4,
    name: {
      en : "Almeria"
    }
  },
  LEJ : {
    country: "DE",
    name: {
      en : "Leipzig"
    }
  },
  LEL : {
    country: "AU",
    name: {
      en : "Lake Evella"
    }
  },
  LEN : {
    country: "ES",
    name: {
      en : "Leon"
    }
  },
  LEQ : {
    country: "GB",
    name: {
      en : "Lands End"
    }
  },
  LER : {
    country: "AU",
    name: {
      en : "Leinster"
    }
  },
  LES : {
    country: "LS",
    name: {
      en : "Lesobeng"
    }
  },
  LET : {
    country: "CO",
    name: {
      en : "Leticia"
    }
  },
  LEU : {
    country: "ES",
    name: {
      en : "Seo de Urgel"
    }
  },
  LEV : {
    country: "FJ",
    name: {
      en : "Levuka"
    }
  },
  LEW : {
    country: "US",
    name: {
      en : "Lewiston"
    }
  },
  LEX : {
    country: "US",
    name: {
      en : "Lexington"
    }
  },
  LEY : {
    country: "NL",
    name: {
      en : "Lelystad"
    }
  },
  LFK : {
    country: "US",
    name: {
      en : "Lufkin"
    }
  },
  LFM : {
    country: "IR",
    name: {
      en : "Lamerd"
    }
  },
  LFO : {
    country: "ET",
    name: {
      en : "Kelafo"
    }
  },
  LFR : {
    country: "VE",
    name: {
      en : "La Fria"
    }
  },
  LFT : {
    country: "US",
    name: {
      en : "Lafayette"
    }
  },
  LFW : {
    country: "TG",
    name: {
      en : "Lome"
    }
  },
  LGB : {
    country: "US",
    name: {
      en : "Long Beach"
    }
  },
  LGC : {
    country: "US",
    name: {
      en : "La Grange"
    }
  },
  LGD : {
    country: "US",
    name: {
      en : "La Grande"
    }
  },
  LGG : {
    country: "BE",
    name: {
      en : "Liege"
    }
  },
  LGH : {
    country: "AU",
    name: {
      en : "Leigh Creek"
    }
  },
  LGI : {
    country: "BS",
    name: {
      en : "Deadmans Cay"
    }
  },
  LGK : {
    country: "MY",
    name: {
      en : "Langkawi"
    }
  },
  LGL : {
    country: "MY",
    name: {
      en : "Long Lellang"
    }
  },
  LGP : {
    country: "PH",
    name: {
      en : "Legaspi"
    }
  },
  LGQ : {
    country: "EC",
    name: {
      en : "Lago Agrio"
    }
  },
  LGU : {
    country: "US",
    name: {
      en : "Logan"
    }
  },
  LHA : {
    country: "DE",
    name: {
      en : "Lahr"
    }
  },
  LHE : {
    country: "PK",
    popularity: 4,
    name: {
      en : "Lahore"
    }
  },
  LHG : {
    country: "AU",
    name: {
      en : "Lightning Ridge"
    }
  },
  LHW : {
    country: "CN",
    name: {
      en : "Lanzhou"
    }
  },
  LIA : {
    country: "CN",
    name: {
      en : "Lianping"
    }
  },
  LID : {
    country: "NL",
    name: {
      en : "Leiden"
    }
  },
  LIF : {
    country: "NC",
    name: {
      en : "Lifou"
    }
  },
  LIG : {
    country: "FR",
    name: {
      en : "Limoges"
    }
  },
  LIH : {
    country: "US",
    name: {
      en : "Lihue"
    }
  },
  LII : {
    country: "ID",
    name: {
      en : "Mulia"
    }
  },
  LIL : {
    country: "FR",
    name: {
      en : "Lille"
    }
  },
  LIM : {
    country: "PE",
    popularity: 50,
    name: {
      en : "Lima"
    }
  },
  LIO : {
    country: "CR",
    name: {
      en : "Limon"
    }
  },
  LIP : {
    country: "BR",
    name: {
      en : "Lins"
    }
  },
  LIQ : {
    country: "CD",
    name: {
      en : "Lisala"
    }
  },
  LIR : {
    country: "CR",
    name: {
      en : "Liberia"
    }
  },
  LIS : {
    country: "PT",
    popularity: 382,
    name: {
      en : "Lisbon"
    }
  },
  LIT : {
    country: "US",
    name: {
      en : "Little Rock"
    }
  },
  LIW : {
    country: "MM",
    name: {
      en : "Loikaw"
    }
  },
  LIX : {
    country: "MW",
    name: {
      en : "Likoma Island"
    }
  },
  LJA : {
    country: "CD",
    name: {
      en : "Lodja"
    }
  },
  LJG : {
    country: "CN",
    name: {
      en : "Lijiang City"
    }
  },
  LJN : {
    country: "US",
    name: {
      en : "Lake Jackson"
    }
  },
  LJU : {
    country: "SI",
    popularity: 228,
    name: {
      en : "Ljubljana"
    }
  },
  LKA : {
    country: "ID",
    name: {
      en : "Larantuka"
    }
  },
  LKB : {
    country: "FJ",
    name: {
      en : "Lakeba"
    }
  },
  LKC : {
    country: "CG",
    name: {
      en : "Lekana"
    }
  },
  LKG : {
    country: "KE",
    name: {
      en : "Lokichoggio"
    }
  },
  LKH : {
    country: "MY",
    name: {
      en : "Long Akah"
    }
  },
  LKL : {
    country: "NO",
    name: {
      en : "Lakselv"
    }
  },
  LKN : {
    country: "NO",
    name: {
      en : "Leknes"
    }
  },
  LKO : {
    country: "IN",
    name: {
      en : "Lucknow"
    }
  },
  LKP : {
    country: "US",
    name: {
      en : "Lake Placid"
    }
  },
  LKY : {
    country: "TZ",
    name: {
      en : "Lake Manyara"
    }
  },
  LLA : {
    country: "SE",
    name: {
      en : "Lulea"
    }
  },
  LLB : {
    country: "CN",
    name: {
      en : "LLB"
    }
  },
  LLE : {
    country: "ZA",
    name: {
      en : "Malelane"
    }
  },
  LLF : {
    country: "CN",
    name: {
      en : "Ling Ling"
    }
  },
  LLI : {
    country: "ET",
    name: {
      en : "Lalibela"
    }
  },
  LLK : {
    country: "AZ",
    name: {
      en : "Lankaran"
    }
  },
  LLU : {
    country: "GL",
    name: {
      en : "Alluitsup Paa"
    }
  },
  LLV : {
    country: "CN",
    name: {
      en : "Lüliang"
    }
  },
  LLW : {
    country: "MW",
    name: {
      en : "Lilongwe"
    }
  },
  LLY : {
    country: "US",
    name: {
      en : "Mount Holly"
    }
  },
  LMA : {
    country: "US",
    name: {
      en : "Lake Minchumina"
    }
  },
  LMC : {
    country: "CO",
    name: {
      en : "Lamacarena"
    }
  },
  LME : {
    country: "FR",
    name: {
      en : "Le Mans"
    }
  },
  LMI : {
    country: "PG",
    name: {
      en : "Lumi"
    }
  },
  LMJ : {
    country: "JP",
    name: {
      en : "LMJ"
    }
  },
  LMK : {
    country: "IE",
    name: {
      en : "Limerick"
    }
  },
  LMM : {
    country: "MX",
    name: {
      en : "Los Mochis"
    }
  },
  LMN : {
    country: "MY",
    name: {
      en : "Limbang"
    }
  },
  LMP : {
    country: "IT",
    name: {
      en : "Lampedusa"
    }
  },
  LMS : {
    country: "US",
    name: {
      en : "Louisville"
    }
  },
  LMT : {
    country: "US",
    name: {
      en : "Klamath Falls"
    }
  },
  LMY : {
    country: "PG",
    name: {
      en : "Lake Murray"
    }
  },
  LNB : {
    country: "VU",
    name: {
      en : "Lamen Bay"
    }
  },
  LNE : {
    country: "VU",
    name: {
      en : "Lonorore"
    }
  },
  LNG : {
    country: "PG",
    name: {
      en : "Lese"
    }
  },
  LNJ : {
    country: "CN",
    name: {
      en : "Lincang"
    }
  },
  LNK : {
    country: "US",
    name: {
      en : "Lincoln"
    }
  },
  LNO : {
    country: "AU",
    name: {
      en : "Leonora"
    }
  },
  LNS : {
    country: "US",
    name: {
      en : "Lancaster"
    }
  },
  LNV : {
    country: "PG",
    name: {
      en : "Lihir Island"
    }
  },
  LNX : {
    country: "RU",
    name: {
      en : "Smolensk"
    }
  },
  LNY : {
    country: "US",
    name: {
      en : "Lanai"
    }
  },
  LNZ : {
    country: "AT",
    name: {
      en : "Linz"
    }
  },
  LOD : {
    country: "VU",
    name: {
      en : "Longana"
    }
  },
  LOE : {
    country: "TH",
    name: {
      en : "Loei"
    }
  },
  LOG : {
    country: "US",
    name: {
      en : "Longview"
    }
  },
  LOH : {
    country: "EC",
    name: {
      en : "Loja"
    }
  },
  LOK : {
    country: "KE",
    name: {
      en : "Lodwar"
    }
  },
  LOM : {
    country: "MX",
    name: {
      en : "Lagos De Moreno"
    }
  },
  LON : {
    country: "GB",
    popularity: 4404,
    name: {
      en : "London"
    }
  },
  LOO : {
    country: "DZ",
    name: {
      en : "Laghouat"
    }
  },
  LOP : {
    country: "ID",
    popularity: 3000000,
    name: {
      en : "Praya"
    }
  },
  LOS : {
    country: "NG",
    name: {
      en : "Lagos"
    }
  },
  LOV : {
    country: "MX",
    name: {
      en : "Monclova"
    }
  },
  LOZ : {
    country: "US",
    popularity: 2,
    name: {
      en : "London"
    }
  },
  LPA : {
    country: "ES",
    popularity: 4,
    name: {
      en : "Las Palmas"
    }
  },
  LPB : {
    country: "BO",
    name: {
      en : "La Paz"
    }
  },
  LPC : {
    country: "US",
    name: {
      en : "Lompoc"
    }
  },
  LPD : {
    country: "CO",
    name: {
      en : "La Pedrera"
    }
  },
  LPG : {
    country: "AR",
    name: {
      en : "La Plata"
    }
  },
  LPH : {
    country: "GB",
    name: {
      en : "Lochgilphead"
    }
  },
  LPI : {
    country: "SE",
    name: {
      en : "Linkoping"
    }
  },
  LPK : {
    country: "RU",
    name: {
      en : "Lipetsk"
    }
  },
  LPL : {
    country: "GB",
    name: {
      en : "Liverpool"
    }
  },
  LPM : {
    country: "VU",
    name: {
      en : "Lamap"
    }
  },
  LPO : {
    country: "US",
    name: {
      en : "La Porte"
    }
  },
  LPP : {
    country: "FI",
    name: {
      en : "Lappeenranta"
    }
  },
  LPQ : {
    country: "LA",
    name: {
      en : "Louangphrabang"
    }
  },
  LPS : {
    country: "US",
    name: {
      en : "Lopez Island"
    }
  },
  LPT : {
    country: "TH",
    name: {
      en : "Lampang"
    }
  },
  LPX : {
    country: "LV",
    name: {
      en : "Liepaja"
    }
  },
  LPY : {
    country: "FR",
    name: {
      en : "Le Puy"
    }
  },
  LQM : {
    country: "CO",
    name: {
      en : "Puerto Leguizamo"
    }
  },
  LQN : {
    country: "AF",
    name: {
      en : "Qala Nau"
    }
  },
  LRA : {
    country: "GR",
    name: {
      en : "Larisa"
    }
  },
  LRB : {
    country: "LS",
    name: {
      en : "Leribe"
    }
  },
  LRD : {
    country: "US",
    name: {
      en : "Laredo"
    }
  },
  LRE : {
    country: "AU",
    name: {
      en : "Longreach"
    }
  },
  LRH : {
    country: "FR",
    name: {
      en : "La Rochelle"
    }
  },
  LRM : {
    country: "DO",
    name: {
      en : "La Romana"
    }
  },
  LRR : {
    country: "IR",
    name: {
      en : "Lar"
    }
  },
  LRS : {
    country: "GR",
    name: {
      en : "Leros"
    }
  },
  LRT : {
    country: "FR",
    name: {
      en : "Lorient"
    }
  },
  LRU : {
    country: "US",
    name: {
      en : "Las Cruces"
    }
  },
  LSA : {
    country: "PG",
    name: {
      en : "Losuia"
    }
  },
  LSC : {
    country: "CL",
    name: {
      en : "La Serena"
    }
  },
  LSE : {
    country: "US",
    name: {
      en : "La Crosse"
    }
  },
  LSH : {
    country: "MM",
    name: {
      en : "Lashio"
    }
  },
  LSI : {
    country: "GB",
    name: {
      en : "Lerwick"
    }
  },
  LSM : {
    country: "MY",
    name: {
      en : "Long Semado"
    }
  },
  LSN : {
    country: "US",
    name: {
      en : "Los Banos"
    }
  },
  LSO : {
    country: "FR",
    name: {
      en : "Les Sables"
    }
  },
  LSP : {
    country: "VE",
    name: {
      en : "Las Piedras"
    }
  },
  LSQ : {
    country: "CL",
    name: {
      en : "Los Angeles"
    }
  },
  LSS : {
    country: "GP",
    name: {
      en : "Les Saintes"
    }
  },
  LST : {
    country: "AU",
    name: {
      en : "Launceston"
    }
  },
  LSW : {
    country: "ID",
    name: {
      en : "Lhoksumawe"
    }
  },
  LSY : {
    country: "AU",
    name: {
      en : "Lismore"
    }
  },
  LTA : {
    country: "ZA",
    name: {
      en : "Tzaneen"
    }
  },
  LTD : {
    country: "LY",
    name: {
      en : "Ghadames"
    }
  },
  LTI : {
    country: "MN",
    name: {
      en : "Altai"
    }
  },
  LTK : {
    country: "SY",
    name: {
      en : "Latakia"
    }
  },
  LTL : {
    country: "GA",
    name: {
      en : "Lastourville"
    }
  },
  LTN : {
    country: "GB",
    name: {
      en : "Luton"
    }
  },
  LTO : {
    country: "MX",
    name: {
      en : "Loreto"
    }
  },
  LTQ : {
    country: "FR",
    popularity: 4,
    name: {
      en : "Le Touquet"
    }
  },
  LTR : {
    country: "IE",
    name: {
      en : "Letterkenny"
    }
  },
  LTS : {
    country: "US",
    name: {
      en : "Altus"
    }
  },
  LTT : {
    country: "FR",
    popularity: 8,
    name: {
      en : "St Tropez"
    }
  },
  LTU : {
    country: "IN",
    name: {
      en : "Latur"
    }
  },
  LTX : {
    country: "EC",
    name: {
      en : "Latacunga"
    }
  },
  LUA : {
    country: "NP",
    name: {
      en : "Lukla"
    }
  },
  LUD : {
    country: "NA",
    name: {
      en : "Luderitz"
    }
  },
  LUG : {
    country: "CH",
    popularity: 4,
    name: {
      en : "Lugano"
    }
  },
  LUH : {
    country: "IN",
    name: {
      en : "Ludhiana"
    }
  },
  LUL : {
    country: "US",
    name: {
      en : "Laurel"
    }
  },
  LUM : {
    country: "CN",
    name: {
      en : "Mangshi"
    }
  },
  LUN : {
    country: "ZM",
    name: {
      en : "Lusaka"
    }
  },
  LUO : {
    country: "AO",
    name: {
      en : "Luena"
    }
  },
  LUP : {
    country: "US",
    name: {
      en : "Kalaupapa"
    }
  },
  LUQ : {
    country: "AR",
    name: {
      en : "San Luis"
    }
  },
  LUR : {
    country: "US",
    name: {
      en : "Cape Lisburne"
    }
  },
  LUV : {
    country: "ID",
    name: {
      en : "Langgur"
    }
  },
  LUW : {
    country: "ID",
    name: {
      en : "Luwuk"
    }
  },
  LUX : {
    country: "LU",
    popularity: 206,
    name: {
      en : "Luxembourg"
    }
  },
  LUZ : {
    country: "PL",
    popularity: 2,
    name: {
      en : "Lublin"
    }
  },
  LVA : {
    country: "FR",
    name: {
      en : "Laval"
    }
  },
  LVB : {
    country: "BR",
    name: {
      en : "Livramento"
    }
  },
  LVI : {
    country: "ZM",
    name: {
      en : "Livingstone"
    }
  },
  LVK : {
    country: "US",
    name: {
      en : "Livermore"
    }
  },
  LVM : {
    country: "US",
    name: {
      en : "Livingston"
    }
  },
  LVO : {
    country: "AU",
    name: {
      en : "Laverton"
    }
  },
  LVS : {
    country: "US",
    name: {
      en : "Las Vegas"
    }
  },
  LWB : {
    country: "US",
    name: {
      en : "Lewisburg"
    }
  },
  LWC : {
    country: "US",
    name: {
      en : "Lawrence"
    }
  },
  LWE : {
    country: "ID",
    name: {
      en : "Lewoleba"
    }
  },
  LWM : {
    country: "US",
    name: {
      en : "Lawrence"
    }
  },
  LWN : {
    country: "AM",
    name: {
      en : "Gyumri"
    }
  },
  LWO : {
    country: "UA",
    popularity: 26,
    name: {
      en : "Lvov"
    }
  },
  LWR : {
    country: "NL",
    name: {
      en : "Leeuwarden"
    }
  },
  LWS : {
    country: "US",
    name: {
      en : "Lewiston"
    }
  },
  LWT : {
    country: "US",
    name: {
      en : "Lewistown"
    }
  },
  LWY : {
    country: "MY",
    name: {
      en : "Lawas"
    }
  },
  LXA : {
    country: "CN",
    popularity: 8,
    name: {
      en : "Lhasa"
    }
  },
  LXG : {
    country: "LA",
    name: {
      en : "Luang Namtha"
    }
  },
  LXH : {
    country: "FR",
    name: {
      en : "Luchon"
    }
  },
  LXN : {
    country: "US",
    name: {
      en : "Lexington"
    }
  },
  LXR : {
    country: "EG",
    popularity: 4,
    name: {
      en : "Luxor"
    }
  },
  LXS : {
    country: "GR",
    name: {
      en : "Limnos"
    }
  },
  LYA : {
    country: "CN",
    name: {
      en : "Luoyang"
    }
  },
  LYB : {
    country: "KY",
    name: {
      en : "Little Cayman"
    }
  },
  LYC : {
    country: "SE",
    name: {
      en : "Lycksele"
    }
  },
  LYG : {
    country: "CN",
    name: {
      en : "Lianyungang"
    }
  },
  LYH : {
    country: "US",
    name: {
      en : "Lynchburg"
    }
  },
  LYI : {
    country: "CN",
    name: {
      en : "Linyi"
    }
  },
  LYP : {
    country: "PK",
    name: {
      en : "Faisalabad"
    }
  },
  LYR : {
    country: "NO",
    name: {
      en : "Longyearbyen"
    }
  },
  LYS : {
    country: "FR",
    popularity: 38,
    name: {
      en : "Lyon"
    }
  },
  LYU : {
    country: "US",
    name: {
      en : "Ely Mn"
    }
  },
  LYX : {
    country: "GB",
    name: {
      en : "Lydd"
    }
  },
  LZC : {
    country: "MX",
    name: {
      en : "Lazaro Cardenas Michoacan"
    }
  },
  LZH : {
    country: "CN",
    name: {
      en : "Liuzhou"
    }
  },
  LZN : {
    country: "TW",
    name: {
      en : "Nangan"
    }
  },
  LZO : {
    country: "CN",
    name: {
      en : "Luzhou"
    }
  },
  LZR : {
    country: "AU",
    name: {
      en : "Lizard Island"
    }
  },
  LZU : {
    country: "US",
    name: {
      en : "Lawrenceville"
    }
  },
  LZY : {
    country: "CN",
    name: {
      en : "LZY"
    }
  },
  MAA : {
    country: "IN",
    name: {
      en : "Chennai"
    }
  },
  MAB : {
    country: "BR",
    name: {
      en : "Maraba"
    }
  },
  MAD : {
    country: "ES",
    popularity: 1913,
    name: {
      en : "Madrid"
    }
  },
  MAE : {
    country: "US",
    name: {
      en : "Madera"
    }
  },
  MAF : {
    country: "US",
    name: {
      en : "Midland"
    }
  },
  MAG : {
    country: "PG",
    popularity: 2,
    name: {
      en : "Madang"
    }
  },
  MAH : {
    country: "ES",
    name: {
      en : "Menorca"
    }
  },
  MAJ : {
    country: "MH",
    name: {
      en : "Majuro"
    }
  },
  MAK : {
    country: "SD",
    name: {
      en : "Malakal"
    }
  },
  MAL : {
    country: "ID",
    name: {
      en : "Mangole"
    }
  },
  MAM : {
    country: "MX",
    name: {
      en : "Matamoros"
    }
  },
  MAN : {
    country: "GB",
    popularity: 160,
    name: {
      en : "Manchester"
    }
  },
  MAO : {
    country: "BR",
    name: {
      en : "Manaus"
    }
  },
  MAP : {
    country: "PG",
    name: {
      en : "Mamai"
    }
  },
  MAQ : {
    country: "TH",
    name: {
      en : "Mae Sot"
    }
  },
  MAR : {
    country: "VE",
    name: {
      en : "Maracaibo"
    }
  },
  MAS : {
    country: "PG",
    name: {
      en : "Manus Island"
    }
  },
  MAT : {
    country: "CD",
    name: {
      en : "Matadi"
    }
  },
  MAU : {
    country: "PF",
    name: {
      en : "Maupiti"
    }
  },
  MAX : {
    country: "SN",
    name: {
      en : "Matam"
    }
  },
  MAY : {
    country: "BS",
    name: {
      en : "Mangrove Cay"
    }
  },
  MAZ : {
    country: "PR",
    name: {
      en : "Mayaguez"
    }
  },
  MBA : {
    country: "KE",
    popularity: 4,
    name: {
      en : "Mombasa"
    }
  },
  MBB : {
    country: "AU",
    name: {
      en : "Marble Bar"
    }
  },
  MBC : {
    country: "GA",
    name: {
      en : "M Bigou"
    }
  },
  MBD : {
    country: "ZA",
    name: {
      en : "Mmabatho"
    }
  },
  MBE : {
    country: "JP",
    name: {
      en : "Monbetsu"
    }
  },
  MBH : {
    country: "AU",
    name: {
      en : "Maryborough"
    }
  },
  MBI : {
    country: "TZ",
    name: {
      en : "Mbeya"
    }
  },
  MBJ : {
    country: "JM",
    popularity: 32,
    name: {
      en : "Montego Bay"
    }
  },
  MBL : {
    country: "US",
    name: {
      en : "Manistee"
    }
  },
  MBQ : {
    country: "UG",
    name: {
      en : "Mbarara"
    }
  },
  MBS : {
    country: "US",
    name: {
      en : "Saginaw"
    }
  },
  MBT : {
    country: "PH",
    name: {
      en : "Masbate"
    }
  },
  MBW : {
    country: "AU",
    name: {
      en : "Moorabbin"
    }
  },
  MBX : {
    country: "SI",
    name: {
      en : "Maribor"
    }
  },
  MCD : {
    country: "US",
    name: {
      en : "Mackinac Island"
    }
  },
  MCE : {
    country: "US",
    name: {
      en : "Merced"
    }
  },
  MCG : {
    country: "US",
    name: {
      en : "Mcgrath"
    }
  },
  MCH : {
    country: "EC",
    name: {
      en : "Machala"
    }
  },
  MCK : {
    country: "US",
    name: {
      en : "McCook"
    }
  },
  MCM : {
    country: "MC",
    popularity: 8,
    name: {
      en : "Monte Carlo"
    }
  },
  MCN : {
    country: "US",
    name: {
      en : "Macon"
    }
  },
  MCP : {
    country: "BR",
    name: {
      en : "Macapa"
    }
  },
  MCQ : {
    country: "HU",
    name: {
      en : "Miskolc"
    }
  },
  MCT : {
    country: "OM",
    popularity: 4,
    name: {
      en : "Muscat"
    }
  },
  MCU : {
    country: "FR",
    name: {
      en : "Montlucon"
    }
  },
  MCV : {
    country: "AU",
    name: {
      en : "McArthur River"
    }
  },
  MCW : {
    country: "US",
    name: {
      en : "Mason City"
    }
  },
  MCX : {
    country: "RU",
    name: {
      en : "Makhachkala"
    }
  },
  MCY : {
    country: "AU",
    name: {
      en : "Maroochydore"
    }
  },
  MCZ : {
    country: "BR",
    name: {
      en : "Maceio"
    }
  },
  MDC : {
    country: "ID",
    name: {
      en : "Manado"
    }
  },
  MDE : {
    country: "CO",
    name: {
      en : "Medellin"
    }
  },
  MDF : {
    country: "US",
    name: {
      en : "Medford"
    }
  },
  MDG : {
    country: "CN",
    name: {
      en : "Mudanjiang"
    }
  },
  MDH : {
    country: "US",
    name: {
      en : "Carbondale"
    }
  },
  MDI : {
    country: "NG",
    name: {
      en : "Makurdi"
    }
  },
  MDJ : {
    country: "IN",
    name: {
      en : "MDJ"
    }
  },
  MDK : {
    country: "CD",
    name: {
      en : "Mbandaka"
    }
  },
  MDL : {
    country: "MM",
    name: {
      en : "Mandalay"
    }
  },
  MDN : {
    country: "US",
    name: {
      en : "Madison"
    }
  },
  MDP : {
    country: "ID",
    name: {
      en : "Mindiptana"
    }
  },
  MDQ : {
    country: "AR",
    name: {
      en : "Mar Del Plata"
    }
  },
  MDR : {
    country: "US",
    name: {
      en : "Medfra"
    }
  },
  MDS : {
    country: "TC",
    name: {
      en : "Middle Caicos"
    }
  },
  MDU : {
    country: "PG",
    name: {
      en : "Mendi"
    }
  },
  MDV : {
    country: "GA",
    name: {
      en : "Medouneu"
    }
  },
  MDY : {
    country: "UM",
    name: {
      en : "Midway Island"
    }
  },
  MDZ : {
    country: "AR",
    name: {
      en : "Mendoza"
    }
  },
  MEA : {
    country: "BR",
    name: {
      en : "Macae"
    }
  },
  MEC : {
    country: "EC",
    name: {
      en : "Manta"
    }
  },
  MED : {
    country: "SA",
    name: {
      en : "Madinah"
    }
  },
  MEE : {
    country: "NC",
    name: {
      en : "Mare"
    }
  },
  MEG : {
    country: "AO",
    name: {
      en : "Malange"
    }
  },
  MEH : {
    country: "NO",
    name: {
      en : "Mehamn"
    }
  },
  MEI : {
    country: "US",
    name: {
      en : "Meridian"
    }
  },
  MEJ : {
    country: "US",
    name: {
      en : "Meadville"
    }
  },
  MEK : {
    country: "MA",
    name: {
      en : "Meknes"
    }
  },
  MEL : {
    country: "AU",
    popularity: 20,
    name: {
      en : "Melbourne"
    }
  },
  MEM : {
    country: "US",
    popularity: 32,
    name: {
      en : "Memphis"
    }
  },
  MEO : {
    country: "US",
    name: {
      en : "Manteo"
    }
  },
  MEP : {
    country: "MY",
    name: {
      en : "Mersing"
    }
  },
  MEQ : {
    country: "ID",
    name: {
      en : "Meulaboh"
    }
  },
  MES : {
    country: "ID",
    name: {
      en : "Medan"
    }
  },
  MEU : {
    country: "BR",
    name: {
      en : "Monte Dourado"
    }
  },
  MEV : {
    country: "US",
    name: {
      en : "Minden"
    }
  },
  MEX : {
    country: "MX",
    popularity: 54,
    name: {
      en : "Mexico City"
    }
  },
  MEY : {
    country: "NP",
    name: {
      en : "Meghauli"
    }
  },
  MFA : {
    country: "TZ",
    name: {
      en : "Mafia"
    }
  },
  MFC : {
    country: "LS",
    name: {
      en : "Mafeteng"
    }
  },
  MFD : {
    country: "US",
    name: {
      en : "Mansfield"
    }
  },
  MFE : {
    country: "US",
    name: {
      en : "McAllen"
    }
  },
  MFF : {
    country: "GA",
    name: {
      en : "Moanda"
    }
  },
  MFH : {
    country: "US",
    name: {
      en : "Mesquite"
    }
  },
  MFI : {
    country: "US",
    name: {
      en : "Marshfield"
    }
  },
  MFJ : {
    country: "FJ",
    name: {
      en : "Moala"
    }
  },
  MFK : {
    country: "TW",
    name: {
      en : "Matsu"
    }
  },
  MFM : {
    country: "MO",
    popularity: 2,
    name: {
      en : "Macau"
    }
  },
  MFN : {
    country: "NZ",
    name: {
      en : "Milford Sound"
    }
  },
  MFR : {
    country: "US",
    name: {
      en : "Medford"
    }
  },
  MFT : {
    country: "PE",
    name: {
      en : "Machu Picchu"
    }
  },
  MFU : {
    country: "ZM",
    name: {
      en : "Mfuwe"
    }
  },
  MGA : {
    country: "NI",
    popularity: 4,
    name: {
      en : "Managua"
    }
  },
  MGB : {
    country: "AU",
    name: {
      en : "Mt Gambier"
    }
  },
  MGC : {
    country: "US",
    name: {
      en : "Michigan City"
    }
  },
  MGD : {
    country: "BO",
    name: {
      en : "Magdalena"
    }
  },
  MGE : {
    country: "US",
    name: {
      en : "Marietta"
    }
  },
  MGF : {
    country: "BR",
    name: {
      en : "Maringa"
    }
  },
  MGH : {
    country: "ZA",
    name: {
      en : "Margate"
    }
  },
  MGJ : {
    country: "US",
    name: {
      en : "Montgomery"
    }
  },
  MGM : {
    country: "US",
    name: {
      en : "Montgomery"
    }
  },
  MGP : {
    country: "PG",
    name: {
      en : "Manga"
    }
  },
  MGQ : {
    country: "SO",
    name: {
      en : "Mogadishu"
    }
  },
  MGR : {
    country: "US",
    name: {
      en : "Moultrie"
    }
  },
  MGS : {
    country: "CK",
    name: {
      en : "Mangaia Island"
    }
  },
  MGT : {
    country: "AU",
    name: {
      en : "Milingimbi"
    }
  },
  MGV : {
    country: "AU",
    name: {
      en : "Margaret River Station"
    }
  },
  MGW : {
    country: "US",
    name: {
      en : "Morgantown"
    }
  },
  MGX : {
    country: "GA",
    name: {
      en : "Maobi"
    }
  },
  MGZ : {
    country: "MM",
    name: {
      en : "Myeik"
    }
  },
  MHD : {
    country: "IR",
    name: {
      en : "Mashad"
    }
  },
  MHE : {
    country: "US",
    name: {
      en : "Mitchell"
    }
  },
  MHG : {
    country: "DE",
    name: {
      en : "Mannheim"
    }
  },
  MHH : {
    country: "BS",
    name: {
      en : "Marsh Harbour"
    }
  },
  MHK : {
    country: "US",
    name: {
      en : "Manhattan"
    }
  },
  MHQ : {
    country: "FI",
    name: {
      en : "Mariehamn"
    }
  },
  MHT : {
    country: "US",
    name: {
      en : "Manchester"
    }
  },
  MHU : {
    country: "AU",
    name: {
      en : "Mount Hotham"
    }
  },
  MHV : {
    country: "US",
    name: {
      en : "Mojave"
    }
  },
  MHY : {
    country: "PG",
    name: {
      en : "Morehead"
    }
  },
  MHZ : {
    country: "GB",
    name: {
      en : "Mildenhall"
    }
  },
  MIA : {
    country: "US",
    popularity: 64,
    name: {
      en : "Miami"
    }
  },
  MID : {
    country: "MX",
    name: {
      en : "Merida"
    }
  },
  MIE : {
    country: "US",
    name: {
      en : "Muncie"
    }
  },
  MIG : {
    country: "CN",
    name: {
      en : "Mian Yang"
    }
  },
  MII : {
    country: "BR",
    name: {
      en : "Marilia"
    }
  },
  MIK : {
    country: "FI",
    name: {
      en : "Mikkeli"
    }
  },
  MIL : {
    country: "IT",
    popularity: 55,
    name: {
      en : "Milan"
    }
  },
  MIM : {
    country: "AU",
    name: {
      en : "Merimbula"
    }
  },
  MIR : {
    country: "TN",
    popularity: 10,
    name: {
      en : "Monastir"
    }
  },
  MIS : {
    country: "PG",
    name: {
      en : "Misima"
    }
  },
  MIU : {
    country: "NG",
    name: {
      en : "Maiduguri"
    }
  },
  MIV : {
    country: "US",
    name: {
      en : "Millville"
    }
  },
  MIW : {
    country: "US",
    name: {
      en : "Marshalltown"
    }
  },
  MJA : {
    country: "MG",
    name: {
      en : "Manja"
    }
  },
  MJC : {
    country: "CI",
    name: {
      en : "Man CI"
    }
  },
  MJD : {
    country: "PK",
    name: {
      en : "Mohenjodaro"
    }
  },
  MJF : {
    country: "NO",
    popularity: 14,
    name: {
      en : "Mosjoen"
    }
  },
  MJI : {
    country: "ET",
    name: {
      en : "Maji"
    }
  },
  MJK : {
    country: "AU",
    name: {
      en : "Monkey Mia"
    }
  },
  MJL : {
    country: "GA",
    name: {
      en : "Mouila"
    }
  },
  MJM : {
    country: "CD",
    name: {
      en : "Mbuji Mayi"
    }
  },
  MJN : {
    country: "MG",
    name: {
      en : "Majunga"
    }
  },
  MJR : {
    country: "AR",
    name: {
      en : "Miramar"
    }
  },
  MJT : {
    country: "GR",
    name: {
      en : "Mytilene"
    }
  },
  MJU : {
    country: "ID",
    name: {
      en : "Mamuju"
    }
  },
  MJV : {
    country: "ES",
    popularity: 68,
    name: {
      en : "Murcia"
    }
  },
  MJW : {
    country: "ZW",
    name: {
      en : "Mahenye"
    }
  },
  MJY : {
    country: "RU",
    name: {
      en : "Motygino"
    }
  },
  MJZ : {
    country: "RU",
    name: {
      en : "Mirnyj"
    }
  },
  MKA : {
    country: "CZ",
    name: {
      en : "Marianske Lazne"
    }
  },
  MKB : {
    country: "GA",
    name: {
      en : "Mekambo"
    }
  },
  MKC : {
    country: "US",
    popularity: 6,
    name: {
      en : "Kansas City"
    }
  },
  MKD : {
    country: "ET",
    name: {
      en : "Metekel"
    }
  },
  MKE : {
    country: "US",
    popularity: 32,
    name: {
      en : "Milwaukee"
    }
  },
  MKG : {
    country: "US",
    name: {
      en : "Muskegon"
    }
  },
  MKH : {
    country: "LS",
    name: {
      en : "Mokhotlong"
    }
  },
  MKJ : {
    country: "CG",
    name: {
      en : "Makoua"
    }
  },
  MKK : {
    country: "US",
    name: {
      en : "Hoolehua"
    }
  },
  MKL : {
    country: "US",
    name: {
      en : "Jackson"
    }
  },
  MKM : {
    country: "MY",
    name: {
      en : "Mukah"
    }
  },
  MKN : {
    country: "PG",
    name: {
      en : "Malekolon"
    }
  },
  MKO : {
    country: "US",
    name: {
      en : "Muskogee"
    }
  },
  MKP : {
    country: "PF",
    name: {
      en : "Makemo"
    }
  },
  MKQ : {
    country: "ID",
    name: {
      en : "Merauke"
    }
  },
  MKR : {
    country: "AU",
    name: {
      en : "Meekathara"
    }
  },
  MKS : {
    country: "ET",
    name: {
      en : "Mekane"
    }
  },
  MKT : {
    country: "US",
    name: {
      en : "Mankato"
    }
  },
  MKU : {
    country: "GA",
    name: {
      en : "Makokou"
    }
  },
  MKW : {
    country: "ID",
    name: {
      en : "Manokwari"
    }
  },
  MKX : {
    country: "YE",
    name: {
      en : "Mukalla"
    }
  },
  MKY : {
    country: "AU",
    name: {
      en : "Mackay"
    }
  },
  MKZ : {
    country: "MY",
    name: {
      en : "Malacca"
    }
  },
  MLA : {
    country: "MT",
    popularity: 58,
    name: {
      en : "Malta"
    }
  },
  MLB : {
    country: "US",
    name: {
      en : "Melbourne"
    }
  },
  MLC : {
    country: "US",
    name: {
      en : "McAlester"
    }
  },
  MLE : {
    country: "MV",
    popularity: 34,
    name: {
      en : "Male"
    }
  },
  MLG : {
    country: "ID",
    name: {
      en : "Malang"
    }
  },
  MLH : {
    country: "FR",
    name: {
      en : "Mulhouse"
    }
  },
  MLI : {
    country: "US",
    name: {
      en : "Moline"
    }
  },
  MLJ : {
    country: "US",
    name: {
      en : "Milledgeville"
    }
  },
  MLL : {
    country: "US",
    name: {
      en : "Marshall"
    }
  },
  MLM : {
    country: "MX",
    name: {
      en : "Morelia"
    }
  },
  MLN : {
    country: "ES",
    name: {
      en : "Melilla"
    }
  },
  MLO : {
    country: "GR",
    name: {
      en : "Milos"
    }
  },
  MLQ : {
    country: "PG",
    name: {
      en : "Malalaua"
    }
  },
  MLS : {
    country: "US",
    name: {
      en : "Miles City"
    }
  },
  MLT : {
    country: "US",
    name: {
      en : "Millinocket"
    }
  },
  MLU : {
    country: "US",
    name: {
      en : "Monroe"
    }
  },
  MLW : {
    country: "LR",
    name: {
      en : "Monrovia"
    }
  },
  MLX : {
    country: "TR",
    name: {
      en : "Malatya"
    }
  },
  MLY : {
    country: "US",
    name: {
      en : "Manley Hot Springs"
    }
  },
  MLZ : {
    country: "UY",
    name: {
      en : "Melo"
    }
  },
  MMA : {
    country: "SE",
    popularity: 2,
    name: {
      en : "Malmo"
    }
  },
  MMB : {
    country: "JP",
    name: {
      en : "Memambetsu"
    }
  },
  MMC : {
    country: "MX",
    name: {
      en : "Ciudad Mante"
    }
  },
  MMD : {
    country: "JP",
    name: {
      en : "Minami Daito"
    }
  },
  MME : {
    country: "GB",
    name: {
      en : "Teesside"
    }
  },
  MMG : {
    country: "AU",
    name: {
      en : "Mount Magnet"
    }
  },
  MMH : {
    country: "US",
    name: {
      en : "Mammoth Lakes"
    }
  },
  MMJ : {
    country: "JP",
    name: {
      en : "Matsumoto"
    }
  },
  MMK : {
    country: "RU",
    popularity: 2,
    name: {
      en : "Murmansk"
    }
  },
  MML : {
    country: "US",
    name: {
      en : "Marshall"
    }
  },
  MMM : {
    country: "AU",
    name: {
      en : "Middlemount"
    }
  },
  MMO : {
    country: "CV",
    name: {
      en : "Maio"
    }
  },
  MMU : {
    country: "US",
    name: {
      en : "Morristown"
    }
  },
  MMY : {
    country: "JP",
    name: {
      en : "Miyako Jima"
    }
  },
  MMZ : {
    country: "AF",
    name: {
      en : "Maimana"
    }
  },
  MNA : {
    country: "ID",
    name: {
      en : "Melangguane"
    }
  },
  MNB : {
    country: "CD",
    name: {
      en : "Moanda"
    }
  },
  MNE : {
    country: "AU",
    name: {
      en : "Mungeranie"
    }
  },
  MNF : {
    country: "FJ",
    name: {
      en : "Mana Island"
    }
  },
  MNG : {
    country: "AU",
    name: {
      en : "Maningrida"
    }
  },
  MNI : {
    country: "MS",
    name: {
      en : "Montserrat"
    }
  },
  MNJ : {
    country: "MG",
    name: {
      en : "Mananjary"
    }
  },
  MNK : {
    country: "KI",
    name: {
      en : "Maiana"
    }
  },
  MNL : {
    country: "PH",
    popularity: 34,
    name: {
      en : "Manila"
    }
  },
  MNM : {
    country: "US",
    name: {
      en : "Menominee"
    }
  },
  MNQ : {
    country: "AU",
    name: {
      en : "Monto"
    }
  },
  MNR : {
    country: "ZM",
    name: {
      en : "Mongu"
    }
  },
  MNS : {
    country: "ZM",
    name: {
      en : "Mansa"
    }
  },
  MNT : {
    country: "US",
    name: {
      en : "Minto"
    }
  },
  MNU : {
    country: "MM",
    name: {
      en : "Moulmein"
    }
  },
  MNY : {
    country: "SB",
    name: {
      en : "Mono"
    }
  },
  MNZ : {
    country: "US",
    popularity: 2,
    name: {
      en : "Manassas"
    }
  },
  MOA : {
    country: "CU",
    name: {
      en : "Moa CU"
    }
  },
  MOB : {
    country: "US",
    name: {
      en : "Mobile"
    }
  },
  MOC : {
    country: "BR",
    name: {
      en : "Montes Claros"
    }
  },
  MOD : {
    country: "US",
    popularity: 2,
    name: {
      en : "Modesto"
    }
  },
  MOE : {
    country: "MM",
    name: {
      en : "Momeik"
    }
  },
  MOF : {
    country: "ID",
    name: {
      en : "Maumere"
    }
  },
  MOG : {
    country: "MM",
    name: {
      en : "Mong Hsat"
    }
  },
  MOI : {
    country: "CK",
    name: {
      en : "Mitiaro Island"
    }
  },
  MOL : {
    country: "NO",
    name: {
      en : "Molde"
    }
  },
  MON : {
    country: "NZ",
    name: {
      en : "Mount Cook"
    }
  },
  MOO : {
    country: "AU",
    name: {
      en : "Moomba"
    }
  },
  MOP : {
    country: "US",
    name: {
      en : "Mount Pleasant"
    }
  },
  MOQ : {
    country: "MG",
    name: {
      en : "Morondava"
    }
  },
  MOR : {
    country: "US",
    name: {
      en : "Morristown"
    }
  },
  MOT : {
    country: "US",
    name: {
      en : "Minot"
    }
  },
  MOU : {
    country: "US",
    name: {
      en : "Mountain Village"
    }
  },
  MOV : {
    country: "AU",
    popularity: 4,
    name: {
      en : "Moranbah"
    }
  },
  MOW : {
    country: "RU",
    popularity: 14143,
    name: {
      en : "Moscow"
    }
  },
  MOZ : {
    country: "PF",
    name: {
      en : "Moorea"
    }
  },
  MPA : {
    country: "NA",
    name: {
      en : "Mpacha"
    }
  },
  MPH : {
    country: "PH",
    name: {
      en : "Caticlan"
    }
  },
  MPI : {
    country: "PA",
    name: {
      en : "Mamitupo"
    }
  },
  MPK : {
    country: "KR",
    name: {
      en : "Mokpo"
    }
  },
  MPL : {
    country: "FR",
    name: {
      en : "Montpellier"
    }
  },
  MPM : {
    country: "MZ",
    name: {
      en : "Maputo"
    }
  },
  MPN : {
    country: "FK",
    name: {
      en : "Mount Pleasant"
    }
  },
  MPO : {
    country: "US",
    name: {
      en : "Mt Pocono"
    }
  },
  MPQ : {
    country: "JO",
    name: {
      en : "Maan"
    }
  },
  MPR : {
    country: "US",
    name: {
      en : "McPherson"
    }
  },
  MPV : {
    country: "US",
    name: {
      en : "Montpelier"
    }
  },
  MQB : {
    country: "US",
    name: {
      en : "Macomb"
    }
  },
  MQC : {
    country: "  ",
    name: {
      en : "MQC"
    }
  },
  MQF : {
    country: "RU",
    popularity: 4,
    name: {
      en : "Magnitogorsk"
    }
  },
  MQJ : {
    country: "RU",
    popularity: 130,
    name: {
      en : "Khonuu"
    }
  },
  MQK : {
    country: "BO",
    name: {
      en : "San Matias"
    }
  },
  MQL : {
    country: "AU",
    name: {
      en : "Mildura"
    }
  },
  MQM : {
    country: "TR",
    name: {
      en : "Mardin"
    }
  },
  MQN : {
    country: "NO",
    name: {
      en : "Mo I Rana"
    }
  },
  MQP : {
    country: "ZA",
    name: {
      en : "Nelspruit"
    }
  },
  MQQ : {
    country: "TD",
    name: {
      en : "Moundou"
    }
  },
  MQS : {
    country: "VC",
    name: {
      en : "Mustique"
    }
  },
  MQT : {
    country: "US",
    name: {
      en : "Marquette"
    }
  },
  MQX : {
    country: "ET",
    name: {
      en : "Makale"
    }
  },
  MQY : {
    country: "US",
    name: {
      en : "Smyrna"
    }
  },
  MQZ : {
    country: "AU",
    name: {
      en : "Margaret River"
    }
  },
  MRA : {
    country: "LY",
    name: {
      en : "Misurata"
    }
  },
  MRB : {
    country: "US",
    name: {
      en : "Martinsburg"
    }
  },
  MRC : {
    country: "US",
    name: {
      en : "Columbia"
    }
  },
  MRD : {
    country: "VE",
    name: {
      en : "Merida"
    }
  },
  MRE : {
    country: "KE",
    name: {
      en : "Mara Lodges"
    }
  },
  MRG : {
    country: "AU",
    name: {
      en : "Mareeba"
    }
  },
  MRK : {
    country: "US",
    name: {
      en : "Marco Island"
    }
  },
  MRM : {
    country: "PG",
    name: {
      en : "Manare"
    }
  },
  MRO : {
    country: "NZ",
    name: {
      en : "Masterton"
    }
  },
  MRQ : {
    country: "PH",
    name: {
      en : "Marinduque"
    }
  },
  MRS : {
    country: "FR",
    popularity: 88,
    name: {
      en : "Marseille"
    }
  },
  MRU : {
    country: "MU",
    popularity: 16,
    name: {
      en : "Mauritius"
    }
  },
  MRV : {
    country: "RU",
    popularity: 16,
    name: {
      en : "Mineralnye Vody"
    }
  },
  MRW : {
    country: "DK",
    name: {
      en : "Maribo"
    }
  },
  MRX : {
    country: "IR",
    name: {
      en : "Bandar Mahshahr"
    }
  },
  MRY : {
    country: "US",
    name: {
      en : "Monterey"
    }
  },
  MRZ : {
    country: "AU",
    name: {
      en : "Moree"
    }
  },
  MSA : {
    country: "CA",
    name: {
      en : "Muskrat Dam"
    }
  },
  MSB : {
    country: "GP",
    name: {
      en : "Marigot St Martin"
    }
  },
  MSC : {
    country: "US",
    name: {
      en : "Mesa"
    }
  },
  MSE : {
    country: "GB",
    name: {
      en : "Manston"
    }
  },
  MSG : {
    country: "LS",
    name: {
      en : "Matsaile"
    }
  },
  MSH : {
    country: "OM",
    name: {
      en : "Masirah"
    }
  },
  MSJ : {
    country: "JP",
    name: {
      en : "Misawa"
    }
  },
  MSL : {
    country: "US",
    name: {
      en : "Muscle Shoals"
    }
  },
  MSN : {
    country: "US",
    popularity: 6,
    name: {
      en : "Madison"
    }
  },
  MSO : {
    country: "US",
    name: {
      en : "Missoula"
    }
  },
  MSP : {
    country: "US",
    popularity: 6,
    name: {
      en : "Minneapolis"
    }
  },
  MSQ : {
    country: "BY",
    popularity: 46,
    name: {
      en : "Minsk"
    }
  },
  MSR : {
    country: "TR",
    name: {
      en : "Mus"
    }
  },
  MSS : {
    country: "US",
    popularity: 2,
    name: {
      en : "Massena"
    }
  },
  MST : {
    country: "NL",
    name: {
      en : "Maastricht"
    }
  },
  MSU : {
    country: "LS",
    popularity: 2,
    name: {
      en : "Maseru"
    }
  },
  MSV : {
    country: "US",
    name: {
      en : "Monticello"
    }
  },
  MSW : {
    country: "ER",
    name: {
      en : "Massawa"
    }
  },
  MSX : {
    country: "CG",
    name: {
      en : "Mossendjo"
    }
  },
  MSY : {
    country: "US",
    popularity: 24,
    name: {
      en : "New Orleans"
    }
  },
  MSZ : {
    country: "AO",
    name: {
      en : "Namibe"
    }
  },
  MTA : {
    country: "NZ",
    name: {
      en : "Matamata"
    }
  },
  MTH : {
    country: "US",
    name: {
      en : "Marathon"
    }
  },
  MTI : {
    country: "CV",
    name: {
      en : "Mosteiros"
    }
  },
  MTJ : {
    country: "US",
    name: {
      en : "Montrose"
    }
  },
  MTK : {
    country: "KI",
    name: {
      en : "Makin Island"
    }
  },
  MTL : {
    country: "AU",
    name: {
      en : "Maitland"
    }
  },
  MTM : {
    country: "US",
    name: {
      en : "Metlakatla"
    }
  },
  MTO : {
    country: "US",
    name: {
      en : "Mattoon"
    }
  },
  MTP : {
    country: "US",
    name: {
      en : "Montauk"
    }
  },
  MTR : {
    country: "CO",
    name: {
      en : "Monteria"
    }
  },
  MTS : {
    country: "SZ",
    name: {
      en : "Manzini"
    }
  },
  MTT : {
    country: "MX",
    name: {
      en : "Minatitlan"
    }
  },
  MTV : {
    country: "VU",
    name: {
      en : "Mota Lava"
    }
  },
  MTW : {
    country: "US",
    name: {
      en : "Manitowoc"
    }
  },
  MTY : {
    country: "MX",
    popularity: 18,
    name: {
      en : "Monterrey"
    }
  },
  MUA : {
    country: "SB",
    name: {
      en : "Munda"
    }
  },
  MUB : {
    country: "BW",
    name: {
      en : "Maun"
    }
  },
  MUC : {
    country: "DE",
    popularity: 528,
    name: {
      en : "Munich"
    }
  },
  MUE : {
    country: "US",
    name: {
      en : "Kamuela"
    }
  },
  MUF : {
    country: "ID",
    name: {
      en : "Muting"
    }
  },
  MUH : {
    country: "EG",
    name: {
      en : "Mersa Matruh"
    }
  },
  MUK : {
    country: "CK",
    name: {
      en : "Mauke"
    }
  },
  MUN : {
    country: "VE",
    name: {
      en : "Maturin"
    }
  },
  MUO : {
    country: "US",
    name: {
      en : "Mountain Home"
    }
  },
  MUP : {
    country: "AU",
    name: {
      en : "Mulga Park"
    }
  },
  MUR : {
    country: "MY",
    name: {
      en : "Marudi"
    }
  },
  MUT : {
    country: "US",
    name: {
      en : "Muscatine"
    }
  },
  MUU : {
    country: "US",
    name: {
      en : "Mount Union"
    }
  },
  MUX : {
    country: "PK",
    name: {
      en : "Multan"
    }
  },
  MUZ : {
    country: "TZ",
    name: {
      en : "Musoma"
    }
  },
  MVB : {
    country: "GA",
    name: {
      en : "Franceville Mvengue"
    }
  },
  MVC : {
    country: "US",
    name: {
      en : "Monroeville"
    }
  },
  MVD : {
    country: "UY",
    name: {
      en : "Montevideo"
    }
  },
  MVF : {
    country: "BR",
    popularity: 2,
    name: {
      en : "Mossoro"
    }
  },
  MVK : {
    country: "AU",
    name: {
      en : "Mulka"
    }
  },
  MVL : {
    country: "US",
    name: {
      en : "Stowe"
    }
  },
  MVM : {
    country: "US",
    name: {
      en : "Monument Valley"
    }
  },
  MVN : {
    country: "US",
    name: {
      en : "Mt Vernon"
    }
  },
  MVP : {
    country: "CO",
    name: {
      en : "Mitu"
    }
  },
  MVQ : {
    country: "BY",
    name: {
      en : "Mogilev"
    }
  },
  MVR : {
    country: "CM",
    name: {
      en : "Maroua"
    }
  },
  MVT : {
    country: "PF",
    name: {
      en : "Mataiva"
    }
  },
  MVV : {
    country: "FR",
    name: {
      en : "Megeve"
    }
  },
  MVW : {
    country: "US",
    name: {
      en : "Mount Vernon"
    }
  },
  MVX : {
    country: "GA",
    name: {
      en : "Minvoul"
    }
  },
  MVY : {
    country: "US",
    name: {
      en : "Martha S Vineyard"
    }
  },
  MVZ : {
    country: "ZW",
    name: {
      en : "Masvingo"
    }
  },
  MWA : {
    country: "US",
    name: {
      en : "Marion"
    }
  },
  MWD : {
    country: "PK",
    name: {
      en : "Mianwali"
    }
  },
  MWE : {
    country: "SD",
    name: {
      en : "Merowe"
    }
  },
  MWF : {
    country: "VU",
    name: {
      en : "Maewo"
    }
  },
  MWH : {
    country: "US",
    name: {
      en : "Moses Lake"
    }
  },
  MWK : {
    country: "ID",
    name: {
      en : "Matak"
    }
  },
  MWO : {
    country: "US",
    name: {
      en : "Middletown"
    }
  },
  MWQ : {
    country: "MM",
    name: {
      en : "Magwe"
    }
  },
  MWT : {
    country: "AU",
    name: {
      en : "Moolawatana"
    }
  },
  MWU : {
    country: "PG",
    name: {
      en : "Mussau"
    }
  },
  MWX : {
    country: "KR",
    name: {
      en : "Gwangju Muan"
    }
  },
  MWY : {
    country: "AU",
    name: {
      en : "Miranda Downs"
    }
  },
  MWZ : {
    country: "TZ",
    name: {
      en : "Mwanza"
    }
  },
  MXG : {
    country: "US",
    name: {
      en : "Marlborough"
    }
  },
  MXH : {
    country: "PG",
    name: {
      en : "Moro"
    }
  },
  MXL : {
    country: "MX",
    name: {
      en : "Mexicali"
    }
  },
  MXM : {
    country: "MG",
    name: {
      en : "Morombe"
    }
  },
  MXN : {
    country: "FR",
    name: {
      en : "Morlaix"
    }
  },
  MXS : {
    country: "WS",
    popularity: 4,
    name: {
      en : "Maota"
    }
  },
  MXT : {
    country: "MG",
    name: {
      en : "Maintirano"
    }
  },
  MXV : {
    country: "MN",
    name: {
      en : "Moron"
    }
  },
  MXX : {
    country: "SE",
    name: {
      en : "Mora"
    }
  },
  MXY : {
    country: "US",
    name: {
      en : "McCarthy"
    }
  },
  MXZ : {
    country: "CN",
    name: {
      en : "Meixian"
    }
  },
  MYA : {
    country: "AU",
    name: {
      en : "Moruya"
    }
  },
  MYC : {
    country: "VE",
    name: {
      en : "Maracay"
    }
  },
  MYD : {
    country: "KE",
    name: {
      en : "Malindi"
    }
  },
  MYE : {
    country: "JP",
    name: {
      en : "Miyakejima"
    }
  },
  MYG : {
    country: "BS",
    name: {
      en : "Mayaguana"
    }
  },
  MYI : {
    country: "AU",
    name: {
      en : "Murray Island"
    }
  },
  MYJ : {
    country: "JP",
    name: {
      en : "Matsuyama"
    }
  },
  MYL : {
    country: "US",
    name: {
      en : "Mccall"
    }
  },
  MYP : {
    country: "TM",
    name: {
      en : "Mary"
    }
  },
  MYQ : {
    country: "IN",
    name: {
      en : "Mysore"
    }
  },
  MYR : {
    country: "US",
    name: {
      en : "Myrtle Beach"
    }
  },
  MYS : {
    country: "ET",
    name: {
      en : "Moyale"
    }
  },
  MYT : {
    country: "MM",
    name: {
      en : "Myitkyina"
    }
  },
  MYU : {
    country: "US",
    name: {
      en : "Mekoryuk"
    }
  },
  MYV : {
    country: "US",
    name: {
      en : "Marysville"
    }
  },
  MYW : {
    country: "TZ",
    name: {
      en : "Mtwara"
    }
  },
  MYX : {
    country: "PG",
    name: {
      en : "Menyamya"
    }
  },
  MYY : {
    country: "MY",
    name: {
      en : "Miri"
    }
  },
  MZC : {
    country: "GA",
    name: {
      en : "Mitzic"
    }
  },
  MZF : {
    country: "ZA",
    name: {
      en : "Mzamba"
    }
  },
  MZG : {
    country: "TW",
    name: {
      en : "Makung"
    }
  },
  MZH : {
    country: "TR",
    name: {
      en : "Merzifon"
    }
  },
  MZI : {
    country: "ML",
    name: {
      en : "Mopti"
    }
  },
  MZK : {
    country: "KI",
    name: {
      en : "Marakai"
    }
  },
  MZL : {
    country: "CO",
    name: {
      en : "Manizales"
    }
  },
  MZM : {
    country: "FR",
    name: {
      en : "Metz"
    }
  },
  MZO : {
    country: "CU",
    name: {
      en : "Manzanillo"
    }
  },
  MZR : {
    country: "AF",
    name: {
      en : "Mazar I Sharif"
    }
  },
  MZT : {
    country: "MX",
    name: {
      en : "Mazatlan"
    }
  },
  MZV : {
    country: "MY",
    name: {
      en : "Mulu"
    }
  },
  MZW : {
    country: "DZ",
    name: {
      en : "Mechria"
    }
  },
  MZX : {
    country: "ET",
    name: {
      en : "Masslo"
    }
  },
  MZY : {
    country: "ZA",
    name: {
      en : "Mossel Bay"
    }
  },
  MZZ : {
    country: "US",
    name: {
      en : "Marion"
    }
  },
  NAA : {
    country: "AU",
    name: {
      en : "Narrabri"
    }
  },
  NAC : {
    country: "AU",
    name: {
      en : "Naracoorte"
    }
  },
  NAG : {
    country: "IN",
    name: {
      en : "Nagpur"
    }
  },
  NAH : {
    country: "ID",
    name: {
      en : "Naha"
    }
  },
  NAJ : {
    country: "AZ",
    name: {
      en : "Nakhichevan"
    }
  },
  NAK : {
    country: "TH",
    name: {
      en : "Nakhon Ratchasima"
    }
  },
  NAL : {
    country: "RU",
    name: {
      en : "Nalchik"
    }
  },
  NAM : {
    country: "ID",
    name: {
      en : "Namlea"
    }
  },
  NAN : {
    country: "FJ",
    name: {
      en : "Nadi"
    }
  },
  NAO : {
    country: "CN",
    name: {
      en : "Nanchong"
    }
  },
  NAP : {
    country: "IT",
    popularity: 4,
    name: {
      en : "Naples"
    }
  },
  NAQ : {
    country: "GL",
    name: {
      en : "Qaanaaq"
    }
  },
  NAR : {
    country: "CO",
    name: {
      en : "Nare"
    }
  },
  NAS : {
    country: "BS",
    popularity: 35,
    name: {
      en : "Nassau"
    }
  },
  NAT : {
    country: "BR",
    name: {
      en : "Natal"
    }
  },
  NAU : {
    country: "PF",
    name: {
      en : "Napuka Island"
    }
  },
  NAV : {
    country: "TR",
    name: {
      en : "Nevsehir"
    }
  },
  NAW : {
    country: "TH",
    name: {
      en : "Narathiwat"
    }
  },
  NBC : {
    country: "RU",
    name: {
      en : "Naberezhnye Chelny"
    }
  },
  NBE : {
    country: "TN",
    name: {
      en : "Enfidha"
    }
  },
  NBO : {
    country: "KE",
    popularity: 14,
    name: {
      en : "Nairobi"
    }
  },
  NBR : {
    country: "AU",
    name: {
      en : "Nambour"
    }
  },
  NBS : {
    country: "CN",
    name: {
      en : "Baishan"
    }
  },
  NBX : {
    country: "ID",
    name: {
      en : "Nabire"
    }
  },
  NCA : {
    country: "TC",
    name: {
      en : "North Caicos"
    }
  },
  NCE : {
    country: "FR",
    popularity: 806,
    name: {
      en : "Nice"
    }
  },
  NCH : {
    country: "TZ",
    name: {
      en : "Nachingwea"
    }
  },
  NCI : {
    country: "CO",
    name: {
      en : "Necocli"
    }
  },
  NCL : {
    country: "GB",
    popularity: 30,
    name: {
      en : "Newcastle"
    }
  },
  NCN : {
    country: "US",
    name: {
      en : "New Chenega"
    }
  },
  NCP : {
    country: "PH",
    name: {
      en : "Luzon Island"
    }
  },
  NCS : {
    country: "ZA",
    name: {
      en : "Newcastle"
    }
  },
  NCT : {
    country: "CR",
    name: {
      en : "Nicoya"
    }
  },
  NCU : {
    country: "UZ",
    name: {
      en : "Nukus"
    }
  },
  NCY : {
    country: "FR",
    name: {
      en : "Annecy"
    }
  },
  NDA : {
    country: "ID",
    name: {
      en : "Bandanaira"
    }
  },
  NDB : {
    country: "MR",
    name: {
      en : "Nouadhibou"
    }
  },
  NDC : {
    country: "IN",
    name: {
      en : "Nanded"
    }
  },
  NDD : {
    country: "AO",
    name: {
      en : "Sumbe"
    }
  },
  NDE : {
    country: "KE",
    name: {
      en : "Mandera"
    }
  },
  NDG : {
    country: "CN",
    name: {
      en : "Qiqihar"
    }
  },
  NDJ : {
    country: "TD",
    name: {
      en : "N Djamena"
    }
  },
  NDK : {
    country: "MH",
    name: {
      en : "Namdrik"
    }
  },
  NDO : {
    country: "ES",
    name: {
      en : "La Palma del Condado"
    }
  },
  NDR : {
    country: "MA",
    name: {
      en : "Nador"
    }
  },
  NDU : {
    country: "NA",
    name: {
      en : "Runda"
    }
  },
  NDV : {
    country: "US",
    name: {
      en : "Anacostia"
    }
  },
  NDY : {
    country: "GB",
    name: {
      en : "Sanday"
    }
  },
  NEC : {
    country: "AR",
    name: {
      en : "Necochea"
    }
  },
  NEF : {
    country: "RU",
    name: {
      en : "Neftekamsk"
    }
  },
  NEG : {
    country: "JM",
    name: {
      en : "Negril"
    }
  },
  NER : {
    country: "RU",
    name: {
      en : "Neryungri"
    }
  },
  NEV : {
    country: "KN",
    name: {
      en : "Nevis"
    }
  },
  NFG : {
    country: "RU",
    name: {
      en : "Nefteyugansk"
    }
  },
  NFL : {
    country: "US",
    name: {
      en : "Fallon"
    }
  },
  NGA : {
    country: "AU",
    name: {
      en : "Young"
    }
  },
  NGB : {
    country: "CN",
    name: {
      en : "Ningbo"
    }
  },
  NGC : {
    country: "US",
    name: {
      en : "North Grand Canyon"
    }
  },
  NGD : {
    country: "VG",
    name: {
      en : "Anegada"
    }
  },
  NGE : {
    country: "CM",
    popularity: 2,
    name: {
      en : "N Gaoundere"
    }
  },
  NGK : {
    country: "RU",
    name: {
      en : "NGK"
    }
  },
  NGO : {
    country: "JP",
    popularity: 2,
    name: {
      en : "Nagoya"
    }
  },
  NGQ : {
    country: "CN",
    name: {
      en : "NGQ"
    }
  },
  NGS : {
    country: "JP",
    name: {
      en : "Nagasaki"
    }
  },
  NHA : {
    country: "VN",
    name: {
      en : "Nha Trang"
    }
  },
  NHK : {
    country: "US",
    name: {
      en : "Patuxent River"
    }
  },
  NHV : {
    country: "PF",
    name: {
      en : "Nuku Hiva"
    }
  },
  NHX : {
    country: "US",
    name: {
      en : "Foley"
    }
  },
  NHZ : {
    country: "US",
    name: {
      en : "Brunswick"
    }
  },
  NIB : {
    country: "US",
    name: {
      en : "Nikolai"
    }
  },
  NIC : {
    country: "CY",
    name: {
      en : "Nicosia"
    }
  },
  NIG : {
    country: "KI",
    name: {
      en : "Nikunau"
    }
  },
  NIM : {
    country: "NE",
    name: {
      en : "Niamey"
    }
  },
  NIN : {
    country: "US",
    name: {
      en : "Ninilchik"
    }
  },
  NIT : {
    country: "FR",
    name: {
      en : "Niort"
    }
  },
  NIU : {
    country: "PF",
    name: {
      en : "NIU"
    }
  },
  NIX : {
    country: "ML",
    name: {
      en : "Nioro"
    }
  },
  NJC : {
    country: "RU",
    popularity: 8,
    name: {
      en : "Nizhnevartovsk"
    }
  },
  NJF : {
    country: "IQ",
    name: {
      en : "Al Najaf"
    }
  },
  NKC : {
    country: "MR",
    name: {
      en : "Nouakchott"
    }
  },
  NKG : {
    country: "CN",
    name: {
      en : "Nanjing"
    }
  },
  NKI : {
    country: "US",
    name: {
      en : "Naukiti"
    }
  },
  NKT : {
    country: "TR",
    name: {
      en : "Sirnak"
    }
  },
  NKU : {
    country: "LS",
    name: {
      en : "Nkaus"
    }
  },
  NKY : {
    country: "CG",
    name: {
      en : "Nkayi"
    }
  },
  NLA : {
    country: "ZM",
    name: {
      en : "N Dola"
    }
  },
  NLC : {
    country: "US",
    name: {
      en : "Lemoore"
    }
  },
  NLD : {
    country: "MX",
    name: {
      en : "Nuevo Laredo"
    }
  },
  NLF : {
    country: "AU",
    name: {
      en : "Darnley Island"
    }
  },
  NLG : {
    country: "US",
    name: {
      en : "Nelson Lagoon"
    }
  },
  NLI : {
    country: "RU",
    popularity: 10,
    name: {
      en : "Nikolayevsk-on-Amur"
    }
  },
  NLK : {
    country: "NF",
    name: {
      en : "Norfolk Island"
    }
  },
  NLL : {
    country: "AU",
    name: {
      en : "Nullagine"
    }
  },
  NLP : {
    country: "ZA",
    name: {
      en : "Nelspruit"
    }
  },
  NLT : {
    country: "CN",
    name: {
      en : "NLT"
    }
  },
  NLV : {
    country: "UA",
    name: {
      en : "Nikolaev"
    }
  },
  NMA : {
    country: "UZ",
    name: {
      en : "Namangan"
    }
  },
  NME : {
    country: "US",
    name: {
      en : "Nightmute"
    }
  },
  NMG : {
    country: "PA",
    name: {
      en : "San Miguel"
    }
  },
  NNB : {
    country: "SB",
    name: {
      en : "Santa Ana"
    }
  },
  NNG : {
    country: "CN",
    name: {
      en : "Nanning"
    }
  },
  NNK : {
    country: "US",
    name: {
      en : "Naknek"
    }
  },
  NNL : {
    country: "US",
    name: {
      en : "Nondalton"
    }
  },
  NNM : {
    country: "RU",
    name: {
      en : "Naryan-Mar"
    }
  },
  NNR : {
    country: "IE",
    name: {
      en : "Spiddal"
    }
  },
  NNT : {
    country: "TH",
    name: {
      en : "Nan Th"
    }
  },
  NNX : {
    country: "ID",
    name: {
      en : "Nunukan"
    }
  },
  NNY : {
    country: "CN",
    name: {
      en : "Nanyang"
    }
  },
  NOA : {
    country: "AU",
    name: {
      en : "Nowra"
    }
  },
  NOB : {
    country: "CR",
    name: {
      en : "Nosara Beach"
    }
  },
  NOC : {
    country: "IE",
    name: {
      en : "Knock"
    }
  },
  NOG : {
    country: "MX",
    name: {
      en : "Nogales"
    }
  },
  NOI : {
    country: "RU",
    name: {
      en : "Novorossiysk"
    }
  },
  NOJ : {
    country: "RU",
    name: {
      en : "Nojabrxsk"
    }
  },
  NOM : {
    country: "PG",
    name: {
      en : "Nomad River"
    }
  },
  NON : {
    country: "KI",
    name: {
      en : "Nonouti"
    }
  },
  NOO : {
    country: "PG",
    name: {
      en : "Naoro"
    }
  },
  NOP : {
    country: "TR",
    name: {
      en : "Sinop"
    }
  },
  NOR : {
    country: "IS",
    name: {
      en : "Nordfjordur"
    }
  },
  NOS : {
    country: "MG",
    name: {
      en : "Nossi Be"
    }
  },
  NOU : {
    country: "NC",
    name: {
      en : "Noumea"
    }
  },
  NOV : {
    country: "AO",
    name: {
      en : "Huambo"
    }
  },
  NOZ : {
    country: "RU",
    name: {
      en : "Novokuznetsk"
    }
  },
  NPE : {
    country: "NZ",
    name: {
      en : "Napier Hastings"
    }
  },
  NPL : {
    country: "NZ",
    name: {
      en : "New Plymouth"
    }
  },
  NPT : {
    country: "US",
    name: {
      en : "Newport"
    }
  },
  NQI : {
    country: "US",
    name: {
      en : "Kingsville"
    }
  },
  NQN : {
    country: "AR",
    name: {
      en : "Neuquen"
    }
  },
  NQT : {
    country: "GB",
    popularity: 1,
    name: {
      en : "Nottingham Uk"
    }
  },
  NQU : {
    country: "CO",
    name: {
      en : "Nuqui"
    }
  },
  NQY : {
    country: "GB",
    name: {
      en : "Newquay"
    }
  },
  NQZ : {
    country: "KZ",
    popularity: 60,
    name: {
      en : "Astana"
    }
  },
  NRA : {
    country: "AU",
    name: {
      en : "Narrandera"
    }
  },
  NRD : {
    country: "DE",
    name: {
      en : "Norderney"
    }
  },
  NRK : {
    country: "SE",
    name: {
      en : "Norrkoping"
    }
  },
  NRL : {
    country: "GB",
    name: {
      en : "North Ronaldsay"
    }
  },
  NSA : {
    country: "AU",
    name: {
      en : "Noosa"
    }
  },
  NSE : {
    country: "US",
    name: {
      en : "Milton"
    }
  },
  NSH : {
    country: "IR",
    name: {
      en : "Now Shahr"
    }
  },
  NSK : {
    country: "RU",
    name: {
      en : "NSK"
    }
  },
  NSM : {
    country: "AU",
    name: {
      en : "Norseman"
    }
  },
  NSN : {
    country: "NZ",
    name: {
      en : "Nelson"
    }
  },
  NSO : {
    country: "AU",
    name: {
      en : "Scone"
    }
  },
  NST : {
    country: "TH",
    name: {
      en : "Nakhon Si Tham"
    }
  },
  NSV : {
    country: "AU",
    name: {
      en : "Noosaville"
    }
  },
  NSZ : {
    country: "CN",
    name: {
      en : "NSZ"
    }
  },
  NTB : {
    country: "NO",
    name: {
      en : "Notodden"
    }
  },
  NTE : {
    country: "FR",
    popularity: 8,
    name: {
      en : "Nantes"
    }
  },
  NTG : {
    country: "CN",
    name: {
      en : "Nantong"
    }
  },
  NTI : {
    country: "ID",
    name: {
      en : "Bintuni"
    }
  },
  NTL : {
    country: "AU",
    name: {
      en : "Newcastle"
    }
  },
  NTN : {
    country: "AU",
    name: {
      en : "Normanton"
    }
  },
  NTO : {
    country: "CV",
    name: {
      en : "Santo Antao"
    }
  },
  NTQ : {
    country: "JP",
    name: {
      en : "Wajima"
    }
  },
  NTT : {
    country: "TO",
    name: {
      en : "Niuatoputapu"
    }
  },
  NTX : {
    country: "ID",
    name: {
      en : "Natuna Ranai"
    }
  },
  NTY : {
    country: "ZA",
    name: {
      en : "Sun City"
    }
  },
  NUA : {
    country: "LK",
    name: {
      en : "Nuwara Eliya"
    }
  },
  NUE : {
    country: "DE",
    popularity: 234,
    name: {
      en : "Nuremberg"
    }
  },
  NUI : {
    country: "US",
    name: {
      en : "Nuiqsut"
    }
  },
  NUK : {
    country: "PF",
    name: {
      en : "Nukutavake"
    }
  },
  NUL : {
    country: "US",
    name: {
      en : "Nulato"
    }
  },
  NUP : {
    country: "US",
    name: {
      en : "Nunapitchuk"
    }
  },
  NUQ : {
    country: "US",
    name: {
      en : "Mountain View"
    }
  },
  NUR : {
    country: "AU",
    name: {
      en : "Nullarbor"
    }
  },
  NUS : {
    country: "VU",
    name: {
      en : "Norsup"
    }
  },
  NUX : {
    country: "RU",
    name: {
      en : "Novy Urengoy"
    }
  },
  NVA : {
    country: "CO",
    name: {
      en : "Neiva"
    }
  },
  NVD : {
    country: "US",
    name: {
      en : "Nevada"
    }
  },
  NVI : {
    country: "UZ",
    name: {
      en : "Navoi"
    }
  },
  NVK : {
    country: "NO",
    name: {
      en : "Narvik"
    }
  },
  NVR : {
    country: "RU",
    name: {
      en : "Novgorod"
    }
  },
  NVS : {
    country: "FR",
    name: {
      en : "Nevers"
    }
  },
  NVT : {
    country: "BR",
    name: {
      en : "Navegantes"
    }
  },
  NWA : {
    country: "KM",
    name: {
      en : "Moheli"
    }
  },
  NWI : {
    country: "GB",
    name: {
      en : "Norwich"
    }
  },
  NWT : {
    country: "PG",
    name: {
      en : "Nowata"
    }
  },
  NYA : {
    country: "RU",
    name: {
      en : "Nyagan"
    }
  },
  NYC : {
    country: "US",
    popularity: 1073,
    name: {
      en : "New York"
    }
  },
  NYE : {
    country: "KE",
    name: {
      en : "Nyeri"
    }
  },
  NYI : {
    country: "GH",
    name: {
      en : "Sunyani"
    }
  },
  NYK : {
    country: "KE",
    name: {
      en : "Nanyuki"
    }
  },
  NYM : {
    country: "RU",
    name: {
      en : "Nadym"
    }
  },
  NYN : {
    country: "AU",
    name: {
      en : "Nyngan"
    }
  },
  NYR : {
    country: "RU",
    name: {
      en : "Nyurba"
    }
  },
  NYT : {
    country: "MM",
    name: {
      en : "Nay Pye Taw"
    }
  },
  NYU : {
    country: "MM",
    name: {
      en : "Nyaung"
    }
  },
  NZE : {
    country: "GN",
    name: {
      en : "Nzerekore"
    }
  },
  NZG : {
    country: "RU",
    name: {
      en : "Nizhneangarsk"
    }
  },
  NZH : {
    country: "CN",
    name: {
      en : "Manzhouli"
    }
  },
  OAG : {
    country: "AU",
    name: {
      en : "Orange"
    }
  },
  OAI : {
    country: "AF",
    name: {
      en : "OAI"
    }
  },
  OAJ : {
    country: "US",
    name: {
      en : "Jacksonville"
    }
  },
  OAK : {
    country: "US",
    name: {
      en : "Oakland"
    }
  },
  OAL : {
    country: "BR",
    name: {
      en : "Cacoal"
    }
  },
  OAM : {
    country: "NZ",
    name: {
      en : "Oamaru"
    }
  },
  OAX : {
    country: "MX",
    name: {
      en : "Oaxaca"
    }
  },
  OAZ : {
    country: "AF",
    name: {
      en : "Zaranj"
    }
  },
  OBE : {
    country: "US",
    name: {
      en : "Okeechobee"
    }
  },
  OBF : {
    country: "DE",
    name: {
      en : "Oberpfaffenhofen"
    }
  },
  OBL : {
    country: "BE",
    name: {
      en : "Zoersel"
    }
  },
  OBM : {
    country: "PG",
    name: {
      en : "Morobe"
    }
  },
  OBN : {
    country: "GB",
    name: {
      en : "Oban"
    }
  },
  OBO : {
    country: "JP",
    name: {
      en : "Obihiro"
    }
  },
  OBU : {
    country: "US",
    name: {
      en : "Kobuk"
    }
  },
  OBX : {
    country: "PG",
    name: {
      en : "Obo"
    }
  },
  OBZ : {
    country: "DE",
    name: {
      en : "OBZ"
    }
  },
  OCA : {
    country: "US",
    name: {
      en : "Ocean Reef"
    }
  },
  OCC : {
    country: "EC",
    name: {
      en : "Coca"
    }
  },
  OCE : {
    country: "US",
    name: {
      en : "Ocean City"
    }
  },
  OCF : {
    country: "US",
    name: {
      en : "Ocala"
    }
  },
  OCH : {
    country: "US",
    name: {
      en : "Nacogdoches"
    }
  },
  OCJ : {
    country: "JM",
    popularity: 2,
    name: {
      en : "Ocho Rios"
    }
  },
  OCN : {
    country: "US",
    name: {
      en : "Oceanside"
    }
  },
  OCV : {
    country: "CO",
    name: {
      en : "Ocana"
    }
  },
  ODB : {
    country: "ES",
    name: {
      en : "Cordoba"
    }
  },
  ODE : {
    country: "DK",
    name: {
      en : "Odense"
    }
  },
  ODL : {
    country: "AU",
    name: {
      en : "Cordillo Downs"
    }
  },
  ODN : {
    country: "MY",
    name: {
      en : "Long Seridan"
    }
  },
  ODO : {
    country: "RU",
    name: {
      en : "Bodaybo"
    }
  },
  ODS : {
    country: "UA",
    popularity: 250,
    name: {
      en : "Odessa"
    }
  },
  ODW : {
    country: "US",
    name: {
      en : "Oak Harbor"
    }
  },
  ODY : {
    country: "LA",
    name: {
      en : "Oudomxay"
    }
  },
  OEA : {
    country: "US",
    name: {
      en : "Vincennes"
    }
  },
  OER : {
    country: "SE",
    name: {
      en : "Ornskoldsvik"
    }
  },
  OES : {
    country: "AR",
    name: {
      en : "San Antonio Oeste"
    }
  },
  OFJ : {
    country: "IS",
    name: {
      en : "Olafsfjordur"
    }
  },
  OFK : {
    country: "US",
    name: {
      en : "Norfolk"
    }
  },
  OGA : {
    country: "US",
    name: {
      en : "Ogallala"
    }
  },
  OGD : {
    country: "US",
    name: {
      en : "Ogden"
    }
  },
  OGG : {
    country: "US",
    name: {
      en : "Maui"
    }
  },
  OGL : {
    country: "GY",
    name: {
      en : "Ogle"
    }
  },
  OGN : {
    country: "JP",
    name: {
      en : "Yonaguni"
    }
  },
  OGS : {
    country: "US",
    name: {
      en : "Ogdensburg"
    }
  },
  OGU : {
    country: "TR",
    name: {
      en : "Ordu"
    }
  },
  OGX : {
    country: "DZ",
    name: {
      en : "Ouargla"
    }
  },
  OGZ : {
    country: "RU",
    name: {
      en : "Vladikavkaz"
    }
  },
  OHD : {
    country: "MK",
    popularity: 6,
    name: {
      en : "Ohrid"
    }
  },
  OHE : {
    country: "CN",
    name: {
      en : "OHE"
    }
  },
  OHH : {
    country: "RU",
    name: {
      en : "Okha"
    }
  },
  OHO : {
    country: "RU",
    popularity: 14143,
    name: {
      en : "OHO"
    }
  },
  OHT : {
    country: "PK",
    name: {
      en : "Kohat"
    }
  },
  OIA : {
    country: "BR",
    name: {
      en : "Ourilandia"
    }
  },
  OIM : {
    country: "JP",
    name: {
      en : "Oshima"
    }
  },
  OIR : {
    country: "JP",
    name: {
      en : "Okushiri"
    }
  },
  OIT : {
    country: "JP",
    name: {
      en : "Oita"
    }
  },
  OKA : {
    country: "JP",
    name: {
      en : "Okinawa"
    }
  },
  OKC : {
    country: "US",
    name: {
      en : "Oklahoma City"
    }
  },
  OKE : {
    country: "JP",
    name: {
      en : "Okino Erabu"
    }
  },
  OKG : {
    country: "CG",
    name: {
      en : "Okoyo"
    }
  },
  OKI : {
    country: "JP",
    name: {
      en : "Oki Island"
    }
  },
  OKJ : {
    country: "JP",
    name: {
      en : "Okayama"
    }
  },
  OKK : {
    country: "US",
    name: {
      en : "Kokomo"
    }
  },
  OKL : {
    country: "ID",
    name: {
      en : "Oksibil"
    }
  },
  OKN : {
    country: "GA",
    name: {
      en : "Okondja"
    }
  },
  OKP : {
    country: "PG",
    name: {
      en : "Oksapmin"
    }
  },
  OKQ : {
    country: "ID",
    name: {
      en : "Okaba"
    }
  },
  OKR : {
    country: "AU",
    name: {
      en : "Yorke Island"
    }
  },
  OKT : {
    country: "RU",
    name: {
      en : "Oktiabrskij"
    }
  },
  OKY : {
    country: "AU",
    name: {
      en : "Oakey"
    }
  },
  OLA : {
    country: "NO",
    name: {
      en : "Orland"
    }
  },
  OLB : {
    country: "IT",
    popularity: 12,
    name: {
      en : "Olbia"
    }
  },
  OLC : {
    country: "BR",
    name: {
      en : "Sao Paulo de Olivenca"
    }
  },
  OLF : {
    country: "US",
    name: {
      en : "Wolf Point"
    }
  },
  OLH : {
    country: "US",
    name: {
      en : "Old Harbor"
    }
  },
  OLI : {
    country: "IS",
    name: {
      en : "Olafsvik"
    }
  },
  OLJ : {
    country: "VU",
    name: {
      en : "Olpoi"
    }
  },
  OLK : {
    country: "PY",
    name: {
      en : "Fuerte Olimpo"
    }
  },
  OLM : {
    country: "US",
    name: {
      en : "Olympia"
    }
  },
  OLO : {
    country: "CZ",
    name: {
      en : "Olomouc"
    }
  },
  OLP : {
    country: "AU",
    name: {
      en : "Olympic Dam"
    }
  },
  OLS : {
    country: "US",
    name: {
      en : "Nogales"
    }
  },
  OLU : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  OLZ : {
    country: "RU",
    name: {
      en : "Olyokminsk"
    }
  },
  OMA : {
    country: "US",
    name: {
      en : "Omaha"
    }
  },
  OMB : {
    country: "GA",
    name: {
      en : "Omboue"
    }
  },
  OMC : {
    country: "PH",
    name: {
      en : "Ormoc"
    }
  },
  OMD : {
    country: "NA",
    name: {
      en : "Oranjemund"
    }
  },
  OME : {
    country: "US",
    name: {
      en : "Nome"
    }
  },
  OMH : {
    country: "IR",
    name: {
      en : "Urmieh"
    }
  },
  OMO : {
    country: "BA",
    popularity: 14,
    name: {
      en : "Mostar"
    }
  },
  OMR : {
    country: "RO",
    name: {
      en : "Oradea"
    }
  },
  OMS : {
    country: "RU",
    popularity: 66,
    name: {
      en : "Omsk"
    }
  },
  ONA : {
    country: "US",
    name: {
      en : "Winona"
    }
  },
  ONB : {
    country: "PG",
    name: {
      en : "Ononge"
    }
  },
  OND : {
    country: "NA",
    name: {
      en : "Ondangwa"
    }
  },
  ONG : {
    country: "AU",
    name: {
      en : "Mornington"
    }
  },
  ONH : {
    country: "US",
    name: {
      en : "Oneonta"
    }
  },
  ONI : {
    country: "ID",
    name: {
      en : "Moanamani"
    }
  },
  ONJ : {
    country: "JP",
    name: {
      en : "Odate Noshiro"
    }
  },
  ONK : {
    country: "RU",
    name: {
      en : "Olenyok"
    }
  },
  ONO : {
    country: "US",
    name: {
      en : "Ontario"
    }
  },
  ONP : {
    country: "US",
    name: {
      en : "Newport"
    }
  },
  ONQ : {
    country: "TR",
    name: {
      en : "Zonguldak"
    }
  },
  ONS : {
    country: "AU",
    name: {
      en : "Onslow"
    }
  },
  ONT : {
    country: "US",
    name: {
      en : "Ontario"
    }
  },
  ONX : {
    country: "PA",
    name: {
      en : "Colon"
    }
  },
  OOK : {
    country: "US",
    name: {
      en : "Toksook Bay"
    }
  },
  OOL : {
    country: "AU",
    name: {
      en : "Gold Coast"
    }
  },
  OOM : {
    country: "AU",
    name: {
      en : "Cooma"
    }
  },
  OOT : {
    country: "KI",
    name: {
      en : "Onotoa"
    }
  },
  OPA : {
    country: "IS",
    name: {
      en : "Kopasker"
    }
  },
  OPB : {
    country: "PG",
    name: {
      en : "Open Bay"
    }
  },
  OPO : {
    country: "PT",
    popularity: 76,
    name: {
      en : "Porto"
    }
  },
  OPS : {
    country: "BR",
    name: {
      en : "Sinop"
    }
  },
  OPU : {
    country: "PG",
    name: {
      en : "Balimo"
    }
  },
  ORB : {
    country: "SE",
    name: {
      en : "Orebro Bofors"
    }
  },
  ORE : {
    country: "FR",
    name: {
      en : "Orleans"
    }
  },
  ORF : {
    country: "US",
    name: {
      en : "Norfolk"
    }
  },
  ORH : {
    country: "US",
    name: {
      en : "Worcester"
    }
  },
  ORI : {
    country: "US",
    name: {
      en : "Port Lions"
    }
  },
  ORK : {
    country: "IE",
    popularity: 32,
    name: {
      en : "Cork"
    }
  },
  ORL : {
    country: "US",
    popularity: 4,
    name: {
      en : "Orlando"
    }
  },
  ORM : {
    country: "GB",
    name: {
      en : "Northampton"
    }
  },
  ORN : {
    country: "DZ",
    popularity: 76,
    name: {
      en : "Oran"
    }
  },
  ORQ : {
    country: "US",
    name: {
      en : "Norwalk"
    }
  },
  ORS : {
    country: "AU",
    name: {
      en : "Orpheus Island"
    }
  },
  ORU : {
    country: "BO",
    name: {
      en : "Oruro"
    }
  },
  ORV : {
    country: "US",
    name: {
      en : "Noorvik"
    }
  },
  OSA : {
    country: "JP",
    popularity: 3,
    name: {
      en : "Osaka"
    }
  },
  OSB : {
    country: "US",
    name: {
      en : "Osage Beach"
    }
  },
  OSD : {
    country: "SE",
    name: {
      en : "Ostersund"
    }
  },
  OSH : {
    country: "US",
    name: {
      en : "Oshkosh"
    }
  },
  OSI : {
    country: "HR",
    name: {
      en : "Osijek"
    }
  },
  OSK : {
    country: "SE",
    name: {
      en : "Oskarshamn"
    }
  },
  OSL : {
    country: "NO",
    popularity: 306,
    name: {
      en : "Oslo"
    }
  },
  OSM : {
    country: "IQ",
    name: {
      en : "Mosul"
    }
  },
  OSP : {
    country: "PL",
    name: {
      en : "Slupsk"
    }
  },
  OSR : {
    country: "CZ",
    popularity: 2,
    name: {
      en : "Ostrava"
    }
  },
  OSS : {
    country: "KG",
    name: {
      en : "Osh"
    }
  },
  OST : {
    country: "BE",
    name: {
      en : "Ostende"
    }
  },
  OSW : {
    country: "RU",
    name: {
      en : "Orsk"
    }
  },
  OSY : {
    country: "NO",
    name: {
      en : "Namsos"
    }
  },
  OSZ : {
    country: "PL",
    name: {
      en : "Koszalin"
    }
  },
  OTD : {
    country: "PA",
    name: {
      en : "Contadora"
    }
  },
  OTG : {
    country: "US",
    name: {
      en : "Worthington"
    }
  },
  OTH : {
    country: "US",
    name: {
      en : "North Bend"
    }
  },
  OTI : {
    country: "ID",
    name: {
      en : "Morotai Island"
    }
  },
  OTM : {
    country: "US",
    name: {
      en : "Ottumwa"
    }
  },
  OTR : {
    country: "CR",
    name: {
      en : "Coto 47"
    }
  },
  OTS : {
    country: "US",
    name: {
      en : "Ancortes"
    }
  },
  OTU : {
    country: "CO",
    name: {
      en : "Otu CO"
    }
  },
  OTZ : {
    country: "US",
    name: {
      en : "Kotzebue"
    }
  },
  OUA : {
    country: "BF",
    name: {
      en : "Ouagadougou"
    }
  },
  OUD : {
    country: "MA",
    name: {
      en : "Oujda"
    }
  },
  OUE : {
    country: "CG",
    name: {
      en : "Ouesso"
    }
  },
  OUH : {
    country: "ZA",
    name: {
      en : "Oudtshoorn"
    }
  },
  OUK : {
    country: "GB",
    name: {
      en : "Outer Skerries"
    }
  },
  OUL : {
    country: "FI",
    name: {
      en : "Oulu"
    }
  },
  OUR : {
    country: "CM",
    name: {
      en : "Batouri"
    }
  },
  OUS : {
    country: "BR",
    name: {
      en : "Ourinhos"
    }
  },
  OUZ : {
    country: "MR",
    name: {
      en : "Zouerate"
    }
  },
  OVA : {
    country: "MG",
    name: {
      en : "Bekily"
    }
  },
  OVB : {
    country: "RU",
    popularity: 72,
    name: {
      en : "Novosibirsk"
    }
  },
  OVD : {
    country: "ES",
    name: {
      en : "Asturias"
    }
  },
  OVS : {
    country: "RU",
    name: {
      en : "SOVETSKY"
    }
  },
  OWA : {
    country: "US",
    name: {
      en : "Owatonna"
    }
  },
  OWB : {
    country: "US",
    name: {
      en : "Owensboro"
    }
  },
  OWD : {
    country: "US",
    name: {
      en : "Norwood"
    }
  },
  OXB : {
    country: "GW",
    name: {
      en : "Bissau"
    }
  },
  OXF : {
    country: "GB",
    name: {
      en : "Oxford"
    }
  },
  OXR : {
    country: "US",
    name: {
      en : "Oxnard"
    }
  },
  OYE : {
    country: "GA",
    name: {
      en : "Oyem"
    }
  },
  OYG : {
    country: "UG",
    name: {
      en : "Moyo"
    }
  },
  OYO : {
    country: "AR",
    name: {
      en : "Tres Arroyos"
    }
  },
  OZC : {
    country: "PH",
    name: {
      en : "Ozamis City"
    }
  },
  OZG : {
    country: "MA",
    name: {
      en : "Zagora"
    }
  },
  OZH : {
    country: "UA",
    name: {
      en : "Zaporozhe"
    }
  },
  OZI : {
    country: "ES",
    name: {
      en : "Bobadilla"
    }
  },
  OZP : {
    country: "ES",
    name: {
      en : "Moron"
    }
  },
  OZU : {
    country: "ES",
    name: {
      en : "Montilla"
    }
  },
  OZZ : {
    country: "MA",
    name: {
      en : "Ourzazate"
    }
  },
  PAD : {
    country: "DE",
    name: {
      en : "Paderborn"
    }
  },
  PAE : {
    country: "US",
    name: {
      en : "Everett"
    }
  },
  PAG : {
    country: "PH",
    name: {
      en : "Pagadian"
    }
  },
  PAH : {
    country: "US",
    name: {
      en : "Paducah"
    }
  },
  PAN : {
    country: "TH",
    name: {
      en : "Pattani"
    }
  },
  PAO : {
    country: "US",
    name: {
      en : "Palo Alto"
    }
  },
  PAP : {
    country: "HT",
    name: {
      en : "Port Au Prince"
    }
  },
  PAR : {
    country: "FR",
    popularity: 3180,
    name: {
      en : "Paris"
    }
  },
  PAS : {
    country: "GR",
    name: {
      en : "Paros"
    }
  },
  PAT : {
    country: "IN",
    name: {
      en : "Patna"
    }
  },
  PAV : {
    country: "BR",
    name: {
      en : "Paulo Afonso"
    }
  },
  PAW : {
    country: "PG",
    name: {
      en : "Pambwa"
    }
  },
  PAY : {
    country: "MY",
    name: {
      en : "Pamol"
    }
  },
  PAZ : {
    country: "MX",
    name: {
      en : "Poza Rica"
    }
  },
  PBB : {
    country: "BR",
    name: {
      en : "Paranaiba"
    }
  },
  PBC : {
    country: "MX",
    name: {
      en : "Puebla"
    }
  },
  PBD : {
    country: "IN",
    name: {
      en : "Porbandar"
    }
  },
  PBE : {
    country: "CO",
    name: {
      en : "Puerto Berrio"
    }
  },
  PBF : {
    country: "US",
    name: {
      en : "Pine Bluff"
    }
  },
  PBG : {
    country: "US",
    name: {
      en : "Plattsburgh"
    }
  },
  PBH : {
    country: "BT",
    name: {
      en : "Paro"
    }
  },
  PBI : {
    country: "US",
    name: {
      en : "West Palm Beach"
    }
  },
  PBJ : {
    country: "VU",
    name: {
      en : "Paama"
    }
  },
  PBL : {
    country: "VE",
    name: {
      en : "Puerto Cabello"
    }
  },
  PBM : {
    country: "SR",
    name: {
      en : "Paramaribo"
    }
  },
  PBO : {
    country: "AU",
    name: {
      en : "Paraburdoo"
    }
  },
  PBP : {
    country: "CR",
    name: {
      en : "Punta Islita"
    }
  },
  PBR : {
    country: "GT",
    name: {
      en : "Puerto Barrios"
    }
  },
  PBS : {
    country: "TH",
    name: {
      en : "Patong Beach"
    }
  },
  PBU : {
    country: "MM",
    name: {
      en : "Putao"
    }
  },
  PBZ : {
    country: "ZA",
    name: {
      en : "Plettenberg Bay"
    }
  },
  PCA : {
    country: "US",
    name: {
      en : "Portage Creek"
    }
  },
  PCD : {
    country: "US",
    name: {
      en : "Prairie Du Chien"
    }
  },
  PCE : {
    country: "US",
    name: {
      en : "Painter Creek"
    }
  },
  PCJ : {
    country: "PY",
    name: {
      en : "Puerto La Victoria"
    }
  },
  PCL : {
    country: "PE",
    name: {
      en : "Pucallpa"
    }
  },
  PCM : {
    country: "MX",
    name: {
      en : "Playa Del Carmen"
    }
  },
  PCN : {
    country: "NZ",
    name: {
      en : "Picton"
    }
  },
  PCP : {
    country: "ST",
    name: {
      en : "Príncipe"
    }
  },
  PCR : {
    country: "CO",
    name: {
      en : "Puerto Carreno"
    }
  },
  PCT : {
    country: "US",
    name: {
      en : "Princeton"
    }
  },
  PDA : {
    country: "CO",
    name: {
      en : "Puerto Inirida"
    }
  },
  PDB : {
    country: "US",
    name: {
      en : "Pedro Bay"
    }
  },
  PDE : {
    country: "AU",
    name: {
      en : "Pandie Pandie"
    }
  },
  PDG : {
    country: "ID",
    name: {
      en : "Padang"
    }
  },
  PDL : {
    country: "PT",
    name: {
      en : "Ponta Delgada"
    }
  },
  PDP : {
    country: "UY",
    name: {
      en : "Punta Del Este"
    }
  },
  PDS : {
    country: "MX",
    name: {
      en : "Piedras Negras"
    }
  },
  PDT : {
    country: "US",
    name: {
      en : "Pendleton"
    }
  },
  PDU : {
    country: "UY",
    name: {
      en : "Paysandu"
    }
  },
  PDV : {
    country: "BG",
    name: {
      en : "Plovdiv"
    }
  },
  PDX : {
    country: "US",
    popularity: 2,
    name: {
      en : "Portland"
    }
  },
  PEA : {
    country: "AU",
    name: {
      en : "Penneshaw"
    }
  },
  PEC : {
    country: "US",
    name: {
      en : "Pelican"
    }
  },
  PED : {
    country: "CZ",
    name: {
      en : "Pardubice"
    }
  },
  PEE : {
    country: "RU",
    popularity: 42,
    name: {
      en : "Perm"
    }
  },
  PEF : {
    country: "DE",
    name: {
      en : "Peenemuende"
    }
  },
  PEG : {
    country: "IT",
    name: {
      en : "Perugia"
    }
  },
  PEI : {
    country: "CO",
    name: {
      en : "Pereira"
    }
  },
  PEJ : {
    country: "IT",
    name: {
      en : "Peschiei"
    }
  },
  PEL : {
    country: "LS",
    name: {
      en : "Pelaneng"
    }
  },
  PEM : {
    country: "PE",
    name: {
      en : "Puerto Maldonado"
    }
  },
  PEN : {
    country: "MY",
    name: {
      en : "Penang"
    }
  },
  PER : {
    country: "AU",
    name: {
      en : "Perth"
    }
  },
  PES : {
    country: "RU",
    popularity: 10,
    name: {
      en : "Petrozavodsk"
    }
  },
  PET : {
    country: "BR",
    name: {
      en : "Pelotas"
    }
  },
  PEU : {
    country: "HN",
    name: {
      en : "Puerto Lempira"
    }
  },
  PEV : {
    country: "HU",
    name: {
      en : "Pecs"
    }
  },
  PEW : {
    country: "PK",
    name: {
      en : "Peshawar"
    }
  },
  PEX : {
    country: "RU",
    name: {
      en : "PEX"
    }
  },
  PEZ : {
    country: "RU",
    popularity: 2,
    name: {
      en : "Penza"
    }
  },
  PFB : {
    country: "BR",
    name: {
      en : "Passo Fundo"
    }
  },
  PFJ : {
    country: "IS",
    name: {
      en : "Patreksfjordur"
    }
  },
  PFN : {
    country: "US",
    name: {
      en : "Panama City"
    }
  },
  PFO : {
    country: "CY",
    popularity: 30,
    name: {
      en : "Paphos"
    }
  },
  PFQ : {
    country: "IR",
    name: {
      en : "Parsabad"
    }
  },
  PGA : {
    country: "US",
    name: {
      en : "Page"
    }
  },
  PGD : {
    country: "US",
    name: {
      en : "Punta Gorda"
    }
  },
  PGF : {
    country: "FR",
    name: {
      en : "Perpignan"
    }
  },
  PGH : {
    country: "IN",
    name: {
      en : "Pantnagar"
    }
  },
  PGK : {
    country: "ID",
    name: {
      en : "Pangkalpinang"
    }
  },
  PGL : {
    country: "US",
    name: {
      en : "Pascagoula"
    }
  },
  PGM : {
    country: "US",
    name: {
      en : "Port Graham"
    }
  },
  PGO : {
    country: "US",
    name: {
      en : "Pagosa Springs"
    }
  },
  PGS : {
    country: "US",
    name: {
      en : "Peach Springs"
    }
  },
  PGU : {
    country: "IR",
    name: {
      en : "PGU"
    }
  },
  PGV : {
    country: "US",
    name: {
      en : "Greenville"
    }
  },
  PGX : {
    country: "FR",
    name: {
      en : "Perigueux"
    }
  },
  PGZ : {
    country: "BR",
    name: {
      en : "Ponta Grossa"
    }
  },
  PHB : {
    country: "BR",
    name: {
      en : "Parnaiba"
    }
  },
  PHC : {
    country: "NG",
    name: {
      en : "Port Harcourt"
    }
  },
  PHE : {
    country: "AU",
    name: {
      en : "Port Hedland"
    }
  },
  PHF : {
    country: "US",
    name: {
      en : "Newport News"
    }
  },
  PHG : {
    country: "NG",
    name: {
      en : "Port Harcourt"
    }
  },
  PHH : {
    country: "VN",
    name: {
      en : "Phan Thiet"
    }
  },
  PHL : {
    country: "US",
    popularity: 40,
    name: {
      en : "Philadelphia"
    }
  },
  PHM : {
    country: "DE",
    name: {
      en : "Boeblingen"
    }
  },
  PHN : {
    country: "US",
    name: {
      en : "Port Huron"
    }
  },
  PHO : {
    country: "US",
    name: {
      en : "Point Hope"
    }
  },
  PHR : {
    country: "FJ",
    name: {
      en : "Pacific Harbour"
    }
  },
  PHS : {
    country: "TH",
    name: {
      en : "Phitsanulok"
    }
  },
  PHT : {
    country: "US",
    popularity: 8,
    name: {
      en : "Paris"
    }
  },
  PHW : {
    country: "ZA",
    name: {
      en : "Phalaborwa"
    }
  },
  PHX : {
    country: "US",
    name: {
      en : "Phoenix"
    }
  },
  PIA : {
    country: "US",
    name: {
      en : "Peoria"
    }
  },
  PIE : {
    country: "US",
    name: {
      en : "St Petersburg"
    }
  },
  PIF : {
    country: "TW",
    name: {
      en : "Pingtung"
    }
  },
  PIH : {
    country: "US",
    name: {
      en : "Pocatello"
    }
  },
  PIN : {
    country: "BR",
    name: {
      en : "Parintins"
    }
  },
  PIO : {
    country: "PE",
    name: {
      en : "Pisco"
    }
  },
  PIP : {
    country: "US",
    name: {
      en : "Pilot Point"
    }
  },
  PIR : {
    country: "US",
    name: {
      en : "Pierre"
    }
  },
  PIS : {
    country: "FR",
    name: {
      en : "Poitiers"
    }
  },
  PIT : {
    country: "US",
    popularity: 4,
    name: {
      en : "Pittsburgh"
    }
  },
  PIU : {
    country: "PE",
    name: {
      en : "Piura"
    }
  },
  PIW : {
    country: "CA",
    name: {
      en : "Pikwitonei"
    }
  },
  PIX : {
    country: "PT",
    name: {
      en : "Pico Island"
    }
  },
  PIZ : {
    country: "US",
    popularity: 128,
    name: {
      en : "Point Lay"
    }
  },
  PJA : {
    country: "SE",
    name: {
      en : "Pajala"
    }
  },
  PJB : {
    country: "US",
    name: {
      en : "Payson"
    }
  },
  PJG : {
    country: "PK",
    name: {
      en : "Panjgur"
    }
  },
  PJM : {
    country: "CR",
    name: {
      en : "Puerto Jimenez"
    }
  },
  PJZ : {
    country: "MX",
    name: {
      en : "Puerto Juarez"
    }
  },
  PKA : {
    country: "US",
    name: {
      en : "Napaskiak"
    }
  },
  PKB : {
    country: "US",
    name: {
      en : "Parkersburg"
    }
  },
  PKC : {
    country: "RU",
    popularity: 466,
    name: {
      en : "Petropavlovsk Kamchatskiy"
    }
  },
  PKD : {
    country: "US",
    name: {
      en : "Park Rapids"
    }
  },
  PKE : {
    country: "AU",
    name: {
      en : "Parkes"
    }
  },
  PKG : {
    country: "MY",
    name: {
      en : "Pangkor"
    }
  },
  PKH : {
    country: "GR",
    name: {
      en : "Portoheli"
    }
  },
  PKJ : {
    country: "GT",
    name: {
      en : "Playa Grande"
    }
  },
  PKK : {
    country: "MM",
    name: {
      en : "Pakokku"
    }
  },
  PKN : {
    country: "ID",
    name: {
      en : "Pangkalanbun"
    }
  },
  PKP : {
    country: "PF",
    name: {
      en : "Puka-Puka"
    }
  },
  PKR : {
    country: "NP",
    name: {
      en : "Pokhara"
    }
  },
  PKU : {
    country: "ID",
    name: {
      en : "Pekanbaru"
    }
  },
  PKV : {
    country: "RU",
    popularity: 2,
    name: {
      en : "Pskov"
    }
  },
  PKW : {
    country: "BW",
    name: {
      en : "Selebi Phikwe"
    }
  },
  PKY : {
    country: "ID",
    name: {
      en : "Palangkaraya"
    }
  },
  PKZ : {
    country: "LA",
    name: {
      en : "Pakse"
    }
  },
  PLB : {
    country: "US",
    name: {
      en : "Plattsburgh"
    }
  },
  PLD : {
    country: "CR",
    name: {
      en : "Playa Samara"
    }
  },
  PLH : {
    country: "GB",
    name: {
      en : "Plymouth"
    }
  },
  PLJ : {
    country: "BZ",
    name: {
      en : "Placencia"
    }
  },
  PLK : {
    country: "US",
    name: {
      en : "Branson Point Lookout"
    }
  },
  PLM : {
    country: "ID",
    name: {
      en : "Palembang"
    }
  },
  PLN : {
    country: "US",
    name: {
      en : "Pellston"
    }
  },
  PLO : {
    country: "AU",
    name: {
      en : "Port Lincoln"
    }
  },
  PLP : {
    country: "PA",
    name: {
      en : "La Palma"
    }
  },
  PLQ : {
    country: "LT",
    name: {
      en : "Palanga"
    }
  },
  PLS : {
    country: "TC",
    name: {
      en : "Providenciales"
    }
  },
  PLV : {
    country: "UA",
    name: {
      en : "Poltava"
    }
  },
  PLW : {
    country: "ID",
    name: {
      en : "Palu"
    }
  },
  PLX : {
    country: "KZ",
    name: {
      en : "Semei"
    }
  },
  PLY : {
    country: "US",
    name: {
      en : "Plymouth"
    }
  },
  PLZ : {
    country: "ZA",
    name: {
      en : "Port Elizabeth"
    }
  },
  PMA : {
    country: "TZ",
    name: {
      en : "Pemba"
    }
  },
  PMC : {
    country: "CL",
    name: {
      en : "Puerto Montt"
    }
  },
  PMD : {
    country: "US",
    name: {
      en : "Palmdale"
    }
  },
  PME : {
    country: "GB",
    name: {
      en : "Portsmouth"
    }
  },
  PMF : {
    country: "IT",
    name: {
      en : "Parma"
    }
  },
  PMG : {
    country: "BR",
    name: {
      en : "Ponta Pora"
    }
  },
  PMI : {
    country: "ES",
    popularity: 286,
    name: {
      en : "Palma Mallorca"
    }
  },
  PMK : {
    country: "AU",
    name: {
      en : "Palm Island"
    }
  },
  PML : {
    country: "US",
    name: {
      en : "Port Moller"
    }
  },
  PMN : {
    country: "PG",
    name: {
      en : "Pumani"
    }
  },
  PMO : {
    country: "IT",
    name: {
      en : "Palermo"
    }
  },
  PMQ : {
    country: "AR",
    name: {
      en : "Perito Moreno"
    }
  },
  PMR : {
    country: "NZ",
    name: {
      en : "Palmerston"
    }
  },
  PMT : {
    country: "GY",
    name: {
      en : "Paramakatoi"
    }
  },
  PMV : {
    country: "VE",
    name: {
      en : "Porlamar"
    }
  },
  PMW : {
    country: "BR",
    name: {
      en : "Palmas"
    }
  },
  PMY : {
    country: "AR",
    name: {
      en : "Puerto Madryn"
    }
  },
  PMZ : {
    country: "CR",
    name: {
      en : "Palmar"
    }
  },
  PNA : {
    country: "ES",
    name: {
      en : "Pamplona"
    }
  },
  PNC : {
    country: "US",
    name: {
      en : "Ponca City"
    }
  },
  PND : {
    country: "BZ",
    name: {
      en : "Punta Gorda"
    }
  },
  PNG : {
    country: "BR",
    name: {
      en : "Paranagua"
    }
  },
  PNH : {
    country: "KH",
    popularity: 2,
    name: {
      en : "Phnom Penh"
    }
  },
  PNI : {
    country: "FM",
    name: {
      en : "Pohnpei"
    }
  },
  PNJ : {
    country: "CN",
    name: {
      en : "Penglai"
    }
  },
  PNK : {
    country: "ID",
    name: {
      en : "Pontianak"
    }
  },
  PNL : {
    country: "IT",
    name: {
      en : "Pantelleria"
    }
  },
  PNO : {
    country: "MX",
    name: {
      en : "Pinotepa Nacional"
    }
  },
  PNP : {
    country: "PG",
    name: {
      en : "Popondetta"
    }
  },
  PNQ : {
    country: "IN",
    popularity: 2,
    name: {
      en : "Pune"
    }
  },
  PNR : {
    country: "CG",
    name: {
      en : "Pointe Noire"
    }
  },
  PNS : {
    country: "US",
    name: {
      en : "Pensacola"
    }
  },
  PNT : {
    country: "CL",
    name: {
      en : "Puerto Natales"
    }
  },
  PNV : {
    country: "LT",
    name: {
      en : "Panevezys"
    }
  },
  PNX : {
    country: "US",
    name: {
      en : "Sherman"
    }
  },
  PNZ : {
    country: "BR",
    name: {
      en : "Petrolina"
    }
  },
  POA : {
    country: "BR",
    name: {
      en : "Porto Alegre"
    }
  },
  POC : {
    country: "US",
    name: {
      en : "La Verne"
    }
  },
  POD : {
    country: "SN",
    name: {
      en : "Podor"
    }
  },
  POE : {
    country: "US",
    name: {
      en : "Fort Polk"
    }
  },
  POF : {
    country: "US",
    name: {
      en : "Poplar Bluff"
    }
  },
  POG : {
    country: "GA",
    name: {
      en : "Port Gentil"
    }
  },
  POJ : {
    country: "BR",
    name: {
      en : "Patos De Minas"
    }
  },
  POL : {
    country: "MZ",
    name: {
      en : "Pemba"
    }
  },
  POM : {
    country: "PG",
    name: {
      en : "Port Moresby"
    }
  },
  POO : {
    country: "BR",
    name: {
      en : "Pocos De Caldas"
    }
  },
  POP : {
    country: "DO",
    name: {
      en : "Puerto Plata"
    }
  },
  POR : {
    country: "FI",
    name: {
      en : "Pori"
    }
  },
  POS : {
    country: "TT",
    name: {
      en : "Port Of Spain"
    }
  },
  POT : {
    country: "JM",
    name: {
      en : "Port Antonio"
    }
  },
  POU : {
    country: "US",
    name: {
      en : "Poughkeepsie"
    }
  },
  POV : {
    country: "SK",
    name: {
      en : "POV"
    }
  },
  POW : {
    country: "SI",
    name: {
      en : "Portoroz"
    }
  },
  POX : {
    country: "FR",
    name: {
      en : "Pontoise"
    }
  },
  POZ : {
    country: "PL",
    name: {
      en : "Poznan"
    }
  },
  PPB : {
    country: "BR",
    name: {
      en : "Presidente Prudente"
    }
  },
  PPC : {
    country: "US",
    name: {
      en : "Prospect Creek"
    }
  },
  PPE : {
    country: "MX",
    name: {
      en : "Puerto Penasco"
    }
  },
  PPF : {
    country: "US",
    name: {
      en : "Parsons"
    }
  },
  PPG : {
    country: "AS",
    popularity: 2,
    name: {
      en : "Pago Pago"
    }
  },
  PPI : {
    country: "AU",
    name: {
      en : "Port Pirie"
    }
  },
  PPK : {
    country: "KZ",
    name: {
      en : "Petropavlovsk"
    }
  },
  PPL : {
    country: "NP",
    popularity: 2,
    name: {
      en : "Phaplu"
    }
  },
  PPM : {
    country: "US",
    name: {
      en : "Pompano Beach"
    }
  },
  PPN : {
    country: "CO",
    name: {
      en : "Popayan"
    }
  },
  PPP : {
    country: "AU",
    name: {
      en : "Proserpine"
    }
  },
  PPQ : {
    country: "NZ",
    name: {
      en : "Paraparaumu"
    }
  },
  PPS : {
    country: "PH",
    name: {
      en : "Puerto Princesa"
    }
  },
  PPT : {
    country: "PF",
    name: {
      en : "Papeete"
    }
  },
  PPV : {
    country: "US",
    name: {
      en : "Port Protection"
    }
  },
  PPW : {
    country: "GB",
    name: {
      en : "Papa Westray"
    }
  },
  PPY : {
    country: "BR",
    name: {
      en : "Pouso Alegre"
    }
  },
  PQC : {
    country: "VN",
    name: {
      en : "Phu Quoc"
    }
  },
  PQI : {
    country: "US",
    name: {
      en : "Presque Isle"
    }
  },
  PQM : {
    country: "MX",
    name: {
      en : "Palenque"
    }
  },
  PQQ : {
    country: "AU",
    name: {
      en : "Pt Macquarie"
    }
  },
  PQS : {
    country: "US",
    name: {
      en : "Pilot Station"
    }
  },
  PRA : {
    country: "AR",
    name: {
      en : "Parana"
    }
  },
  PRB : {
    country: "US",
    name: {
      en : "Paso Robles"
    }
  },
  PRC : {
    country: "US",
    name: {
      en : "Prescott"
    }
  },
  PRG : {
    country: "CZ",
    popularity: 654,
    name: {
      en : "Prague"
    }
  },
  PRH : {
    country: "TH",
    name: {
      en : "Phrae"
    }
  },
  PRI : {
    country: "SC",
    popularity: 4,
    name: {
      en : "Praslin Island"
    }
  },
  PRJ : {
    country: "IT",
    name: {
      en : "Capri"
    }
  },
  PRM : {
    country: "PT",
    name: {
      en : "Portimao"
    }
  },
  PRN : {
    country: "RS",
    popularity: 8,
    name: {
      en : "Pristina"
    }
  },
  PRP : {
    country: "FR",
    name: {
      en : "Propriano"
    }
  },
  PRS : {
    country: "SB",
    name: {
      en : "Parasi"
    }
  },
  PRX : {
    country: "US",
    popularity: 4,
    name: {
      en : "Paris"
    }
  },
  PRY : {
    country: "ZA",
    name: {
      en : "Pretoria"
    }
  },
  PSA : {
    country: "IT",
    popularity: 4,
    name: {
      en : "Pisa"
    }
  },
  PSB : {
    country: "US",
    name: {
      en : "Philipsburg"
    }
  },
  PSC : {
    country: "US",
    name: {
      en : "Pasco"
    }
  },
  PSD : {
    country: "EG",
    name: {
      en : "Port Said"
    }
  },
  PSE : {
    country: "PR",
    name: {
      en : "Ponce"
    }
  },
  PSF : {
    country: "US",
    name: {
      en : "Pittsfield"
    }
  },
  PSG : {
    country: "US",
    popularity: 12,
    name: {
      en : "Petersburg"
    }
  },
  PSH : {
    country: "DE",
    name: {
      en : "St Peter"
    }
  },
  PSI : {
    country: "PK",
    name: {
      en : "Pasni"
    }
  },
  PSJ : {
    country: "ID",
    name: {
      en : "Poso"
    }
  },
  PSK : {
    country: "US",
    name: {
      en : "Dublin"
    }
  },
  PSL : {
    country: "GB",
    name: {
      en : "Perth"
    }
  },
  PSM : {
    country: "US",
    name: {
      en : "Portsmouth"
    }
  },
  PSN : {
    country: "US",
    name: {
      en : "Palestine"
    }
  },
  PSO : {
    country: "CO",
    name: {
      en : "Pasto"
    }
  },
  PSP : {
    country: "US",
    name: {
      en : "Palm Springs"
    }
  },
  PSQ : {
    country: "  ",
    name: {
      en : "PSQ"
    }
  },
  PSR : {
    country: "IT",
    name: {
      en : "Pescara"
    }
  },
  PSS : {
    country: "AR",
    name: {
      en : "Posadas"
    }
  },
  PSU : {
    country: "ID",
    name: {
      en : "Putussibau"
    }
  },
  PSV : {
    country: "GB",
    name: {
      en : "Papa Stour"
    }
  },
  PSY : {
    country: "FK",
    name: {
      en : "Port Stanley"
    }
  },
  PSZ : {
    country: "BO",
    name: {
      en : "Puerto Suarez"
    }
  },
  PTA : {
    country: "US",
    name: {
      en : "Port Alsworth"
    }
  },
  PTB : {
    country: "US",
    name: {
      en : "Petersburg"
    }
  },
  PTE : {
    country: "AU",
    name: {
      en : "Port Stephens"
    }
  },
  PTF : {
    country: "FJ",
    name: {
      en : "Malololailai"
    }
  },
  PTG : {
    country: "ZA",
    popularity: 4,
    name: {
      en : "Pietersburg"
    }
  },
  PTH : {
    country: "US",
    name: {
      en : "Port Heiden"
    }
  },
  PTI : {
    country: "AU",
    name: {
      en : "Port Douglas"
    }
  },
  PTJ : {
    country: "AU",
    name: {
      en : "Portland"
    }
  },
  PTK : {
    country: "US",
    name: {
      en : "Pontiac"
    }
  },
  PTO : {
    country: "BR",
    name: {
      en : "Pato Branco"
    }
  },
  PTP : {
    country: "GP",
    name: {
      en : "Pointe-a-Pitre"
    }
  },
  PTS : {
    country: "US",
    name: {
      en : "Pittsburg"
    }
  },
  PTU : {
    country: "US",
    name: {
      en : "Platinum"
    }
  },
  PTW : {
    country: "US",
    name: {
      en : "Pottstown"
    }
  },
  PTY : {
    country: "PA",
    popularity: 2,
    name: {
      en : "Panama City"
    }
  },
  PUB : {
    country: "US",
    name: {
      en : "Pueblo"
    }
  },
  PUC : {
    country: "US",
    name: {
      en : "Price"
    }
  },
  PUD : {
    country: "AR",
    name: {
      en : "Puerto Deseado"
    }
  },
  PUF : {
    country: "FR",
    name: {
      en : "Pau Fr"
    }
  },
  PUG : {
    country: "AU",
    name: {
      en : "Port Augusta"
    }
  },
  PUJ : {
    country: "DO",
    popularity: 8,
    name: {
      en : "Punta Cana"
    }
  },
  PUK : {
    country: "PF",
    name: {
      en : "Pukarua"
    }
  },
  PUL : {
    country: "US",
    name: {
      en : "Poulsbo"
    }
  },
  PUM : {
    country: "ID",
    name: {
      en : "Pomala"
    }
  },
  PUO : {
    country: "US",
    name: {
      en : "Prudhoe Bay"
    }
  },
  PUQ : {
    country: "CL",
    name: {
      en : "Punta Arenas"
    }
  },
  PUS : {
    country: "KR",
    name: {
      en : "Busan"
    }
  },
  PUU : {
    country: "CO",
    name: {
      en : "Puerto Asis"
    }
  },
  PUW : {
    country: "US",
    popularity: 2,
    name: {
      en : "Pullman"
    }
  },
  PUX : {
    country: "CL",
    name: {
      en : "Puerto Varas"
    }
  },
  PUY : {
    country: "HR",
    popularity: 6,
    name: {
      en : "Pula"
    }
  },
  PVA : {
    country: "CO",
    name: {
      en : "Providencia"
    }
  },
  PVC : {
    country: "US",
    name: {
      en : "Provincetown"
    }
  },
  PVD : {
    country: "US",
    name: {
      en : "Providence"
    }
  },
  PVE : {
    country: "PA",
    name: {
      en : "El Porvenir"
    }
  },
  PVH : {
    country: "BR",
    name: {
      en : "Porto Velho"
    }
  },
  PVK : {
    country: "GR",
    name: {
      en : "Preveza"
    }
  },
  PVN : {
    country: "BG",
    name: {
      en : "Pleven"
    }
  },
  PVO : {
    country: "EC",
    name: {
      en : "Portoviejo"
    }
  },
  PVR : {
    country: "MX",
    name: {
      en : "Puerto Vallarta"
    }
  },
  PVS : {
    country: "RU",
    name: {
      en : "Provideniya"
    }
  },
  PVU : {
    country: "US",
    name: {
      en : "Provo"
    }
  },
  PVW : {
    country: "US",
    name: {
      en : "Plainview"
    }
  },
  PVZ : {
    country: "US",
    name: {
      en : "Painesville"
    }
  },
  PWE : {
    country: "RU",
    name: {
      en : "Pevek"
    }
  },
  PWM : {
    country: "US",
    popularity: 2,
    name: {
      en : "Portland"
    }
  },
  PWQ : {
    country: "KZ",
    popularity: 19,
    name: {
      en : "Pavlodar"
    }
  },
  PWT : {
    country: "US",
    name: {
      en : "Bremerton"
    }
  },
  PXM : {
    country: "MX",
    name: {
      en : "Puerto Escondido"
    }
  },
  PXO : {
    country: "PT",
    name: {
      en : "Porto Santo"
    }
  },
  PXS : {
    country: "ES",
    name: {
      en : "Puerto de Santa Maria"
    }
  },
  PXU : {
    country: "VN",
    name: {
      en : "Pleiku"
    }
  },
  PYC : {
    country: "PA",
    name: {
      en : "Playon Chico"
    }
  },
  PYH : {
    country: "VE",
    name: {
      en : "Puerto Ayacucho"
    }
  },
  PYJ : {
    country: "RU",
    name: {
      en : "PYJ"
    }
  },
  PYM : {
    country: "US",
    name: {
      en : "Plymouth"
    }
  },
  PYX : {
    country: "TH",
    name: {
      en : "Pattaya"
    }
  },
  PYY : {
    country: "TH",
    name: {
      en : "Pai City"
    }
  },
  PZB : {
    country: "ZA",
    popularity: 2,
    name: {
      en : "Pietermaritzburg"
    }
  },
  PZE : {
    country: "GB",
    popularity: 2,
    name: {
      en : "Penzance"
    }
  },
  PZH : {
    country: "PK",
    name: {
      en : "Zhob"
    }
  },
  PZI : {
    country: "CN",
    name: {
      en : "Panzhihua"
    }
  },
  PZK : {
    country: "CK",
    name: {
      en : "Pukapuka Island"
    }
  },
  PZO : {
    country: "VE",
    name: {
      en : "Puerto Ordaz"
    }
  },
  PZU : {
    country: "SD",
    name: {
      en : "Port Sudan"
    }
  },
  PZY : {
    country: "SK",
    name: {
      en : "Piestany"
    }
  },
  QAD : {
    country: "IT",
    name: {
      en : "Pordenone"
    }
  },
  QAJ : {
    country: "AE",
    name: {
      en : "Ajman City"
    }
  },
  QAK : {
    country: "BR",
    name: {
      en : "Barbacena"
    }
  },
  QAL : {
    country: "IT",
    name: {
      en : "Alessandria"
    }
  },
  QAM : {
    country: "FR",
    name: {
      en : "Amiens"
    }
  },
  QAO : {
    country: "IT",
    name: {
      en : "Agrigento"
    }
  },
  QAQ : {
    country: "IT",
    name: {
      en : "Laquila"
    }
  },
  QAR : {
    country: "NL",
    name: {
      en : "Arnhem"
    }
  },
  QAU : {
    country: "BR",
    name: {
      en : "Bebedouro"
    }
  },
  QAZ : {
    country: "PL",
    name: {
      en : "Zakopane"
    }
  },
  QBA : {
    country: "ME",
    name: {
      en : "Budva"
    }
  },
  QBC : {
    country: "CA",
    name: {
      en : "Bella Coola"
    }
  },
  QBH : {
    country: "FR",
    name: {
      en : "Levallois"
    }
  },
  QBI : {
    country: "MK",
    name: {
      en : "Bitola"
    }
  },
  QBK : {
    country: "BR",
    name: {
      en : "Betim"
    }
  },
  QBM : {
    country: "FR",
    name: {
      en : "Bourg St Maurice"
    }
  },
  QBO : {
    country: "DE",
    name: {
      en : "Bochum"
    }
  },
  QBQ : {
    country: "FR",
    name: {
      en : "Besancon"
    }
  },
  QBS : {
    country: "IT",
    name: {
      en : "Brescia"
    }
  },
  QBV : {
    country: "IT",
    name: {
      en : "Benevento"
    }
  },
  QBW : {
    country: "AU",
    name: {
      en : "Batesman Bay"
    }
  },
  QCA : {
    country: "SA",
    name: {
      en : "Makkah"
    }
  },
  QCB : {
    country: "JP",
    name: {
      en : "Chiba"
    }
  },
  QCC : {
    country: "BR",
    name: {
      en : "Camacari"
    }
  },
  QCE : {
    country: "US",
    name: {
      en : "Copper Mountain"
    }
  },
  QCF : {
    country: "BR",
    name: {
      en : "Birigui"
    }
  },
  QCH : {
    country: "BR",
    name: {
      en : "Colatina"
    }
  },
  QCI : {
    country: "ES",
    name: {
      en : "Playa de los Cristianos"
    }
  },
  QCJ : {
    country: "BR",
    name: {
      en : "Botucatu"
    }
  },
  QCK : {
    country: "BR",
    name: {
      en : "Cabo Frio Br"
    }
  },
  QCM : {
    country: "IT",
    name: {
      en : "Como"
    }
  },
  QCN : {
    country: "BR",
    name: {
      en : "Canela"
    }
  },
  QCQ : {
    country: "BR",
    name: {
      en : "Caraguatatuba"
    }
  },
  QCS : {
    country: "IT",
    name: {
      en : "Cosenza"
    }
  },
  QCZ : {
    country: "IT",
    name: {
      en : "Catanzaro"
    }
  },
  QDE : {
    country: "BR",
    name: {
      en : "Catanduva"
    }
  },
  QDH : {
    country: "GB",
    name: {
      en : "Ashford"
    }
  },
  QDI : {
    country: "AT",
    name: {
      en : "Dornbirn"
    }
  },
  QDM : {
    country: "HK",
    name: {
      en : "Shek Mum"
    }
  },
  QDN : {
    country: "AU",
    name: {
      en : "Eden"
    }
  },
  QDQ : {
    country: "BR",
    name: {
      en : "Duque De Caxias"
    }
  },
  QDV : {
    country: "BR",
    name: {
      en : "Jundiai"
    }
  },
  QEA : {
    country: "IT",
    name: {
      en : "Teramo"
    }
  },
  QEB : {
    country: "JP",
    name: {
      en : "Maebashi"
    }
  },
  QEI : {
    country: "DE",
    name: {
      en : "Crailsheim"
    }
  },
  QEO : {
    country: "PL",
    name: {
      en : "Bielsko Baila"
    }
  },
  QEV : {
    country: "FR",
    name: {
      en : "Courbevoie"
    }
  },
  QEW : {
    country: "GB",
    name: {
      en : "Leicester"
    }
  },
  QEX : {
    country: "DE",
    name: {
      en : "Emmerich"
    }
  },
  QEZ : {
    country: "IT",
    name: {
      en : "Pomezia"
    }
  },
  QFA : {
    country: "NL",
    name: {
      en : "Aalsmeer"
    }
  },
  QFB : {
    country: "DE",
    name: {
      en : "Freiburg"
    }
  },
  QFE : {
    country: "US",
    name: {
      en : "Ft Benning"
    }
  },
  QFH : {
    country: "DK",
    name: {
      en : "Frederickshavn"
    }
  },
  QFL : {
    country: "DE",
    name: {
      en : "Freilassing"
    }
  },
  QFQ : {
    country: "NO",
    name: {
      en : "Maloy"
    }
  },
  QFR : {
    country: "IT",
    name: {
      en : "Frosinone"
    }
  },
  QFU : {
    country: "ES",
    name: {
      en : "Corralejo"
    }
  },
  QGB : {
    country: "BR",
    name: {
      en : "Limeira"
    }
  },
  QGC : {
    country: "BR",
    name: {
      en : "Lencois Paulista"
    }
  },
  QGJ : {
    country: "BR",
    name: {
      en : "Nova Friburgo"
    }
  },
  QGL : {
    country: "CH",
    name: {
      en : "St Gallen"
    }
  },
  QGN : {
    country: "ES",
    name: {
      en : "Tarragona"
    }
  },
  QGS : {
    country: "BR",
    name: {
      en : "Alagoinhas"
    }
  },
  QGU : {
    country: "JP",
    name: {
      en : "Gifu"
    }
  },
  QGY : {
    country: "HU",
    name: {
      en : "Gyor"
    }
  },
  QHA : {
    country: "BE",
    name: {
      en : "Hasselt"
    }
  },
  QHB : {
    country: "BR",
    name: {
      en : "Piracicaba"
    }
  },
  QHG : {
    country: "BR",
    name: {
      en : "Sete Lagoas"
    }
  },
  QHP : {
    country: "BR",
    name: {
      en : "Taubate"
    }
  },
  QHT : {
    country: "BR",
    name: {
      en : "Terezopolis"
    }
  },
  QHU : {
    country: "DE",
    name: {
      en : "Husum"
    }
  },
  QHV : {
    country: "BR",
    name: {
      en : "Novo Hamburgo"
    }
  },
  QHZ : {
    country: "NL",
    name: {
      en : "Hoofddorp"
    }
  },
  QIA : {
    country: "BR",
    name: {
      en : "Itauna"
    }
  },
  QIC : {
    country: "IT",
    name: {
      en : "Syracuse"
    }
  },
  QIE : {
    country: "FR",
    name: {
      en : "Istres"
    }
  },
  QIG : {
    country: "BR",
    name: {
      en : "Iguatu"
    }
  },
  QIH : {
    country: "BR",
    name: {
      en : "Tres Rios"
    }
  },
  QII : {
    country: "DE",
    name: {
      en : "Lindau"
    }
  },
  QIJ : {
    country: "ES",
    name: {
      en : "Gijon"
    }
  },
  QIN : {
    country: "TR",
    name: {
      en : "Mersin"
    }
  },
  QIQ : {
    country: "BR",
    name: {
      en : "Rio Claro"
    }
  },
  QIS : {
    country: "JP",
    name: {
      en : "Mito"
    }
  },
  QIU : {
    country: "ES",
    name: {
      en : "Ciudadela"
    }
  },
  QIV : {
    country: "EG",
    name: {
      en : "Ismailiya"
    }
  },
  QIZ : {
    country: "TN",
    name: {
      en : "Bizerte"
    }
  },
  QJA : {
    country: "BR",
    name: {
      en : "Jaragua Do Sul"
    }
  },
  QJB : {
    country: "SA",
    name: {
      en : "Jubail"
    }
  },
  QJC : {
    country: "  ",
    name: {
      en : "QJC"
    }
  },
  QJM : {
    country: "BR",
    name: {
      en : "Brusque"
    }
  },
  QJN : {
    country: "LB",
    name: {
      en : "Jounieh"
    }
  },
  QJO : {
    country: "BR",
    name: {
      en : "Campos Do Jordao"
    }
  },
  QJV : {
    country: "DK",
    name: {
      en : "Skagen"
    }
  },
  QKB : {
    country: "US",
    name: {
      en : "Breckenridge"
    }
  },
  QKF : {
    country: "DE",
    name: {
      en : "Krefeld"
    }
  },
  QKI : {
    country: "PL",
    name: {
      en : "Kielce"
    }
  },
  QKN : {
    country: "TN",
    name: {
      en : "Kairouan"
    }
  },
  QKQ : {
    country: "DE",
    name: {
      en : "Anklam"
    }
  },
  QKR : {
    country: "GF",
    name: {
      en : "Kourou"
    }
  },
  QKS : {
    country: "US",
    name: {
      en : "Keystone"
    }
  },
  QKW : {
    country: "JP",
    name: {
      en : "Kanazawa"
    }
  },
  QKZ : {
    country: "DE",
    name: {
      en : "Konstanz"
    }
  },
  QLB : {
    country: "BR",
    name: {
      en : "Lajeado"
    }
  },
  QLC : {
    country: "PL",
    name: {
      en : "Gliwice"
    }
  },
  QLD : {
    country: "DZ",
    name: {
      en : "Blida"
    }
  },
  QLE : {
    country: "AU",
    name: {
      en : "Leeton"
    }
  },
  QLF : {
    country: "FI",
    name: {
      en : "Lahti"
    }
  },
  QLG : {
    country: "DE",
    name: {
      en : "Landshut"
    }
  },
  QLH : {
    country: "DE",
    name: {
      en : "Kelsterbach"
    }
  },
  QLI : {
    country: "CY",
    name: {
      en : "Limassol"
    }
  },
  QLJ : {
    country: "CH",
    name: {
      en : "Lucerne"
    }
  },
  QLP : {
    country: "IT",
    name: {
      en : "La Spezia"
    }
  },
  QLQ : {
    country: "ES",
    name: {
      en : "Lerida"
    }
  },
  QLR : {
    country: "PT",
    name: {
      en : "Leiria"
    }
  },
  QLS : {
    country: "CH",
    popularity: 2,
    name: {
      en : "Lausanne"
    }
  },
  QLT : {
    country: "IT",
    name: {
      en : "Latina"
    }
  },
  QLU : {
    country: "PL",
    name: {
      en : "Lublin"
    }
  },
  QLW : {
    country: "BR",
    name: {
      en : "Lavras"
    }
  },
  QLY : {
    country: "ES",
    name: {
      en : "Playa Blanca"
    }
  },
  QLZ : {
    country: "PL",
    name: {
      en : "QLZ"
    }
  },
  QMB : {
    country: "BR",
    name: {
      en : "Panambi"
    }
  },
  QME : {
    country: "IT",
    name: {
      en : "Messina"
    }
  },
  QMI : {
    country: "BR",
    name: {
      en : "Mogi das Cruzes"
    }
  },
  QMN : {
    country: "SZ",
    name: {
      en : "Mbabane"
    }
  },
  QMO : {
    country: "BE",
    name: {
      en : "Mons"
    }
  },
  QMR : {
    country: "IT",
    name: {
      en : "Marsala"
    }
  },
  QMU : {
    country: "FR",
    name: {
      en : "Moutiers"
    }
  },
  QMZ : {
    country: "DE",
    name: {
      en : "Mainz"
    }
  },
  QNC : {
    country: "CH",
    name: {
      en : "Neuchalet"
    }
  },
  QND : {
    country: "RS",
    name: {
      en : "Novi Sad"
    }
  },
  QNG : {
    country: "JP",
    name: {
      en : "Nagano"
    }
  },
  QNJ : {
    country: "FR",
    name: {
      en : "Annemasse"
    }
  },
  QNL : {
    country: "FR",
    name: {
      en : "Neuilly sur Seine"
    }
  },
  QNM : {
    country: "BE",
    name: {
      en : "Namure"
    }
  },
  QNO : {
    country: "IT",
    name: {
      en : "Ascoli Piceno"
    }
  },
  QNP : {
    country: "CY",
    name: {
      en : "Ayia Napa"
    }
  },
  QNR : {
    country: "BR",
    name: {
      en : "Santa Cruz Rio Pardo"
    }
  },
  QNT : {
    country: "BR",
    name: {
      en : "Niteroi"
    }
  },
  QNU : {
    country: "IT",
    name: {
      en : "Nuoro"
    }
  },
  QNX : {
    country: "FR",
    name: {
      en : "Macon"
    }
  },
  QOA : {
    country: "BR",
    name: {
      en : "Mococa"
    }
  },
  QOB : {
    country: "DE",
    name: {
      en : "Ansbach"
    }
  },
  QOC : {
    country: "BR",
    name: {
      en : "Osasco"
    }
  },
  QOG : {
    country: "DE",
    name: {
      en : "Homburg"
    }
  },
  QOI : {
    country: "BR",
    name: {
      en : "Cotia"
    }
  },
  QOM : {
    country: "JP",
    name: {
      en : "Omiya"
    }
  },
  QON : {
    country: "BE",
    name: {
      en : "Arlon"
    }
  },
  QOR : {
    country: "TR",
    name: {
      en : "Ordu"
    }
  },
  QOS : {
    country: "IT",
    name: {
      en : "Oristano"
    }
  },
  QOT : {
    country: "JP",
    name: {
      en : "Otaru"
    }
  },
  QOW : {
    country: "NG",
    name: {
      en : "QOW"
    }
  },
  QOX : {
    country: "DE",
    name: {
      en : "Memmingen"
    }
  },
  QPA : {
    country: "IT",
    name: {
      en : "Padova"
    }
  },
  QPB : {
    country: "IT",
    name: {
      en : "Campobasso"
    }
  },
  QPE : {
    country: "BR",
    name: {
      en : "Petropolis"
    }
  },
  QPO : {
    country: "IT",
    name: {
      en : "Potenza"
    }
  },
  QPR : {
    country: "IT",
    name: {
      en : "Prato"
    }
  },
  QPS : {
    country: "BR",
    name: {
      en : "Pirassununga"
    }
  },
  QPZ : {
    country: "IT",
    name: {
      en : "Piacenza"
    }
  },
  QQD : {
    country: "GB",
    name: {
      en : "Dover"
    }
  },
  QQX : {
    country: "GB",
    name: {
      en : "Bath"
    }
  },
  QQY : {
    country: "GB",
    name: {
      en : "York"
    }
  },
  QRG : {
    country: "IT",
    name: {
      en : "Ragusa"
    }
  },
  QRL : {
    country: "ES",
    name: {
      en : "Marbella"
    }
  },
  QRM : {
    country: "AU",
    name: {
      en : "Narromine"
    }
  },
  QRO : {
    country: "MX",
    name: {
      en : "Queretaro"
    }
  },
  QRP : {
    country: "BR",
    name: {
      en : "Gramado"
    }
  },
  QRV : {
    country: "FR",
    name: {
      en : "Arras"
    }
  },
  QRW : {
    country: "NG",
    name: {
      en : "Warri"
    }
  },
  QRZ : {
    country: "BR",
    name: {
      en : "Resende"
    }
  },
  QSA : {
    country: "ES",
    name: {
      en : "Sabadell"
    }
  },
  QSC : {
    country: "BR",
    name: {
      en : "Sao Carlos"
    }
  },
  QSF : {
    country: "DZ",
    name: {
      en : "Setif"
    }
  },
  QSJ : {
    country: "BR",
    name: {
      en : "Sao Joao Del Rei"
    }
  },
  QSO : {
    country: "TN",
    name: {
      en : "Sousse"
    }
  },
  QSR : {
    country: "IT",
    name: {
      en : "Salerno"
    }
  },
  QSS : {
    country: "IT",
    name: {
      en : "Sassari"
    }
  },
  QSZ : {
    country: "JP",
    name: {
      en : "Shizuoka"
    }
  },
  QTC : {
    country: "IT",
    name: {
      en : "Caserta"
    }
  },
  QTH : {
    country: "AU",
    name: {
      en : "Thredbo"
    }
  },
  QTJ : {
    country: "FR",
    name: {
      en : "Chartres"
    }
  },
  QTK : {
    country: "DE",
    name: {
      en : "Rothenburg"
    }
  },
  QTL : {
    country: "BR",
    name: {
      en : "Caratinga"
    }
  },
  QTO : {
    country: "AU",
    name: {
      en : "Skitube"
    }
  },
  QTR : {
    country: "SY",
    name: {
      en : "Tartous"
    }
  },
  QTS : {
    country: "  ",
    name: {
      en : "QTS"
    }
  },
  QTU : {
    country: "BR",
    name: {
      en : "Itu"
    }
  },
  QTY : {
    country: "JP",
    name: {
      en : "Tsu Jp"
    }
  },
  QTZ : {
    country: "MX",
    name: {
      en : "Coatzacoalcos"
    }
  },
  QUB : {
    country: "LY",
    name: {
      en : "Ubari"
    }
  },
  QUL : {
    country: "DE",
    name: {
      en : "Ulm"
    }
  },
  QUO : {
    country: "NG",
    name: {
      en : "Uyo"
    }
  },
  QUQ : {
    country: "ES",
    name: {
      en : "Caceres"
    }
  },
  QUR : {
    country: "BR",
    name: {
      en : "Muriae"
    }
  },
  QUT : {
    country: "JP",
    name: {
      en : "Utsunomiya"
    }
  },
  QUZ : {
    country: "ES",
    name: {
      en : "Puerto de la Luz"
    }
  },
  QVA : {
    country: "IT",
    name: {
      en : "Varese"
    }
  },
  QVC : {
    country: "BR",
    name: {
      en : "Vicosa"
    }
  },
  QVD : {
    country: "FI",
    name: {
      en : "Salo"
    }
  },
  QVE : {
    country: "FI",
    name: {
      en : "Forssa"
    }
  },
  QVH : {
    country: "BR",
    name: {
      en : "Vila Velha"
    }
  },
  QVL : {
    country: "NG",
    name: {
      en : "Victoria Island"
    }
  },
  QVM : {
    country: "FI",
    name: {
      en : "Hameenlinna"
    }
  },
  QVN : {
    country: "IT",
    name: {
      en : "Avellino"
    }
  },
  QVP : {
    country: "BR",
    name: {
      en : "Avare"
    }
  },
  QVR : {
    country: "BR",
    name: {
      en : "Volta Redonda"
    }
  },
  QVU : {
    country: "LI",
    name: {
      en : "Vaduz"
    }
  },
  QVW : {
    country: "FI",
    name: {
      en : "Kotka"
    }
  },
  QVZ : {
    country: "FI",
    name: {
      en : "Hamina"
    }
  },
  QWI : {
    country: "DE",
    name: {
      en : "Schleswig"
    }
  },
  QWJ : {
    country: "BR",
    name: {
      en : "Americana"
    }
  },
  QWL : {
    country: "AU",
    name: {
      en : "Crackenback Village"
    }
  },
  QWM : {
    country: "US",
    name: {
      en : "Longmont"
    }
  },
  QWP : {
    country: "US",
    name: {
      en : "Winter Park"
    }
  },
  QWQ : {
    country: "DK",
    name: {
      en : "Struer"
    }
  },
  QWR : {
    country: "DE",
    name: {
      en : "Donauwoerth"
    }
  },
  QWT : {
    country: "ES",
    name: {
      en : "Talavera De La Reina"
    }
  },
  QWU : {
    country: "DE",
    name: {
      en : "Wurzburg"
    }
  },
  QWW : {
    country: "ES",
    name: {
      en : "Navalmoral de la Mata"
    }
  },
  QWX : {
    country: "ES",
    name: {
      en : "Merida"
    }
  },
  QWY : {
    country: "US",
    name: {
      en : "Albany"
    }
  },
  QXB : {
    country: "FR",
    name: {
      en : "Aix En Provence"
    }
  },
  QXJ : {
    country: "FI",
    name: {
      en : "Porvoo"
    }
  },
  QXP : {
    country: "MK",
    name: {
      en : "Struga"
    }
  },
  QXW : {
    country: "BR",
    name: {
      en : "Alfenas"
    }
  },
  QYC : {
    country: "NL",
    name: {
      en : "Drachten"
    }
  },
  QYD : {
    country: "PL",
    name: {
      en : "Gdynia"
    }
  },
  QYG : {
    country: "DE",
    name: {
      en : "QYG"
    }
  },
  QYH : {
    country: "NL",
    name: {
      en : "Hengelo"
    }
  },
  QYI : {
    country: "NL",
    name: {
      en : "Hilversum"
    }
  },
  QYM : {
    country: "NL",
    name: {
      en : "Amersfoort"
    }
  },
  QYN : {
    country: "AU",
    name: {
      en : "Byron Bay"
    }
  },
  QYO : {
    country: "PL",
    name: {
      en : "Olsztyn"
    }
  },
  QYP : {
    country: "NL",
    name: {
      en : "Apeldoorn"
    }
  },
  QYR : {
    country: "FR",
    name: {
      en : "Troyes"
    }
  },
  QYV : {
    country: "NL",
    name: {
      en : "Deventer"
    }
  },
  QYX : {
    country: "SE",
    name: {
      en : "Uppsala"
    }
  },
  QYZ : {
    country: "NL",
    name: {
      en : "Heerenveen"
    }
  },
  QZB : {
    country: "CH",
    name: {
      en : "Zermatt"
    }
  },
  QZD : {
    country: "HU",
    name: {
      en : "Szeged"
    }
  },
  QZO : {
    country: "IT",
    name: {
      en : "Arezzo"
    }
  },
  RAB : {
    country: "PG",
    name: {
      en : "Rabaul"
    }
  },
  RAC : {
    country: "US",
    name: {
      en : "Racine"
    }
  },
  RAE : {
    country: "SA",
    name: {
      en : "Arar"
    }
  },
  RAH : {
    country: "SA",
    name: {
      en : "Rafha"
    }
  },
  RAI : {
    country: "CV",
    name: {
      en : "Praia"
    }
  },
  RAJ : {
    country: "IN",
    name: {
      en : "Rajkot"
    }
  },
  RAK : {
    country: "MA",
    popularity: 6,
    name: {
      en : "Marrakech"
    }
  },
  RAL : {
    country: "US",
    name: {
      en : "Riverside"
    }
  },
  RAM : {
    country: "AU",
    name: {
      en : "Ramingining"
    }
  },
  RAN : {
    country: "IT",
    name: {
      en : "Ravenna"
    }
  },
  RAO : {
    country: "BR",
    name: {
      en : "Ribeirao Preto"
    }
  },
  RAP : {
    country: "US",
    name: {
      en : "Rapid City"
    }
  },
  RAQ : {
    country: "ID",
    name: {
      en : "Raha"
    }
  },
  RAR : {
    country: "CK",
    name: {
      en : "Rarotonga"
    }
  },
  RAS : {
    country: "IR",
    name: {
      en : "Rasht"
    }
  },
  RAT : {
    country: "RU",
    name: {
      en : "Raduzhny"
    }
  },
  RAW : {
    country: "PG",
    name: {
      en : "Arawa"
    }
  },
  RAY : {
    country: "GB",
    name: {
      en : "Rothesay"
    }
  },
  RBA : {
    country: "MA",
    name: {
      en : "Rabat"
    }
  },
  RBF : {
    country: "US",
    name: {
      en : "Big Bear City"
    }
  },
  RBG : {
    country: "US",
    name: {
      en : "Roseburg"
    }
  },
  RBH : {
    country: "US",
    name: {
      en : "Brooks Lodge"
    }
  },
  RBI : {
    country: "FJ",
    name: {
      en : "Rabi"
    }
  },
  RBJ : {
    country: "JP",
    name: {
      en : "Rebun"
    }
  },
  RBM : {
    country: "DE",
    name: {
      en : "Straubing"
    }
  },
  RBP : {
    country: "PG",
    name: {
      en : "Rabaraba"
    }
  },
  RBQ : {
    country: "BO",
    name: {
      en : "Rurrenabaque"
    }
  },
  RBR : {
    country: "BR",
    name: {
      en : "Rio Branco"
    }
  },
  RBV : {
    country: "SB",
    name: {
      en : "Ramata"
    }
  },
  RBW : {
    country: "US",
    name: {
      en : "Walterboro"
    }
  },
  RBX : {
    country: "SD",
    name: {
      en : "RBX"
    }
  },
  RBY : {
    country: "US",
    name: {
      en : "Ruby"
    }
  },
  RCB : {
    country: "ZA",
    name: {
      en : "Richards Bay"
    }
  },
  RCE : {
    country: "US",
    name: {
      en : "Roche Harbor"
    }
  },
  RCH : {
    country: "CO",
    name: {
      en : "Riohacha"
    }
  },
  RCL : {
    country: "VU",
    name: {
      en : "Redcliffe"
    }
  },
  RCM : {
    country: "AU",
    name: {
      en : "Richmond"
    }
  },
  RCO : {
    country: "FR",
    name: {
      en : "Rochefort"
    }
  },
  RCP : {
    country: "US",
    name: {
      en : "Cinder Park"
    }
  },
  RCQ : {
    country: "AR",
    name: {
      en : "Reconquista"
    }
  },
  RCS : {
    country: "GB",
    name: {
      en : "Rochester"
    }
  },
  RCU : {
    country: "AR",
    name: {
      en : "Rio Cuarto"
    }
  },
  RDB : {
    country: "US",
    name: {
      en : "Red Dog"
    }
  },
  RDD : {
    country: "US",
    name: {
      en : "Redding"
    }
  },
  RDG : {
    country: "US",
    name: {
      en : "Reading"
    }
  },
  RDM : {
    country: "US",
    name: {
      en : "Redmond"
    }
  },
  RDN : {
    country: "MY",
    name: {
      en : "Redang"
    }
  },
  RDO : {
    country: "PL",
    name: {
      en : "Radom"
    }
  },
  RDP : {
    country: "IN",
    name: {
      en : "Durgapur"
    }
  },
  RDT : {
    country: "SN",
    name: {
      en : "Richard Toll"
    }
  },
  RDU : {
    country: "US",
    popularity: 32,
    name: {
      en : "Raleigh"
    }
  },
  RDV : {
    country: "US",
    name: {
      en : "Red Devil"
    }
  },
  RDZ : {
    country: "FR",
    name: {
      en : "Rodez"
    }
  },
  REA : {
    country: "PF",
    name: {
      en : "Reao"
    }
  },
  REC : {
    country: "BR",
    name: {
      en : "Recife"
    }
  },
  REG : {
    country: "IT",
    name: {
      en : "Reggio Calabria"
    }
  },
  REH : {
    country: "US",
    name: {
      en : "Rehoboth Beach"
    }
  },
  REK : {
    country: "IS",
    popularity: 29,
    name: {
      en : "Reykjavik"
    }
  },
  REL : {
    country: "AR",
    name: {
      en : "Trelew"
    }
  },
  REN : {
    country: "RU",
    name: {
      en : "Orenburg"
    }
  },
  REP : {
    country: "KH",
    popularity: 2,
    name: {
      en : "Siem Reap"
    }
  },
  RER : {
    country: "GT",
    name: {
      en : "Retalhuleu"
    }
  },
  RES : {
    country: "AR",
    name: {
      en : "Resistencia"
    }
  },
  RET : {
    country: "NO",
    name: {
      en : "Rost"
    }
  },
  REU : {
    country: "ES",
    name: {
      en : "Reus"
    }
  },
  REX : {
    country: "MX",
    name: {
      en : "Reynosa"
    }
  },
  RFD : {
    country: "US",
    name: {
      en : "Rockford"
    }
  },
  RFN : {
    country: "IS",
    name: {
      en : "Raufarhofn"
    }
  },
  RFP : {
    country: "PF",
    name: {
      en : "Raiatea"
    }
  },
  RGA : {
    country: "AR",
    name: {
      en : "Rio Grande"
    }
  },
  RGE : {
    country: "PG",
    name: {
      en : "Porgera"
    }
  },
  RGI : {
    country: "PF",
    name: {
      en : "Rangiroa Island"
    }
  },
  RGK : {
    country: "RU",
    name: {
      en : "Gorno-Altaisk"
    }
  },
  RGL : {
    country: "AR",
    name: {
      en : "Rio Gallegos"
    }
  },
  RGN : {
    country: "MM",
    name: {
      en : "Yangon"
    }
  },
  RGR : {
    country: "US",
    name: {
      en : "Ranger"
    }
  },
  RGS : {
    country: "ES",
    name: {
      en : "Burgos"
    }
  },
  RGT : {
    country: "ID",
    name: {
      en : "Rengat"
    }
  },
  RHE : {
    country: "FR",
    name: {
      en : "Reims"
    }
  },
  RHI : {
    country: "US",
    name: {
      en : "Rhinelander"
    }
  },
  RHN : {
    country: "NA",
    name: {
      en : "Rosh Pina"
    }
  },
  RHO : {
    country: "GR",
    name: {
      en : "Rhodes"
    }
  },
  RHP : {
    country: "NP",
    name: {
      en : "Ramechhap"
    }
  },
  RIA : {
    country: "BR",
    name: {
      en : "Santa Maria"
    }
  },
  RIB : {
    country: "BO",
    name: {
      en : "Riberalta"
    }
  },
  RIC : {
    country: "US",
    name: {
      en : "Richmond"
    }
  },
  RID : {
    country: "US",
    name: {
      en : "Richmond"
    }
  },
  RIF : {
    country: "US",
    name: {
      en : "Richfield"
    }
  },
  RIG : {
    country: "BR",
    name: {
      en : "Rio Grande"
    }
  },
  RIJ : {
    country: "PE",
    name: {
      en : "Rioja"
    }
  },
  RIL : {
    country: "US",
    name: {
      en : "Rifle"
    }
  },
  RIO : {
    country: "BR",
    popularity: 18,
    name: {
      en : "Rio De Janeiro"
    }
  },
  RIS : {
    country: "JP",
    name: {
      en : "Rishiri"
    }
  },
  RIW : {
    country: "US",
    name: {
      en : "Riverton"
    }
  },
  RIX : {
    country: "LV",
    popularity: 264,
    name: {
      en : "Riga"
    }
  },
  RIY : {
    country: "YE",
    name: {
      en : "Riyan"
    }
  },
  RIZ : {
    country: "CN",
    name: {
      en : "Rizhao"
    }
  },
  RJA : {
    country: "IN",
    name: {
      en : "Rajahmundry"
    }
  },
  RJH : {
    country: "BD",
    name: {
      en : "Rajshahi"
    }
  },
  RJK : {
    country: "HR",
    name: {
      en : "Rijeka"
    }
  },
  RJL : {
    country: "ES",
    name: {
      en : "Logroño"
    }
  },
  RKA : {
    country: "PF",
    name: {
      en : "RKA"
    }
  },
  RKC : {
    country: "US",
    name: {
      en : "Yreka"
    }
  },
  RKD : {
    country: "US",
    name: {
      en : "Rockland"
    }
  },
  RKE : {
    country: "DK",
    name: {
      en : "Roskilde"
    }
  },
  RKH : {
    country: "US",
    name: {
      en : "Rock Hill"
    }
  },
  RKP : {
    country: "US",
    name: {
      en : "Rockport"
    }
  },
  RKS : {
    country: "US",
    name: {
      en : "Rock Springs"
    }
  },
  RKT : {
    country: "AE",
    name: {
      en : "Ras Al Khaimah"
    }
  },
  RKU : {
    country: "PG",
    name: {
      en : "Yule Island"
    }
  },
  RKZ : {
    country: "CN",
    name: {
      en : "Rikaze"
    }
  },
  RLA : {
    country: "US",
    name: {
      en : "Rolla"
    }
  },
  RLD : {
    country: "US",
    name: {
      en : "Richland"
    }
  },
  RLG : {
    country: "DE",
    name: {
      en : "Rostock Laage"
    }
  },
  RLK : {
    country: "CN",
    name: {
      en : "Bayannur"
    }
  },
  RMA : {
    country: "AU",
    name: {
      en : "Roma"
    }
  },
  RME : {
    country: "US",
    name: {
      en : "Rome"
    }
  },
  RMF : {
    country: "EG",
    popularity: 14,
    name: {
      en : "Marsa Alam"
    }
  },
  RMG : {
    country: "US",
    name: {
      en : "Rome"
    }
  },
  RMI : {
    country: "IT",
    popularity: 6,
    name: {
      en : "Rimini"
    }
  },
  RMK : {
    country: "AU",
    name: {
      en : "Renmark"
    }
  },
  RMO : {
    country: "MD",
    popularity: 440,
    name: {
      en : "Chisinau"
    }
  },
  RMP : {
    country: "US",
    name: {
      en : "Rampart"
    }
  },
  RMQ : {
    country: "TW",
    name: {
      en : "Taichung"
    }
  },
  RMS : {
    country: "DE",
    name: {
      en : "Ramstein"
    }
  },
  RMT : {
    country: "PF",
    name: {
      en : "Rimatara"
    }
  },
  RNA : {
    country: "SB",
    name: {
      en : "Arona"
    }
  },
  RNB : {
    country: "SE",
    name: {
      en : "Ronneby"
    }
  },
  RNE : {
    country: "FR",
    name: {
      en : "Roanne"
    }
  },
  RNG : {
    country: "US",
    name: {
      en : "Rangely"
    }
  },
  RNH : {
    country: "US",
    name: {
      en : "New Richmond"
    }
  },
  RNJ : {
    country: "JP",
    name: {
      en : "Yoronjima"
    }
  },
  RNL : {
    country: "SB",
    name: {
      en : "Rennell"
    }
  },
  RNN : {
    country: "DK",
    name: {
      en : "Bornholm"
    }
  },
  RNO : {
    country: "US",
    name: {
      en : "Reno"
    }
  },
  RNP : {
    country: "MH",
    name: {
      en : "Rongelap"
    }
  },
  RNR : {
    country: "PG",
    name: {
      en : "Robinson River"
    }
  },
  RNS : {
    country: "FR",
    popularity: 8,
    name: {
      en : "Rennes"
    }
  },
  RNZ : {
    country: "US",
    name: {
      en : "Rensselaer"
    }
  },
  ROA : {
    country: "US",
    name: {
      en : "Roanoke"
    }
  },
  ROC : {
    country: "US",
    name: {
      en : "Rochester"
    }
  },
  ROG : {
    country: "US",
    name: {
      en : "Rogers"
    }
  },
  ROH : {
    country: "AU",
    name: {
      en : "Robinhood"
    }
  },
  ROI : {
    country: "TH",
    name: {
      en : "Roi Et"
    }
  },
  ROK : {
    country: "AU",
    name: {
      en : "Rockhampton"
    }
  },
  ROM : {
    country: "IT",
    popularity: 177,
    name: {
      en : "Rome"
    }
  },
  ROO : {
    country: "BR",
    name: {
      en : "Rondonopolis"
    }
  },
  ROP : {
    country: "MP",
    name: {
      en : "Rota"
    }
  },
  ROR : {
    country: "PW",
    name: {
      en : "Koror"
    }
  },
  ROS : {
    country: "AR",
    name: {
      en : "Rosario"
    }
  },
  ROT : {
    country: "NZ",
    name: {
      en : "Rotorua"
    }
  },
  ROU : {
    country: "BG",
    name: {
      en : "Ruse"
    }
  },
  ROV : {
    country: "RU",
    popularity: 488,
    name: {
      en : "Rostov-on-Don"
    }
  },
  ROW : {
    country: "US",
    name: {
      en : "Roswell"
    }
  },
  ROY : {
    country: "AR",
    name: {
      en : "Rio Mayo"
    }
  },
  RPN : {
    country: "IL",
    popularity: 6,
    name: {
      en : "Rosh Pina"
    }
  },
  RPR : {
    country: "IN",
    name: {
      en : "Raipur"
    }
  },
  RQW : {
    country: "IQ",
    name: {
      en : "RQW"
    }
  },
  RRA : {
    country: "ES",
    name: {
      en : "Ronda"
    }
  },
  RRG : {
    country: "MU",
    name: {
      en : "Rodrigues Island"
    }
  },
  RRO : {
    country: "IT",
    name: {
      en : "Sorrento"
    }
  },
  RRR : {
    country: "PF",
    name: {
      en : "RRR"
    }
  },
  RRS : {
    country: "NO",
    name: {
      en : "Roros"
    }
  },
  RSA : {
    country: "AR",
    name: {
      en : "Santa Rosa"
    }
  },
  RSB : {
    country: "AU",
    name: {
      en : "Roseberth"
    }
  },
  RSD : {
    country: "BS",
    name: {
      en : "Rock Sound"
    }
  },
  RSG : {
    country: "BR",
    name: {
      en : "Serra Pelada"
    }
  },
  RSH : {
    country: "US",
    name: {
      en : "Russian Mission"
    }
  },
  RSJ : {
    country: "US",
    name: {
      en : "Rosario"
    }
  },
  RSK : {
    country: "ID",
    name: {
      en : "Ransiki"
    }
  },
  RSN : {
    country: "US",
    name: {
      en : "Ruston"
    }
  },
  RST : {
    country: "US",
    name: {
      en : "Rochester"
    }
  },
  RSU : {
    country: "KR",
    name: {
      en : "Yeosu"
    }
  },
  RTA : {
    country: "FJ",
    name: {
      en : "Rotuma Island"
    }
  },
  RTB : {
    country: "HN",
    name: {
      en : "Roatan"
    }
  },
  RTG : {
    country: "ID",
    name: {
      en : "Ruteng"
    }
  },
  RTI : {
    country: "ID",
    name: {
      en : "Roti"
    }
  },
  RTM : {
    country: "NL",
    popularity: 10,
    name: {
      en : "Rotterdam"
    }
  },
  RTN : {
    country: "US",
    name: {
      en : "Raton"
    }
  },
  RTP : {
    country: "AU",
    name: {
      en : "Rutland Plains"
    }
  },
  RTS : {
    country: "AU",
    name: {
      en : "Rottnest"
    }
  },
  RTW : {
    country: "RU",
    popularity: 14,
    name: {
      en : "Saratov"
    }
  },
  RTY : {
    country: "AU",
    name: {
      en : "Merty"
    }
  },
  RUA : {
    country: "UG",
    name: {
      en : "Arua"
    }
  },
  RUD : {
    country: "IR",
    name: {
      en : "RUD"
    }
  },
  RUE : {
    country: "CD",
    name: {
      en : "RUE"
    }
  },
  RUH : {
    country: "SA",
    popularity: 4,
    name: {
      en : "Riyadh"
    }
  },
  RUI : {
    country: "US",
    name: {
      en : "Ruidoso"
    }
  },
  RUM : {
    country: "NP",
    name: {
      en : "Rumjatar"
    }
  },
  RUN : {
    country: "RE",
    name: {
      en : "Reunion Island"
    }
  },
  RUR : {
    country: "PF",
    name: {
      en : "Rurutu"
    }
  },
  RUS : {
    country: "SB",
    name: {
      en : "Marau"
    }
  },
  RUT : {
    country: "US",
    name: {
      en : "Rutland"
    }
  },
  RUY : {
    country: "HN",
    name: {
      en : "Copan"
    }
  },
  RVA : {
    country: "MG",
    name: {
      en : "Farafangana"
    }
  },
  RVD : {
    country: "BR",
    name: {
      en : "Rio Verde"
    }
  },
  RVE : {
    country: "CO",
    name: {
      en : "Saravena"
    }
  },
  RVK : {
    country: "NO",
    name: {
      en : "Roervik"
    }
  },
  RVN : {
    country: "FI",
    name: {
      en : "Rovaniemi"
    }
  },
  RVR : {
    country: "US",
    name: {
      en : "Green River"
    }
  },
  RVT : {
    country: "AU",
    name: {
      en : "Ravensthorpe"
    }
  },
  RVV : {
    country: "PF",
    name: {
      en : "Rairua"
    }
  },
  RWI : {
    country: "US",
    name: {
      en : "Rocky Mount"
    }
  },
  RWL : {
    country: "US",
    name: {
      en : "Rawlins"
    }
  },
  RWN : {
    country: "UA",
    name: {
      en : "Rovno"
    }
  },
  RWP : {
    country: "PK",
    name: {
      en : "Rawalpindi"
    }
  },
  RWS : {
    country: "BR",
    name: {
      en : "Sumare"
    }
  },
  RXS : {
    country: "PH",
    name: {
      en : "Roxas City"
    }
  },
  RYK : {
    country: "PK",
    name: {
      en : "Rahim Yar Khan"
    }
  },
  RYL : {
    country: "ZM",
    name: {
      en : "Lower Zambezi National Park"
    }
  },
  RYN : {
    country: "FR",
    name: {
      en : "Royan"
    }
  },
  RYO : {
    country: "AR",
    name: {
      en : "Rio Turbio"
    }
  },
  RZA : {
    country: "AR",
    name: {
      en : "Santa Cruz"
    }
  },
  RZE : {
    country: "PL",
    name: {
      en : "Rzeszow"
    }
  },
  RZH : {
    country: "RU",
    name: {
      en : "Preobrazheniye"
    }
  },
  RZP : {
    country: "PH",
    name: {
      en : "Taytay Sandoval"
    }
  },
  RZR : {
    country: "IR",
    name: {
      en : "Ramsar"
    }
  },
  RZS : {
    country: "PK",
    name: {
      en : "Sawan"
    }
  },
  RZV : {
    country: "TR",
    name: {
      en : "Rize"
    }
  },
  RZZ : {
    country: "US",
    name: {
      en : "Roanoke Rapids"
    }
  },
  SAB : {
    country: "BQ",
    name: {
      en : "Saba Island"
    }
  },
  SAC : {
    country: "US",
    name: {
      en : "Sacramento"
    }
  },
  SAD : {
    country: "US",
    name: {
      en : "Safford"
    }
  },
  SAF : {
    country: "US",
    name: {
      en : "Santa Fe"
    }
  },
  SAG : {
    country: "IN",
    name: {
      en : "Shirdi"
    }
  },
  SAH : {
    country: "YE",
    name: {
      en : "Sanaa"
    }
  },
  SAI : {
    country: "KH",
    name: {
      en : "Siem Reap"
    }
  },
  SAK : {
    country: "IS",
    name: {
      en : "Saudarkrokur"
    }
  },
  SAL : {
    country: "SV",
    name: {
      en : "San Salvador"
    }
  },
  SAM : {
    country: "PG",
    name: {
      en : "Salamo"
    }
  },
  SAN : {
    country: "US",
    name: {
      en : "San Diego"
    }
  },
  SAO : {
    country: "BR",
    popularity: 4,
    name: {
      en : "Sao Paulo"
    }
  },
  SAP : {
    country: "HN",
    name: {
      en : "San Pedro Sula"
    }
  },
  SAQ : {
    country: "BS",
    name: {
      en : "San Andros"
    }
  },
  SAR : {
    country: "US",
    name: {
      en : "Sparta"
    }
  },
  SAT : {
    country: "US",
    name: {
      en : "San Antonio"
    }
  },
  SAV : {
    country: "US",
    name: {
      en : "Savannah"
    }
  },
  SAX : {
    country: "PA",
    name: {
      en : "Sambu"
    }
  },
  SAY : {
    country: "IT",
    name: {
      en : "Siena"
    }
  },
  SBA : {
    country: "US",
    name: {
      en : "Santa Barbara"
    }
  },
  SBH : {
    country: "BL",
    popularity: 4,
    name: {
      en : "St Barthelemy"
    }
  },
  SBJ : {
    country: "BR",
    name: {
      en : "Sao Mateus"
    }
  },
  SBK : {
    country: "FR",
    name: {
      en : "St Brieuc"
    }
  },
  SBL : {
    country: "BO",
    name: {
      en : "Santa Ana"
    }
  },
  SBM : {
    country: "US",
    name: {
      en : "Sheboygan"
    }
  },
  SBN : {
    country: "US",
    name: {
      en : "South Bend"
    }
  },
  SBR : {
    country: "AU",
    name: {
      en : "Saibai Island"
    }
  },
  SBS : {
    country: "US",
    name: {
      en : "Steamboat Springs"
    }
  },
  SBT : {
    country: "RU",
    name: {
      en : "Sabetta"
    }
  },
  SBU : {
    country: "ZA",
    name: {
      en : "Springbok"
    }
  },
  SBV : {
    country: "PG",
    name: {
      en : "Sabah"
    }
  },
  SBW : {
    country: "MY",
    name: {
      en : "Sibu"
    }
  },
  SBY : {
    country: "US",
    name: {
      en : "Salisbury Ocean City"
    }
  },
  SBZ : {
    country: "RO",
    name: {
      en : "Sibiu"
    }
  },
  SCC : {
    country: "US",
    name: {
      en : "Prudhoe Bay Deadhorse"
    }
  },
  SCE : {
    country: "US",
    name: {
      en : "State College"
    }
  },
  SCF : {
    country: "US",
    name: {
      en : "Scottsdale"
    }
  },
  SCH : {
    country: "US",
    name: {
      en : "Schenectady"
    }
  },
  SCI : {
    country: "VE",
    name: {
      en : "San Crystobal"
    }
  },
  SCK : {
    country: "US",
    name: {
      en : "Stockton"
    }
  },
  SCL : {
    country: "CL",
    popularity: 128,
    name: {
      en : "Santiago"
    }
  },
  SCM : {
    country: "US",
    name: {
      en : "Scammon Bay"
    }
  },
  SCN : {
    country: "DE",
    name: {
      en : "Saarbruecken"
    }
  },
  SCO : {
    country: "KZ",
    name: {
      en : "Aktau"
    }
  },
  SCQ : {
    country: "ES",
    name: {
      en : "Santiago De Compostela"
    }
  },
  SCT : {
    country: "YE",
    name: {
      en : "Socotra"
    }
  },
  SCU : {
    country: "CU",
    popularity: 12,
    name: {
      en : "Santiago"
    }
  },
  SCV : {
    country: "RO",
    name: {
      en : "Suceava"
    }
  },
  SCW : {
    country: "RU",
    name: {
      en : "Syktyvkar"
    }
  },
  SCX : {
    country: "MX",
    name: {
      en : "Salina Cruz"
    }
  },
  SCY : {
    country: "EC",
    name: {
      en : "San Cristobal"
    }
  },
  SCZ : {
    country: "SB",
    name: {
      en : "Santa Cruz Island"
    }
  },
  SDB : {
    country: "ZA",
    name: {
      en : "Saldanha Bay"
    }
  },
  SDD : {
    country: "AO",
    name: {
      en : "Lubango"
    }
  },
  SDE : {
    country: "AR",
    name: {
      en : "Santiago Del Estero"
    }
  },
  SDF : {
    country: "US",
    popularity: 2,
    name: {
      en : "Louisville"
    }
  },
  SDG : {
    country: "IR",
    name: {
      en : "Sanandaj"
    }
  },
  SDI : {
    country: "PG",
    name: {
      en : "Saidor"
    }
  },
  SDJ : {
    country: "JP",
    name: {
      en : "Sendai"
    }
  },
  SDK : {
    country: "MY",
    name: {
      en : "Sandakan"
    }
  },
  SDL : {
    country: "SE",
    name: {
      en : "Sundsvall"
    }
  },
  SDN : {
    country: "NO",
    name: {
      en : "Sandane"
    }
  },
  SDP : {
    country: "US",
    name: {
      en : "Sand Point"
    }
  },
  SDQ : {
    country: "DO",
    popularity: 16,
    name: {
      en : "Santo Domingo"
    }
  },
  SDR : {
    country: "ES",
    name: {
      en : "Santander"
    }
  },
  SDT : {
    country: "PK",
    name: {
      en : "Saidu Sharif"
    }
  },
  SDX : {
    country: "US",
    name: {
      en : "Sedona"
    }
  },
  SDY : {
    country: "US",
    popularity: 2,
    name: {
      en : "Sidney"
    }
  },
  SDZ : {
    country: "GB",
    name: {
      en : "Shetland Islands Area"
    }
  },
  SEA : {
    country: "US",
    popularity: 8,
    name: {
      en : "Seattle"
    }
  },
  SEB : {
    country: "LY",
    name: {
      en : "Sebha"
    }
  },
  SEF : {
    country: "US",
    name: {
      en : "Sebring"
    }
  },
  SEK : {
    country: "RU",
    name: {
      en : "Srednekolymsk"
    }
  },
  SEL : {
    country: "KR",
    popularity: 15,
    name: {
      en : "Seoul"
    }
  },
  SEN : {
    country: "GB",
    name: {
      en : "Southend"
    }
  },
  SEO : {
    country: "CI",
    name: {
      en : "Seguela"
    }
  },
  SEP : {
    country: "US",
    name: {
      en : "Stephenville"
    }
  },
  SES : {
    country: "RU",
    popularity: 1,
    name: {
      en : "Svetlogorsk"
    }
  },
  SEU : {
    country: "TZ",
    name: {
      en : "Seronera"
    }
  },
  SEV : {
    country: "UA",
    name: {
      en : "SEV"
    }
  },
  SEY : {
    country: "MR",
    name: {
      en : "Selibaby"
    }
  },
  SEZ : {
    country: "SC",
    popularity: 16,
    name: {
      en : "Mahe Island"
    }
  },
  SFA : {
    country: "TN",
    name: {
      en : "Sfax"
    }
  },
  SFB : {
    country: "US",
    name: {
      en : "Sanford"
    }
  },
  SFC : {
    country: "GP",
    name: {
      en : "St Francois"
    }
  },
  SFD : {
    country: "VE",
    name: {
      en : "San Fernando"
    }
  },
  SFE : {
    country: "PH",
    name: {
      en : "San Fernando"
    }
  },
  SFG : {
    country: "MF",
    name: {
      en : "Saint Martin"
    }
  },
  SFH : {
    country: "MX",
    name: {
      en : "San Felipe"
    }
  },
  SFJ : {
    country: "GL",
    name: {
      en : "Kangerlussuaq"
    }
  },
  SFL : {
    country: "CV",
    name: {
      en : "Sao Filipe"
    }
  },
  SFM : {
    country: "US",
    name: {
      en : "Sanford"
    }
  },
  SFN : {
    country: "AR",
    name: {
      en : "Santa Fe"
    }
  },
  SFO : {
    country: "US",
    popularity: 198,
    name: {
      en : "San Francisco"
    }
  },
  SFP : {
    country: "AU",
    name: {
      en : "Surfers Paradise"
    }
  },
  SFQ : {
    country: "TR",
    name: {
      en : "Sanli Urfa"
    }
  },
  SFS : {
    country: "PH",
    name: {
      en : "Subic Bay"
    }
  },
  SFT : {
    country: "SE",
    popularity: 4,
    name: {
      en : "Skelleftea"
    }
  },
  SFU : {
    country: "PG",
    name: {
      en : "Safia"
    }
  },
  SFX : {
    country: "VE",
    name: {
      en : "San Felix"
    }
  },
  SFY : {
    country: "US",
    name: {
      en : "Springfield"
    }
  },
  SFZ : {
    country: "US",
    name: {
      en : "Smithfield"
    }
  },
  SGC : {
    country: "RU",
    popularity: 2,
    name: {
      en : "Surgut"
    }
  },
  SGD : {
    country: "DK",
    name: {
      en : "Sonderborg"
    }
  },
  SGE : {
    country: "DE",
    name: {
      en : "Siegen"
    }
  },
  SGF : {
    country: "US",
    name: {
      en : "Springfield"
    }
  },
  SGH : {
    country: "US",
    name: {
      en : "Springfield"
    }
  },
  SGJ : {
    country: "PG",
    name: {
      en : "Sagarai"
    }
  },
  SGK : {
    country: "PG",
    name: {
      en : "Sangapi"
    }
  },
  SGN : {
    country: "VN",
    popularity: 2,
    name: {
      en : "Ho Chi Minh City"
    }
  },
  SGO : {
    country: "AU",
    name: {
      en : "St George"
    }
  },
  SGR : {
    country: "US",
    name: {
      en : "Sugar Land"
    }
  },
  SGS : {
    country: "PH",
    name: {
      en : "Sanga Sanga"
    }
  },
  SGT : {
    country: "US",
    name: {
      en : "Stuttgart"
    }
  },
  SGU : {
    country: "US",
    name: {
      en : "St George"
    }
  },
  SGV : {
    country: "AR",
    name: {
      en : "Sierra Grande"
    }
  },
  SGX : {
    country: "TZ",
    name: {
      en : "Songea"
    }
  },
  SGY : {
    country: "US",
    name: {
      en : "Skagway"
    }
  },
  SHA : {
    country: "CN",
    popularity: 10,
    name: {
      en : "Shanghai"
    }
  },
  SHB : {
    country: "JP",
    name: {
      en : "Nakashibetsu"
    }
  },
  SHC : {
    country: "ET",
    name: {
      en : "Shire Indaselassie"
    }
  },
  SHD : {
    country: "US",
    name: {
      en : "Staunton"
    }
  },
  SHE : {
    country: "CN",
    name: {
      en : "Shenyang"
    }
  },
  SHF : {
    country: "CN",
    name: {
      en : "Shihezi"
    }
  },
  SHG : {
    country: "US",
    name: {
      en : "Shungnak"
    }
  },
  SHH : {
    country: "US",
    name: {
      en : "Shismaref"
    }
  },
  SHI : {
    country: "JP",
    name: {
      en : "Shimojishima"
    }
  },
  SHJ : {
    country: "AE",
    name: {
      en : "Sharjah"
    }
  },
  SHL : {
    country: "IN",
    name: {
      en : "Shillong"
    }
  },
  SHM : {
    country: "JP",
    name: {
      en : "Nanki Shirahama"
    }
  },
  SHO : {
    country: "KR",
    name: {
      en : "Sokcho"
    }
  },
  SHP : {
    country: "CN",
    name: {
      en : "Qinhuangdao"
    }
  },
  SHQ : {
    country: "AU",
    name: {
      en : "Southport"
    }
  },
  SHR : {
    country: "US",
    name: {
      en : "Sheridan"
    }
  },
  SHS : {
    country: "CN",
    name: {
      en : "Shashi"
    }
  },
  SHT : {
    country: "AU",
    name: {
      en : "Shepparton"
    }
  },
  SHV : {
    country: "US",
    name: {
      en : "Shreveport"
    }
  },
  SHW : {
    country: "SA",
    name: {
      en : "Sharurah"
    }
  },
  SHX : {
    country: "US",
    name: {
      en : "Shageluk"
    }
  },
  SHY : {
    country: "TZ",
    name: {
      en : "Shinyanga"
    }
  },
  SIA : {
    country: "CN",
    name: {
      en : "Xi An"
    }
  },
  SIC : {
    country: "TR",
    name: {
      en : "Sinop"
    }
  },
  SID : {
    country: "CV",
    popularity: 8,
    name: {
      en : "Sal Island"
    }
  },
  SIF : {
    country: "NP",
    name: {
      en : "Simara"
    }
  },
  SIG : {
    country: "US",
    name: {
      en : "Isla Grande"
    }
  },
  SIJ : {
    country: "IS",
    name: {
      en : "Siglufjordur"
    }
  },
  SIM : {
    country: "PG",
    name: {
      en : "Simbai"
    }
  },
  SIN : {
    country: "SG",
    popularity: 66,
    name: {
      en : "Singapore"
    }
  },
  SIO : {
    country: "AU",
    name: {
      en : "Smithton"
    }
  },
  SIP : {
    country: "AK",
    popularity: 138,
    name: {
      en : "Simferopol"
    }
  },
  SIQ : {
    country: "ID",
    name: {
      en : "Singkep"
    }
  },
  SIR : {
    country: "CH",
    name: {
      en : "Sion"
    }
  },
  SIS : {
    country: "ZA",
    name: {
      en : "Sishen"
    }
  },
  SIT : {
    country: "US",
    name: {
      en : "Sitka"
    }
  },
  SIX : {
    country: "AU",
    name: {
      en : "Singleton"
    }
  },
  SJB : {
    country: "BO",
    name: {
      en : "San Joaquin"
    }
  },
  SJC : {
    country: "US",
    name: {
      en : "San Jose"
    }
  },
  SJD : {
    country: "MX",
    name: {
      en : "San Jose Cabo"
    }
  },
  SJE : {
    country: "CO",
    name: {
      en : "San Jose Guaviare"
    }
  },
  SJF : {
    country: "US",
    name: {
      en : "St John"
    }
  },
  SJI : {
    country: "PH",
    name: {
      en : "San Jose"
    }
  },
  SJJ : {
    country: "BA",
    name: {
      en : "Sarajevo"
    }
  },
  SJK : {
    country: "BR",
    name: {
      en : "Sao Jose dos Campos"
    }
  },
  SJL : {
    country: "BR",
    name: {
      en : "Sao Gabriel"
    }
  },
  SJO : {
    country: "CR",
    popularity: 2,
    name: {
      en : "San Jose"
    }
  },
  SJP : {
    country: "BR",
    name: {
      en : "Sao Jose Do Rio Preto"
    }
  },
  SJT : {
    country: "US",
    name: {
      en : "San Angelo"
    }
  },
  SJU : {
    country: "PR",
    name: {
      en : "San Juan"
    }
  },
  SJW : {
    country: "CN",
    name: {
      en : "Shijiazhuang"
    }
  },
  SJY : {
    country: "FI",
    name: {
      en : "Seinajoki"
    }
  },
  SJZ : {
    country: "PT",
    name: {
      en : "Sao Jorge Island"
    }
  },
  SKB : {
    country: "KN",
    name: {
      en : "St Kitts"
    }
  },
  SKC : {
    country: "PG",
    name: {
      en : "Suki"
    }
  },
  SKD : {
    country: "UZ",
    name: {
      en : "Samarkand"
    }
  },
  SKE : {
    country: "NO",
    name: {
      en : "Skien"
    }
  },
  SKG : {
    country: "GR",
    popularity: 48,
    name: {
      en : "Thessaloniki"
    }
  },
  SKH : {
    country: "NP",
    name: {
      en : "Surkhet"
    }
  },
  SKK : {
    country: "US",
    name: {
      en : "Shaktoolik"
    }
  },
  SKL : {
    country: "GB",
    name: {
      en : "Isle of Skye"
    }
  },
  SKN : {
    country: "NO",
    name: {
      en : "Stokmarknes"
    }
  },
  SKO : {
    country: "NG",
    name: {
      en : "Sokoto"
    }
  },
  SKP : {
    country: "MK",
    popularity: 14,
    name: {
      en : "Skopje"
    }
  },
  SKS : {
    country: "DK",
    name: {
      en : "Skrydstrup"
    }
  },
  SKT : {
    country: "PK",
    name: {
      en : "Sialkot"
    }
  },
  SKU : {
    country: "GR",
    name: {
      en : "Skiros"
    }
  },
  SKV : {
    country: "EG",
    name: {
      en : "Santa Katarina"
    }
  },
  SKX : {
    country: "RU",
    name: {
      en : "Saransk"
    }
  },
  SKY : {
    country: "US",
    name: {
      en : "Sandusky"
    }
  },
  SKZ : {
    country: "PK",
    name: {
      en : "Sukkur"
    }
  },
  SLA : {
    country: "AR",
    name: {
      en : "Salta"
    }
  },
  SLC : {
    country: "US",
    name: {
      en : "Salt Lake City"
    }
  },
  SLD : {
    country: "SK",
    name: {
      en : "Sliac"
    }
  },
  SLE : {
    country: "US",
    name: {
      en : "Salem"
    }
  },
  SLH : {
    country: "VU",
    name: {
      en : "Sola"
    }
  },
  SLI : {
    country: "ZM",
    name: {
      en : "Solwezi"
    }
  },
  SLK : {
    country: "US",
    name: {
      en : "Saranac Lake"
    }
  },
  SLL : {
    country: "OM",
    name: {
      en : "Salalah"
    }
  },
  SLM : {
    country: "ES",
    name: {
      en : "Salamanca"
    }
  },
  SLN : {
    country: "US",
    name: {
      en : "Salina"
    }
  },
  SLP : {
    country: "MX",
    name: {
      en : "San Luis Potosi"
    }
  },
  SLQ : {
    country: "US",
    name: {
      en : "Sleetmute"
    }
  },
  SLS : {
    country: "BG",
    name: {
      en : "SLS"
    }
  },
  SLT : {
    country: "US",
    name: {
      en : "Salida"
    }
  },
  SLU : {
    country: "LC",
    name: {
      en : "St Lucia"
    }
  },
  SLV : {
    country: "IN",
    name: {
      en : "Simla"
    }
  },
  SLW : {
    country: "MX",
    name: {
      en : "Saltillo"
    }
  },
  SLX : {
    country: "TC",
    name: {
      en : "Salt Cay"
    }
  },
  SLY : {
    country: "RU",
    name: {
      en : "Salehard"
    }
  },
  SLZ : {
    country: "BR",
    name: {
      en : "Sao Luiz"
    }
  },
  SMA : {
    country: "PT",
    name: {
      en : "Santa Maria"
    }
  },
  SME : {
    country: "US",
    name: {
      en : "Somerset"
    }
  },
  SMF : {
    country: "US",
    name: {
      en : "Sacramento Cal"
    }
  },
  SMI : {
    country: "GR",
    popularity: 2,
    name: {
      en : "Samos"
    }
  },
  SMK : {
    country: "US",
    name: {
      en : "St Michael"
    }
  },
  SML : {
    country: "BS",
    name: {
      en : "Stella Maris"
    }
  },
  SMM : {
    country: "MY",
    name: {
      en : "Semporna"
    }
  },
  SMO : {
    country: "US",
    name: {
      en : "Santa Monica"
    }
  },
  SMP : {
    country: "PG",
    name: {
      en : "Stockholm"
    }
  },
  SMQ : {
    country: "ID",
    name: {
      en : "Sampit"
    }
  },
  SMR : {
    country: "CO",
    name: {
      en : "Santa Marta"
    }
  },
  SMS : {
    country: "MG",
    name: {
      en : "Saint Marie"
    }
  },
  SMV : {
    country: "CH",
    name: {
      en : "St Moritz"
    }
  },
  SMW : {
    country: "MA",
    name: {
      en : "Smara"
    }
  },
  SMX : {
    country: "US",
    name: {
      en : "Santa Maria"
    }
  },
  SNA : {
    country: "US",
    name: {
      en : "Santa Ana"
    }
  },
  SNB : {
    country: "AU",
    name: {
      en : "Snake Bay"
    }
  },
  SNC : {
    country: "EC",
    name: {
      en : "Salinas"
    }
  },
  SNE : {
    country: "CV",
    name: {
      en : "Sao Nicolau"
    }
  },
  SNF : {
    country: "VE",
    name: {
      en : "San Felipe"
    }
  },
  SNH : {
    country: "AU",
    name: {
      en : "Stanthorpe"
    }
  },
  SNI : {
    country: "LR",
    name: {
      en : "Sinoe"
    }
  },
  SNL : {
    country: "US",
    name: {
      en : "Shawnee"
    }
  },
  SNN : {
    country: "IE",
    name: {
      en : "Shannon"
    }
  },
  SNO : {
    country: "TH",
    name: {
      en : "Sakon Nakhon"
    }
  },
  SNP : {
    country: "US",
    name: {
      en : "St Paul Island"
    }
  },
  SNQ : {
    country: "MX",
    name: {
      en : "San Quintin"
    }
  },
  SNR : {
    country: "FR",
    name: {
      en : "St Nazaire"
    }
  },
  SNS : {
    country: "US",
    name: {
      en : "Salinas"
    }
  },
  SNU : {
    country: "CU",
    name: {
      en : "Santa Clara"
    }
  },
  SNW : {
    country: "MM",
    name: {
      en : "Sandoway"
    }
  },
  SNY : {
    country: "US",
    name: {
      en : "Sidney"
    }
  },
  SOB : {
    country: "HU",
    name: {
      en : "Hévíz"
    }
  },
  SOC : {
    country: "ID",
    name: {
      en : "Solo"
    }
  },
  SOD : {
    country: "BR",
    name: {
      en : "Sorocaba"
    }
  },
  SOF : {
    country: "BG",
    popularity: 22,
    name: {
      en : "Sofia"
    }
  },
  SOG : {
    country: "NO",
    name: {
      en : "Sogndal"
    }
  },
  SOI : {
    country: "AU",
    name: {
      en : "South Molle"
    }
  },
  SOJ : {
    country: "NO",
    name: {
      en : "Sorkjosen"
    }
  },
  SOM : {
    country: "VE",
    name: {
      en : "San Tome"
    }
  },
  SON : {
    country: "VU",
    name: {
      en : "Espiritu Santo"
    }
  },
  SOO : {
    country: "SE",
    name: {
      en : "Soderhamn"
    }
  },
  SOP : {
    country: "US",
    name: {
      en : "Pinehurst"
    }
  },
  SOQ : {
    country: "ID",
    name: {
      en : "Sorong"
    }
  },
  SOT : {
    country: "FI",
    name: {
      en : "Sodankyla"
    }
  },
  SOU : {
    country: "GB",
    name: {
      en : "Southampton"
    }
  },
  SOV : {
    country: "US",
    name: {
      en : "Seldovia"
    }
  },
  SOW : {
    country: "US",
    name: {
      en : "Show Low"
    }
  },
  SOY : {
    country: "GB",
    name: {
      en : "Stronsay"
    }
  },
  SPC : {
    country: "ES",
    name: {
      en : "Santa Cruz"
    }
  },
  SPD : {
    country: "BD",
    name: {
      en : "Saidpur"
    }
  },
  SPF : {
    country: "US",
    name: {
      en : "Spearfish"
    }
  },
  SPG : {
    country: "US",
    name: {
      en : "St Petersburg"
    }
  },
  SPH : {
    country: "PG",
    name: {
      en : "Sopu"
    }
  },
  SPI : {
    country: "US",
    name: {
      en : "Springfield"
    }
  },
  SPJ : {
    country: "GR",
    name: {
      en : "Sparta"
    }
  },
  SPK : {
    country: "JP",
    name: {
      en : "Sapporo"
    }
  },
  SPM : {
    country: "DE",
    name: {
      en : "Spangdahlem"
    }
  },
  SPN : {
    country: "MP",
    name: {
      en : "Saipan"
    }
  },
  SPP : {
    country: "AO",
    name: {
      en : "Menongue"
    }
  },
  SPQ : {
    country: "US",
    name: {
      en : "San Pedro"
    }
  },
  SPR : {
    country: "BZ",
    name: {
      en : "San Pedro"
    }
  },
  SPS : {
    country: "US",
    name: {
      en : "Wichita Falls"
    }
  },
  SPU : {
    country: "HR",
    popularity: 8,
    name: {
      en : "Split"
    }
  },
  SPW : {
    country: "US",
    name: {
      en : "Spencer"
    }
  },
  SPY : {
    country: "CI",
    name: {
      en : "San Pedro"
    }
  },
  SPZ : {
    country: "US",
    name: {
      en : "Springdale"
    }
  },
  SQA : {
    country: "US",
    name: {
      en : "Santa Ynez"
    }
  },
  SQC : {
    country: "AU",
    name: {
      en : "Southern Cross"
    }
  },
  SQD : {
    country: "CN",
    name: {
      en : "Shangrao"
    }
  },
  SQG : {
    country: "ID",
    name: {
      en : "Sintang"
    }
  },
  SQH : {
    country: "VN",
    popularity: 2,
    name: {
      en : "Son La"
    }
  },
  SQI : {
    country: "US",
    name: {
      en : "Sterling"
    }
  },
  SQL : {
    country: "US",
    name: {
      en : "San Carlos"
    }
  },
  SQM : {
    country: "BR",
    name: {
      en : "Sao Miguel do Araguaia"
    }
  },
  SQO : {
    country: "SE",
    popularity: 2,
    name: {
      en : "Storuman"
    }
  },
  SQV : {
    country: "US",
    name: {
      en : "Sequim"
    }
  },
  SRA : {
    country: "BR",
    name: {
      en : "Santa Rosa"
    }
  },
  SRE : {
    country: "BO",
    name: {
      en : "Sucre"
    }
  },
  SRF : {
    country: "US",
    name: {
      en : "San Rafael"
    }
  },
  SRG : {
    country: "ID",
    name: {
      en : "Semarang"
    }
  },
  SRI : {
    country: "ID",
    name: {
      en : "Samarinda"
    }
  },
  SRJ : {
    country: "BO",
    name: {
      en : "San Borja"
    }
  },
  SRL : {
    country: "MX",
    name: {
      en : "Santa Rosalia"
    }
  },
  SRN : {
    country: "AU",
    name: {
      en : "Strahan"
    }
  },
  SRP : {
    country: "NO",
    name: {
      en : "Stord"
    }
  },
  SRQ : {
    country: "US",
    name: {
      en : "Sarasota"
    }
  },
  SRU : {
    country: "US",
    name: {
      en : "Santa Cruz"
    }
  },
  SRV : {
    country: "US",
    name: {
      en : "Stony River"
    }
  },
  SRX : {
    country: "LY",
    name: {
      en : "Sert"
    }
  },
  SRY : {
    country: "IR",
    name: {
      en : "Sary"
    }
  },
  SRZ : {
    country: "BO",
    name: {
      en : "Santa Cruz"
    }
  },
  SSA : {
    country: "BR",
    name: {
      en : "Salvador"
    }
  },
  SSE : {
    country: "IN",
    name: {
      en : "Sholapur"
    }
  },
  SSG : {
    country: "GQ",
    name: {
      en : "Malabo"
    }
  },
  SSH : {
    country: "EG",
    popularity: 78,
    name: {
      en : "Sharm El Sheik"
    }
  },
  SSI : {
    country: "US",
    name: {
      en : "St Simons Is"
    }
  },
  SSJ : {
    country: "NO",
    name: {
      en : "Sandnessjoen"
    }
  },
  SSM : {
    country: "US",
    name: {
      en : "Sault Ste Marie"
    }
  },
  SSQ : {
    country: "CA",
    name: {
      en : "La Sarre"
    }
  },
  SSR : {
    country: "VU",
    name: {
      en : "Sara"
    }
  },
  SSS : {
    country: "PG",
    name: {
      en : "Siassi"
    }
  },
  SSX : {
    country: "TR",
    popularity: 1,
    name: {
      en : "Samsun"
    }
  },
  SSZ : {
    country: "BR",
    name: {
      en : "Santos"
    }
  },
  STA : {
    country: "DK",
    name: {
      en : "Stauning"
    }
  },
  STB : {
    country: "VE",
    name: {
      en : "Santa Barbara"
    }
  },
  STC : {
    country: "US",
    name: {
      en : "Saint Cloud"
    }
  },
  STD : {
    country: "VE",
    name: {
      en : "Santo Domingo"
    }
  },
  STE : {
    country: "US",
    name: {
      en : "Stevens Point"
    }
  },
  STG : {
    country: "US",
    name: {
      en : "St George Island"
    }
  },
  STI : {
    country: "DO",
    popularity: 4,
    name: {
      en : "Santiago"
    }
  },
  STJ : {
    country: "US",
    name: {
      en : "St Joseph"
    }
  },
  STK : {
    country: "US",
    name: {
      en : "Sterling"
    }
  },
  STL : {
    country: "US",
    popularity: 32,
    name: {
      en : "St Louis"
    }
  },
  STM : {
    country: "BR",
    name: {
      en : "Santarem"
    }
  },
  STO : {
    country: "SE",
    popularity: 128,
    name: {
      en : "Stockholm"
    }
  },
  STP : {
    country: "US",
    name: {
      en : "Saint Paul"
    }
  },
  STR : {
    country: "DE",
    popularity: 6,
    name: {
      en : "Stuttgart"
    }
  },
  STS : {
    country: "US",
    name: {
      en : "Santa Rosa"
    }
  },
  STT : {
    country: "VI",
    name: {
      en : "Saint Thomas"
    }
  },
  STV : {
    country: "IN",
    name: {
      en : "Surat"
    }
  },
  STW : {
    country: "RU",
    name: {
      en : "Stavropol"
    }
  },
  STX : {
    country: "VI",
    name: {
      en : "St Croix"
    }
  },
  STY : {
    country: "UY",
    name: {
      en : "Salto"
    }
  },
  STZ : {
    country: "BR",
    name: {
      en : "Santa Terezinha"
    }
  },
  SUA : {
    country: "US",
    name: {
      en : "Stuart"
    }
  },
  SUB : {
    country: "ID",
    name: {
      en : "Surabaya"
    }
  },
  SUE : {
    country: "US",
    name: {
      en : "Sturgeon Bay"
    }
  },
  SUF : {
    country: "IT",
    name: {
      en : "Lamezia Terme"
    }
  },
  SUG : {
    country: "PH",
    name: {
      en : "Surigao"
    }
  },
  SUH : {
    country: "OM",
    name: {
      en : "Sur Om"
    }
  },
  SUI : {
    country: "AB",
    name: {
      en : "Sukhumi"
    }
  },
  SUJ : {
    country: "RO",
    name: {
      en : "Satu Mare"
    }
  },
  SUK : {
    country: "RU",
    name: {
      en : "Batagay-Alyta"
    }
  },
  SUL : {
    country: "PK",
    name: {
      en : "Sui PK"
    }
  },
  SUM : {
    country: "US",
    name: {
      en : "Sumter"
    }
  },
  SUN : {
    country: "US",
    name: {
      en : "Sun Valley"
    }
  },
  SUR : {
    country: "CA",
    name: {
      en : "Summer Beaver"
    }
  },
  SUU : {
    country: "US",
    name: {
      en : "Fairfield"
    }
  },
  SUV : {
    country: "FJ",
    popularity: 2,
    name: {
      en : "Suva"
    }
  },
  SUW : {
    country: "US",
    name: {
      en : "Superior"
    }
  },
  SUX : {
    country: "US",
    name: {
      en : "Sioux City"
    }
  },
  SUY : {
    country: "RU",
    name: {
      en : "Suntar"
    }
  },
  SUZ : {
    country: "PG",
    name: {
      en : "Suria"
    }
  },
  SVA : {
    country: "US",
    name: {
      en : "Savoonga"
    }
  },
  SVB : {
    country: "MG",
    name: {
      en : "Sambava"
    }
  },
  SVC : {
    country: "US",
    name: {
      en : "Silver City"
    }
  },
  SVD : {
    country: "VC",
    name: {
      en : "St Vincent"
    }
  },
  SVE : {
    country: "US",
    name: {
      en : "Susanville"
    }
  },
  SVG : {
    country: "NO",
    name: {
      en : "Stavanger"
    }
  },
  SVH : {
    country: "US",
    name: {
      en : "Statesville"
    }
  },
  SVI : {
    country: "CO",
    name: {
      en : "San Vincent"
    }
  },
  SVJ : {
    country: "NO",
    name: {
      en : "Svolvaer"
    }
  },
  SVL : {
    country: "FI",
    name: {
      en : "Savonlinna"
    }
  },
  SVP : {
    country: "AO",
    name: {
      en : "Kuito"
    }
  },
  SVQ : {
    country: "ES",
    popularity: 8,
    name: {
      en : "Sevilla"
    }
  },
  SVS : {
    country: "US",
    name: {
      en : "Stevens Village"
    }
  },
  SVU : {
    country: "FJ",
    name: {
      en : "Savusavu"
    }
  },
  SVX : {
    country: "RU",
    popularity: 136,
    name: {
      en : "Ekaterinburg"
    }
  },
  SVZ : {
    country: "VE",
    name: {
      en : "San Antonio"
    }
  },
  SWA : {
    country: "CN",
    name: {
      en : "Shantou"
    }
  },
  SWC : {
    country: "AU",
    name: {
      en : "Stawell"
    }
  },
  SWD : {
    country: "US",
    name: {
      en : "Seward"
    }
  },
  SWF : {
    country: "US",
    name: {
      en : "Newburgh"
    }
  },
  SWG : {
    country: "PG",
    name: {
      en : "Satwag"
    }
  },
  SWH : {
    country: "AU",
    name: {
      en : "Swan Hill"
    }
  },
  SWI : {
    country: "GB",
    name: {
      en : "Swindon"
    }
  },
  SWJ : {
    country: "VU",
    name: {
      en : "South West Bay"
    }
  },
  SWO : {
    country: "US",
    name: {
      en : "Stillwater"
    }
  },
  SWP : {
    country: "NA",
    name: {
      en : "Swakopmund"
    }
  },
  SWQ : {
    country: "ID",
    name: {
      en : "Sumbawa"
    }
  },
  SWS : {
    country: "GB",
    name: {
      en : "Swansea"
    }
  },
  SWT : {
    country: "RU",
    name: {
      en : "Strzhewoi"
    }
  },
  SWV : {
    country: "RU",
    name: {
      en : "Evensk"
    }
  },
  SXB : {
    country: "FR",
    name: {
      en : "Strasbourg"
    }
  },
  SXD : {
    country: "FR",
    name: {
      en : "Sophia Antipolis"
    }
  },
  SXE : {
    country: "AU",
    name: {
      en : "Sale"
    }
  },
  SXL : {
    country: "IE",
    name: {
      en : "Sligo"
    }
  },
  SXM : {
    country: "SX",
    name: {
      en : "Sint Maarten"
    }
  },
  SXP : {
    country: "US",
    name: {
      en : "Sheldon Point"
    }
  },
  SXQ : {
    country: "US",
    name: {
      en : "Soldotna"
    }
  },
  SXR : {
    country: "IN",
    name: {
      en : "Srinagar"
    }
  },
  SXV : {
    country: "IN",
    name: {
      en : "Salem"
    }
  },
  SYA : {
    country: "US",
    name: {
      en : "Shemya Island"
    }
  },
  SYB : {
    country: "US",
    name: {
      en : "Seal Bay"
    }
  },
  SYD : {
    country: "AU",
    popularity: 124,
    name: {
      en : "Sydney"
    }
  },
  SYJ : {
    country: "IR",
    name: {
      en : "Sirjan"
    }
  },
  SYK : {
    country: "IS",
    name: {
      en : "Stykkisholmur"
    }
  },
  SYM : {
    country: "CN",
    name: {
      en : "Simao"
    }
  },
  SYO : {
    country: "JP",
    name: {
      en : "Shonai"
    }
  },
  SYP : {
    country: "PA",
    name: {
      en : "Santiago"
    }
  },
  SYR : {
    country: "US",
    name: {
      en : "Syracuse"
    }
  },
  SYS : {
    country: "RU",
    name: {
      en : "Saskylakh"
    }
  },
  SYX : {
    country: "CN",
    name: {
      en : "Sanya"
    }
  },
  SYY : {
    country: "GB",
    name: {
      en : "Stornoway"
    }
  },
  SYZ : {
    country: "IR",
    name: {
      en : "Shiraz"
    }
  },
  SZA : {
    country: "AO",
    name: {
      en : "Soyo"
    }
  },
  SZC : {
    country: "CR",
    name: {
      en : "Santa Cruz"
    }
  },
  SZD : {
    country: "GB",
    name: {
      en : "Sheffield"
    }
  },
  SZE : {
    country: "ET",
    name: {
      en : "Semera"
    }
  },
  SZF : {
    country: "TR",
    name: {
      en : "Samsun"
    }
  },
  SZG : {
    country: "AT",
    popularity: 8,
    name: {
      en : "Salzburg"
    }
  },
  SZJ : {
    country: "CU",
    name: {
      en : "Siguanea"
    }
  },
  SZK : {
    country: "ZA",
    name: {
      en : "Skukuza"
    }
  },
  SZO : {
    country: "CN",
    name: {
      en : "Shanzhou"
    }
  },
  SZP : {
    country: "US",
    name: {
      en : "Santa Paula"
    }
  },
  SZS : {
    country: "NZ",
    name: {
      en : "Stewart Island"
    }
  },
  SZT : {
    country: "MX",
    name: {
      en : "San Cristobal De Las Casas"
    }
  },
  SZV : {
    country: "CN",
    name: {
      en : "Suzhou"
    }
  },
  SZX : {
    country: "CN",
    name: {
      en : "Shenzhen"
    }
  },
  SZY : {
    country: "PL",
    name: {
      en : "Szymany"
    }
  },
  SZZ : {
    country: "PL",
    name: {
      en : "Szczecin"
    }
  },
  TAB : {
    country: "TT",
    name: {
      en : "Tobago"
    }
  },
  TAC : {
    country: "PH",
    name: {
      en : "Tacloban"
    }
  },
  TAD : {
    country: "US",
    name: {
      en : "Trinidad"
    }
  },
  TAE : {
    country: "KR",
    name: {
      en : "Daegu"
    }
  },
  TAG : {
    country: "PH",
    name: {
      en : "Tagbilaran"
    }
  },
  TAH : {
    country: "VU",
    name: {
      en : "Tanna"
    }
  },
  TAI : {
    country: "YE",
    name: {
      en : "Taiz"
    }
  },
  TAK : {
    country: "JP",
    name: {
      en : "Takamatsu"
    }
  },
  TAL : {
    country: "US",
    popularity: 2,
    name: {
      en : "Tanana"
    }
  },
  TAM : {
    country: "MX",
    name: {
      en : "Tampico"
    }
  },
  TAN : {
    country: "AU",
    name: {
      en : "Tangalooma"
    }
  },
  TAO : {
    country: "CN",
    name: {
      en : "Qingdao"
    }
  },
  TAP : {
    country: "MX",
    name: {
      en : "Tapachula"
    }
  },
  TAR : {
    country: "IT",
    name: {
      en : "Taranto"
    }
  },
  TAS : {
    country: "UZ",
    popularity: 30,
    name: {
      en : "Tashkent"
    }
  },
  TAT : {
    country: "SK",
    name: {
      en : "Poprad"
    }
  },
  TAY : {
    country: "EE",
    name: {
      en : "Tartu"
    }
  },
  TAZ : {
    country: "TM",
    name: {
      en : "Dashoguz"
    }
  },
  TBB : {
    country: "VN",
    name: {
      en : "Tuy Hoa"
    }
  },
  TBG : {
    country: "PG",
    name: {
      en : "Tububil"
    }
  },
  TBH : {
    country: "PH",
    name: {
      en : "Tablas"
    }
  },
  TBI : {
    country: "BS",
    name: {
      en : "The Bight"
    }
  },
  TBJ : {
    country: "TN",
    name: {
      en : "Tabarka"
    }
  },
  TBN : {
    country: "US",
    name: {
      en : "Ft Leonard Wood"
    }
  },
  TBO : {
    country: "TZ",
    name: {
      en : "Tabora"
    }
  },
  TBP : {
    country: "PE",
    name: {
      en : "Tumbes"
    }
  },
  TBS : {
    country: "GE",
    popularity: 14,
    name: {
      en : "Tbilisi"
    }
  },
  TBT : {
    country: "BR",
    name: {
      en : "Tabatinga"
    }
  },
  TBU : {
    country: "TO",
    name: {
      en : "Nuku Alofa"
    }
  },
  TBW : {
    country: "RU",
    name: {
      en : "Tambov"
    }
  },
  TBZ : {
    country: "IR",
    name: {
      en : "Tabriz"
    }
  },
  TCA : {
    country: "AU",
    name: {
      en : "Tennant Creek"
    }
  },
  TCB : {
    country: "BS",
    name: {
      en : "Treasure Cay"
    }
  },
  TCD : {
    country: "CO",
    name: {
      en : "Tarapaca"
    }
  },
  TCE : {
    country: "RO",
    name: {
      en : "Tulcea"
    }
  },
  TCG : {
    country: "CN",
    name: {
      en : "Tacheng"
    }
  },
  TCI : {
    country: "ES",
    popularity: 12,
    name: {
      en : "Tenerife"
    }
  },
  TCL : {
    country: "US",
    name: {
      en : "Tuscaloosa"
    }
  },
  TCN : {
    country: "MX",
    name: {
      en : "Tehuacan"
    }
  },
  TCO : {
    country: "CO",
    name: {
      en : "Tumaco"
    }
  },
  TCP : {
    country: "EG",
    name: {
      en : "Taba"
    }
  },
  TCQ : {
    country: "PE",
    name: {
      en : "Tacna"
    }
  },
  TCR : {
    country: "IN",
    name: {
      en : "Tuticorin"
    }
  },
  TCT : {
    country: "US",
    name: {
      en : "Takotna"
    }
  },
  TCU : {
    country: "ZA",
    name: {
      en : "Thaba Nchu"
    }
  },
  TCW : {
    country: "AU",
    name: {
      en : "Tocumwal"
    }
  },
  TCX : {
    country: "IR",
    name: {
      en : "Tabas"
    }
  },
  TCZ : {
    country: "CN",
    name: {
      en : "Tengchong"
    }
  },
  TDB : {
    country: "PG",
    name: {
      en : "Tetebedi"
    }
  },
  TDD : {
    country: "BO",
    name: {
      en : "Trinidad"
    }
  },
  TDK : {
    country: "KZ",
    name: {
      en : "Taldy Kurgan"
    }
  },
  TDL : {
    country: "AR",
    name: {
      en : "Tandil"
    }
  },
  TDX : {
    country: "TH",
    name: {
      en : "Trat"
    }
  },
  TEA : {
    country: "HN",
    name: {
      en : "Tela"
    }
  },
  TEB : {
    country: "US",
    name: {
      en : "Teterboro"
    }
  },
  TEC : {
    country: "BR",
    name: {
      en : "Telemaco Borba"
    }
  },
  TED : {
    country: "DK",
    name: {
      en : "Thisted"
    }
  },
  TEE : {
    country: "DZ",
    name: {
      en : "Tbessa"
    }
  },
  TEF : {
    country: "AU",
    name: {
      en : "Telfer"
    }
  },
  TEG : {
    country: "BF",
    name: {
      en : "Tenkodogo"
    }
  },
  TEK : {
    country: "US",
    name: {
      en : "Tatitlek"
    }
  },
  TEM : {
    country: "AU",
    name: {
      en : "Temora"
    }
  },
  TEN : {
    country: "CN",
    name: {
      en : "Tongren"
    }
  },
  TEO : {
    country: "PG",
    name: {
      en : "Terapo"
    }
  },
  TEP : {
    country: "PG",
    name: {
      en : "Teptep"
    }
  },
  TEQ : {
    country: "TR",
    name: {
      en : "Tekirdag"
    }
  },
  TER : {
    country: "PT",
    name: {
      en : "Terceira"
    }
  },
  TET : {
    country: "MZ",
    name: {
      en : "Tete"
    }
  },
  TEU : {
    country: "NZ",
    name: {
      en : "Te Anau"
    }
  },
  TEX : {
    country: "US",
    name: {
      en : "Telluride"
    }
  },
  TEY : {
    country: "IS",
    name: {
      en : "Thingeyri"
    }
  },
  TEZ : {
    country: "IN",
    name: {
      en : "Tezpur"
    }
  },
  TFC : {
    country: "IT",
    name: {
      en : "Taormina"
    }
  },
  TFF : {
    country: "BR",
    name: {
      en : "Tefe"
    }
  },
  TFI : {
    country: "PG",
    name: {
      en : "Tufi"
    }
  },
  TFL : {
    country: "BR",
    name: {
      en : "Teofilo Otoni"
    }
  },
  TFM : {
    country: "PG",
    name: {
      en : "Telefomin"
    }
  },
  TGC : {
    country: "MY",
    name: {
      en : "Trenton"
    }
  },
  TGD : {
    country: "ME",
    popularity: 64,
    name: {
      en : "Podgorica"
    }
  },
  TGG : {
    country: "MY",
    name: {
      en : "Kuala Terengganu"
    }
  },
  TGH : {
    country: "VU",
    name: {
      en : "Tongoa"
    }
  },
  TGI : {
    country: "PE",
    name: {
      en : "Tingo Maria"
    }
  },
  TGJ : {
    country: "NC",
    name: {
      en : "Tiga"
    }
  },
  TGK : {
    country: "RU",
    name: {
      en : "Taganrog"
    }
  },
  TGL : {
    country: "PG",
    name: {
      en : "Tagula"
    }
  },
  TGM : {
    country: "RO",
    name: {
      en : "Tirgu Mures"
    }
  },
  TGN : {
    country: "AU",
    name: {
      en : "Traralgon"
    }
  },
  TGO : {
    country: "CN",
    name: {
      en : "Tongliao"
    }
  },
  TGP : {
    country: "RU",
    name: {
      en : "Bor"
    }
  },
  TGR : {
    country: "DZ",
    name: {
      en : "Touggourt"
    }
  },
  TGT : {
    country: "TZ",
    name: {
      en : "Tanga"
    }
  },
  TGU : {
    country: "HN",
    name: {
      en : "Tegucigalpa"
    }
  },
  TGZ : {
    country: "MX",
    name: {
      en : "Tuxtla Gutierrez"
    }
  },
  THA : {
    country: "US",
    name: {
      en : "Tullahoma"
    }
  },
  THD : {
    country: "VN",
    name: {
      en : "Sao Vang"
    }
  },
  THE : {
    country: "BR",
    name: {
      en : "Teresina"
    }
  },
  THG : {
    country: "AU",
    name: {
      en : "Thangool"
    }
  },
  THL : {
    country: "MM",
    name: {
      en : "Tachilek"
    }
  },
  THN : {
    country: "SE",
    name: {
      en : "Trollhattan"
    }
  },
  THO : {
    country: "IS",
    name: {
      en : "Thorshofn"
    }
  },
  THP : {
    country: "US",
    name: {
      en : "Thermopolis"
    }
  },
  THQ : {
    country: "CN",
    name: {
      en : "THQ"
    }
  },
  THR : {
    country: "IR",
    name: {
      en : "Tehran"
    }
  },
  THS : {
    country: "TH",
    name: {
      en : "Sukhothai"
    }
  },
  THU : {
    country: "GL",
    name: {
      en : "Pituffik"
    }
  },
  THV : {
    country: "US",
    name: {
      en : "York"
    }
  },
  THX : {
    country: "RU",
    name: {
      en : "Turukhansk"
    }
  },
  TIA : {
    country: "AL",
    popularity: 8,
    name: {
      en : "Tirana"
    }
  },
  TID : {
    country: "DZ",
    name: {
      en : "Tiaret"
    }
  },
  TIF : {
    country: "SA",
    name: {
      en : "Taif"
    }
  },
  TIG : {
    country: "PG",
    name: {
      en : "Tingwon"
    }
  },
  TIH : {
    country: "PF",
    name: {
      en : "Tikehau"
    }
  },
  TII : {
    country: "AF",
    name: {
      en : "Tarinkot"
    }
  },
  TIJ : {
    country: "MX",
    name: {
      en : "Tijuana"
    }
  },
  TIM : {
    country: "ID",
    name: {
      en : "Timika"
    }
  },
  TIN : {
    country: "DZ",
    name: {
      en : "Tindouf"
    }
  },
  TIP : {
    country: "LY",
    popularity: 74,
    name: {
      en : "Tripoli"
    }
  },
  TIQ : {
    country: "MP",
    name: {
      en : "Tinian"
    }
  },
  TIR : {
    country: "IN",
    name: {
      en : "Tirupati"
    }
  },
  TIS : {
    country: "AU",
    name: {
      en : "Thursday Island"
    }
  },
  TIU : {
    country: "NZ",
    name: {
      en : "Timaru"
    }
  },
  TIV : {
    country: "ME",
    popularity: 66,
    name: {
      en : "Tivat"
    }
  },
  TIW : {
    country: "US",
    name: {
      en : "Tacoma"
    }
  },
  TIX : {
    country: "US",
    name: {
      en : "Titusville"
    }
  },
  TIZ : {
    country: "PG",
    name: {
      en : "Tari"
    }
  },
  TJA : {
    country: "BO",
    name: {
      en : "Tarija"
    }
  },
  TJM : {
    country: "RU",
    popularity: 20,
    name: {
      en : "Tyumen"
    }
  },
  TJN : {
    country: "PF",
    name: {
      en : "Takume"
    }
  },
  TJQ : {
    country: "ID",
    name: {
      en : "Tanjung Pandan"
    }
  },
  TJU : {
    country: "TJ",
    name: {
      en : "Kulob"
    }
  },
  TKD : {
    country: "GH",
    name: {
      en : "Takoradi"
    }
  },
  TKE : {
    country: "US",
    name: {
      en : "Tenakee"
    }
  },
  TKF : {
    country: "US",
    name: {
      en : "Truckee"
    }
  },
  TKG : {
    country: "ID",
    name: {
      en : "Bandar Lampung"
    }
  },
  TKJ : {
    country: "US",
    name: {
      en : "Tok Ak"
    }
  },
  TKK : {
    country: "FM",
    name: {
      en : "Truk"
    }
  },
  TKM : {
    country: "RU",
    name: {
      en : "Taksimo"
    }
  },
  TKN : {
    country: "JP",
    name: {
      en : "Tokunoshima"
    }
  },
  TKP : {
    country: "PF",
    name: {
      en : "Takapoto"
    }
  },
  TKQ : {
    country: "TZ",
    name: {
      en : "Kigoma"
    }
  },
  TKS : {
    country: "JP",
    name: {
      en : "Tokushima"
    }
  },
  TKT : {
    country: "TH",
    name: {
      en : "Tak TH"
    }
  },
  TKU : {
    country: "FI",
    name: {
      en : "Turku"
    }
  },
  TKV : {
    country: "PF",
    name: {
      en : "Tatakoto"
    }
  },
  TKX : {
    country: "PF",
    name: {
      en : "Takaroa"
    }
  },
  TLA : {
    country: "US",
    name: {
      en : "Teller"
    }
  },
  TLC : {
    country: "MX",
    name: {
      en : "Toluca"
    }
  },
  TLD : {
    country: "BW",
    name: {
      en : "Tuli Block"
    }
  },
  TLE : {
    country: "MG",
    name: {
      en : "Tulear"
    }
  },
  TLH : {
    country: "US",
    name: {
      en : "Tallahassee"
    }
  },
  TLJ : {
    country: "US",
    name: {
      en : "Tatalina"
    }
  },
  TLK : {
    country: "RU",
    name: {
      en : "Talakan"
    }
  },
  TLL : {
    country: "EE",
    popularity: 10,
    name: {
      en : "Tallinn"
    }
  },
  TLM : {
    country: "DZ",
    name: {
      en : "Tlemcen"
    }
  },
  TLN : {
    country: "FR",
    popularity: 12,
    name: {
      en : "Toulon"
    }
  },
  TLO : {
    country: "PG",
    name: {
      en : "Tol PG"
    }
  },
  TLQ : {
    country: "CN",
    name: {
      en : "TLQ"
    }
  },
  TLR : {
    country: "US",
    name: {
      en : "Tulare"
    }
  },
  TLS : {
    country: "FR",
    name: {
      en : "Toulouse"
    }
  },
  TLT : {
    country: "US",
    name: {
      en : "Tuluksak"
    }
  },
  TLV : {
    country: "IL",
    popularity: 441,
    name: {
      en : "Tel Aviv"
    }
  },
  TLY : {
    country: "RU",
    name: {
      en : "TLY"
    }
  },
  TMA : {
    country: "US",
    name: {
      en : "Tifton"
    }
  },
  TMC : {
    country: "ID",
    name: {
      en : "Tambolaka"
    }
  },
  TME : {
    country: "CO",
    name: {
      en : "Tame"
    }
  },
  TMG : {
    country: "MY",
    name: {
      en : "Tomanggong"
    }
  },
  TMI : {
    country: "NP",
    name: {
      en : "Tumling Tar"
    }
  },
  TMJ : {
    country: "UZ",
    name: {
      en : "Termez"
    }
  },
  TML : {
    country: "GH",
    name: {
      en : "Tamale"
    }
  },
  TMM : {
    country: "MG",
    name: {
      en : "Tamatave"
    }
  },
  TMP : {
    country: "FI",
    name: {
      en : "Tampere"
    }
  },
  TMR : {
    country: "DZ",
    name: {
      en : "Tamenghest"
    }
  },
  TMS : {
    country: "ST",
    name: {
      en : "Sao Tome"
    }
  },
  TMT : {
    country: "BR",
    name: {
      en : "Trombetas"
    }
  },
  TMU : {
    country: "CR",
    name: {
      en : "Tambor"
    }
  },
  TMW : {
    country: "AU",
    name: {
      en : "Tamworth"
    }
  },
  TMX : {
    country: "DZ",
    name: {
      en : "Timimoun"
    }
  },
  TMZ : {
    country: "NZ",
    name: {
      en : "Thames"
    }
  },
  TNA : {
    country: "CN",
    name: {
      en : "Jinan"
    }
  },
  TNC : {
    country: "US",
    name: {
      en : "Tin City"
    }
  },
  TND : {
    country: "CU",
    name: {
      en : "Trinidad"
    }
  },
  TNE : {
    country: "JP",
    name: {
      en : "Tanega Shima"
    }
  },
  TNF : {
    country: "FR",
    name: {
      en : "Toussus Le Noble"
    }
  },
  TNG : {
    country: "MA",
    name: {
      en : "Tangier"
    }
  },
  TNH : {
    country: "CN",
    name: {
      en : "Tonghua"
    }
  },
  TNJ : {
    country: "ID",
    name: {
      en : "Tanjung Pinang"
    }
  },
  TNK : {
    country: "US",
    name: {
      en : "Tununak"
    }
  },
  TNL : {
    country: "UA",
    name: {
      en : "Ternopol"
    }
  },
  TNN : {
    country: "TW",
    name: {
      en : "Tainan"
    }
  },
  TNO : {
    country: "CR",
    name: {
      en : "Tamarindo"
    }
  },
  TNP : {
    country: "US",
    name: {
      en : "Twenty Nine Palms"
    }
  },
  TNR : {
    country: "MG",
    name: {
      en : "Antananarivo"
    }
  },
  TNU : {
    country: "US",
    name: {
      en : "Newton"
    }
  },
  TNV : {
    country: "KI",
    name: {
      en : "Tabuaeran"
    }
  },
  TOA : {
    country: "US",
    name: {
      en : "Torrance"
    }
  },
  TOB : {
    country: "LY",
    popularity: 4,
    name: {
      en : "Tobruk"
    }
  },
  TOC : {
    country: "US",
    name: {
      en : "Toccoa"
    }
  },
  TOD : {
    country: "MY",
    name: {
      en : "Tioman"
    }
  },
  TOE : {
    country: "TN",
    name: {
      en : "Tozeur"
    }
  },
  TOF : {
    country: "RU",
    popularity: 10,
    name: {
      en : "Tomsk"
    }
  },
  TOG : {
    country: "US",
    name: {
      en : "Togiak"
    }
  },
  TOH : {
    country: "VU",
    name: {
      en : "Torres"
    }
  },
  TOK : {
    country: "PG",
    name: {
      en : "Torokina"
    }
  },
  TOL : {
    country: "US",
    name: {
      en : "Toledo"
    }
  },
  TOM : {
    country: "ML",
    name: {
      en : "Tombouctou"
    }
  },
  TON : {
    country: "PG",
    name: {
      en : "Tonu"
    }
  },
  TOP : {
    country: "US",
    name: {
      en : "Topeka"
    }
  },
  TOR : {
    country: "US",
    name: {
      en : "Torrington"
    }
  },
  TOS : {
    country: "NO",
    name: {
      en : "Tromso"
    }
  },
  TOU : {
    country: "NC",
    name: {
      en : "Touho"
    }
  },
  TOV : {
    country: "VG",
    name: {
      en : "Tortola Westend"
    }
  },
  TOW : {
    country: "BR",
    name: {
      en : "Toledo"
    }
  },
  TOX : {
    country: "RU",
    name: {
      en : "Tobolsk"
    }
  },
  TOY : {
    country: "JP",
    name: {
      en : "Toyama"
    }
  },
  TPA : {
    country: "US",
    name: {
      en : "Tampa"
    }
  },
  TPE : {
    country: "TW",
    popularity: 2,
    name: {
      en : "Taipei"
    }
  },
  TPH : {
    country: "US",
    name: {
      en : "Tonopah"
    }
  },
  TPI : {
    country: "PG",
    name: {
      en : "Tapini"
    }
  },
  TPL : {
    country: "US",
    name: {
      en : "Temple"
    }
  },
  TPP : {
    country: "PE",
    name: {
      en : "Tarapoto"
    }
  },
  TPQ : {
    country: "MX",
    name: {
      en : "Tepic"
    }
  },
  TPR : {
    country: "AU",
    name: {
      en : "Tom Price"
    }
  },
  TPS : {
    country: "IT",
    name: {
      en : "Trapani"
    }
  },
  TPU : {
    country: "NP",
    name: {
      en : "Tikapur"
    }
  },
  TQD : {
    country: "IQ",
    name: {
      en : "TQD"
    }
  },
  TQL : {
    country: "RU",
    name: {
      en : "TQL"
    }
  },
  TQR : {
    country: "IT",
    name: {
      en : "San Domino Island"
    }
  },
  TRA : {
    country: "JP",
    name: {
      en : "Taramajima"
    }
  },
  TRC : {
    country: "MX",
    name: {
      en : "Torreon"
    }
  },
  TRD : {
    country: "NO",
    name: {
      en : "Trondheim"
    }
  },
  TRE : {
    country: "GB",
    name: {
      en : "Tiree"
    }
  },
  TRG : {
    country: "NZ",
    name: {
      en : "Tauranga"
    }
  },
  TRI : {
    country: "US",
    name: {
      en : "Bristol"
    }
  },
  TRK : {
    country: "ID",
    name: {
      en : "Tarakan"
    }
  },
  TRL : {
    country: "US",
    name: {
      en : "Terrell"
    }
  },
  TRN : {
    country: "IT",
    popularity: 16,
    name: {
      en : "Turin"
    }
  },
  TRO : {
    country: "AU",
    name: {
      en : "Taree"
    }
  },
  TRS : {
    country: "IT",
    name: {
      en : "Trieste"
    }
  },
  TRU : {
    country: "PE",
    name: {
      en : "Trujillo"
    }
  },
  TRV : {
    country: "IN",
    popularity: 4,
    name: {
      en : "Thiruvananthapuram"
    }
  },
  TRW : {
    country: "KI",
    name: {
      en : "Tarawa"
    }
  },
  TRZ : {
    country: "IN",
    name: {
      en : "Tiruchirappali"
    }
  },
  TSB : {
    country: "NA",
    name: {
      en : "Tsumeb"
    }
  },
  TSF : {
    country: "IT",
    name: {
      en : "Treviso"
    }
  },
  TSJ : {
    country: "JP",
    name: {
      en : "Tsushima"
    }
  },
  TSM : {
    country: "US",
    name: {
      en : "Taos"
    }
  },
  TSN : {
    country: "CN",
    name: {
      en : "Tianjin"
    }
  },
  TSP : {
    country: "US",
    name: {
      en : "Tehachapi"
    }
  },
  TSQ : {
    country: "BR",
    name: {
      en : "Torres"
    }
  },
  TSR : {
    country: "RO",
    name: {
      en : "Timisoara"
    }
  },
  TST : {
    country: "TH",
    name: {
      en : "Trang"
    }
  },
  TSV : {
    country: "AU",
    name: {
      en : "Townsville"
    }
  },
  TTA : {
    country: "MA",
    name: {
      en : "Tan Tan"
    }
  },
  TTB : {
    country: "IT",
    name: {
      en : "Tortoli"
    }
  },
  TTD : {
    country: "US",
    name: {
      en : "Troutdale"
    }
  },
  TTE : {
    country: "ID",
    name: {
      en : "Ternate"
    }
  },
  TTJ : {
    country: "JP",
    name: {
      en : "Tottori"
    }
  },
  TTL : {
    country: "FJ",
    name: {
      en : "Turtle Island"
    }
  },
  TTN : {
    country: "US",
    name: {
      en : "Trenton"
    }
  },
  TTQ : {
    country: "CR",
    name: {
      en : "Tortuquero"
    }
  },
  TTR : {
    country: "ID",
    name: {
      en : "Tana Toraja"
    }
  },
  TTT : {
    country: "TW",
    name: {
      en : "Taitung"
    }
  },
  TTU : {
    country: "MA",
    name: {
      en : "Tetuan"
    }
  },
  TUA : {
    country: "EC",
    name: {
      en : "Tulcan"
    }
  },
  TUB : {
    country: "PF",
    name: {
      en : "Tubuai"
    }
  },
  TUC : {
    country: "AR",
    name: {
      en : "Tucuman"
    }
  },
  TUD : {
    country: "SN",
    name: {
      en : "Tambacounda"
    }
  },
  TUE : {
    country: "PA",
    name: {
      en : "Tupile"
    }
  },
  TUF : {
    country: "FR",
    name: {
      en : "Tours"
    }
  },
  TUG : {
    country: "PH",
    name: {
      en : "Tuguegarao"
    }
  },
  TUI : {
    country: "SA",
    name: {
      en : "Turaif"
    }
  },
  TUK : {
    country: "PK",
    name: {
      en : "Turbat"
    }
  },
  TUL : {
    country: "US",
    name: {
      en : "Tulsa"
    }
  },
  TUM : {
    country: "AU",
    name: {
      en : "Tumut"
    }
  },
  TUN : {
    country: "TN",
    name: {
      en : "Tunis"
    }
  },
  TUO : {
    country: "NZ",
    name: {
      en : "Taupo"
    }
  },
  TUP : {
    country: "US",
    name: {
      en : "Tupelo"
    }
  },
  TUR : {
    country: "BR",
    name: {
      en : "Tucurui"
    }
  },
  TUS : {
    country: "US",
    name: {
      en : "Tucson"
    }
  },
  TUU : {
    country: "SA",
    name: {
      en : "Tabuk"
    }
  },
  TUV : {
    country: "VE",
    name: {
      en : "Tucupita"
    }
  },
  TUW : {
    country: "PA",
    name: {
      en : "Tubala"
    }
  },
  TUY : {
    country: "MX",
    name: {
      en : "Tulum"
    }
  },
  TUZ : {
    country: "BR",
    name: {
      en : "Tucuma"
    }
  },
  TVC : {
    country: "US",
    name: {
      en : "Traverse City"
    }
  },
  TVF : {
    country: "US",
    name: {
      en : "Thief River Falls"
    }
  },
  TVL : {
    country: "US",
    popularity: 4,
    name: {
      en : "Lake Tahoe"
    }
  },
  TVS : {
    country: "CN",
    name: {
      en : "Tangshan"
    }
  },
  TVU : {
    country: "FJ",
    name: {
      en : "Taveuni"
    }
  },
  TVY : {
    country: "MM",
    name: {
      en : "Tavoy"
    }
  },
  TWA : {
    country: "US",
    name: {
      en : "Twin Hills"
    }
  },
  TWB : {
    country: "AU",
    name: {
      en : "Toowoomba"
    }
  },
  TWF : {
    country: "US",
    name: {
      en : "Twin Falls"
    }
  },
  TWT : {
    country: "PH",
    name: {
      en : "Tawitawi"
    }
  },
  TWU : {
    country: "MY",
    name: {
      en : "Tawau"
    }
  },
  TXF : {
    country: "BR",
    name: {
      en : "Teixeira De Freitas"
    }
  },
  TXG : {
    country: "TW",
    name: {
      en : "Taichung"
    }
  },
  TXK : {
    country: "US",
    name: {
      en : "Texarkana"
    }
  },
  TXN : {
    country: "CN",
    name: {
      en : "Tunxi"
    }
  },
  TYD : {
    country: "RU",
    name: {
      en : "Tynda"
    }
  },
  TYF : {
    country: "SE",
    name: {
      en : "Torsby"
    }
  },
  TYL : {
    country: "PE",
    name: {
      en : "Talara"
    }
  },
  TYN : {
    country: "CN",
    name: {
      en : "Taiyuan"
    }
  },
  TYO : {
    country: "JP",
    popularity: 57,
    name: {
      en : "Tokyo"
    }
  },
  TYR : {
    country: "US",
    name: {
      en : "Tyler"
    }
  },
  TYS : {
    country: "US",
    name: {
      en : "Knoxville"
    }
  },
  TZL : {
    country: "BA",
    name: {
      en : "Tuzla"
    }
  },
  TZN : {
    country: "BS",
    name: {
      en : "South Andros"
    }
  },
  TZX : {
    country: "TR",
    name: {
      en : "Trabzon"
    }
  },
  UAC : {
    country: "MX",
    name: {
      en : "San Luis Rio Colorado"
    }
  },
  UAH : {
    country: "PF",
    name: {
      en : "Ua Huka"
    }
  },
  UAI : {
    country: "TL",
    name: {
      en : "Suai"
    }
  },
  UAK : {
    country: "GL",
    name: {
      en : "Narsarsuaq"
    }
  },
  UAP : {
    country: "PF",
    name: {
      en : "Ua Pou"
    }
  },
  UAQ : {
    country: "AR",
    name: {
      en : "San Juan"
    }
  },
  UAS : {
    country: "KE",
    name: {
      en : "Samburu"
    }
  },
  UBA : {
    country: "BR",
    name: {
      en : "Uberaba"
    }
  },
  UBB : {
    country: "AU",
    name: {
      en : "Mabuiag Island"
    }
  },
  UBJ : {
    country: "JP",
    name: {
      en : "Ube Jp"
    }
  },
  UBN : {
    country: "MN",
    popularity: 14,
    name: {
      en : "Ulaanbaatar"
    }
  },
  UBP : {
    country: "TH",
    name: {
      en : "Ubon Ratchathani"
    }
  },
  UBS : {
    country: "US",
    name: {
      en : "Columbus"
    }
  },
  UCA : {
    country: "US",
    name: {
      en : "Utica"
    }
  },
  UCK : {
    country: "UA",
    name: {
      en : "Lutsk"
    }
  },
  UCT : {
    country: "RU",
    name: {
      en : "Ukhta"
    }
  },
  UDD : {
    country: "US",
    name: {
      en : "Palm Desert"
    }
  },
  UDE : {
    country: "NL",
    name: {
      en : "Uden"
    }
  },
  UDI : {
    country: "BR",
    name: {
      en : "Uberlandia"
    }
  },
  UDJ : {
    country: "UA",
    name: {
      en : "Uzhgorod"
    }
  },
  UDN : {
    country: "IT",
    name: {
      en : "Udine"
    }
  },
  UDR : {
    country: "IN",
    name: {
      en : "Udaipur"
    }
  },
  UEE : {
    country: "AU",
    name: {
      en : "Queenstown"
    }
  },
  UEL : {
    country: "MZ",
    name: {
      en : "Quelimane"
    }
  },
  UEO : {
    country: "JP",
    name: {
      en : "Kume Jima"
    }
  },
  UER : {
    country: "ES",
    name: {
      en : "Puertollano"
    }
  },
  UET : {
    country: "PK",
    name: {
      en : "Quetta"
    }
  },
  UFA : {
    country: "RU",
    popularity: 50,
    name: {
      en : "Ufa"
    }
  },
  UGC : {
    country: "UZ",
    name: {
      en : "Urgench"
    }
  },
  UGI : {
    country: "US",
    name: {
      en : "Uganik"
    }
  },
  UGN : {
    country: "US",
    name: {
      en : "Waukegan"
    }
  },
  UGT : {
    country: "MN",
    name: {
      en : "Umnugobitour"
    }
  },
  UHE : {
    country: "CZ",
    name: {
      en : "Uherske Hradiste"
    }
  },
  UIB : {
    country: "CO",
    name: {
      en : "Quibdo"
    }
  },
  UIH : {
    country: "VN",
    name: {
      en : "Qui Nhon"
    }
  },
  UII : {
    country: "HN",
    name: {
      en : "Utila"
    }
  },
  UIK : {
    country: "RU",
    name: {
      en : "Ust-Ilimsk"
    }
  },
  UIN : {
    country: "US",
    name: {
      en : "Quincy"
    }
  },
  UIO : {
    country: "EC",
    popularity: 48,
    name: {
      en : "Quito"
    }
  },
  UIP : {
    country: "FR",
    name: {
      en : "Quimper"
    }
  },
  UIR : {
    country: "AU",
    name: {
      en : "Quirindi"
    }
  },
  UKA : {
    country: "KE",
    name: {
      en : "Ukunda"
    }
  },
  UKB : {
    country: "JP",
    name: {
      en : "Kobe"
    }
  },
  UKG : {
    country: "RU",
    name: {
      en : "Ust-Kuyga"
    }
  },
  UKI : {
    country: "US",
    name: {
      en : "Ukiah"
    }
  },
  UKK : {
    country: "KZ",
    name: {
      en : "Ust Kamenogorsk"
    }
  },
  UKS : {
    country: "AK",
    name: {
      en : "Sevastopol"
    }
  },
  UKT : {
    country: "US",
    name: {
      en : "Quakertown"
    }
  },
  UKU : {
    country: "PG",
    name: {
      en : "Nuku"
    }
  },
  UKX : {
    country: "RU",
    name: {
      en : "Ust-Kut"
    }
  },
  UKY : {
    country: "JP",
    name: {
      en : "Kyoto"
    }
  },
  ULA : {
    country: "AR",
    name: {
      en : "San Julian"
    }
  },
  ULB : {
    country: "VU",
    name: {
      en : "Ulei"
    }
  },
  ULD : {
    country: "ZA",
    name: {
      en : "Ulundi"
    }
  },
  ULE : {
    country: "PG",
    name: {
      en : "Sule"
    }
  },
  ULG : {
    country: "MN",
    name: {
      en : "Ulgit"
    }
  },
  ULK : {
    country: "RU",
    name: {
      en : "Lensk"
    }
  },
  ULM : {
    country: "US",
    name: {
      en : "New Ulm"
    }
  },
  ULN : {
    country: "MN",
    popularity: 14,
    name: {
      en : "Ulaanbaatar"
    }
  },
  ULO : {
    country: "MN",
    name: {
      en : "Ulaangom"
    }
  },
  ULP : {
    country: "AU",
    name: {
      en : "Quilpie"
    }
  },
  ULU : {
    country: "UG",
    name: {
      en : "Gulu"
    }
  },
  ULX : {
    country: "ZA",
    name: {
      en : "Ulusaba"
    }
  },
  ULY : {
    country: "RU",
    name: {
      en : "Ulyanovsk"
    }
  },
  ULZ : {
    country: "MN",
    name: {
      en : "Uliastai"
    }
  },
  UMD : {
    country: "GL",
    name: {
      en : "Uummannaq"
    }
  },
  UME : {
    country: "SE",
    name: {
      en : "Umea"
    }
  },
  UMR : {
    country: "AU",
    name: {
      en : "Woomera"
    }
  },
  UMS : {
    country: "RU",
    name: {
      en : "Ust-Maya"
    }
  },
  UMU : {
    country: "BR",
    name: {
      en : "Umuarama"
    }
  },
  UMY : {
    country: "UA",
    name: {
      en : "Sumy"
    }
  },
  UNA : {
    country: "BR",
    name: {
      en : "Una BR"
    }
  },
  UND : {
    country: "AF",
    name: {
      en : "Kunduz"
    }
  },
  UNG : {
    country: "PG",
    name: {
      en : "Kiunga"
    }
  },
  UNI : {
    country: "VC",
    name: {
      en : "Union Island"
    }
  },
  UNK : {
    country: "US",
    name: {
      en : "Unalakleet"
    }
  },
  UNN : {
    country: "TH",
    name: {
      en : "Ranong"
    }
  },
  UNT : {
    country: "GB",
    name: {
      en : "Unst"
    }
  },
  UOX : {
    country: "US",
    name: {
      en : "University-Oxford"
    }
  },
  UPF : {
    country: "DE",
    name: {
      en : "Pforzheim"
    }
  },
  UPG : {
    country: "ID",
    name: {
      en : "Ujung Pandang"
    }
  },
  UPN : {
    country: "MX",
    name: {
      en : "Uruapan"
    }
  },
  URA : {
    country: "KZ",
    name: {
      en : "Uralsk"
    }
  },
  URC : {
    country: "CN",
    name: {
      en : "Urumqi"
    }
  },
  URE : {
    country: "EE",
    name: {
      en : "Kuressaare"
    }
  },
  URG : {
    country: "BR",
    name: {
      en : "Uruguaina"
    }
  },
  URJ : {
    country: "RU",
    name: {
      en : "Uraj"
    }
  },
  URO : {
    country: "FR",
    name: {
      en : "Rouen"
    }
  },
  URS : {
    country: "RU",
    name: {
      en : "Kursk"
    }
  },
  URT : {
    country: "TH",
    name: {
      en : "Surat Thani"
    }
  },
  URY : {
    country: "SA",
    name: {
      en : "Gurayat"
    }
  },
  USH : {
    country: "AR",
    popularity: 2,
    name: {
      en : "Ushuaia"
    }
  },
  USJ : {
    country: "KZ",
    name: {
      en : "Usharal"
    }
  },
  USK : {
    country: "RU",
    name: {
      en : "Usinsk"
    }
  },
  USL : {
    country: "AU",
    name: {
      en : "Useless Loop"
    }
  },
  USM : {
    country: "TH",
    popularity: 8,
    name: {
      en : "Ko Samui"
    }
  },
  USN : {
    country: "KR",
    name: {
      en : "Ulsan"
    }
  },
  USQ : {
    country: "TR",
    name: {
      en : "Usak"
    }
  },
  USR : {
    country: "RU",
    name: {
      en : "Ust-Nera"
    }
  },
  USS : {
    country: "CU",
    name: {
      en : "Sancti Spiritus"
    }
  },
  UST : {
    country: "US",
    name: {
      en : "St Augustine"
    }
  },
  USU : {
    country: "PH",
    name: {
      en : "Busuanga"
    }
  },
  UTA : {
    country: "ZW",
    name: {
      en : "Mutare"
    }
  },
  UTC : {
    country: "NL",
    name: {
      en : "Utrecht"
    }
  },
  UTH : {
    country: "TH",
    name: {
      en : "Udon Thani"
    }
  },
  UTL : {
    country: "ES",
    name: {
      en : "Torremolinos"
    }
  },
  UTM : {
    country: "US",
    name: {
      en : "Tunica"
    }
  },
  UTN : {
    country: "ZA",
    name: {
      en : "Upington"
    }
  },
  UTO : {
    country: "US",
    name: {
      en : "Utopia"
    }
  },
  UTP : {
    country: "TH",
    popularity: 100,
    name: {
      en : "Pattaya"
    }
  },
  UTS : {
    country: "RU",
    name: {
      en : "Ust-Tsilma"
    }
  },
  UTT : {
    country: "ZA",
    name: {
      en : "Umtata"
    }
  },
  UTU : {
    country: "PA",
    name: {
      en : "Ustupo"
    }
  },
  UTW : {
    country: "ZA",
    name: {
      en : "Queenstown"
    }
  },
  UUA : {
    country: "RU",
    name: {
      en : "Bugulma"
    }
  },
  UUD : {
    country: "RU",
    popularity: 8,
    name: {
      en : "Ulan Ude"
    }
  },
  UUS : {
    country: "RU",
    popularity: 2,
    name: {
      en : "Yuzhno Sakhalinsk"
    }
  },
  UUU : {
    country: "PG",
    name: {
      en : "Manumu"
    }
  },
  UVE : {
    country: "NC",
    name: {
      en : "Ouvea"
    }
  },
  UVF : {
    country: "LC",
    name: {
      en : "Vieux Fort St Lucia"
    }
  },
  UVL : {
    country: "EG",
    name: {
      en : "Kharga"
    }
  },
  UVO : {
    country: "PG",
    name: {
      en : "Uvol"
    }
  },
  UWE : {
    country: "DE",
    name: {
      en : "Wiesbaden"
    }
  },
  UWP : {
    country: "DE",
    name: {
      en : "Wuppertal"
    }
  },
  UYL : {
    country: "SD",
    name: {
      en : "Nyala"
    }
  },
  UYN : {
    country: "CN",
    name: {
      en : "Yulin"
    }
  },
  UYU : {
    country: "BO",
    name: {
      en : "Uyuni"
    }
  },
  VAA : {
    country: "FI",
    name: {
      en : "Vaasa"
    }
  },
  VAF : {
    country: "FR",
    name: {
      en : "Valence"
    }
  },
  VAG : {
    country: "BR",
    name: {
      en : "Varginha"
    }
  },
  VAI : {
    country: "PG",
    name: {
      en : "Vanimo"
    }
  },
  VAK : {
    country: "US",
    name: {
      en : "Chevak"
    }
  },
  VAL : {
    country: "BR",
    name: {
      en : "Valenca"
    }
  },
  VAN : {
    country: "TR",
    name: {
      en : "Van"
    }
  },
  VAO : {
    country: "SB",
    name: {
      en : "Suavanao"
    }
  },
  VAP : {
    country: "CL",
    name: {
      en : "Valparaiso"
    }
  },
  VAR : {
    country: "BG",
    popularity: 10,
    name: {
      en : "Varna"
    }
  },
  VAS : {
    country: "TR",
    name: {
      en : "Sivas"
    }
  },
  VAV : {
    country: "TO",
    name: {
      en : "Vava U"
    }
  },
  VAW : {
    country: "NO",
    name: {
      en : "Vardoe"
    }
  },
  VAZ : {
    country: "FR",
    name: {
      en : "Val D Isere"
    }
  },
  VBM : {
    country: "US",
    name: {
      en : "VBM"
    }
  },
  VBV : {
    country: "FJ",
    name: {
      en : "Vanuabalavu"
    }
  },
  VBY : {
    country: "SE",
    name: {
      en : "Visby"
    }
  },
  VCA : {
    country: "VN",
    name: {
      en : "Can Tho"
    }
  },
  VCE : {
    country: "IT",
    popularity: 86,
    name: {
      en : "Venice"
    }
  },
  VCL : {
    country: "VN",
    name: {
      en : "Tamky"
    }
  },
  VCS : {
    country: "VN",
    name: {
      en : "Con Dao"
    }
  },
  VCT : {
    country: "US",
    name: {
      en : "Victoria"
    }
  },
  VCV : {
    country: "US",
    name: {
      en : "Victorville"
    }
  },
  VDA : {
    country: "IL",
    name: {
      en : "Ovda"
    }
  },
  VDB : {
    country: "NO",
    name: {
      en : "Fagernes"
    }
  },
  VDC : {
    country: "BR",
    name: {
      en : "Vitoria Da Conquista"
    }
  },
  VDD : {
    country: "AT",
    name: {
      en : "VDD"
    }
  },
  VDE : {
    country: "ES",
    name: {
      en : "Valverde"
    }
  },
  VDH : {
    country: "VN",
    name: {
      en : "Dong Hoi"
    }
  },
  VDI : {
    country: "US",
    name: {
      en : "Vidalia"
    }
  },
  VDM : {
    country: "AR",
    name: {
      en : "Viedma"
    }
  },
  VDP : {
    country: "VE",
    name: {
      en : "Valle de la Pascua"
    }
  },
  VDS : {
    country: "NO",
    name: {
      en : "Vadso"
    }
  },
  VDZ : {
    country: "US",
    name: {
      en : "Valdez"
    }
  },
  VEE : {
    country: "US",
    name: {
      en : "Venetie"
    }
  },
  VEJ : {
    country: "DK",
    name: {
      en : "Vejle"
    }
  },
  VEL : {
    country: "US",
    name: {
      en : "Vernal"
    }
  },
  VEO : {
    country: "RU",
    name: {
      en : "Severo-Yeniseysky"
    }
  },
  VER : {
    country: "MX",
    name: {
      en : "Veracruz"
    }
  },
  VEY : {
    country: "IS",
    name: {
      en : "Vestmannaeyjar"
    }
  },
  VFA : {
    country: "ZW",
    name: {
      en : "Victoria Falls"
    }
  },
  VGA : {
    country: "IN",
    name: {
      en : "Vijayawada"
    }
  },
  VGD : {
    country: "RU",
    name: {
      en : "Vologda"
    }
  },
  VGO : {
    country: "ES",
    name: {
      en : "Vigo"
    }
  },
  VGZ : {
    country: "CO",
    name: {
      en : "Villagarzon"
    }
  },
  VHC : {
    country: "AO",
    name: {
      en : "Saurimo"
    }
  },
  VHM : {
    country: "SE",
    name: {
      en : "Vilhelmina"
    }
  },
  VHN : {
    country: "US",
    name: {
      en : "Van Horn"
    }
  },
  VHV : {
    country: "RU",
    name: {
      en : "Verkhnevilyuysk"
    }
  },
  VHY : {
    country: "FR",
    name: {
      en : "Vichy"
    }
  },
  VHZ : {
    country: "PF",
    name: {
      en : "Vahitahi"
    }
  },
  VIB : {
    country: "MX",
    name: {
      en : "Villa Constitucion"
    }
  },
  VIC : {
    country: "IT",
    name: {
      en : "Vicenza"
    }
  },
  VIE : {
    country: "AT",
    popularity: 420,
    name: {
      en : "Vienna"
    }
  },
  VIF : {
    country: "IT",
    name: {
      en : "Vieste"
    }
  },
  VIG : {
    country: "VE",
    name: {
      en : "El Vigia"
    }
  },
  VII : {
    country: "VN",
    name: {
      en : "Vinh City"
    }
  },
  VIJ : {
    country: "VG",
    name: {
      en : "Virgin Gorda"
    }
  },
  VIK : {
    country: "US",
    name: {
      en : "Kavik"
    }
  },
  VIL : {
    country: "MA",
    name: {
      en : "Dakhla"
    }
  },
  VIN : {
    country: "UA",
    name: {
      en : "Vinnitsa"
    }
  },
  VIQ : {
    country: "TL",
    name: {
      en : "Viqueque"
    }
  },
  VIS : {
    country: "US",
    name: {
      en : "Visalia"
    }
  },
  VIT : {
    country: "ES",
    name: {
      en : "Vitoria"
    }
  },
  VIV : {
    country: "PG",
    name: {
      en : "Vivigani"
    }
  },
  VIX : {
    country: "BR",
    name: {
      en : "Vitoria"
    }
  },
  VJI : {
    country: "US",
    name: {
      en : "Abingdon"
    }
  },
  VKG : {
    country: "VN",
    name: {
      en : "Rach Gia"
    }
  },
  VKS : {
    country: "US",
    name: {
      en : "Vicksburg"
    }
  },
  VKT : {
    country: "RU",
    name: {
      en : "Vorkuta"
    }
  },
  VLA : {
    country: "US",
    name: {
      en : "Vandalia"
    }
  },
  VLC : {
    country: "ES",
    popularity: 86,
    name: {
      en : "Valencia"
    }
  },
  VLD : {
    country: "US",
    name: {
      en : "Valdosta"
    }
  },
  VLG : {
    country: "AR",
    name: {
      en : "Villa Gesell"
    }
  },
  VLI : {
    country: "VU",
    name: {
      en : "Port Vila"
    }
  },
  VLK : {
    country: "RU",
    name: {
      en : "Volgodonsk"
    }
  },
  VLL : {
    country: "ES",
    name: {
      en : "Valladolid"
    }
  },
  VLN : {
    country: "VE",
    name: {
      en : "Valencia"
    }
  },
  VLO : {
    country: "US",
    name: {
      en : "Vallejo"
    }
  },
  VLS : {
    country: "VU",
    name: {
      en : "Valesdir"
    }
  },
  VLU : {
    country: "RU",
    name: {
      en : "Velikiye Luki"
    }
  },
  VLV : {
    country: "VE",
    name: {
      en : "Valera"
    }
  },
  VLY : {
    country: "GB",
    name: {
      en : "Anglesey"
    }
  },
  VME : {
    country: "AR",
    name: {
      en : "Villa Mercedes"
    }
  },
  VMI : {
    country: "PY",
    name: {
      en : "Vallemi"
    }
  },
  VMU : {
    country: "PG",
    name: {
      en : "Balimuru"
    }
  },
  VNC : {
    country: "US",
    popularity: 2,
    name: {
      en : "Venice"
    }
  },
  VNE : {
    country: "FR",
    name: {
      en : "Vannes"
    }
  },
  VNO : {
    country: "LT",
    popularity: 64,
    name: {
      en : "Vilnius"
    }
  },
  VNR : {
    country: "AU",
    name: {
      en : "Vanrook"
    }
  },
  VNS : {
    country: "IN",
    name: {
      en : "Varanasi"
    }
  },
  VNX : {
    country: "MZ",
    name: {
      en : "Vilanculos"
    }
  },
  VOG : {
    country: "RU",
    popularity: 38,
    name: {
      en : "Volgograd"
    }
  },
  VOL : {
    country: "GR",
    name: {
      en : "Volos"
    }
  },
  VOT : {
    country: "BR",
    name: {
      en : "Votuporanga"
    }
  },
  VOZ : {
    country: "RU",
    name: {
      en : "Voronezh"
    }
  },
  VPE : {
    country: "AO",
    name: {
      en : "Ongiva"
    }
  },
  VPG : {
    country: "KE",
    name: {
      en : "Vipingo"
    }
  },
  VPN : {
    country: "IS",
    name: {
      en : "Vopnafjordur"
    }
  },
  VPS : {
    country: "US",
    name: {
      en : "Valparaiso"
    }
  },
  VPY : {
    country: "MZ",
    name: {
      en : "Chimoio"
    }
  },
  VPZ : {
    country: "US",
    name: {
      en : "Valparaiso"
    }
  },
  VQS : {
    country: "PR",
    name: {
      en : "Vieques"
    }
  },
  VRA : {
    country: "CU",
    popularity: 10,
    name: {
      en : "Varadero"
    }
  },
  VRB : {
    country: "US",
    name: {
      en : "Vero Beach"
    }
  },
  VRC : {
    country: "PH",
    name: {
      en : "Virac"
    }
  },
  VRK : {
    country: "FI",
    name: {
      en : "Varkaus"
    }
  },
  VRL : {
    country: "PT",
    name: {
      en : "Vila Real"
    }
  },
  VRN : {
    country: "IT",
    popularity: 22,
    name: {
      en : "Verona"
    }
  },
  VRO : {
    country: "CU",
    name: {
      en : "Matanzas"
    }
  },
  VRY : {
    country: "NO",
    name: {
      en : "Vaeroy"
    }
  },
  VSA : {
    country: "MX",
    name: {
      en : "Villahermosa"
    }
  },
  VSE : {
    country: "PT",
    name: {
      en : "Viseu"
    }
  },
  VSF : {
    country: "US",
    name: {
      en : "Springfield"
    }
  },
  VST : {
    country: "SE",
    name: {
      en : "Vasteras"
    }
  },
  VTB : {
    country: "BY",
    name: {
      en : "Vitebsk"
    }
  },
  VTE : {
    country: "LA",
    name: {
      en : "Vientiane"
    }
  },
  VTG : {
    country: "VN",
    name: {
      en : "Vung Tau"
    }
  },
  VTL : {
    country: "FR",
    name: {
      en : "Vittel"
    }
  },
  VTN : {
    country: "US",
    name: {
      en : "Valentine"
    }
  },
  VTU : {
    country: "CU",
    name: {
      en : "Las Tunas"
    }
  },
  VTZ : {
    country: "IN",
    name: {
      en : "Vishakhapatanam"
    }
  },
  VUP : {
    country: "CO",
    name: {
      en : "Valleduper"
    }
  },
  VUS : {
    country: "RU",
    name: {
      en : "Velikij Ustyug"
    }
  },
  VVC : {
    country: "CO",
    name: {
      en : "Villavicencio"
    }
  },
  VVK : {
    country: "SE",
    name: {
      en : "Vastervik"
    }
  },
  VVO : {
    country: "RU",
    popularity: 64,
    name: {
      en : "Vladivostok"
    }
  },
  VVZ : {
    country: "DZ",
    name: {
      en : "Illizi"
    }
  },
  VXC : {
    country: "MZ",
    name: {
      en : "Lichinga"
    }
  },
  VXE : {
    country: "CV",
    popularity: 2,
    name: {
      en : "Sao Vicente"
    }
  },
  VXO : {
    country: "SE",
    name: {
      en : "Vaxjo"
    }
  },
  VYD : {
    country: "ZA",
    name: {
      en : "Vryheid"
    }
  },
  VYS : {
    country: "US",
    name: {
      en : "Peru"
    }
  },
  WAA : {
    country: "US",
    name: {
      en : "Wales"
    }
  },
  WAC : {
    country: "ET",
    name: {
      en : "Waca"
    }
  },
  WAE : {
    country: "SA",
    name: {
      en : "Wadi Ad Dawasir"
    }
  },
  WAG : {
    country: "NZ",
    name: {
      en : "Wanganui"
    }
  },
  WAH : {
    country: "US",
    name: {
      en : "Wahpeton"
    }
  },
  WAI : {
    country: "MG",
    name: {
      en : "Antsohihy"
    }
  },
  WAL : {
    country: "US",
    name: {
      en : "Chincoteague"
    }
  },
  WAO : {
    country: "PG",
    name: {
      en : "Wabo"
    }
  },
  WAS : {
    country: "US",
    popularity: 31,
    name: {
      en : "Washington"
    }
  },
  WAT : {
    country: "IE",
    name: {
      en : "Waterford"
    }
  },
  WAW : {
    country: "PL",
    popularity: 256,
    name: {
      en : "Warsaw"
    }
  },
  WAZ : {
    country: "AU",
    name: {
      en : "Warwick"
    }
  },
  WBB : {
    country: "US",
    name: {
      en : "Stebbins"
    }
  },
  WBM : {
    country: "PG",
    name: {
      en : "Wapenamanda"
    }
  },
  WBQ : {
    country: "US",
    name: {
      en : "Beaver"
    }
  },
  WBU : {
    country: "US",
    name: {
      en : "Boulder"
    }
  },
  WDG : {
    country: "US",
    name: {
      en : "Enid"
    }
  },
  WDH : {
    country: "NA",
    name: {
      en : "Windhoek"
    }
  },
  WDS : {
    country: "CN",
    name: {
      en : "Shiyan"
    }
  },
  WEA : {
    country: "US",
    name: {
      en : "Weatherford"
    }
  },
  WED : {
    country: "PG",
    name: {
      en : "Wedau"
    }
  },
  WEF : {
    country: "CN",
    name: {
      en : "Weifang"
    }
  },
  WEH : {
    country: "CN",
    name: {
      en : "Weihai"
    }
  },
  WEI : {
    country: "AU",
    name: {
      en : "Weipa"
    }
  },
  WEL : {
    country: "ZA",
    name: {
      en : "Welkom"
    }
  },
  WEW : {
    country: "AU",
    name: {
      en : "Wee Waa"
    }
  },
  WEX : {
    country: "IE",
    name: {
      en : "Wexford"
    }
  },
  WFK : {
    country: "US",
    name: {
      en : "Frenchville"
    }
  },
  WGA : {
    country: "AU",
    name: {
      en : "Wagga Wagga"
    }
  },
  WGE : {
    country: "AU",
    name: {
      en : "Walgett"
    }
  },
  WGN : {
    country: "NZ",
    name: {
      en : "Waitangi"
    }
  },
  WGO : {
    country: "US",
    name: {
      en : "Winchester"
    }
  },
  WGP : {
    country: "ID",
    name: {
      en : "Waingapu"
    }
  },
  WGT : {
    country: "AU",
    name: {
      en : "Wangaratta"
    }
  },
  WHK : {
    country: "NZ",
    name: {
      en : "Whakatane"
    }
  },
  WHL : {
    country: "AU",
    name: {
      en : "Welshpool"
    }
  },
  WHO : {
    country: "NZ",
    name: {
      en : "Franz Josef"
    }
  },
  WHS : {
    country: "GB",
    name: {
      en : "Whalsay"
    }
  },
  WHT : {
    country: "US",
    name: {
      en : "Wharton"
    }
  },
  WHU : {
    country: "CN",
    name: {
      en : "Wuhu"
    }
  },
  WIC : {
    country: "GB",
    name: {
      en : "Wick"
    }
  },
  WIN : {
    country: "AU",
    name: {
      en : "Winton"
    }
  },
  WIU : {
    country: "PG",
    name: {
      en : "Witu"
    }
  },
  WJA : {
    country: "MH",
    name: {
      en : "Woja"
    }
  },
  WJF : {
    country: "US",
    name: {
      en : "Lancaster"
    }
  },
  WJR : {
    country: "KE",
    name: {
      en : "Wajir"
    }
  },
  WJU : {
    country: "KR",
    name: {
      en : "WonJu"
    }
  },
  WKA : {
    country: "NZ",
    name: {
      en : "Wanaka"
    }
  },
  WKJ : {
    country: "JP",
    name: {
      en : "Wakkanai"
    }
  },
  WKK : {
    country: "US",
    name: {
      en : "Aleknagik"
    }
  },
  WKN : {
    country: "PG",
    name: {
      en : "Wakunai"
    }
  },
  WLD : {
    country: "US",
    name: {
      en : "Winfield"
    }
  },
  WLG : {
    country: "NZ",
    popularity: 18,
    name: {
      en : "Wellington"
    }
  },
  WLH : {
    country: "VU",
    name: {
      en : "Walaha"
    }
  },
  WLK : {
    country: "US",
    name: {
      en : "Selawik"
    }
  },
  WLL : {
    country: "AU",
    name: {
      en : "Wollogorang"
    }
  },
  WLM : {
    country: "US",
    name: {
      en : "Waltham"
    }
  },
  WLS : {
    country: "WF",
    name: {
      en : "Wallis Island"
    }
  },
  WMB : {
    country: "AU",
    name: {
      en : "Warrnambool"
    }
  },
  WMC : {
    country: "US",
    name: {
      en : "Winnemucca"
    }
  },
  WMH : {
    country: "US",
    name: {
      en : "Mountain Home"
    }
  },
  WMK : {
    country: "US",
    name: {
      en : "Meyers Chuck"
    }
  },
  WMN : {
    country: "MG",
    name: {
      en : "Maroantsetra"
    }
  },
  WMO : {
    country: "US",
    name: {
      en : "White Mountain"
    }
  },
  WNA : {
    country: "US",
    name: {
      en : "Napakiak"
    }
  },
  WNH : {
    country: "CN",
    name: {
      en : "WNH"
    }
  },
  WNN : {
    country: "CA",
    name: {
      en : "Wunnummin Lake"
    }
  },
  WNP : {
    country: "PH",
    name: {
      en : "Naga"
    }
  },
  WNR : {
    country: "AU",
    name: {
      en : "Windorah"
    }
  },
  WNS : {
    country: "PK",
    name: {
      en : "Nawabshah"
    }
  },
  WNZ : {
    country: "CN",
    name: {
      en : "Wenzhou"
    }
  },
  WOL : {
    country: "AU",
    name: {
      en : "Wollongong"
    }
  },
  WPA : {
    country: "CL",
    name: {
      en : "Puerto Aisen"
    }
  },
  WPB : {
    country: "MG",
    name: {
      en : "Port Berge"
    }
  },
  WPM : {
    country: "PG",
    name: {
      en : "Wipim"
    }
  },
  WRE : {
    country: "NZ",
    name: {
      en : "Whangarei"
    }
  },
  WRG : {
    country: "US",
    name: {
      en : "Wrangell"
    }
  },
  WRL : {
    country: "US",
    name: {
      en : "Worland"
    }
  },
  WRO : {
    country: "PL",
    name: {
      en : "Wroclaw"
    }
  },
  WRY : {
    country: "GB",
    name: {
      en : "Westray"
    }
  },
  WSG : {
    country: "US",
    name: {
      en : "Washington"
    }
  },
  WSN : {
    country: "US",
    name: {
      en : "South Naknek"
    }
  },
  WST : {
    country: "US",
    name: {
      en : "Westerly"
    }
  },
  WSU : {
    country: "PG",
    name: {
      en : "Wasu"
    }
  },
  WSX : {
    country: "US",
    name: {
      en : "Westsound"
    }
  },
  WSY : {
    country: "AU",
    name: {
      en : "Airlie Beach"
    }
  },
  WSZ : {
    country: "NZ",
    name: {
      en : "Westport"
    }
  },
  WTB : {
    country: "AU",
    name: {
      en : "Toowoomba"
    }
  },
  WTD : {
    country: "BS",
    name: {
      en : "West End"
    }
  },
  WTK : {
    country: "US",
    name: {
      en : "Noatak"
    }
  },
  WTL : {
    country: "US",
    name: {
      en : "Tuntatuliak"
    }
  },
  WTP : {
    country: "PG",
    name: {
      en : "Woitape"
    }
  },
  WUA : {
    country: "CN",
    name: {
      en : "Wuhai"
    }
  },
  WUG : {
    country: "PG",
    name: {
      en : "Wau PG"
    }
  },
  WUH : {
    country: "CN",
    name: {
      en : "Wuhan"
    }
  },
  WUN : {
    country: "AU",
    name: {
      en : "Wiluna"
    }
  },
  WUS : {
    country: "CN",
    name: {
      en : "Wuyishan"
    }
  },
  WUT : {
    country: "CN",
    name: {
      en : "Dingxiang County"
    }
  },
  WUV : {
    country: "PG",
    name: {
      en : "Wuvulu Island"
    }
  },
  WUX : {
    country: "CN",
    name: {
      en : "Wuxi"
    }
  },
  WUZ : {
    country: "CN",
    name: {
      en : "Wuzhou"
    }
  },
  WVB : {
    country: "NA",
    name: {
      en : "Walvis Bay"
    }
  },
  WVI : {
    country: "US",
    name: {
      en : "Watsonville"
    }
  },
  WVL : {
    country: "US",
    name: {
      en : "Waterville"
    }
  },
  WVN : {
    country: "DE",
    name: {
      en : "Wilhelmshaven"
    }
  },
  WWD : {
    country: "US",
    name: {
      en : "Cape May"
    }
  },
  WWK : {
    country: "PG",
    name: {
      en : "Wewak"
    }
  },
  WWP : {
    country: "US",
    name: {
      en : "Whale Pass"
    }
  },
  WWR : {
    country: "US",
    name: {
      en : "Woodward"
    }
  },
  WWT : {
    country: "US",
    name: {
      en : "Newtok"
    }
  },
  WWY : {
    country: "AU",
    name: {
      en : "West Wyalong"
    }
  },
  WXF : {
    country: "GB",
    name: {
      en : "Braintree"
    }
  },
  WXN : {
    country: "CN",
    name: {
      en : "Wanxian"
    }
  },
  WYA : {
    country: "AU",
    name: {
      en : "Whyalla"
    }
  },
  WYN : {
    country: "AU",
    name: {
      en : "Wyndham"
    }
  },
  WYS : {
    country: "US",
    name: {
      en : "West Yellowstone"
    }
  },
  XAB : {
    country: "FR",
    name: {
      en : "Abbeville"
    }
  },
  XAC : {
    country: "FR",
    name: {
      en : "Arcachon"
    }
  },
  XAG : {
    country: "FR",
    name: {
      en : "Agde"
    }
  },
  XAH : {
    country: "DK",
    name: {
      en : "Silkeborg"
    }
  },
  XAI : {
    country: "CN",
    name: {
      en : "Xinyang"
    }
  },
  XAK : {
    country: "DK",
    name: {
      en : "Herning"
    }
  },
  XAL : {
    country: "MX",
    name: {
      en : "Alamos"
    }
  },
  XAN : {
    country: "FR",
    name: {
      en : "Alencon"
    }
  },
  XAP : {
    country: "BR",
    name: {
      en : "Chapeco"
    }
  },
  XAS : {
    country: "FR",
    name: {
      en : "Ales"
    }
  },
  XAT : {
    country: "FR",
    name: {
      en : "Antibes"
    }
  },
  XAV : {
    country: "FR",
    name: {
      en : "Albertville"
    }
  },
  XAW : {
    country: "CA",
    name: {
      en : "Capreol"
    }
  },
  XAZ : {
    country: "CA",
    name: {
      en : "Campbellton"
    }
  },
  XBC : {
    country: "FR",
    name: {
      en : "Briancon"
    }
  },
  XBD : {
    country: "FR",
    name: {
      en : "Bar Le Duc"
    }
  },
  XBE : {
    country: "CA",
    name: {
      en : "Bearskin Lake"
    }
  },
  XBF : {
    country: "FR",
    name: {
      en : "Bellegarde"
    }
  },
  XBH : {
    country: "FR",
    name: {
      en : "Bethune"
    }
  },
  XBJ : {
    country: "IR",
    name: {
      en : "Birjand"
    }
  },
  XBK : {
    country: "FR",
    name: {
      en : "Bourg En Bresse"
    }
  },
  XBM : {
    country: "FR",
    name: {
      en : "Beaulieu-sur-Mer"
    }
  },
  XBN : {
    country: "PG",
    name: {
      en : "Biniguni"
    }
  },
  XBQ : {
    country: "FR",
    name: {
      en : "Blois"
    }
  },
  XBR : {
    country: "CA",
    name: {
      en : "Brockville"
    }
  },
  XBS : {
    country: "FR",
    name: {
      en : "Boulogne Sur Mer"
    }
  },
  XBT : {
    country: "FR",
    name: {
      en : "Boulogne Billancourt"
    }
  },
  XBV : {
    country: "FR",
    name: {
      en : "Beaune"
    }
  },
  XBW : {
    country: "CA",
    name: {
      en : "Killineq"
    }
  },
  XBY : {
    country: "FR",
    name: {
      en : "Bayonne"
    }
  },
  XCB : {
    country: "FR",
    name: {
      en : "Cambrai"
    }
  },
  XCC : {
    country: "FR",
    name: {
      en : "Le Creusot"
    }
  },
  XCD : {
    country: "FR",
    name: {
      en : "Chalon Sur Saone"
    }
  },
  XCF : {
    country: "FR",
    name: {
      en : "Chamonix Mont Blanc"
    }
  },
  XCH : {
    country: "CX",
    name: {
      en : "Christmas Island"
    }
  },
  XCI : {
    country: "CA",
    name: {
      en : "Chambord"
    }
  },
  XCK : {
    country: "FR",
    name: {
      en : "St Die"
    }
  },
  XCM : {
    country: "CA",
    name: {
      en : "Chatham"
    }
  },
  XCO : {
    country: "AU",
    name: {
      en : "Colac"
    }
  },
  XCP : {
    country: "FR",
    name: {
      en : "Compiegne"
    }
  },
  XCR : {
    country: "FR",
    popularity: 2,
    name: {
      en : "Chalons Sur Marne"
    }
  },
  XCT : {
    country: "FR",
    name: {
      en : "La Ciotat"
    }
  },
  XCV : {
    country: "FR",
    name: {
      en : "Chantilly"
    }
  },
  XCW : {
    country: "FR",
    name: {
      en : "Chaumont"
    }
  },
  XCX : {
    country: "FR",
    name: {
      en : "Chatellerault"
    }
  },
  XCY : {
    country: "FR",
    name: {
      en : "Chateau Thierry"
    }
  },
  XCZ : {
    country: "FR",
    name: {
      en : "Charleville Mezieres"
    }
  },
  XDA : {
    country: "FR",
    name: {
      en : "Dax Les Thermes"
    }
  },
  XDI : {
    country: "FR",
    name: {
      en : "Digne"
    }
  },
  XDK : {
    country: "FR",
    name: {
      en : "Dunkerque"
    }
  },
  XDL : {
    country: "CA",
    name: {
      en : "Chandler"
    }
  },
  XDM : {
    country: "CA",
    name: {
      en : "Drummondville"
    }
  },
  XDN : {
    country: "FR",
    name: {
      en : "Douai"
    }
  },
  XDO : {
    country: "CA",
    name: {
      en : "Grande Riviere"
    }
  },
  XDR : {
    country: "FR",
    name: {
      en : "Dreux"
    }
  },
  XDU : {
    country: "CA",
    name: {
      en : "Hervey"
    }
  },
  XEB : {
    country: "FR",
    name: {
      en : "Evian Les Bains"
    }
  },
  XED : {
    country: "FR",
    name: {
      en : "Disneyland Paris Rail"
    }
  },
  XEE : {
    country: "CA",
    name: {
      en : "Lac Edouard"
    }
  },
  XEH : {
    country: "CA",
    name: {
      en : "Ladysmith"
    }
  },
  XEI : {
    country: "JP",
    name: {
      en : "Tsukuba"
    }
  },
  XEJ : {
    country: "CA",
    name: {
      en : "Langford"
    }
  },
  XEK : {
    country: "CA",
    name: {
      en : "Melville"
    }
  },
  XEL : {
    country: "CA",
    name: {
      en : "New Carlisle"
    }
  },
  XEM : {
    country: "CA",
    name: {
      en : "New Richmond"
    }
  },
  XEP : {
    country: "FR",
    name: {
      en : "Epernay"
    }
  },
  XER : {
    country: "FR",
    name: {
      en : "XER"
    }
  },
  XFB : {
    country: "FR",
    name: {
      en : "Fontainebleau"
    }
  },
  XFD : {
    country: "CA",
    name: {
      en : "Stratford"
    }
  },
  XFE : {
    country: "CA",
    name: {
      en : "Parent"
    }
  },
  XFF : {
    country: "FR",
    name: {
      en : "Calais City"
    }
  },
  XFG : {
    country: "CA",
    name: {
      en : "Perce"
    }
  },
  XFI : {
    country: "CA",
    name: {
      en : "Port Daniel"
    }
  },
  XFK : {
    country: "CA",
    name: {
      en : "Senneterre"
    }
  },
  XFL : {
    country: "CA",
    name: {
      en : "Shawinigan"
    }
  },
  XFM : {
    country: "CA",
    name: {
      en : "Shawnigan"
    }
  },
  XFN : {
    country: "CN",
    name: {
      en : "Xiangfan"
    }
  },
  XFO : {
    country: "CA",
    name: {
      en : "Taschereau"
    }
  },
  XFQ : {
    country: "CA",
    name: {
      en : "Weymont"
    }
  },
  XFS : {
    country: "CA",
    name: {
      en : "Alexandria"
    }
  },
  XFV : {
    country: "CA",
    name: {
      en : "Brantford"
    }
  },
  XFX : {
    country: "FR",
    name: {
      en : "Foix"
    }
  },
  XGC : {
    country: "SE",
    name: {
      en : "Lund C"
    }
  },
  XGD : {
    country: "NO",
    name: {
      en : "Arendal"
    }
  },
  XGF : {
    country: "CA",
    name: {
      en : "Percex"
    }
  },
  XGJ : {
    country: "CA",
    name: {
      en : "Cobourg"
    }
  },
  XGK : {
    country: "CA",
    name: {
      en : "Coteau"
    }
  },
  XGR : {
    country: "CA",
    name: {
      en : "Kangiqsualujjuaq"
    }
  },
  XGV : {
    country: "FR",
    name: {
      en : "Saint Gilles Croix de Vie"
    }
  },
  XGW : {
    country: "CA",
    name: {
      en : "Gananoque"
    }
  },
  XGY : {
    country: "CA",
    name: {
      en : "Grimsby"
    }
  },
  XGZ : {
    country: "AT",
    name: {
      en : "Bregenz"
    }
  },
  XHE : {
    country: "FR",
    name: {
      en : "Hyeres"
    }
  },
  XHF : {
    country: "NO",
    name: {
      en : "Honefoss"
    }
  },
  XHK : {
    country: "FR",
    name: {
      en : "XHK"
    }
  },
  XHM : {
    country: "CA",
    name: {
      en : "Georgetown"
    }
  },
  XHS : {
    country: "CA",
    name: {
      en : "Chemainus"
    }
  },
  XHU : {
    country: "GB",
    name: {
      en : "Huntingdon"
    }
  },
  XHV : {
    country: "RO",
    name: {
      en : "Brasov"
    }
  },
  XHY : {
    country: "FR",
    name: {
      en : "Hendaye"
    }
  },
  XIA : {
    country: "CA",
    name: {
      en : "Guelph"
    }
  },
  XIB : {
    country: "CA",
    name: {
      en : "Ingersoll"
    }
  },
  XIC : {
    country: "CN",
    name: {
      en : "Xichang"
    }
  },
  XID : {
    country: "CA",
    name: {
      en : "Maxville"
    }
  },
  XIF : {
    country: "CA",
    name: {
      en : "Napanee"
    }
  },
  XII : {
    country: "CA",
    name: {
      en : "Prescott"
    }
  },
  XIL : {
    country: "CN",
    name: {
      en : "Xilinhot"
    }
  },
  XIM : {
    country: "CA",
    name: {
      en : "Saint Hyacinthe"
    }
  },
  XIO : {
    country: "CA",
    name: {
      en : "St Marys"
    }
  },
  XIP : {
    country: "CA",
    name: {
      en : "Woodstock"
    }
  },
  XIZ : {
    country: "FR",
    name: {
      en : "XIZ"
    }
  },
  XJL : {
    country: "CA",
    name: {
      en : "Joliette"
    }
  },
  XJQ : {
    country: "CA",
    name: {
      en : "Jonquiere"
    }
  },
  XKD : {
    country: "NO",
    name: {
      en : "Halden"
    }
  },
  XKF : {
    country: "NO",
    name: {
      en : "Fredrikstad"
    }
  },
  XKH : {
    country: "LA",
    name: {
      en : "Xieng Khouang"
    }
  },
  XKI : {
    country: "NO",
    name: {
      en : "Lillestrom"
    }
  },
  XKJ : {
    country: "NO",
    name: {
      en : "Steinkjer"
    }
  },
  XKK : {
    country: "NO",
    name: {
      en : "Larvik"
    }
  },
  XKM : {
    country: "NO",
    name: {
      en : "Moss"
    }
  },
  XKQ : {
    country: "NO",
    name: {
      en : "Sarpsborg"
    }
  },
  XKS : {
    country: "CA",
    name: {
      en : "Kasabonika"
    }
  },
  XKV : {
    country: "CA",
    name: {
      en : "Sackville"
    }
  },
  XLE : {
    country: "FR",
    name: {
      en : "Lens"
    }
  },
  XLG : {
    country: "FR",
    name: {
      en : "Lognes"
    }
  },
  XLI : {
    country: "FR",
    name: {
      en : "Saint Louis"
    }
  },
  XLL : {
    country: "FR",
    name: {
      en : "Lons Le Saunier"
    }
  },
  XLM : {
    country: "CA",
    name: {
      en : "XLM"
    }
  },
  XLN : {
    country: "FR",
    name: {
      en : "Laon"
    }
  },
  XLP : {
    country: "CA",
    name: {
      en : "Matapedia"
    }
  },
  XLQ : {
    country: "CA",
    name: {
      en : "XLQ"
    }
  },
  XLR : {
    country: "FR",
    name: {
      en : "Libourne"
    }
  },
  XLV : {
    country: "CA",
    name: {
      en : "Niagara Falls"
    }
  },
  XLY : {
    country: "CA",
    name: {
      en : "Aldershot"
    }
  },
  XLZ : {
    country: "CA",
    name: {
      en : "Truro"
    }
  },
  XME : {
    country: "FR",
    name: {
      en : "Maubeuge"
    }
  },
  XMF : {
    country: "FR",
    name: {
      en : "Montbelliard"
    }
  },
  XMH : {
    country: "PF",
    name: {
      en : "Manihi"
    }
  },
  XMJ : {
    country: "FR",
    name: {
      en : "Mont De Marsen"
    }
  },
  XMK : {
    country: "FR",
    name: {
      en : "Montelimar"
    }
  },
  XMM : {
    country: "FR",
    name: {
      en : "Monaco"
    }
  },
  XMN : {
    country: "CN",
    name: {
      en : "Xiamen"
    }
  },
  XMR : {
    country: "FR",
    name: {
      en : "Marmande"
    }
  },
  XMS : {
    country: "EC",
    name: {
      en : "Macas"
    }
  },
  XMT : {
    country: "FR",
    name: {
      en : "Menton"
    }
  },
  XMW : {
    country: "FR",
    name: {
      en : "Montauban"
    }
  },
  XMY : {
    country: "AU",
    name: {
      en : "Yam Island"
    }
  },
  XNC : {
    country: "IT",
    name: {
      en : "XNC"
    }
  },
  XNM : {
    country: "GB",
    name: {
      en : "Nottingham"
    }
  },
  XNN : {
    country: "CN",
    name: {
      en : "Xining"
    }
  },
  XNR : {
    country: "DK",
    name: {
      en : "Aabenraa"
    }
  },
  XNT : {
    country: "CN",
    name: {
      en : "Xingtai"
    }
  },
  XOG : {
    country: "FR",
    name: {
      en : "Orange"
    }
  },
  XOJ : {
    country: "ES",
    name: {
      en : "XOJ"
    }
  },
  XOK : {
    country: "CA",
    name: {
      en : "Oakville"
    }
  },
  XON : {
    country: "CA",
    name: {
      en : "Carleton"
    }
  },
  XOR : {
    country: "NO",
    name: {
      en : "Otta"
    }
  },
  XPB : {
    country: "CA",
    name: {
      en : "Parksville"
    }
  },
  XPH : {
    country: "CA",
    name: {
      en : "Port Hope"
    }
  },
  XPK : {
    country: "CA",
    name: {
      en : "Pukatawagan"
    }
  },
  XPL : {
    country: "HN",
    name: {
      en : "Comayagua"
    }
  },
  XPN : {
    country: "CA",
    name: {
      en : "Brampton"
    }
  },
  XPS : {
    country: "FR",
    name: {
      en : "Provins"
    }
  },
  XPT : {
    country: "GB",
    name: {
      en : "Preston"
    }
  },
  XPX : {
    country: "CA",
    name: {
      en : "Pointe Aux Trembles"
    }
  },
  XQB : {
    country: "GB",
    name: {
      en : "Basingstoke"
    }
  },
  XQD : {
    country: "GB",
    name: {
      en : "Bedford"
    }
  },
  XQG : {
    country: "GB",
    name: {
      en : "Berwick Upon Tweed"
    }
  },
  XQH : {
    country: "GB",
    name: {
      en : "Derby"
    }
  },
  XQP : {
    country: "CR",
    name: {
      en : "Quepos"
    }
  },
  XQU : {
    country: "CA",
    name: {
      en : "Qualicum"
    }
  },
  XRE : {
    country: "GB",
    name: {
      en : "Reading"
    }
  },
  XRG : {
    country: "GB",
    name: {
      en : "Rugeley"
    }
  },
  XRO : {
    country: "FR",
    name: {
      en : "La Roche Sur Yon"
    }
  },
  XRP : {
    country: "CA",
    name: {
      en : "Riviere A Pierre"
    }
  },
  XRT : {
    country: "FR",
    name: {
      en : "Rambouillet"
    }
  },
  XRU : {
    country: "GB",
    name: {
      en : "Rugby"
    }
  },
  XRY : {
    country: "ES",
    name: {
      en : "Jerez De La Frontera"
    }
  },
  XSB : {
    country: "FR",
    name: {
      en : "St Malo"
    }
  },
  XSC : {
    country: "TC",
    name: {
      en : "South Caicos"
    }
  },
  XSF : {
    country: "FR",
    name: {
      en : "Sens"
    }
  },
  XSH : {
    country: "FR",
    name: {
      en : "St Pierre Des Corps"
    }
  },
  XSJ : {
    country: "FR",
    name: {
      en : "St Quentin"
    }
  },
  XSK : {
    country: "FR",
    name: {
      en : "St Raphael"
    }
  },
  XSL : {
    country: "FR",
    name: {
      en : "Sarlat"
    }
  },
  XSR : {
    country: "GB",
    name: {
      en : "Salisbury"
    }
  },
  XSS : {
    country: "FR",
    name: {
      en : "Soissons"
    }
  },
  XST : {
    country: "FR",
    name: {
      en : "Saintes"
    }
  },
  XSU : {
    country: "FR",
    name: {
      en : "Saumur"
    }
  },
  XSV : {
    country: "FR",
    name: {
      en : "Senlis"
    }
  },
  XSY : {
    country: "FR",
    name: {
      en : "Sete"
    }
  },
  XSZ : {
    country: "PT",
    name: {
      en : "Setubal"
    }
  },
  XTB : {
    country: "FR",
    name: {
      en : "Tarbes"
    }
  },
  XTG : {
    country: "AU",
    name: {
      en : "Thargomindah"
    }
  },
  XTH : {
    country: "FR",
    name: {
      en : "Thionville"
    }
  },
  XTL : {
    country: "CA",
    name: {
      en : "Tadoule Lake"
    }
  },
  XTU : {
    country: "FR",
    name: {
      en : "Tulle"
    }
  },
  XTY : {
    country: "CA",
    name: {
      en : "Strathroy"
    }
  },
  XUT : {
    country: "ES",
    name: {
      en : "XUT"
    }
  },
  XUY : {
    country: "FR",
    name: {
      en : "Auray"
    }
  },
  XUZ : {
    country: "CN",
    name: {
      en : "Xuzhou"
    }
  },
  XVA : {
    country: "GB",
    name: {
      en : "Stockport"
    }
  },
  XVB : {
    country: "GB",
    name: {
      en : "Stafford"
    }
  },
  XVE : {
    country: "FR",
    name: {
      en : "Versailles"
    }
  },
  XVF : {
    country: "FR",
    name: {
      en : "Villefranche Sur Saone"
    }
  },
  XVH : {
    country: "GB",
    name: {
      en : "Peterborough"
    }
  },
  XVI : {
    country: "FR",
    name: {
      en : "Vienne"
    }
  },
  XVJ : {
    country: "GB",
    name: {
      en : "Stevenage"
    }
  },
  XVN : {
    country: "FR",
    name: {
      en : "Verdun"
    }
  },
  XVO : {
    country: "FR",
    name: {
      en : "Vesoul"
    }
  },
  XVP : {
    country: "FR",
    name: {
      en : "Villepinte"
    }
  },
  XVS : {
    country: "FR",
    name: {
      en : "Valenciennes"
    }
  },
  XVV : {
    country: "CA",
    name: {
      en : "Belleville"
    }
  },
  XVW : {
    country: "GB",
    name: {
      en : "Wolverhampton"
    }
  },
  XVZ : {
    country: "FR",
    name: {
      en : "Vierzon"
    }
  },
  XWA : {
    country: "CA",
    name: {
      en : "Watford"
    }
  },
  XWB : {
    country: "GB",
    name: {
      en : "Stirling"
    }
  },
  XWD : {
    country: "GB",
    name: {
      en : "Wakefield Westgate"
    }
  },
  XWE : {
    country: "GB",
    name: {
      en : "Wellingborough"
    }
  },
  XWF : {
    country: "SE",
    name: {
      en : "Falun"
    }
  },
  XWG : {
    country: "FR",
    name: {
      en : "XWG"
    }
  },
  XWH : {
    country: "GB",
    name: {
      en : "Stoke On Trent"
    }
  },
  XWI : {
    country: "GB",
    name: {
      en : "Wigan"
    }
  },
  XWN : {
    country: "GB",
    name: {
      en : "Warrington"
    }
  },
  XWO : {
    country: "GB",
    name: {
      en : "Woking"
    }
  },
  XWP : {
    country: "SE",
    name: {
      en : "Hassleholm"
    }
  },
  XWQ : {
    country: "SE",
    name: {
      en : "Enkoping"
    }
  },
  XWV : {
    country: "SE",
    name: {
      en : "Varberg"
    }
  },
  XWY : {
    country: "CA",
    name: {
      en : "Wyoming"
    }
  },
  XXA : {
    country: "SE",
    name: {
      en : "Alvesta"
    }
  },
  XXD : {
    country: "SE",
    name: {
      en : "Degerfors"
    }
  },
  XXL : {
    country: "NO",
    name: {
      en : "Lille Hammer"
    }
  },
  XXM : {
    country: "SE",
    name: {
      en : "Mjolby"
    }
  },
  XXP : {
    country: "DE",
    name: {
      en : "Potsdam"
    }
  },
  XXR : {
    country: "NO",
    name: {
      en : "Al No"
    }
  },
  XYH : {
    country: "SE",
    name: {
      en : "XYH"
    }
  },
  XYN : {
    country: "SE",
    name: {
      en : "Kristinehamn"
    }
  },
  XYY : {
    country: "SE",
    name: {
      en : "Arvika"
    }
  },
  XYZ : {
    country: "SE",
    name: {
      en : "Harnosand"
    }
  },
  XZB : {
    country: "CA",
    name: {
      en : "Casselman"
    }
  },
  XZC : {
    country: "CA",
    name: {
      en : "Glencoe"
    }
  },
  XZD : {
    country: "NO",
    name: {
      en : "Kongsvinger"
    }
  },
  XZI : {
    country: "FR",
    name: {
      en : "XZI"
    }
  },
  XZJ : {
    country: "JP",
    name: {
      en : "Rail"
    }
  },
  XZK : {
    country: "CA",
    name: {
      en : "Amherst"
    }
  },
  XZU : {
    country: "US",
    name: {
      en : "XZU"
    }
  },
  XZV : {
    country: "FR",
    name: {
      en : "XZV"
    }
  },
  XZY : {
    country: "DE",
    name: {
      en : "Alzey"
    }
  },
  XZZ : {
    country: "ES",
    name: {
      en : "XZZ"
    }
  },
  YAA : {
    country: "CA",
    name: {
      en : "Anahim Lake"
    }
  },
  YAB : {
    country: "CA",
    name: {
      en : "Arctic Bay"
    }
  },
  YAC : {
    country: "CA",
    name: {
      en : "Cat Lake"
    }
  },
  YAG : {
    country: "CA",
    name: {
      en : "Fort Frances"
    }
  },
  YAJ : {
    country: "CA",
    name: {
      en : "Lyall Harbour"
    }
  },
  YAK : {
    country: "US",
    name: {
      en : "Yakutat"
    }
  },
  YAL : {
    country: "CA",
    name: {
      en : "Alert Bay"
    }
  },
  YAM : {
    country: "CA",
    name: {
      en : "Sault Ste Marie"
    }
  },
  YAO : {
    country: "CM",
    name: {
      en : "Yaounde"
    }
  },
  YAP : {
    country: "FM",
    name: {
      en : "Yap FM"
    }
  },
  YAT : {
    country: "CA",
    name: {
      en : "Attawapiskat"
    }
  },
  YAV : {
    country: "CA",
    name: {
      en : "Miner's Bay"
    }
  },
  YAX : {
    country: "CA",
    name: {
      en : "Angling Lake"
    }
  },
  YAY : {
    country: "CA",
    name: {
      en : "St Anthony"
    }
  },
  YAZ : {
    country: "CA",
    name: {
      en : "Tofino"
    }
  },
  YBA : {
    country: "CA",
    name: {
      en : "Banff"
    }
  },
  YBB : {
    country: "CA",
    name: {
      en : "Pelly Bay"
    }
  },
  YBC : {
    country: "CA",
    name: {
      en : "Baie Comeau"
    }
  },
  YBD : {
    country: "CA",
    name: {
      en : "New Westminster"
    }
  },
  YBE : {
    country: "CA",
    name: {
      en : "Uranium City"
    }
  },
  YBG : {
    country: "CA",
    name: {
      en : "Bagotville"
    }
  },
  YBJ : {
    country: "CA",
    name: {
      en : "Baie Johan Beetz"
    }
  },
  YBK : {
    country: "CA",
    name: {
      en : "Baker Lake"
    }
  },
  YBL : {
    country: "CA",
    name: {
      en : "Campbell River"
    }
  },
  YBP : {
    country: "CN",
    name: {
      en : "Yibin"
    }
  },
  YBR : {
    country: "CA",
    name: {
      en : "Brandon"
    }
  },
  YBW : {
    country: "CA",
    name: {
      en : "Bedwell Harbor"
    }
  },
  YBX : {
    country: "CA",
    name: {
      en : "Blanc Sablon"
    }
  },
  YCA : {
    country: "CA",
    name: {
      en : "Courtenay"
    }
  },
  YCB : {
    country: "CA",
    name: {
      en : "Cambridge Bay"
    }
  },
  YCC : {
    country: "CA",
    name: {
      en : "Cornwall"
    }
  },
  YCD : {
    country: "CA",
    name: {
      en : "Nanaimo"
    }
  },
  YCF : {
    country: "CA",
    name: {
      en : "Cortes Bay"
    }
  },
  YCG : {
    country: "CA",
    name: {
      en : "Castlegar"
    }
  },
  YCH : {
    country: "CA",
    name: {
      en : "Miramichi"
    }
  },
  YCK : {
    country: "CA",
    name: {
      en : "Colville"
    }
  },
  YCL : {
    country: "CA",
    name: {
      en : "Charlo"
    }
  },
  YCM : {
    country: "CA",
    name: {
      en : "St Catherines"
    }
  },
  YCN : {
    country: "CA",
    name: {
      en : "Cochrane"
    }
  },
  YCO : {
    country: "CA",
    name: {
      en : "Kugluktuk Coppermine"
    }
  },
  YCS : {
    country: "CA",
    name: {
      en : "Chesterfield Inlet"
    }
  },
  YCU : {
    country: "CN",
    name: {
      en : "Yun Cheng"
    }
  },
  YCW : {
    country: "CA",
    name: {
      en : "Chilliwack"
    }
  },
  YCY : {
    country: "CA",
    name: {
      en : "Clyde River"
    }
  },
  YCZ : {
    country: "CA",
    name: {
      en : "Fairmont Springs"
    }
  },
  YDA : {
    country: "CA",
    name: {
      en : "Dawson City"
    }
  },
  YDC : {
    country: "CA",
    name: {
      en : "Drayton Valley"
    }
  },
  YDF : {
    country: "CA",
    name: {
      en : "Deer Lake"
    }
  },
  YDG : {
    country: "CA",
    name: {
      en : "Digby"
    }
  },
  YDL : {
    country: "CA",
    name: {
      en : "Dease Lake"
    }
  },
  YDN : {
    country: "CA",
    name: {
      en : "Dauphin"
    }
  },
  YDO : {
    country: "CA",
    name: {
      en : "Dolbeau"
    }
  },
  YDP : {
    country: "CA",
    name: {
      en : "Nain"
    }
  },
  YDQ : {
    country: "CA",
    name: {
      en : "Dawson Creek"
    }
  },
  YDS : {
    country: "CA",
    name: {
      en : "Desolation Sound"
    }
  },
  YEA : {
    country: "CA",
    name: {
      en : "Edmonton"
    }
  },
  YEB : {
    country: "CA",
    name: {
      en : "Bar River"
    }
  },
  YEC : {
    country: "KR",
    name: {
      en : "Yechon"
    }
  },
  YEH : {
    country: "IR",
    name: {
      en : "Assaluyeh"
    }
  },
  YEI : {
    country: "TR",
    name: {
      en : "Bursa"
    }
  },
  YEK : {
    country: "CA",
    popularity: 2,
    name: {
      en : "Arviat"
    }
  },
  YEL : {
    country: "CA",
    name: {
      en : "Elliot Lake"
    }
  },
  YEN : {
    country: "CA",
    name: {
      en : "Estevan"
    }
  },
  YER : {
    country: "CA",
    name: {
      en : "Fort Severn"
    }
  },
  YES : {
    country: "IR",
    name: {
      en : "Yasouj"
    }
  },
  YET : {
    country: "CA",
    name: {
      en : "Edson"
    }
  },
  YEV : {
    country: "CA",
    name: {
      en : "Inuvik"
    }
  },
  YEY : {
    country: "CA",
    name: {
      en : "Amos"
    }
  },
  YFA : {
    country: "CA",
    name: {
      en : "Fort Albany"
    }
  },
  YFB : {
    country: "CA",
    name: {
      en : "Iqaluit"
    }
  },
  YFC : {
    country: "CA",
    name: {
      en : "Fredericton"
    }
  },
  YFH : {
    country: "CA",
    name: {
      en : "Fort Hope"
    }
  },
  YFJ : {
    country: "CA",
    name: {
      en : "Snare Lake"
    }
  },
  YFO : {
    country: "CA",
    name: {
      en : "Flin Flon"
    }
  },
  YFS : {
    country: "CA",
    name: {
      en : "Fort Simpson"
    }
  },
  YFT : {
    country: "MO",
    name: {
      en : "Taipa"
    }
  },
  YFX : {
    country: "CA",
    name: {
      en : "Fox Harbour"
    }
  },
  YGB : {
    country: "CA",
    name: {
      en : "Gillies Bay"
    }
  },
  YGG : {
    country: "CA",
    name: {
      en : "Ganges Harbor"
    }
  },
  YGH : {
    country: "CA",
    name: {
      en : "Fort Good Hope"
    }
  },
  YGJ : {
    country: "JP",
    name: {
      en : "Yonago"
    }
  },
  YGK : {
    country: "CA",
    name: {
      en : "Kingston"
    }
  },
  YGL : {
    country: "CA",
    name: {
      en : "La Grande"
    }
  },
  YGN : {
    country: "CA",
    name: {
      en : "Greenway Sound"
    }
  },
  YGP : {
    country: "CA",
    name: {
      en : "Gaspe"
    }
  },
  YGQ : {
    country: "CA",
    name: {
      en : "Geraldton"
    }
  },
  YGR : {
    country: "CA",
    name: {
      en : "Iles De Madeleine"
    }
  },
  YGT : {
    country: "CA",
    name: {
      en : "Igloolik"
    }
  },
  YGV : {
    country: "CA",
    name: {
      en : "Havre St Pierre"
    }
  },
  YGW : {
    country: "CA",
    name: {
      en : "Poste De La Baleine"
    }
  },
  YGX : {
    country: "CA",
    name: {
      en : "Gillam"
    }
  },
  YGZ : {
    country: "CA",
    name: {
      en : "Grise Fiord"
    }
  },
  YHA : {
    country: "CA",
    name: {
      en : "Port Hope Simpson"
    }
  },
  YHB : {
    country: "CA",
    name: {
      en : "Hudson Bay"
    }
  },
  YHD : {
    country: "CA",
    name: {
      en : "Dryden"
    }
  },
  YHE : {
    country: "CA",
    name: {
      en : "Hope"
    }
  },
  YHF : {
    country: "CA",
    name: {
      en : "Hearst"
    }
  },
  YHG : {
    country: "CA",
    name: {
      en : "Charlottetown"
    }
  },
  YHI : {
    country: "CA",
    name: {
      en : "Holman Island"
    }
  },
  YHK : {
    country: "CA",
    name: {
      en : "Gjoa Haven"
    }
  },
  YHM : {
    country: "CA",
    name: {
      en : "Hamilton"
    }
  },
  YHN : {
    country: "CA",
    name: {
      en : "Hornepayne"
    }
  },
  YHO : {
    country: "CA",
    name: {
      en : "Hopedale"
    }
  },
  YHP : {
    country: "CA",
    name: {
      en : "Poplar Hill"
    }
  },
  YHR : {
    country: "CA",
    name: {
      en : "Chevery"
    }
  },
  YHS : {
    country: "CA",
    name: {
      en : "Sechelt"
    }
  },
  YHY : {
    country: "CA",
    name: {
      en : "Hay River"
    }
  },
  YHZ : {
    country: "CA",
    name: {
      en : "Halifax"
    }
  },
  YIB : {
    country: "CA",
    name: {
      en : "Atikokan"
    }
  },
  YIF : {
    country: "CA",
    name: {
      en : "Pakuashipi"
    }
  },
  YIH : {
    country: "CN",
    name: {
      en : "Yichang"
    }
  },
  YIK : {
    country: "CA",
    name: {
      en : "Ivujivik"
    }
  },
  YIN : {
    country: "CN",
    name: {
      en : "Yining"
    }
  },
  YIO : {
    country: "CA",
    name: {
      en : "Pond Inlet"
    }
  },
  YIW : {
    country: "CN",
    name: {
      en : "Yiwu"
    }
  },
  YJA : {
    country: "CA",
    name: {
      en : "Jasper"
    }
  },
  YJT : {
    country: "CA",
    name: {
      en : "Stephenville"
    }
  },
  YKA : {
    country: "CA",
    name: {
      en : "Kamloops"
    }
  },
  YKF : {
    country: "CA",
    name: {
      en : "Kitchener"
    }
  },
  YKG : {
    country: "CA",
    name: {
      en : "Kangirsuk"
    }
  },
  YKH : {
    country: "CN",
    name: {
      en : "Yingkou"
    }
  },
  YKI : {
    country: "CA",
    name: {
      en : "Kennosao Lake"
    }
  },
  YKL : {
    country: "CA",
    name: {
      en : "Schefferville"
    }
  },
  YKM : {
    country: "US",
    name: {
      en : "Yakima"
    }
  },
  YKN : {
    country: "US",
    name: {
      en : "Yankton"
    }
  },
  YKO : {
    country: "TR",
    name: {
      en : "Yuksekova"
    }
  },
  YKQ : {
    country: "CA",
    name: {
      en : "Waskaganish"
    }
  },
  YKS : {
    country: "RU",
    name: {
      en : "Yakutsk"
    }
  },
  YKT : {
    country: "CA",
    name: {
      en : "Klemtu"
    }
  },
  YKU : {
    country: "CA",
    name: {
      en : "Chisasibi"
    }
  },
  YKX : {
    country: "CA",
    name: {
      en : "Kirkland"
    }
  },
  YKY : {
    country: "CA",
    name: {
      en : "Kindersley"
    }
  },
  YLC : {
    country: "CA",
    name: {
      en : "Kimmirut Lake Harbour"
    }
  },
  YLD : {
    country: "CA",
    name: {
      en : "Chapleau"
    }
  },
  YLE : {
    country: "CA",
    name: {
      en : "Wha Ti/Lac La Martre"
    }
  },
  YLH : {
    country: "CA",
    name: {
      en : "Lansdowne"
    }
  },
  YLI : {
    country: "FI",
    name: {
      en : "Ylivieska"
    }
  },
  YLJ : {
    country: "CA",
    name: {
      en : "Meadow Lake"
    }
  },
  YLL : {
    country: "CA",
    name: {
      en : "Lloydminster"
    }
  },
  YLQ : {
    country: "CA",
    name: {
      en : "La Tuque"
    }
  },
  YLW : {
    country: "CA",
    name: {
      en : "Kelowna"
    }
  },
  YLY : {
    country: "CA",
    name: {
      en : "Langley"
    }
  },
  YMA : {
    country: "CA",
    name: {
      en : "Mayo"
    }
  },
  YMB : {
    country: "CA",
    name: {
      en : "Merritt"
    }
  },
  YME : {
    country: "CA",
    name: {
      en : "Matane"
    }
  },
  YMF : {
    country: "CA",
    name: {
      en : "Montagne Harbor"
    }
  },
  YMG : {
    country: "CA",
    name: {
      en : "Manitouwadge"
    }
  },
  YMH : {
    country: "CA",
    name: {
      en : "Mary's Harbour"
    }
  },
  YMI : {
    country: "CA",
    name: {
      en : "Minaki"
    }
  },
  YMJ : {
    country: "CA",
    name: {
      en : "Moose Jaw"
    }
  },
  YMK : {
    country: "RU",
    name: {
      en : "Mys Kamenny"
    }
  },
  YMM : {
    country: "CA",
    name: {
      en : "Ft McMurray"
    }
  },
  YMN : {
    country: "CA",
    name: {
      en : "Makkovik"
    }
  },
  YMO : {
    country: "CA",
    name: {
      en : "Moosonee"
    }
  },
  YMP : {
    country: "CA",
    name: {
      en : "Port McNeil"
    }
  },
  YMQ : {
    country: "CA",
    popularity: 16,
    name: {
      en : "Montreal"
    }
  },
  YMS : {
    country: "PE",
    name: {
      en : "Yurimaguas"
    }
  },
  YMT : {
    country: "CA",
    name: {
      en : "Chibougamau"
    }
  },
  YMU : {
    country: "CA",
    name: {
      en : "YMU"
    }
  },
  YNA : {
    country: "CA",
    name: {
      en : "Natashquan"
    }
  },
  YNB : {
    country: "SA",
    name: {
      en : "Yanbu"
    }
  },
  YNC : {
    country: "CA",
    name: {
      en : "Wemindji"
    }
  },
  YND : {
    country: "CA",
    name: {
      en : "Gatineau Hull"
    }
  },
  YNG : {
    country: "US",
    name: {
      en : "Youngstown"
    }
  },
  YNJ : {
    country: "CN",
    name: {
      en : "Yanji"
    }
  },
  YNL : {
    country: "CA",
    name: {
      en : "Points North Landing"
    }
  },
  YNM : {
    country: "CA",
    name: {
      en : "Matagami"
    }
  },
  YNN : {
    country: "AU",
    name: {
      en : "Yandicoogina"
    }
  },
  YNO : {
    country: "CA",
    name: {
      en : "North Spirit Lake"
    }
  },
  YNP : {
    country: "CA",
    name: {
      en : "Natuashish"
    }
  },
  YNS : {
    country: "CA",
    name: {
      en : "Nemiscau"
    }
  },
  YNT : {
    country: "CN",
    name: {
      en : "Yantai"
    }
  },
  YNY : {
    country: "KR",
    name: {
      en : "Yangyang"
    }
  },
  YNZ : {
    country: "CN",
    name: {
      en : "Yancheng"
    }
  },
  YOC : {
    country: "CA",
    name: {
      en : "Old Crow"
    }
  },
  YOD : {
    country: "CA",
    name: {
      en : "Cold Lake"
    }
  },
  YOG : {
    country: "CA",
    name: {
      en : "Ogoki"
    }
  },
  YOJ : {
    country: "CA",
    name: {
      en : "High Level"
    }
  },
  YOK : {
    country: "JP",
    name: {
      en : "Yokohama"
    }
  },
  YOL : {
    country: "NG",
    name: {
      en : "Yola"
    }
  },
  YOO : {
    country: "CA",
    name: {
      en : "Oshawa"
    }
  },
  YOP : {
    country: "CA",
    name: {
      en : "Rainbow Lake"
    }
  },
  YOS : {
    country: "CA",
    name: {
      en : "Owen Sound"
    }
  },
  YOT : {
    country: "IL",
    name: {
      en : "Yotvata"
    }
  },
  YOW : {
    country: "CA",
    popularity: 2,
    name: {
      en : "Ottawa"
    }
  },
  YPA : {
    country: "CA",
    name: {
      en : "Prince Albert"
    }
  },
  YPB : {
    country: "CA",
    name: {
      en : "Port Alberni"
    }
  },
  YPC : {
    country: "CA",
    name: {
      en : "Paulatuk"
    }
  },
  YPD : {
    country: "CA",
    name: {
      en : "Parry Sound"
    }
  },
  YPE : {
    country: "CA",
    name: {
      en : "Peace River"
    }
  },
  YPF : {
    country: "CA",
    name: {
      en : "Esquimalt"
    }
  },
  YPG : {
    country: "CA",
    name: {
      en : "Portage La Prairie"
    }
  },
  YPH : {
    country: "CA",
    name: {
      en : "Inukjuak"
    }
  },
  YPJ : {
    country: "CA",
    name: {
      en : "Aupaluk"
    }
  },
  YPL : {
    country: "CA",
    name: {
      en : "Pickle Lake"
    }
  },
  YPM : {
    country: "CA",
    name: {
      en : "St Pierre"
    }
  },
  YPN : {
    country: "CA",
    name: {
      en : "Port Menier"
    }
  },
  YPO : {
    country: "CA",
    name: {
      en : "Peawanuck"
    }
  },
  YPQ : {
    country: "CA",
    name: {
      en : "Peterborough"
    }
  },
  YPR : {
    country: "CA",
    name: {
      en : "Prince Rupert"
    }
  },
  YPS : {
    country: "CA",
    name: {
      en : "Port Hawkesbury"
    }
  },
  YPT : {
    country: "CA",
    name: {
      en : "Pender Harbor"
    }
  },
  YPW : {
    country: "CA",
    name: {
      en : "Powell River"
    }
  },
  YPX : {
    country: "CA",
    name: {
      en : "Puvirnituq"
    }
  },
  YPY : {
    country: "CA",
    name: {
      en : "Fort Chipewyan"
    }
  },
  YPZ : {
    country: "CA",
    name: {
      en : "Burns Lake"
    }
  },
  YQA : {
    country: "CA",
    name: {
      en : "Muskoka"
    }
  },
  YQB : {
    country: "CA",
    popularity: 2,
    name: {
      en : "Quebec"
    }
  },
  YQC : {
    country: "CA",
    name: {
      en : "Quaqtaq"
    }
  },
  YQD : {
    country: "CA",
    name: {
      en : "The Pas"
    }
  },
  YQE : {
    country: "CA",
    name: {
      en : "Kimberley"
    }
  },
  YQF : {
    country: "CA",
    name: {
      en : "Red Deer"
    }
  },
  YQG : {
    country: "CA",
    name: {
      en : "Windsor"
    }
  },
  YQH : {
    country: "CA",
    name: {
      en : "Watson Lake"
    }
  },
  YQI : {
    country: "CA",
    name: {
      en : "Yarmouth"
    }
  },
  YQJ : {
    country: "CA",
    name: {
      en : "YQJ"
    }
  },
  YQK : {
    country: "CA",
    name: {
      en : "Kenora"
    }
  },
  YQL : {
    country: "CA",
    name: {
      en : "Lethbridge"
    }
  },
  YQM : {
    country: "CA",
    name: {
      en : "Moncton"
    }
  },
  YQN : {
    country: "CA",
    name: {
      en : "Nakina"
    }
  },
  YQQ : {
    country: "CA",
    name: {
      en : "Comox"
    }
  },
  YQR : {
    country: "CA",
    name: {
      en : "Regina"
    }
  },
  YQS : {
    country: "CA",
    name: {
      en : "St. Thomas"
    }
  },
  YQT : {
    country: "CA",
    name: {
      en : "Thunder Bay"
    }
  },
  YQU : {
    country: "CA",
    name: {
      en : "Grande Prairie"
    }
  },
  YQV : {
    country: "CA",
    name: {
      en : "Yorkton"
    }
  },
  YQW : {
    country: "CA",
    name: {
      en : "North Battleford"
    }
  },
  YQX : {
    country: "CA",
    name: {
      en : "Gander"
    }
  },
  YQY : {
    country: "CA",
    name: {
      en : "Sydney"
    }
  },
  YQZ : {
    country: "CA",
    name: {
      en : "Quesnel"
    }
  },
  YRA : {
    country: "CA",
    name: {
      en : "Rae Lakes"
    }
  },
  YRB : {
    country: "CA",
    name: {
      en : "Resolute"
    }
  },
  YRC : {
    country: "CA",
    name: {
      en : "YRC"
    }
  },
  YRF : {
    country: "CA",
    name: {
      en : "Cartwright"
    }
  },
  YRG : {
    country: "CA",
    name: {
      en : "Rigolet"
    }
  },
  YRI : {
    country: "CA",
    name: {
      en : "Riviere Du Loup"
    }
  },
  YRJ : {
    country: "CA",
    name: {
      en : "Roberval"
    }
  },
  YRL : {
    country: "CA",
    name: {
      en : "Red Lake"
    }
  },
  YRM : {
    country: "CA",
    name: {
      en : "Rocky Mountain House"
    }
  },
  YRO : {
    country: "CA",
    name: {
      en : "YRO"
    }
  },
  YRQ : {
    country: "CA",
    name: {
      en : "Trois Rivieres"
    }
  },
  YRR : {
    country: "CA",
    name: {
      en : "Stuart Island"
    }
  },
  YRT : {
    country: "CA",
    name: {
      en : "Rankin Inlet"
    }
  },
  YRV : {
    country: "CA",
    name: {
      en : "Revelstoke"
    }
  },
  YSB : {
    country: "CA",
    name: {
      en : "Sudbury"
    }
  },
  YSC : {
    country: "CA",
    name: {
      en : "Sherbrooke"
    }
  },
  YSF : {
    country: "CA",
    name: {
      en : "Stony Rapids"
    }
  },
  YSG : {
    country: "CA",
    name: {
      en : "Lutselke/Snowdrift"
    }
  },
  YSH : {
    country: "CA",
    name: {
      en : "Smith Falls"
    }
  },
  YSJ : {
    country: "CA",
    name: {
      en : "St John"
    }
  },
  YSK : {
    country: "CA",
    name: {
      en : "Sanikiluaq"
    }
  },
  YSL : {
    country: "CA",
    name: {
      en : "St Leonard"
    }
  },
  YSM : {
    country: "CA",
    name: {
      en : "Ft Smith"
    }
  },
  YSN : {
    country: "CA",
    name: {
      en : "Salmon Arm"
    }
  },
  YSO : {
    country: "CA",
    name: {
      en : "Postville"
    }
  },
  YSP : {
    country: "CA",
    name: {
      en : "Marathon"
    }
  },
  YSQ : {
    country: "CN",
    name: {
      en : "Songyuan"
    }
  },
  YSR : {
    country: "CA",
    name: {
      en : "Nanisivik"
    }
  },
  YST : {
    country: "CA",
    name: {
      en : "St Theris Point"
    }
  },
  YSU : {
    country: "CA",
    name: {
      en : "Summerside"
    }
  },
  YSY : {
    country: "CA",
    name: {
      en : "Sachs Harbour"
    }
  },
  YTA : {
    country: "CA",
    name: {
      en : "Pembroke"
    }
  },
  YTD : {
    country: "CA",
    name: {
      en : "Thicket Portage"
    }
  },
  YTE : {
    country: "CA",
    name: {
      en : "Cape Dorset"
    }
  },
  YTF : {
    country: "CA",
    name: {
      en : "Alma"
    }
  },
  YTG : {
    country: "CA",
    name: {
      en : "Sullivan Bay"
    }
  },
  YTH : {
    country: "CA",
    name: {
      en : "Thompson"
    }
  },
  YTJ : {
    country: "CA",
    name: {
      en : "Terrace Bay"
    }
  },
  YTL : {
    country: "CA",
    name: {
      en : "Big Trout"
    }
  },
  YTM : {
    country: "CA",
    name: {
      en : "Mont-Tremblant"
    }
  },
  YTO : {
    country: "CA",
    popularity: 33,
    name: {
      en : "Toronto"
    }
  },
  YTQ : {
    country: "CA",
    name: {
      en : "Tasiujaq"
    }
  },
  YTR : {
    country: "CA",
    name: {
      en : "Trenton"
    }
  },
  YTS : {
    country: "CA",
    name: {
      en : "Timmins"
    }
  },
  YTY : {
    country: "CN",
    name: {
      en : "Yangzhou"
    }
  },
  YUB : {
    country: "CA",
    name: {
      en : "Tuktoyaktuk"
    }
  },
  YUD : {
    country: "CA",
    name: {
      en : "Umiujaq"
    }
  },
  YUM : {
    country: "US",
    name: {
      en : "Yuma"
    }
  },
  YUS : {
    country: "CN",
    name: {
      en : "YUS"
    }
  },
  YUT : {
    country: "CA",
    name: {
      en : "YUT"
    }
  },
  YUX : {
    country: "CA",
    name: {
      en : "Hall Beach"
    }
  },
  YUY : {
    country: "CA",
    name: {
      en : "Rouyn Noranda"
    }
  },
  YVA : {
    country: "KM",
    name: {
      en : "Moroni"
    }
  },
  YVB : {
    country: "CA",
    name: {
      en : "Bonaventure"
    }
  },
  YVC : {
    country: "CA",
    name: {
      en : "Lac La Ronge"
    }
  },
  YVE : {
    country: "CA",
    name: {
      en : "Vernon"
    }
  },
  YVG : {
    country: "CA",
    name: {
      en : "Vermilion"
    }
  },
  YVM : {
    country: "CA",
    name: {
      en : "Qikiqtarjuaq"
    }
  },
  YVO : {
    country: "CA",
    name: {
      en : "Val D Or"
    }
  },
  YVP : {
    country: "CA",
    name: {
      en : "Kuujjuaq"
    }
  },
  YVQ : {
    country: "CA",
    name: {
      en : "Norman Wells"
    }
  },
  YVR : {
    country: "CA",
    popularity: 12,
    name: {
      en : "Vancouver"
    }
  },
  YVZ : {
    country: "CA",
    name: {
      en : "Deer Lake"
    }
  },
  YWA : {
    country: "CA",
    name: {
      en : "Petawawa"
    }
  },
  YWB : {
    country: "CA",
    name: {
      en : "Kangiqsujuaq"
    }
  },
  YWG : {
    country: "CA",
    name: {
      en : "Winnipeg"
    }
  },
  YWH : {
    country: "CA",
    name: {
      en : "Victoria Harbour"
    }
  },
  YWJ : {
    country: "CA",
    name: {
      en : "Deline"
    }
  },
  YWK : {
    country: "CA",
    name: {
      en : "Wabush"
    }
  },
  YWL : {
    country: "CA",
    name: {
      en : "Williams Lake"
    }
  },
  YWM : {
    country: "CA",
    name: {
      en : "Williams Harbour"
    }
  },
  YWP : {
    country: "CA",
    name: {
      en : "Webequie"
    }
  },
  YWR : {
    country: "CA",
    name: {
      en : "White River"
    }
  },
  YWS : {
    country: "CA",
    name: {
      en : "Whistler"
    }
  },
  YXC : {
    country: "CA",
    name: {
      en : "Cranbrook"
    }
  },
  YXE : {
    country: "CA",
    name: {
      en : "Saskatoon"
    }
  },
  YXH : {
    country: "CA",
    name: {
      en : "Medicine Hat"
    }
  },
  YXJ : {
    country: "CA",
    name: {
      en : "Ft St John"
    }
  },
  YXK : {
    country: "CA",
    name: {
      en : "Rimouski"
    }
  },
  YXL : {
    country: "CA",
    name: {
      en : "Sioux Lookout"
    }
  },
  YXN : {
    country: "CA",
    name: {
      en : "Whale Cove"
    }
  },
  YXP : {
    country: "CA",
    name: {
      en : "Pangnirtung"
    }
  },
  YXR : {
    country: "CA",
    name: {
      en : "Earlton"
    }
  },
  YXS : {
    country: "CA",
    name: {
      en : "Prince George"
    }
  },
  YXT : {
    country: "CA",
    name: {
      en : "Terrace"
    }
  },
  YXU : {
    country: "CA",
    popularity: 10,
    name: {
      en : "London"
    }
  },
  YXX : {
    country: "CA",
    name: {
      en : "Abbotsford"
    }
  },
  YXY : {
    country: "CA",
    name: {
      en : "Whitehorse"
    }
  },
  YXZ : {
    country: "CA",
    name: {
      en : "Wawa"
    }
  },
  YYB : {
    country: "CA",
    name: {
      en : "North Bay"
    }
  },
  YYC : {
    country: "CA",
    name: {
      en : "Calgary"
    }
  },
  YYD : {
    country: "CA",
    name: {
      en : "Smithers"
    }
  },
  YYE : {
    country: "CA",
    name: {
      en : "Fort Nelson"
    }
  },
  YYF : {
    country: "CA",
    name: {
      en : "Penticton"
    }
  },
  YYG : {
    country: "CA",
    name: {
      en : "Charlottetown"
    }
  },
  YYH : {
    country: "CA",
    name: {
      en : "Taloyoak"
    }
  },
  YYI : {
    country: "CA",
    name: {
      en : "Rivers"
    }
  },
  YYJ : {
    country: "CA",
    name: {
      en : "Victoria"
    }
  },
  YYL : {
    country: "CA",
    name: {
      en : "Lynn Lake"
    }
  },
  YYM : {
    country: "CA",
    name: {
      en : "Cowley"
    }
  },
  YYN : {
    country: "CA",
    name: {
      en : "Swift Current"
    }
  },
  YYQ : {
    country: "CA",
    name: {
      en : "Churchill"
    }
  },
  YYR : {
    country: "CA",
    name: {
      en : "Goose Bay"
    }
  },
  YYT : {
    country: "CA",
    name: {
      en : "St Johns"
    }
  },
  YYU : {
    country: "CA",
    name: {
      en : "Kapuskasing"
    }
  },
  YYW : {
    country: "CA",
    name: {
      en : "Armstromg"
    }
  },
  YYY : {
    country: "CA",
    name: {
      en : "Mont Joli"
    }
  },
  YZA : {
    country: "CA",
    name: {
      en : "Ashcroft"
    }
  },
  YZE : {
    country: "CA",
    name: {
      en : "Gore Bay"
    }
  },
  YZF : {
    country: "CA",
    name: {
      en : "Yellowknife"
    }
  },
  YZG : {
    country: "CA",
    name: {
      en : "Salluit"
    }
  },
  YZH : {
    country: "CA",
    name: {
      en : "Slave Lake"
    }
  },
  YZP : {
    country: "CA",
    name: {
      en : "Sandspit"
    }
  },
  YZR : {
    country: "CA",
    name: {
      en : "Sarnia"
    }
  },
  YZS : {
    country: "CA",
    name: {
      en : "Coral Harbour"
    }
  },
  YZT : {
    country: "CA",
    name: {
      en : "Port Hardy"
    }
  },
  YZU : {
    country: "CA",
    name: {
      en : "Whitecourt"
    }
  },
  YZV : {
    country: "CA",
    name: {
      en : "Sept Iles"
    }
  },
  YZX : {
    country: "CA",
    name: {
      en : "Greenwood"
    }
  },
  YZY : {
    country: "CN",
    name: {
      en : "Zhangye"
    }
  },
  YZZ : {
    country: "CA",
    name: {
      en : "Trail"
    }
  },
  ZAD : {
    country: "HR",
    popularity: 2,
    name: {
      en : "Zadar"
    }
  },
  ZAF : {
    country: "FR",
    name: {
      en : "Arles"
    }
  },
  ZAG : {
    country: "HR",
    popularity: 260,
    name: {
      en : "Zagreb"
    }
  },
  ZAH : {
    country: "IR",
    name: {
      en : "Zahedan"
    }
  },
  ZAJ : {
    country: "AF",
    name: {
      en : "Zaranj"
    }
  },
  ZAK : {
    country: "IT",
    name: {
      en : "Chiusa Klausen"
    }
  },
  ZAL : {
    country: "CL",
    name: {
      en : "Valdivia"
    }
  },
  ZAM : {
    country: "PH",
    name: {
      en : "Zamboanga"
    }
  },
  ZAN : {
    country: "GR",
    name: {
      en : "Aghios Nicolaos"
    }
  },
  ZAO : {
    country: "FR",
    name: {
      en : "Cahors"
    }
  },
  ZAQ : {
    country: "DE",
    name: {
      en : "ZAQ"
    }
  },
  ZAT : {
    country: "CN",
    name: {
      en : "Zhaotong"
    }
  },
  ZAU : {
    country: "DE",
    name: {
      en : "Aue De"
    }
  },
  ZAV : {
    country: "PT",
    name: {
      en : "Aveiro"
    }
  },
  ZAX : {
    country: "DE",
    name: {
      en : "Angermuende"
    }
  },
  ZAZ : {
    country: "ES",
    name: {
      en : "Zaragoza"
    }
  },
  ZBF : {
    country: "CA",
    name: {
      en : "Bathurst"
    }
  },
  ZBG : {
    country: "PL",
    name: {
      en : "Elblag"
    }
  },
  ZBJ : {
    country: "DK",
    name: {
      en : "Fredericia"
    }
  },
  ZBL : {
    country: "AU",
    name: {
      en : "Biloela"
    }
  },
  ZBM : {
    country: "CA",
    name: {
      en : "Bromont"
    }
  },
  ZBO : {
    country: "AU",
    name: {
      en : "Bowen"
    }
  },
  ZBR : {
    country: "IR",
    name: {
      en : "Chah-Bahar"
    }
  },
  ZBV : {
    country: "US",
    name: {
      en : "Beaver Creek"
    }
  },
  ZBW : {
    country: "BR",
    name: {
      en : "Atibaia"
    }
  },
  ZBX : {
    country: "HU",
    name: {
      en : "Szombathely"
    }
  },
  ZBZ : {
    country: "DE",
    name: {
      en : "Bad Salzungen"
    }
  },
  ZCA : {
    country: "DE",
    name: {
      en : "Arnsberg"
    }
  },
  ZCB : {
    country: "DE",
    name: {
      en : "Aschaffenburg"
    }
  },
  ZCC : {
    country: "DE",
    name: {
      en : "Baden Baden"
    }
  },
  ZCD : {
    country: "DE",
    name: {
      en : "Bamberg"
    }
  },
  ZCF : {
    country: "DE",
    name: {
      en : "Bergheim"
    }
  },
  ZCI : {
    country: "DE",
    name: {
      en : "Bocholt"
    }
  },
  ZCJ : {
    country: "DE",
    name: {
      en : "Bottrop"
    }
  },
  ZCK : {
    country: "DE",
    name: {
      en : "Bruehl"
    }
  },
  ZCL : {
    country: "MX",
    name: {
      en : "Zacatecas"
    }
  },
  ZCN : {
    country: "DE",
    name: {
      en : "Celle"
    }
  },
  ZCO : {
    country: "CL",
    name: {
      en : "Temuco"
    }
  },
  ZCQ : {
    country: "CL",
    name: {
      en : "Curico"
    }
  },
  ZCR : {
    country: "DE",
    name: {
      en : "Dachau"
    }
  },
  ZCS : {
    country: "DE",
    name: {
      en : "Darmstadt"
    }
  },
  ZCT : {
    country: "DE",
    name: {
      en : "Delmenhorst"
    }
  },
  ZCU : {
    country: "DE",
    name: {
      en : "Detmold"
    }
  },
  ZCY : {
    country: "DE",
    name: {
      en : "Dueren"
    }
  },
  ZCZ : {
    country: "DE",
    name: {
      en : "Erlangen"
    }
  },
  ZDB : {
    country: "CH",
    name: {
      en : "Adelboden"
    }
  },
  ZDK : {
    country: "CH",
    name: {
      en : "Biel"
    }
  },
  ZDL : {
    country: "CH",
    name: {
      en : "Brig"
    }
  },
  ZDT : {
    country: "CH",
    name: {
      en : "Chur"
    }
  },
  ZDV : {
    country: "CH",
    name: {
      en : "Davos"
    }
  },
  ZEB : {
    country: "DE",
    name: {
      en : "Esslingen"
    }
  },
  ZEC : {
    country: "ZA",
    name: {
      en : "Secunda"
    }
  },
  ZED : {
    country: "DE",
    name: {
      en : "Euskirchen"
    }
  },
  ZEE : {
    country: "DE",
    name: {
      en : "Fulda"
    }
  },
  ZEF : {
    country: "DE",
    name: {
      en : "Fuerth"
    }
  },
  ZEH : {
    country: "DE",
    name: {
      en : "Garbsen"
    }
  },
  ZEI : {
    country: "DE",
    name: {
      en : "Garmisch Partenkirchen"
    }
  },
  ZEJ : {
    country: "DE",
    name: {
      en : "Gelsenkirchen"
    }
  },
  ZEK : {
    country: "DE",
    name: {
      en : "Gladbeck"
    }
  },
  ZEL : {
    country: "CA",
    name: {
      en : "Bella Bella"
    }
  },
  ZEM : {
    country: "CA",
    name: {
      en : "East Main"
    }
  },
  ZEP : {
    country: "GB",
    name: {
      en : "ZEP"
    }
  },
  ZES : {
    country: "DE",
    name: {
      en : "Goeppingen"
    }
  },
  ZET : {
    country: "DE",
    name: {
      en : "Goslar"
    }
  },
  ZEU : {
    country: "DE",
    name: {
      en : "Goettingen"
    }
  },
  ZEY : {
    country: "DE",
    name: {
      en : "Hagen"
    }
  },
  ZEZ : {
    country: "DE",
    name: {
      en : "Hameln"
    }
  },
  ZFD : {
    country: "CA",
    name: {
      en : "Fond Du Lac"
    }
  },
  ZFI : {
    country: "GB",
    name: {
      en : "Chesterfield"
    }
  },
  ZFM : {
    country: "CA",
    name: {
      en : "Fort Mcpherson"
    }
  },
  ZFN : {
    country: "CA",
    name: {
      en : "Tulita/Fort Norman"
    }
  },
  ZFP : {
    country: "HU",
    name: {
      en : "Veszprem"
    }
  },
  ZFR : {
    country: "DE",
    name: {
      en : "Frankfurt An Der Oder"
    }
  },
  ZFV : {
    country: "US",
    name: {
      en : "Philadelphia Rail Station"
    }
  },
  ZFZ : {
    country: "US",
    name: {
      en : "Buffalo"
    }
  },
  ZGA : {
    country: "DE",
    name: {
      en : "Gera"
    }
  },
  ZGD : {
    country: "US",
    name: {
      en : "Groton"
    }
  },
  ZGE : {
    country: "DE",
    name: {
      en : "Goerlitz"
    }
  },
  ZGF : {
    country: "CA",
    name: {
      en : "Grand Forks"
    }
  },
  ZGJ : {
    country: "BE",
    name: {
      en : "Brugge"
    }
  },
  ZGK : {
    country: "BE",
    name: {
      en : "Leuven"
    }
  },
  ZGN : {
    country: "DE",
    name: {
      en : "Nanning"
    }
  },
  ZGO : {
    country: "DE",
    name: {
      en : "Gotha"
    }
  },
  ZGP : {
    country: "BE",
    name: {
      en : "Mechelen"
    }
  },
  ZGQ : {
    country: "BE",
    name: {
      en : "Tournai"
    }
  },
  ZGS : {
    country: "CA",
    name: {
      en : "Gethsemanie"
    }
  },
  ZGU : {
    country: "VU",
    name: {
      en : "Gaua"
    }
  },
  ZGV : {
    country: "BE",
    name: {
      en : "Wavre"
    }
  },
  ZGW : {
    country: "DE",
    name: {
      en : "Greifswald"
    }
  },
  ZHA : {
    country: "CN",
    name: {
      en : "Zhangjiang"
    }
  },
  ZHD : {
    country: "CH",
    name: {
      en : "Fluelen"
    }
  },
  ZHF : {
    country: "CH",
    name: {
      en : "Fribourg"
    }
  },
  ZHO : {
    country: "CA",
    name: {
      en : "Houston"
    }
  },
  ZHQ : {
    country: "DE",
    name: {
      en : "Halberstadt"
    }
  },
  ZHR : {
    country: "CH",
    name: {
      en : "Kandersteg"
    }
  },
  ZHS : {
    country: "CH",
    name: {
      en : "Klosters"
    }
  },
  ZHX : {
    country: "BR",
    name: {
      en : "Tubarao"
    }
  },
  ZHY : {
    country: "CN",
    name: {
      en : "Zhongwei"
    }
  },
  ZHZ : {
    country: "DE",
    name: {
      en : "Halle"
    }
  },
  ZIA : {
    country: "RU",
    name: {
      en : "Zhukovskiy"
    }
  },
  ZIG : {
    country: "SN",
    name: {
      en : "Ziguinchor"
    }
  },
  ZIH : {
    country: "MX",
    name: {
      en : "Zihuatanejo"
    }
  },
  ZIN : {
    country: "CH",
    name: {
      en : "Interlaken"
    }
  },
  ZIS : {
    country: "CN",
    name: {
      en : "Zhongshan"
    }
  },
  ZIT : {
    country: "DE",
    name: {
      en : "Zittau"
    }
  },
  ZIX : {
    country: "RU",
    name: {
      en : "Zhigansk"
    }
  },
  ZJI : {
    country: "CH",
    name: {
      en : "Locarno"
    }
  },
  ZJJ : {
    country: "IT",
    name: {
      en : "Procida"
    }
  },
  ZJM : {
    country: "CH",
    name: {
      en : "Martigny"
    }
  },
  ZJN : {
    country: "CA",
    name: {
      en : "Swan River"
    }
  },
  ZJP : {
    country: "CH",
    name: {
      en : "Montreux"
    }
  },
  ZJS : {
    country: "DE",
    name: {
      en : "Jena"
    }
  },
  ZKE : {
    country: "CA",
    name: {
      en : "Kaschechewan"
    }
  },
  ZKG : {
    country: "CA",
    name: {
      en : "Kegaska"
    }
  },
  ZKK : {
    country: "CH",
    name: {
      en : "Schwyz"
    }
  },
  ZKO : {
    country: "CH",
    name: {
      en : "Sierre"
    }
  },
  ZKP : {
    country: "RU",
    name: {
      en : "Zyryanka"
    }
  },
  ZKT : {
    country: "GR",
    name: {
      en : "Komotini"
    }
  },
  ZKW : {
    country: "CH",
    name: {
      en : "Wetzikon"
    }
  },
  ZKZ : {
    country: "CH",
    name: {
      en : "Vevey"
    }
  },
  ZLA : {
    country: "CH",
    name: {
      en : "Villars"
    }
  },
  ZLJ : {
    country: "CH",
    name: {
      en : "Yverdon"
    }
  },
  ZLM : {
    country: "CH",
    name: {
      en : "Zug Ch"
    }
  },
  ZLO : {
    country: "MX",
    name: {
      en : "Manzanillo"
    }
  },
  ZLR : {
    country: "CL",
    name: {
      en : "Linares"
    }
  },
  ZLS : {
    country: "GB",
    name: {
      en : "ZLS"
    }
  },
  ZLT : {
    country: "CA",
    name: {
      en : "La Tabatiere"
    }
  },
  ZLU : {
    country: "DE",
    name: {
      en : "Ludwigslust"
    }
  },
  ZMA : {
    country: "GB",
    name: {
      en : "Mansfield"
    }
  },
  ZME : {
    country: "US",
    name: {
      en : "ZME"
    }
  },
  ZMG : {
    country: "DE",
    name: {
      en : "Magdeburg"
    }
  },
  ZMM : {
    country: "MX",
    name: {
      en : "Zamora"
    }
  },
  ZMO : {
    country: "IT",
    name: {
      en : "Modena"
    }
  },
  ZMT : {
    country: "CA",
    name: {
      en : "Masset"
    }
  },
  ZNB : {
    country: "DE",
    name: {
      en : "Hamm"
    }
  },
  ZNC : {
    country: "US",
    name: {
      en : "Nyac"
    }
  },
  ZNE : {
    country: "AU",
    popularity: 2,
    name: {
      en : "Newman"
    }
  },
  ZNF : {
    country: "DE",
    name: {
      en : "Hanau"
    }
  },
  ZNI : {
    country: "DE",
    name: {
      en : "Heidenheim"
    }
  },
  ZNJ : {
    country: "DE",
    name: {
      en : "Heilbronn"
    }
  },
  ZNK : {
    country: "DE",
    name: {
      en : "Herford"
    }
  },
  ZNN : {
    country: "DE",
    name: {
      en : "Hilden"
    }
  },
  ZNO : {
    country: "DE",
    name: {
      en : "Hildesheim"
    }
  },
  ZNQ : {
    country: "DE",
    name: {
      en : "Ingolstadt"
    }
  },
  ZNR : {
    country: "DE",
    name: {
      en : "Iserlohn"
    }
  },
  ZNS : {
    country: "DE",
    name: {
      en : "Kempten"
    }
  },
  ZNV : {
    country: "DE",
    name: {
      en : "Koblenz"
    }
  },
  ZNW : {
    country: "DE",
    name: {
      en : "Limburg"
    }
  },
  ZNZ : {
    country: "TZ",
    name: {
      en : "Zanzibar"
    }
  },
  ZOB : {
    country: "DE",
    name: {
      en : "Lippstadt"
    }
  },
  ZOC : {
    country: "DE",
    name: {
      en : "Ludenscheid"
    }
  },
  ZOD : {
    country: "DE",
    name: {
      en : "Ludwigsburg"
    }
  },
  ZOE : {
    country: "DE",
    name: {
      en : "Ludwigshafen"
    }
  },
  ZOG : {
    country: "DE",
    name: {
      en : "Lueneburg"
    }
  },
  ZOH : {
    country: "DE",
    name: {
      en : "Luenen"
    }
  },
  ZOI : {
    country: "DE",
    name: {
      en : "Marburg An Der Lahn"
    }
  },
  ZOJ : {
    country: "DE",
    name: {
      en : "Marl"
    }
  },
  ZOM : {
    country: "DE",
    name: {
      en : "Minden"
    }
  },
  ZON : {
    country: "DE",
    name: {
      en : "Moers"
    }
  },
  ZOO : {
    country: "DE",
    name: {
      en : "Muelheim An Der Ruhr"
    }
  },
  ZOQ : {
    country: "DE",
    name: {
      en : "Neuss"
    }
  },
  ZOR : {
    country: "DE",
    name: {
      en : "Neustadt An Der Weinstrasse"
    }
  },
  ZOS : {
    country: "CL",
    name: {
      en : "Osorno"
    }
  },
  ZOU : {
    country: "DE",
    name: {
      en : "Neuwied"
    }
  },
  ZOV : {
    country: "DE",
    name: {
      en : "Norderstedt"
    }
  },
  ZOW : {
    country: "DE",
    name: {
      en : "Nordhorn"
    }
  },
  ZOY : {
    country: "DE",
    name: {
      en : "Oberhausen"
    }
  },
  ZOZ : {
    country: "DE",
    name: {
      en : "Offenbach"
    }
  },
  ZPA : {
    country: "DE",
    name: {
      en : "Offenburg"
    }
  },
  ZPB : {
    country: "CA",
    name: {
      en : "Sachigo Lake"
    }
  },
  ZPC : {
    country: "CL",
    name: {
      en : "Pucon"
    }
  },
  ZPD : {
    country: "DE",
    name: {
      en : "Oldenburg"
    }
  },
  ZPE : {
    country: "DE",
    name: {
      en : "Osnabruck"
    }
  },
  ZPF : {
    country: "DE",
    name: {
      en : "Passau"
    }
  },
  ZPJ : {
    country: "DE",
    name: {
      en : "Ratingen"
    }
  },
  ZPK : {
    country: "DE",
    name: {
      en : "Ravensburg"
    }
  },
  ZPL : {
    country: "DE",
    name: {
      en : "Recklinghausen"
    }
  },
  ZPM : {
    country: "DE",
    name: {
      en : "Regensburg"
    }
  },
  ZPP : {
    country: "DE",
    name: {
      en : "Reutlingen"
    }
  },
  ZPQ : {
    country: "DE",
    name: {
      en : "Rheine"
    }
  },
  ZPR : {
    country: "DE",
    name: {
      en : "Rosenheim"
    }
  },
  ZPS : {
    country: "DE",
    name: {
      en : "Ruesselsheim"
    }
  },
  ZPU : {
    country: "DE",
    name: {
      en : "Salzgitter"
    }
  },
  ZPV : {
    country: "DE",
    name: {
      en : "Schwaebisch Gmuend"
    }
  },
  ZPW : {
    country: "DE",
    name: {
      en : "Schweinfurt"
    }
  },
  ZPZ : {
    country: "DE",
    name: {
      en : "Sindelfingen"
    }
  },
  ZQA : {
    country: "DE",
    name: {
      en : "Singen"
    }
  },
  ZQB : {
    country: "DE",
    name: {
      en : "Solingen"
    }
  },
  ZQC : {
    country: "DE",
    name: {
      en : "Speyer"
    }
  },
  ZQD : {
    country: "DE",
    name: {
      en : "Stade"
    }
  },
  ZQF : {
    country: "DE",
    name: {
      en : "Trier"
    }
  },
  ZQH : {
    country: "DE",
    name: {
      en : "Tuebingen"
    }
  },
  ZQJ : {
    country: "DE",
    name: {
      en : "Velbert"
    }
  },
  ZQK : {
    country: "DE",
    name: {
      en : "Viersen"
    }
  },
  ZQL : {
    country: "DE",
    name: {
      en : "Villingen Schwenningen"
    }
  },
  ZQN : {
    country: "NZ",
    popularity: 4,
    name: {
      en : "Queenstown"
    }
  },
  ZQO : {
    country: "DE",
    name: {
      en : "Waiblingen"
    }
  },
  ZQP : {
    country: "DE",
    name: {
      en : "Wesel"
    }
  },
  ZQQ : {
    country: "DE",
    name: {
      en : "Wetzlar"
    }
  },
  ZQS : {
    country: "CA",
    name: {
      en : "Queen Charlotte Island"
    }
  },
  ZQU : {
    country: "DE",
    name: {
      en : "Wolfsburg"
    }
  },
  ZQV : {
    country: "DE",
    name: {
      en : "Worms"
    }
  },
  ZQW : {
    country: "DE",
    name: {
      en : "Zweibruecken"
    }
  },
  ZQZ : {
    country: "CN",
    name: {
      en : "Zhangjiakou"
    }
  },
  ZRC : {
    country: "ES",
    name: {
      en : "San Pedro de Alcantara"
    }
  },
  ZRD : {
    country: "US",
    name: {
      en : "Richmond"
    }
  },
  ZRH : {
    country: "CH",
    popularity: 408,
    name: {
      en : "Zurich"
    }
  },
  ZRI : {
    country: "ID",
    name: {
      en : "Serui"
    }
  },
  ZRJ : {
    country: "CA",
    name: {
      en : "Round Lake"
    }
  },
  ZRL : {
    country: "US",
    name: {
      en : "Lancaster"
    }
  },
  ZRN : {
    country: "CH",
    name: {
      en : "Nyon"
    }
  },
  ZRO : {
    country: "IT",
    name: {
      en : "Reggio Nellemilia"
    }
  },
  ZRS : {
    country: "AT",
    name: {
      en : "Zurs Lech"
    }
  },
  ZRV : {
    country: "US",
    name: {
      en : "Providence"
    }
  },
  ZRW : {
    country: "DE",
    name: {
      en : "Rastatt"
    }
  },
  ZRX : {
    country: "DE",
    name: {
      en : "Riesa"
    }
  },
  ZSA : {
    country: "BS",
    name: {
      en : "San Salvador"
    }
  },
  ZSE : {
    country: "RE",
    name: {
      en : "St Pierre Dela Reunion"
    }
  },
  ZSG : {
    country: "DE",
    name: {
      en : "Sonneberg"
    }
  },
  ZSJ : {
    country: "CA",
    name: {
      en : "Sandy Lake"
    }
  },
  ZSM : {
    country: "US",
    name: {
      en : "Santa Clara"
    }
  },
  ZSN : {
    country: "DE",
    name: {
      en : "Stendal"
    }
  },
  ZSO : {
    country: "DE",
    name: {
      en : "Suhl"
    }
  },
  ZSR : {
    country: "DE",
    name: {
      en : "Schwerin"
    }
  },
  ZSU : {
    country: "DE",
    name: {
      en : "Dessau"
    }
  },
  ZSX : {
    country: "DE",
    name: {
      en : "Stralsund"
    }
  },
  ZTA : {
    country: "PF",
    name: {
      en : "Tureira"
    }
  },
  ZTB : {
    country: "CA",
    name: {
      en : "Tete A La Baleine"
    }
  },
  ZTD : {
    country: "US",
    name: {
      en : "Schenectady"
    }
  },
  ZTE : {
    country: "US",
    name: {
      en : "Rochester"
    }
  },
  ZTF : {
    country: "US",
    name: {
      en : "Westchester County"
    }
  },
  ZTH : {
    country: "GR",
    popularity: 4,
    name: {
      en : "Zakinthos"
    }
  },
  ZTI : {
    country: "CN",
    name: {
      en : "Humen"
    }
  },
  ZTJ : {
    country: "US",
    name: {
      en : "Princeton"
    }
  },
  ZTP : {
    country: "BR",
    name: {
      en : "Itapetininga"
    }
  },
  ZTR : {
    country: "UA",
    name: {
      en : "ZTR"
    }
  },
  ZTU : {
    country: "AZ",
    name: {
      en : "Zaqatala"
    }
  },
  ZTV : {
    country: "US",
    name: {
      en : "ZTV"
    }
  },
  ZTZ : {
    country: "DE",
    name: {
      en : "Chemnitz"
    }
  },
  ZUA : {
    country: "US",
    name: {
      en : "Utica"
    }
  },
  ZUH : {
    country: "CN",
    name: {
      en : "Zhuhai"
    }
  },
  ZUM : {
    country: "CA",
    name: {
      en : "Churchhill Falls"
    }
  },
  ZVD : {
    country: "NO",
    name: {
      en : "Drangedal"
    }
  },
  ZVE : {
    country: "US",
    name: {
      en : "New Haven"
    }
  },
  ZVH : {
    country: "AE",
    name: {
      en : "Al Ain"
    }
  },
  ZVJ : {
    country: "AE",
    name: {
      en : "ZVJ"
    }
  },
  ZVK : {
    country: "LA",
    name: {
      en : "Savannakhet"
    }
  },
  ZWA : {
    country: "MG",
    name: {
      en : "Andapa"
    }
  },
  ZWB : {
    country: "US",
    name: {
      en : "Hampton"
    }
  },
  ZWE : {
    country: "BE",
    name: {
      en : "ZWE"
    }
  },
  ZWL : {
    country: "CA",
    name: {
      en : "Wollaston Lake"
    }
  },
  ZWM : {
    country: "DE",
    name: {
      en : "Wismar"
    }
  },
  ZWT : {
    country: "DE",
    name: {
      en : "Wittenberg"
    }
  },
  ZWV : {
    country: "US",
    name: {
      en : "ZWV"
    }
  },
  ZWW : {
    country: "US",
    name: {
      en : "Hampton"
    }
  },
  ZWY : {
    country: "BE",
    name: {
      en : "ZWY"
    }
  },
  ZXO : {
    country: "NO",
    name: {
      en : "Fauske"
    }
  },
  ZXU : {
    country: "NO",
    name: {
      en : "Rygge"
    }
  },
  ZXX : {
    country: "NO",
    name: {
      en : "Rade"
    }
  },
  ZYI : {
    country: "CN",
    name: {
      en : "Zunyi"
    }
  },
  ZYK : {
    country: "CN",
    name: {
      en : "Shekou"
    }
  },
  ZYL : {
    country: "BD",
    name: {
      en : "Sylhet"
    }
  },
  ZYN : {
    country: "FR",
    name: {
      en : "ZYN"
    }
  },
  ZYO : {
    country: "NL",
    name: {
      en : "Roosendaal"
    }
  },
  ZYP : {
    country: "US",
    name: {
      en : "New York Penn STN"
    }
  },
  ZYQ : {
    country: "US",
    name: {
      en : "Syracuse"
    }
  },
  ZYS : {
    country: "NO",
    name: {
      en : "Sandefjord"
    }
  },
  ZYV : {
    country: "NO",
    name: {
      en : "Vegarshei"
    }
  },
  ZYW : {
    country: "NO",
    name: {
      en : "Sandvika"
    }
  },
  ZYY : {
    country: "NO",
    name: {
      en : "Marnardal"
    }
  },
  ZZO : {
    country: "RU",
    name: {
      en : "Zonalnoe"
    }
  },
  ZZU : {
    country: "MW",
    name: {
      en : "Mzuzu"
    }
  },
  ZZV : {
    country: "US",
    name: {
      en : "Zanesville"
    }
  }
};

global.___cities = cities;
var lang = "ru";
if (typeof window !== "undefined") {
 switch (self.document.documentElement.lang) {
     case "uk-ua":
       lang = "ua";
       break;
     case "ru-ua":
       lang = "ru";
       break;
     default:
       lang = self.document.documentElement.lang.substring(0, 2);
       break;
 }
}
const defineProps = function(obj) {
  var keys = Object.keys(obj);
  var key;
  var val;
  var type;
  var k = keys.length;
  while (k--) {
    key = keys[k];
    val = obj[key];
    val.$code = key 
    val.$type = "city"
    type = typeof val;
    if (type === "object") {
      if (val[lang]) {
        Object.defineProperty(obj, key, {
          value: val[lang]
        });
        Object.defineProperty(obj, key+"En", {
          value: val.en,
          enumerable: true
        });
      } else {
        defineProps(val);
      }
    }
  }
};
typeof window !== "undefined" && defineProps(cities);
module.exports = cities;
